import { Translations as d, Dates as g, Numeric as y, Objects as ul, CalcGroup as C, CalculationRowType as v, IncomeTypesLogic as V, EnumerationsLogic as G, Unit as L, ReportType as Se, CalculatorLogic as Jr, PaymentChannel as X, TaxcardKind as Rn, FrameworkAgreement as ql, PensionCalculation as E, UnionPaymentType as Kl, UnionPaymentKind as Jl, Years as Qr, TaxDeductionWorkCategories as Zr, CalculationRowCategory as De, Arrays as nn, InvoiceType as ae, BicHelper as ln, Iban as ea, InvoiceStatus as An, CalcRowsLogic as Ql } from "../core/salaxy-lib-core.js";
function wt(l) {
  return l && l.__esModule && Object.prototype.hasOwnProperty.call(l, "default") ? l.default : l;
}
var $n = { exports: {} }, W = {}, Y = {};
Y.__esModule = !0;
Y.extend = Rt;
Y.indexOf = aa;
Y.escapeExpression = oa;
Y.isEmpty = ua;
Y.createFrame = ia;
Y.blockParams = sa;
Y.appendContextPath = ca;
var na = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#x27;",
  "`": "&#x60;",
  "=": "&#x3D;"
}, la = /[&<>"'`=]/g, ta = /[&<>"'`=]/;
function ra(l) {
  return na[l];
}
function Rt(l) {
  for (var e = 1; e < arguments.length; e++)
    for (var t in arguments[e])
      Object.prototype.hasOwnProperty.call(arguments[e], t) && (l[t] = arguments[e][t]);
  return l;
}
var il = Object.prototype.toString;
Y.toString = il;
var Bn = function(e) {
  return typeof e == "function";
};
Bn(/x/) && (Y.isFunction = Bn = function(l) {
  return typeof l == "function" && il.call(l) === "[object Function]";
});
Y.isFunction = Bn;
var At = Array.isArray || function(l) {
  return l && typeof l == "object" ? il.call(l) === "[object Array]" : !1;
};
Y.isArray = At;
function aa(l, e) {
  for (var t = 0, s = l.length; t < s; t++)
    if (l[t] === e)
      return t;
  return -1;
}
function oa(l) {
  if (typeof l != "string") {
    if (l && l.toHTML)
      return l.toHTML();
    if (l == null)
      return "";
    if (!l)
      return l + "";
    l = "" + l;
  }
  return ta.test(l) ? l.replace(la, ra) : l;
}
function ua(l) {
  return !l && l !== 0 ? !0 : !!(At(l) && l.length === 0);
}
function ia(l) {
  var e = Rt({}, l);
  return e._parent = l, e;
}
function sa(l, e) {
  return l.path = e, l;
}
function ca(l, e) {
  return (l ? l + "." : "") + e;
}
var Fn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  var t = ["description", "fileName", "lineNumber", "endLineNumber", "message", "name", "number", "stack"];
  function s(a, n) {
    var o = n && n.loc, r = void 0, u = void 0, i = void 0, c = void 0;
    o && (r = o.start.line, u = o.end.line, i = o.start.column, c = o.end.column, a += " - " + r + ":" + i);
    for (var f = Error.prototype.constructor.call(this, a), m = 0; m < t.length; m++)
      this[t[m]] = f[t[m]];
    Error.captureStackTrace && Error.captureStackTrace(this, s);
    try {
      o && (this.lineNumber = r, this.endLineNumber = u, Object.defineProperty ? (Object.defineProperty(this, "column", {
        value: i,
        enumerable: !0
      }), Object.defineProperty(this, "endColumn", {
        value: c,
        enumerable: !0
      })) : (this.column = i, this.endColumn = c));
    } catch {
    }
  }
  s.prototype = new Error(), e.default = s, l.exports = e.default;
})(Fn, Fn.exports);
var ye = Fn.exports, Fe = {}, jn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  var t = Y;
  e.default = function(s) {
    s.registerHelper("blockHelperMissing", function(a, n) {
      var o = n.inverse, r = n.fn;
      if (a === !0)
        return r(this);
      if (a === !1 || a == null)
        return o(this);
      if (t.isArray(a))
        return a.length > 0 ? (n.ids && (n.ids = [n.name]), s.helpers.each(a, n)) : o(this);
      if (n.data && n.ids) {
        var u = t.createFrame(n.data);
        u.contextPath = t.appendContextPath(n.data.contextPath, n.name), n = { data: u };
      }
      return r(a, n);
    });
  }, l.exports = e.default;
})(jn, jn.exports);
var ma = jn.exports, Vn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var s = Y, a = ye, n = t(a);
  e.default = function(o) {
    o.registerHelper("each", function(r, u) {
      if (!u)
        throw new n.default("Must pass iterator to #each");
      var i = u.fn, c = u.inverse, f = 0, m = "", p = void 0, w = void 0;
      u.data && u.ids && (w = s.appendContextPath(u.data.contextPath, u.ids[0]) + "."), s.isFunction(r) && (r = r.call(this)), u.data && (p = s.createFrame(u.data));
      function b(S, T, M) {
        p && (p.key = S, p.index = T, p.first = T === 0, p.last = !!M, w && (p.contextPath = w + S)), m = m + i(r[S], {
          data: p,
          blockParams: s.blockParams([r[S], S], [w + S, null])
        });
      }
      if (r && typeof r == "object")
        if (s.isArray(r))
          for (var O = r.length; f < O; f++)
            f in r && b(f, f, f === r.length - 1);
        else if (typeof Symbol == "function" && r[Symbol.iterator]) {
          for (var k = [], h = r[Symbol.iterator](), A = h.next(); !A.done; A = h.next())
            k.push(A.value);
          r = k;
          for (var O = r.length; f < O; f++)
            b(f, f, f === r.length - 1);
        } else
          (function() {
            var S = void 0;
            Object.keys(r).forEach(function(T) {
              S !== void 0 && b(S, f - 1), S = T, f++;
            }), S !== void 0 && b(S, f - 1, !0);
          })();
      return f === 0 && (m = c(this)), m;
    });
  }, l.exports = e.default;
})(Vn, Vn.exports);
var fa = Vn.exports, Un = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  function t(n) {
    return n && n.__esModule ? n : { default: n };
  }
  var s = ye, a = t(s);
  e.default = function(n) {
    n.registerHelper("helperMissing", function() {
      if (arguments.length !== 1)
        throw new a.default('Missing helper: "' + arguments[arguments.length - 1].name + '"');
    });
  }, l.exports = e.default;
})(Un, Un.exports);
var ya = Un.exports, Nn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var s = Y, a = ye, n = t(a);
  e.default = function(o) {
    o.registerHelper("if", function(r, u) {
      if (arguments.length != 2)
        throw new n.default("#if requires exactly one argument");
      return s.isFunction(r) && (r = r.call(this)), !u.hash.includeZero && !r || s.isEmpty(r) ? u.inverse(this) : u.fn(this);
    }), o.registerHelper("unless", function(r, u) {
      if (arguments.length != 2)
        throw new n.default("#unless requires exactly one argument");
      return o.helpers.if.call(this, r, {
        fn: u.inverse,
        inverse: u.fn,
        hash: u.hash
      });
    });
  }, l.exports = e.default;
})(Nn, Nn.exports);
var da = Nn.exports, zn = { exports: {} };
(function(l, e) {
  e.__esModule = !0, e.default = function(t) {
    t.registerHelper("log", function() {
      for (var s = [void 0], a = arguments[arguments.length - 1], n = 0; n < arguments.length - 1; n++)
        s.push(arguments[n]);
      var o = 1;
      a.hash.level != null ? o = a.hash.level : a.data && a.data.level != null && (o = a.data.level), s[0] = o, t.log.apply(t, s);
    });
  }, l.exports = e.default;
})(zn, zn.exports);
var ga = zn.exports, Gn = { exports: {} };
(function(l, e) {
  e.__esModule = !0, e.default = function(t) {
    t.registerHelper("lookup", function(s, a, n) {
      return s && n.lookupProperty(s, a);
    });
  }, l.exports = e.default;
})(Gn, Gn.exports);
var Pa = Gn.exports, Wn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  function t(o) {
    return o && o.__esModule ? o : { default: o };
  }
  var s = Y, a = ye, n = t(a);
  e.default = function(o) {
    o.registerHelper("with", function(r, u) {
      if (arguments.length != 2)
        throw new n.default("#with requires exactly one argument");
      s.isFunction(r) && (r = r.call(this));
      var i = u.fn;
      if (s.isEmpty(r))
        return u.inverse(this);
      var c = u.data;
      return u.data && u.ids && (c = s.createFrame(u.data), c.contextPath = s.appendContextPath(u.data.contextPath, u.ids[0])), i(r, {
        data: c,
        blockParams: s.blockParams([r], [c && c.contextPath])
      });
    });
  }, l.exports = e.default;
})(Wn, Wn.exports);
var pa = Wn.exports;
Fe.__esModule = !0;
Fe.registerDefaultHelpers = _a;
Fe.moveHelperToHooks = Da;
function de(l) {
  return l && l.__esModule ? l : { default: l };
}
var ha = ma, va = de(ha), ka = fa, Sa = de(ka), wa = ya, Ra = de(wa), Aa = da, ba = de(Aa), Ea = ga, Oa = de(Ea), Ca = Pa, Ta = de(Ca), xa = pa, La = de(xa);
function _a(l) {
  va.default(l), Sa.default(l), Ra.default(l), ba.default(l), Oa.default(l), Ta.default(l), La.default(l);
}
function Da(l, e, t) {
  l.helpers[e] && (l.hooks[e] = l.helpers[e], t || delete l.helpers[e]);
}
var sl = {}, qn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  var t = Y;
  e.default = function(s) {
    s.registerDecorator("inline", function(a, n, o, r) {
      var u = a;
      return n.partials || (n.partials = {}, u = function(i, c) {
        var f = o.partials;
        o.partials = t.extend({}, f, n.partials);
        var m = a(i, c);
        return o.partials = f, m;
      }), n.partials[r.args[0]] = r.fn, u;
    });
  }, l.exports = e.default;
})(qn, qn.exports);
var Ma = qn.exports;
sl.__esModule = !0;
sl.registerDefaultDecorators = Ha;
function Xa(l) {
  return l && l.__esModule ? l : { default: l };
}
var Ya = Ma, Ia = Xa(Ya);
function Ha(l) {
  Ia.default(l);
}
var Kn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  var t = Y, s = {
    methodMap: ["debug", "info", "warn", "error"],
    level: "info",
    // Maps a given level value to the `methodMap` indexes above.
    lookupLevel: function(n) {
      if (typeof n == "string") {
        var o = t.indexOf(s.methodMap, n.toLowerCase());
        o >= 0 ? n = o : n = parseInt(n, 10);
      }
      return n;
    },
    // Can be overridden in the host environment
    log: function(n) {
      if (n = s.lookupLevel(n), typeof console < "u" && s.lookupLevel(s.level) <= n) {
        var o = s.methodMap[n];
        console[o] || (o = "log");
        for (var r = arguments.length, u = Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)
          u[i - 1] = arguments[i];
        console[o].apply(console, u);
      }
    }
  };
  e.default = s, l.exports = e.default;
})(Kn, Kn.exports);
var bt = Kn.exports, Oe = {}, cl = {};
cl.__esModule = !0;
cl.createNewLookupObject = Ba;
var $a = Y;
function Ba() {
  for (var l = arguments.length, e = Array(l), t = 0; t < l; t++)
    e[t] = arguments[t];
  return $a.extend.apply(void 0, [/* @__PURE__ */ Object.create(null)].concat(e));
}
Oe.__esModule = !0;
Oe.createProtoAccessControl = Ua;
Oe.resultIsAllowed = Na;
Oe.resetLoggedProperties = Ga;
function Fa(l) {
  return l && l.__esModule ? l : { default: l };
}
var Zl = cl, ja = bt, Va = Fa(ja), tn = /* @__PURE__ */ Object.create(null);
function Ua(l) {
  var e = /* @__PURE__ */ Object.create(null);
  e.constructor = !1, e.__defineGetter__ = !1, e.__defineSetter__ = !1, e.__lookupGetter__ = !1;
  var t = /* @__PURE__ */ Object.create(null);
  return t.__proto__ = !1, {
    properties: {
      whitelist: Zl.createNewLookupObject(t, l.allowedProtoProperties),
      defaultValue: l.allowProtoPropertiesByDefault
    },
    methods: {
      whitelist: Zl.createNewLookupObject(e, l.allowedProtoMethods),
      defaultValue: l.allowProtoMethodsByDefault
    }
  };
}
function Na(l, e, t) {
  return et(typeof l == "function" ? e.methods : e.properties, t);
}
function et(l, e) {
  return l.whitelist[e] !== void 0 ? l.whitelist[e] === !0 : l.defaultValue !== void 0 ? l.defaultValue : (za(e), !1);
}
function za(l) {
  tn[l] !== !0 && (tn[l] = !0, Va.default.log("error", 'Handlebars: Access has been denied to resolve the property "' + l + `" because it is not an "own property" of its parent.
You can add a runtime option to disable the check or this warning:
See https://handlebarsjs.com/api-reference/runtime-options.html#options-to-control-prototype-access for details`));
}
function Ga() {
  Object.keys(tn).forEach(function(l) {
    delete tn[l];
  });
}
W.__esModule = !0;
W.HandlebarsEnvironment = Jn;
function Et(l) {
  return l && l.__esModule ? l : { default: l };
}
var me = Y, Wa = ye, bn = Et(Wa), qa = Fe, Ka = sl, Ja = bt, rn = Et(Ja), Qa = Oe, Za = "4.7.8";
W.VERSION = Za;
var eo = 8;
W.COMPILER_REVISION = eo;
var no = 7;
W.LAST_COMPATIBLE_COMPILER_REVISION = no;
var lo = {
  1: "<= 1.0.rc.2",
  // 1.0.rc.2 is actually rev2 but doesn't report it
  2: "== 1.0.0-rc.3",
  3: "== 1.0.0-rc.4",
  4: "== 1.x.x",
  5: "== 2.0.0-alpha.x",
  6: ">= 2.0.0-beta.1",
  7: ">= 4.0.0 <4.3.0",
  8: ">= 4.3.0"
};
W.REVISION_CHANGES = lo;
var En = "[object Object]";
function Jn(l, e, t) {
  this.helpers = l || {}, this.partials = e || {}, this.decorators = t || {}, qa.registerDefaultHelpers(this), Ka.registerDefaultDecorators(this);
}
Jn.prototype = {
  constructor: Jn,
  logger: rn.default,
  log: rn.default.log,
  registerHelper: function(e, t) {
    if (me.toString.call(e) === En) {
      if (t)
        throw new bn.default("Arg not supported with multiple helpers");
      me.extend(this.helpers, e);
    } else
      this.helpers[e] = t;
  },
  unregisterHelper: function(e) {
    delete this.helpers[e];
  },
  registerPartial: function(e, t) {
    if (me.toString.call(e) === En)
      me.extend(this.partials, e);
    else {
      if (typeof t > "u")
        throw new bn.default('Attempting to register a partial called "' + e + '" as undefined');
      this.partials[e] = t;
    }
  },
  unregisterPartial: function(e) {
    delete this.partials[e];
  },
  registerDecorator: function(e, t) {
    if (me.toString.call(e) === En) {
      if (t)
        throw new bn.default("Arg not supported with multiple decorators");
      me.extend(this.decorators, e);
    } else
      this.decorators[e] = t;
  },
  unregisterDecorator: function(e) {
    delete this.decorators[e];
  },
  /**
   * Reset the memory of illegal property accesses that have already been logged.
   * @deprecated should only be used in handlebars test-cases
   */
  resetLoggedPropertyAccesses: function() {
    Qa.resetLoggedProperties();
  }
};
var to = rn.default.log;
W.log = to;
W.createFrame = me.createFrame;
W.logger = rn.default;
var Qn = { exports: {} };
(function(l, e) {
  e.__esModule = !0;
  function t(s) {
    this.string = s;
  }
  t.prototype.toString = t.prototype.toHTML = function() {
    return "" + this.string;
  }, e.default = t, l.exports = e.default;
})(Qn, Qn.exports);
var ro = Qn.exports, ie = {}, ml = {};
ml.__esModule = !0;
ml.wrapHelper = ao;
function ao(l, e) {
  if (typeof l != "function")
    return l;
  var t = function() {
    var a = arguments[arguments.length - 1];
    return arguments[arguments.length - 1] = e(a), l.apply(this, arguments);
  };
  return t;
}
ie.__esModule = !0;
ie.checkRevision = mo;
ie.template = fo;
ie.wrapProgram = en;
ie.resolvePartial = yo;
ie.invokePartial = go;
ie.noop = Ot;
function oo(l) {
  return l && l.__esModule ? l : { default: l };
}
function uo(l) {
  if (l && l.__esModule)
    return l;
  var e = {};
  if (l != null)
    for (var t in l)
      Object.prototype.hasOwnProperty.call(l, t) && (e[t] = l[t]);
  return e.default = l, e;
}
var io = Y, ee = uo(io), so = ye, ne = oo(so), le = W, nt = Fe, co = ml, lt = Oe;
function mo(l) {
  var e = l && l[0] || 1, t = le.COMPILER_REVISION;
  if (!(e >= le.LAST_COMPATIBLE_COMPILER_REVISION && e <= le.COMPILER_REVISION))
    if (e < le.LAST_COMPATIBLE_COMPILER_REVISION) {
      var s = le.REVISION_CHANGES[t], a = le.REVISION_CHANGES[e];
      throw new ne.default("Template was precompiled with an older version of Handlebars than the current runtime. Please update your precompiler to a newer version (" + s + ") or downgrade your runtime to an older version (" + a + ").");
    } else
      throw new ne.default("Template was precompiled with a newer version of Handlebars than the current runtime. Please update your runtime to a newer version (" + l[1] + ").");
}
function fo(l, e) {
  if (!e)
    throw new ne.default("No environment passed to template");
  if (!l || !l.main)
    throw new ne.default("Unknown template object: " + typeof l);
  l.main.decorator = l.main_d, e.VM.checkRevision(l.compiler);
  var t = l.compiler && l.compiler[0] === 7;
  function s(o, r, u) {
    u.hash && (r = ee.extend({}, r, u.hash), u.ids && (u.ids[0] = !0)), o = e.VM.resolvePartial.call(this, o, r, u);
    var i = ee.extend({}, u, {
      hooks: this.hooks,
      protoAccessControl: this.protoAccessControl
    }), c = e.VM.invokePartial.call(this, o, r, i);
    if (c == null && e.compile && (u.partials[u.name] = e.compile(o, l.compilerOptions, e), c = u.partials[u.name](r, i)), c != null) {
      if (u.indent) {
        for (var f = c.split(`
`), m = 0, p = f.length; m < p && !(!f[m] && m + 1 === p); m++)
          f[m] = u.indent + f[m];
        c = f.join(`
`);
      }
      return c;
    } else
      throw new ne.default("The partial " + u.name + " could not be compiled when running in runtime-only mode");
  }
  var a = {
    strict: function(r, u, i) {
      if (!r || !(u in r))
        throw new ne.default('"' + u + '" not defined in ' + r, {
          loc: i
        });
      return a.lookupProperty(r, u);
    },
    lookupProperty: function(r, u) {
      var i = r[u];
      if (i == null || Object.prototype.hasOwnProperty.call(r, u) || lt.resultIsAllowed(i, a.protoAccessControl, u))
        return i;
    },
    lookup: function(r, u) {
      for (var i = r.length, c = 0; c < i; c++) {
        var f = r[c] && a.lookupProperty(r[c], u);
        if (f != null)
          return r[c][u];
      }
    },
    lambda: function(r, u) {
      return typeof r == "function" ? r.call(u) : r;
    },
    escapeExpression: ee.escapeExpression,
    invokePartial: s,
    fn: function(r) {
      var u = l[r];
      return u.decorator = l[r + "_d"], u;
    },
    programs: [],
    program: function(r, u, i, c, f) {
      var m = this.programs[r], p = this.fn(r);
      return u || f || c || i ? m = en(this, r, p, u, i, c, f) : m || (m = this.programs[r] = en(this, r, p)), m;
    },
    data: function(r, u) {
      for (; r && u--; )
        r = r._parent;
      return r;
    },
    mergeIfNeeded: function(r, u) {
      var i = r || u;
      return r && u && r !== u && (i = ee.extend({}, u, r)), i;
    },
    // An empty object to use as replacement for null-contexts
    nullContext: Object.seal({}),
    noop: e.VM.noop,
    compilerInfo: l.compiler
  };
  function n(o) {
    var r = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], u = r.data;
    n._setup(r), !r.partial && l.useData && (u = Po(o, u));
    var i = void 0, c = l.useBlockParams ? [] : void 0;
    l.useDepths && (r.depths ? i = o != r.depths[0] ? [o].concat(r.depths) : r.depths : i = [o]);
    function f(m) {
      return "" + l.main(a, m, a.helpers, a.partials, u, c, i);
    }
    return f = Ct(l.main, f, a, r.depths || [], u, c), f(o, r);
  }
  return n.isTop = !0, n._setup = function(o) {
    if (o.partial)
      a.protoAccessControl = o.protoAccessControl, a.helpers = o.helpers, a.partials = o.partials, a.decorators = o.decorators, a.hooks = o.hooks;
    else {
      var r = ee.extend({}, e.helpers, o.helpers);
      po(r, a), a.helpers = r, l.usePartial && (a.partials = a.mergeIfNeeded(o.partials, e.partials)), (l.usePartial || l.useDecorators) && (a.decorators = ee.extend({}, e.decorators, o.decorators)), a.hooks = {}, a.protoAccessControl = lt.createProtoAccessControl(o);
      var u = o.allowCallsToHelperMissing || t;
      nt.moveHelperToHooks(a, "helperMissing", u), nt.moveHelperToHooks(a, "blockHelperMissing", u);
    }
  }, n._child = function(o, r, u, i) {
    if (l.useBlockParams && !u)
      throw new ne.default("must pass block params");
    if (l.useDepths && !i)
      throw new ne.default("must pass parent depths");
    return en(a, o, l[o], r, 0, u, i);
  }, n;
}
function en(l, e, t, s, a, n, o) {
  function r(u) {
    var i = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1], c = o;
    return o && u != o[0] && !(u === l.nullContext && o[0] === null) && (c = [u].concat(o)), t(l, u, l.helpers, l.partials, i.data || s, n && [i.blockParams].concat(n), c);
  }
  return r = Ct(t, r, l, o, s, n), r.program = e, r.depth = o ? o.length : 0, r.blockParams = a || 0, r;
}
function yo(l, e, t) {
  return l ? !l.call && !t.name && (t.name = l, l = t.partials[l]) : t.name === "@partial-block" ? l = t.data["partial-block"] : l = t.partials[t.name], l;
}
function go(l, e, t) {
  var s = t.data && t.data["partial-block"];
  t.partial = !0, t.ids && (t.data.contextPath = t.ids[0] || t.data.contextPath);
  var a = void 0;
  if (t.fn && t.fn !== Ot && function() {
    t.data = le.createFrame(t.data);
    var n = t.fn;
    a = t.data["partial-block"] = function(r) {
      var u = arguments.length <= 1 || arguments[1] === void 0 ? {} : arguments[1];
      return u.data = le.createFrame(u.data), u.data["partial-block"] = s, n(r, u);
    }, n.partials && (t.partials = ee.extend({}, t.partials, n.partials));
  }(), l === void 0 && a && (l = a), l === void 0)
    throw new ne.default("The partial " + t.name + " could not be found");
  if (l instanceof Function)
    return l(e, t);
}
function Ot() {
  return "";
}
function Po(l, e) {
  return (!e || !("root" in e)) && (e = e ? le.createFrame(e) : {}, e.root = l), e;
}
function Ct(l, e, t, s, a, n) {
  if (l.decorator) {
    var o = {};
    e = l.decorator(e, o, t, s && s[0], a, n, s), ee.extend(e, o);
  }
  return e;
}
function po(l, e) {
  Object.keys(l).forEach(function(t) {
    var s = l[t];
    l[t] = ho(s, e);
  });
}
function ho(l, e) {
  var t = e.lookupProperty;
  return co.wrapHelper(l, function(s) {
    return ee.extend({ lookupProperty: t }, s);
  });
}
var Zn = { exports: {} };
(function(l, e) {
  e.__esModule = !0, e.default = function(t) {
    (function() {
      typeof globalThis != "object" && (Object.prototype.__defineGetter__("__magic__", function() {
        return this;
      }), __magic__.globalThis = __magic__, delete Object.prototype.__magic__);
    })();
    var s = globalThis.Handlebars;
    t.noConflict = function() {
      return globalThis.Handlebars === t && (globalThis.Handlebars = s), t;
    };
  }, l.exports = e.default;
})(Zn, Zn.exports);
var vo = Zn.exports;
(function(l, e) {
  e.__esModule = !0;
  function t(h) {
    return h && h.__esModule ? h : { default: h };
  }
  function s(h) {
    if (h && h.__esModule)
      return h;
    var A = {};
    if (h != null)
      for (var S in h)
        Object.prototype.hasOwnProperty.call(h, S) && (A[S] = h[S]);
    return A.default = h, A;
  }
  var a = W, n = s(a), o = ro, r = t(o), u = ye, i = t(u), c = Y, f = s(c), m = ie, p = s(m), w = vo, b = t(w);
  function O() {
    var h = new n.HandlebarsEnvironment();
    return f.extend(h, n), h.SafeString = r.default, h.Exception = i.default, h.Utils = f, h.escapeExpression = f.escapeExpression, h.VM = p, h.template = function(A) {
      return p.template(A, h);
    }, h;
  }
  var k = O();
  k.create = O, b.default(k), k.default = k, e.default = k, l.exports = e.default;
})($n, $n.exports);
var ko = $n.exports, So = ko.default;
const P = /* @__PURE__ */ wt(So), wo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
Still going strong at ` + l.escapeExpression(l.lambda((n = e != null ? o(e, "report") : e) != null ? o(n, "timestamp") : n, e)) + ` GMT\r
\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), Ro = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "accountingReportHead"), e, { name: "accountingReportHead", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "accountingTable"), e, { name: "accountingTable", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), Ao = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `<div style="page-break-before: always"></div>\r
` + ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(4, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "employerReportHeadV2"), e, { name: "employerReportHeadV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "employerCalculationTablesV2"), e, { name: "employerCalculationTablesV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
<h3>` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.moreInfoOnNextPage", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 4 }, end: { line: 8, column: 61 } } })) + `</h3>\r
\r
\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "employerReportHeadV2"), e, { name: "employerReportHeadV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
<h2 class="salaxy-content-subheader">` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.salaryAdditionalInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 37 }, end: { line: 17, column: 96 } } })) + `</h2>\r
<p>&nbsp;</p>\r
\r
` + ((n = l.invokePartial(o(s, "employerCalculationAdditionalInfoV2"), e, { name: "employerCalculationAdditionalInfoV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), bo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "employerReportHeadV2"), e, { name: "employerReportHeadV2", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + ((n = l.invokePartial(o(s, "employerCalculationTablesV2"), e, { name: "employerCalculationTablesV2", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Eo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "paymentReportHeadV2"), e, { name: "paymentReportHeadV2", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "paymentTablesV2"), e, { name: "paymentTablesV2", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Oo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "summaryReportHead"), e, { name: "summaryReportHead", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "summaryReportTable"), e, { name: "summaryReportTable", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), Co = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<h1>\r
  ` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.attorney", { name: "t", hash: {}, data: a, loc: { start: { line: 4, column: 2 }, end: { line: 4, column: 47 } } })) + `\r
</h1>\r
<br>\r
<div>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorizer", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 8 }, end: { line: 8, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.name", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 8 }, end: { line: 10, column: 56 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.personalId", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 8 }, end: { line: 11, column: 62 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "personalId") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.telephone", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 8 }, end: { line: 12, column: 61 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "telephone") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.email", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 8 }, end: { line: 13, column: 57 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "email") : n, e)) + `</li>\r
  </ul>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorized", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 8 }, end: { line: 15, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.palkkausfi", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 8 }, end: { line: 17, column: 55 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.companyId", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 8 }, end: { line: 18, column: 54 } } })) + `: 2554393-3</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.contactInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 8 }, end: { line: 19, column: 56 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.authorizedInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 22, column: 5 }, end: { line: 22, column: 63 } } })) + `</p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.employeeAndEmployer", { name: "t", hash: {}, data: a, loc: { start: { line: 24, column: 8 }, end: { line: 24, column: 70 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.taxAndIr", { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 8 }, end: { line: 25, column: 59 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.pensions", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 8 }, end: { line: 26, column: 59 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.insurances", { name: "t", hash: {}, data: a, loc: { start: { line: 27, column: 8 }, end: { line: 27, column: 61 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.employmentFund", { name: "t", hash: {}, data: a, loc: { start: { line: 28, column: 8 }, end: { line: 28, column: 65 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.unEmploymentFund", { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 8 }, end: { line: 29, column: 67 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.authorizationValid", { name: "t", hash: {}, data: a, loc: { start: { line: 32, column: 5 }, end: { line: 32, column: 67 } } })) + " " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "signedAt") : n, e)) + `</p><br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.palkkausSite", { name: "t", hash: {}, data: a, loc: { start: { line: 33, column: 5 }, end: { line: 33, column: 61 } } })) + " " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "signedAt") : n, e)) + `</p>\r
  <p>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</p>\r
</div>\r
\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), To = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<h1>\r
  ` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.attorney", { name: "t", hash: {}, data: a, loc: { start: { line: 4, column: 2 }, end: { line: 4, column: 47 } } })) + `\r
</h1>\r
<br>\r
<div>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorizer", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 8 }, end: { line: 8, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.name", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 8 }, end: { line: 10, column: 57 } } })) + ": " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "name") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.companyId", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 8 }, end: { line: 11, column: 54 } } })) + ": " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "officialId") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.email", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 8 }, end: { line: 12, column: 58 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "email") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.authorizerName", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 8 }, end: { line: 13, column: 67 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.authorizerPersonalId", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 8 }, end: { line: 14, column: 73 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "personalId") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.authorizerPhone", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 8 }, end: { line: 15, column: 68 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "telephone") : n, e)) + `</li>\r
  </ul>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorized", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 8 }, end: { line: 17, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.palkkausfi", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 8 }, end: { line: 19, column: 55 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.companyId", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 8 }, end: { line: 20, column: 54 } } })) + `: 2554393-3</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.contactInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 8 }, end: { line: 21, column: 56 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.authorizedInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 24, column: 5 }, end: { line: 24, column: 64 } } })) + `</p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.workers", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 8 }, end: { line: 26, column: 58 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.taxIr", { name: "t", hash: {}, data: a, loc: { start: { line: 27, column: 8 }, end: { line: 27, column: 56 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.pensions", { name: "t", hash: {}, data: a, loc: { start: { line: 28, column: 8 }, end: { line: 28, column: 59 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.insurances", { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 8 }, end: { line: 29, column: 61 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.employmentFund", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 8 }, end: { line: 30, column: 65 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.banksAndPaymentIntermediaries", { name: "t", hash: {}, data: a, loc: { start: { line: 31, column: 8 }, end: { line: 31, column: 80 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.workerUnions", { name: "t", hash: {}, data: a, loc: { start: { line: 32, column: 8 }, end: { line: 32, column: 63 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.authorizationValid", { name: "t", hash: {}, data: a, loc: { start: { line: 35, column: 5 }, end: { line: 35, column: 68 } } })) + " " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "signedAt") : n, e)) + `</p><br>\r
\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.company.palkkausService", { name: "t", hash: {}, data: a, loc: { start: { line: 37, column: 5 }, end: { line: 37, column: 65 } } })) + " " + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "signedAt") : n, e)) + `</p>\r
  <p>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</p>\r
</div>\r
\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), xo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<h1>\r
  ` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.attorney", { name: "t", hash: {}, data: a, loc: { start: { line: 4, column: 2 }, end: { line: 4, column: 47 } } })) + `\r
</h1>\r
<br>\r
<p>` + ((n = i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) != null ? n : "") + `</p>\r
<div>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorizer", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 8 }, end: { line: 9, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.name", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 8 }, end: { line: 11, column: 56 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.personalId", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 8 }, end: { line: 12, column: 62 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "personalId") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.telephone", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 8 }, end: { line: 13, column: 61 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "telephone") : n, e)) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.email", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 8 }, end: { line: 14, column: 57 } } })) + ": " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "email") : n, e)) + `</li>\r
  </ul>\r
  <p><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.authorized", { name: "t", hash: {}, data: a, loc: { start: { line: 16, column: 8 }, end: { line: 16, column: 55 } } })) + `</b></p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.palkkausfi", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 8 }, end: { line: 18, column: 55 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.companyId", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 8 }, end: { line: 19, column: 54 } } })) + `: 2554393-3</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.contactInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 8 }, end: { line: 20, column: 56 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.person.authorizedInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 23, column: 5 }, end: { line: 23, column: 63 } } })) + `</p>\r
  <ul>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.employeeAndEmployer", { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 8 }, end: { line: 25, column: 70 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.taxAndIr", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 8 }, end: { line: 26, column: 59 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.pensions", { name: "t", hash: {}, data: a, loc: { start: { line: 27, column: 8 }, end: { line: 27, column: 59 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.insurances", { name: "t", hash: {}, data: a, loc: { start: { line: 28, column: 8 }, end: { line: 28, column: 61 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.employmentFund", { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 8 }, end: { line: 29, column: 65 } } })) + `</li>\r
    <li>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.lists.unEmploymentFund", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 8 }, end: { line: 30, column: 67 } } })) + `</li>\r
  </ul>\r
  <br>\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.time", { name: "t", hash: {}, data: a, loc: { start: { line: 33, column: 5 }, end: { line: 33, column: 46 } } })) + ` </p>\r
  <br>\r
  ` + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "signedAt") : n, e)) + `\r
  <p>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.authorization.signature", { name: "t", hash: {}, data: a, loc: { start: { line: 36, column: 5 }, end: { line: 36, column: 51 } } })) + `</p>\r
  <br>\r
  <p>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "signer") : n) != null ? c(n, "name") : n, e)) + `</p>\r
</div>\r
\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Lo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "invoiceHead"), e, { name: "invoiceHead", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "invoiceTable"), e, { name: "invoiceTable", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), _o = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(8, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, 2: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "<h2>" + r(o((n = e != null ? u(e, "report") : e) != null ? u(n, "name") : n, e)) + " (" + r(o((n = e != null ? u(e, "report") : e) != null ? u(n, "officialId") : n, e)) + `)</h2>\r
` + ((n = u(t, "with").call(e ?? (l.nullContext || {}), (n = e != null ? u(e, "report") : e) != null ? u(n, "companyData") : n, { name: "with", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 4, column: 0 }, end: { line: 37, column: 9 } } })) != null ? n : "") + `\r
\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = l.escapeExpression, c = "function", f = l.lambda, m = l.lookupProperty || function(p, w) {
    if (Object.prototype.hasOwnProperty.call(p, w))
      return p[w];
  };
  return "<div>" + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.createdAt", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 5 }, end: { line: 5, column: 48 } } })) + ": " + i((o = (o = m(t, "createdAt") || (e != null ? m(e, "createdAt") : e)) != null ? o : u, typeof o === c ? o.call(r, { name: "createdAt", hash: {}, data: a, loc: { start: { line: 5, column: 50 }, end: { line: 5, column: 64 } } }) : o)) + `</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.principalActivity", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 5 }, end: { line: 6, column: 56 } } })) + ": " + i(f((n = e != null ? m(e, "info") : e) != null ? m(n, "principalActivityText") : n, e)) + " (" + i(f((n = e != null ? m(e, "info") : e) != null ? m(n, "principalActivity") : n, e)) + `)</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.companyType", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 5 }, end: { line: 7, column: 50 } } })) + ": " + i(f((n = e != null ? m(e, "info") : e) != null ? m(n, "companyTypeText") : n, e)) + " (" + i(f((n = e != null ? m(e, "info") : e) != null ? m(n, "companyType") : n, e)) + `)</div>\r
\r
<div><strong>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.contactInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 13 }, end: { line: 9, column: 58 } } })) + `</strong></div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "email") : n, e)) + `</div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "telephone") : n, e)) + `</div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "street") : n, e)) + `</div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "postalCode") : n, e)) + `</div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "city") : n, e)) + " " + ((n = m(t, "if").call(r, (n = e != null ? m(e, "contact") : e) != null ? m(n, "country") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 14, column: 22 }, end: { line: 14, column: 74 } } })) != null ? n : "") + " (" + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "country") : n, e)) + `)</div>\r
<div>` + i(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "countryOtherName") : n, e)) + `</div>\r
\r
<p>&nbsp;</p>\r
<h2>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.suomifiHeading", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 4 }, end: { line: 18, column: 52 } } })) + `</h2>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.socsec", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 5 }, end: { line: 19, column: 45 } } })) + ": " + i(f((n = e != null ? m(e, "authorization") : e) != null ? m(n, "personalId") : n, e)) + `</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.session", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 5 }, end: { line: 20, column: 46 } } })) + ": " + i(f((n = e != null ? m(e, "authorization") : e) != null ? m(n, "sessionId") : n, e)) + `</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.state", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 5 }, end: { line: 21, column: 44 } } })) + ": " + i(f((n = e != null ? m(e, "authorization") : e) != null ? m(n, "stateId") : n, e)) + `</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.roles", { name: "t", hash: {}, data: a, loc: { start: { line: 22, column: 5 }, end: { line: 22, column: 44 } } })) + ": " + i(f((n = e != null ? m(e, "authorization") : e) != null ? m(n, "roles") : n, e)) + `</div>\r
<div>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.time", { name: "t", hash: {}, data: a, loc: { start: { line: 23, column: 5 }, end: { line: 23, column: 43 } } })) + ": " + i(f((n = e != null ? m(e, "authorization") : e) != null ? m(n, "time") : n, e)) + `</div>\r
\r
<p>&nbsp;</p>\r
<h2>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.reporterAdmin", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 4 }, end: { line: 26, column: 51 } } })) + `</h2>\r
` + ((n = m(t, "with").call(r, (n = e != null ? m(e, "admin") : e) != null ? m(n, "0") : n, { name: "with", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 27, column: 0 }, end: { line: 29, column: 9 } } })) != null ? n : "") + `\r
<p>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.authorization.company.palkkausService", { name: "t", hash: {}, data: a, loc: { start: { line: 31, column: 3 }, end: { line: 31, column: 63 } } })) + " " + i((o = (o = m(t, "signedAt") || (e != null ? m(e, "signedAt") : e)) != null ? o : u, typeof o === c ? o.call(r, { name: "signedAt", hash: {}, data: a, loc: { start: { line: 31, column: 64 }, end: { line: 31, column: 76 } } }) : o)) + `</p>\r
<p>` + i(f((n = e != null ? m(e, "signer") : e) != null ? m(n, "name") : n, e)) + `</p>\r
\r
<p>&nbsp;</p>\r
<p>` + i((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.kycCompany.beneficialBeneficiariesNote", { name: "t", hash: {}, data: a, loc: { start: { line: 35, column: 3 }, end: { line: 35, column: 64 } } })) + `</p>\r
\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ", " + l.escapeExpression(l.lambda((n = e != null ? o(e, "contact") : e) != null ? o(n, "country") : n, e)) + " ";
}, 6: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "iamPerson"), e, { name: "iamPerson", data: a, indent: "  ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 8: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `\r
<h1>` + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, "SALAXY.REPORTS.kycCompany.beneficialBeneficiaries", { name: "t", hash: {}, data: a, loc: { start: { line: 44, column: 4 }, end: { line: 44, column: 61 } } })) + `</h1>\r
` + ((n = r(t, "each").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "companyData") : n) != null ? r(n, "ubo") : n, { name: "each", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 45, column: 0 }, end: { line: 48, column: 9 } } })) != null ? n : "") + `\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "iamPerson"), e, { name: "iamPerson", data: a, indent: "  ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `  <p>&nbsp;</p>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Do = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `        <PartyIdentificationId>\r
          <Authority>` + i((n = (n = c(t, "authority") || (e != null ? c(e, "authority") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "authority", hash: {}, data: a, loc: { start: { line: 21, column: 21 }, end: { line: 21, column: 34 } } }) : n)) + `</Authority>\r
          <Value>` + i((n = (n = c(t, "value") || (e != null ? c(e, "value") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "value", hash: {}, data: a, loc: { start: { line: 22, column: 17 }, end: { line: 22, column: 26 } } }) : n)) + `</Value>\r
        </PartyIdentificationId>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `        <DeliveryChannel>\r
          <DeliveryMethodCode>` + r((o = (o = u(t, "deliveryMethodCode") || (e != null ? u(e, "deliveryMethodCode") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "deliveryMethodCode", hash: {}, data: a, loc: { start: { line: 29, column: 30 }, end: { line: 29, column: 52 } } }) : o)) + `</DeliveryMethodCode>\r
          <DeliveryInfo>\r
            <BankCode>` + r(l.lambda((n = e != null ? u(e, "deliveryInfo") : e) != null ? u(n, "bankCode") : n, e)) + `</BankCode>\r
          </DeliveryInfo>\r
        </DeliveryChannel>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <StartDate>\r
          <Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "payPeriod") : n) != null ? i(n, "periodDates") : n) != null ? i(n, "startDate") : n) != null ? i(n, "label") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 54, column: 17 }, end: { line: 54, column: 71 } } })) + `</Label>\r
          <Date>` + u((i(t, "d") || e && i(e, "d") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "payPeriod") : n) != null ? i(n, "periodDates") : n) != null ? i(n, "startDate") : n) != null ? i(n, "date") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 55, column: 16 }, end: { line: 55, column: 69 } } })) + `</Date>\r
        </StartDate>\r
`;
}, 7: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <TermDate>\r
          <Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "payPeriod") : n) != null ? i(n, "periodDates") : n) != null ? i(n, "termDate") : n) != null ? i(n, "label") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 60, column: 17 }, end: { line: 60, column: 70 } } })) + `</Label>\r
          <Date>` + u((i(t, "d") || e && i(e, "d") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "payPeriod") : n) != null ? i(n, "periodDates") : n) != null ? i(n, "termDate") : n) != null ? i(n, "date") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 61, column: 16 }, end: { line: 61, column: 68 } } })) + `</Date>\r
        </TermDate>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `        <Telephone>\r
          <MobileNumber>` + l.escapeExpression((n = (n = o(t, "phoneNumber") || (e != null ? o(e, "phoneNumber") : e)) != null ? n : l.hooks.helperMissing, typeof n == "function" ? n.call(e ?? (l.nullContext || {}), { name: "phoneNumber", hash: {}, data: a, loc: { start: { line: 77, column: 24 }, end: { line: 77, column: 39 } } }) : n)) + `</MobileNumber>\r
        </Telephone>\r
`;
}, 11: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `      <EmploymentDate>\r
        <Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "employee") : n) != null ? i(n, "employmentDate") : n) != null ? i(n, "label") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 109, column: 15 }, end: { line: 109, column: 61 } } })) + `</Label>\r
        <Value>` + u((i(t, "d") || e && i(e, "d") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "employee") : n) != null ? i(n, "employmentDate") : n) != null ? i(n, "value") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 110, column: 15 }, end: { line: 110, column: 61 } } })) + `</Value>\r
      </EmploymentDate>\r
`;
}, 13: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), e != null ? u(e, "hasRows") : e, { name: "if", hash: {}, fn: l.program(14, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 134, column: 10 }, end: { line: 143, column: 17 } } })) != null ? r : "";
}, 14: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "each").call(e ?? (l.nullContext || {}), e != null ? u(e, "rows") : e, { name: "each", hash: {}, fn: l.program(15, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 135, column: 12 }, end: { line: 142, column: 21 } } })) != null ? r : "";
}, 15: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), o[1] != null ? u(o[1], "isTotals") : o[1], { name: "if", hash: {}, fn: l.program(16, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 136, column: 14 }, end: { line: 141, column: 21 } } })) != null ? r : "";
}, 16: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `                <Record>\r
                  <Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "message") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 138, column: 25 }, end: { line: 138, column: 50 } } })) + `</Label>\r
                  <Value>` + u((i(t, "r") || e && i(e, "r") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "total") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 139, column: 25 }, end: { line: 139, column: 48 } } })) + `</Value>\r
                </Record>\r
`;
}, 18: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <Record>\r
					<Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "calculationBases") : n) != null ? i(n, "taxationRates") : n) != null ? i(n, "recordLabels") : n) != null ? i(n, "taxPercent") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 150, column: 12 }, end: { line: 150, column: 83 } } })) + `</Label>\r
					<Value>` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "report") : n) != null ? i(n, "header") : n) != null ? i(n, "taxcardTaxPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 151, column: 12 }, end: { line: 151, column: 60 } } })) + `</Value>\r
				</Record>\r
`;
}, 20: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <Record>\r
					<Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "calculationBases") : n) != null ? i(n, "taxationRates") : n) != null ? i(n, "recordLabels") : n) != null ? i(n, "taxPercent2") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 156, column: 12 }, end: { line: 156, column: 84 } } })) + `</Label>\r
					<Value>` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "report") : n) != null ? i(n, "header") : n) != null ? i(n, "taxcardTaxPercent2") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 157, column: 12 }, end: { line: 157, column: 61 } } })) + `</Value>\r
				</Record>\r
`;
}, 22: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <Record>\r
					<Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "calculationBases") : n) != null ? i(n, "incomeLimitLabel") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 162, column: 12 }, end: { line: 162, column: 62 } } })) + `</Label>\r
					<Value>` + u((i(t, "r") || e && i(e, "r") || r).call(o, (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "calculationBases") : n) != null ? i(n, "incomeLimit") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 163, column: 12 }, end: { line: 163, column: 57 } } })) + `</Value>\r
				</Record>\r
`;
}, 24: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `        <Record>\r
					<Label>` + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? r(e, "eSalaryHbs") : e) != null ? r(n, "calculationBases") : n) != null ? r(n, "taxcardValidityLabel") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 168, column: 12 }, end: { line: 168, column: 66 } } })) + `</Label>\r
					<Value>` + o(l.lambda((n = (n = e != null ? r(e, "eSalaryHbs") : e) != null ? r(n, "calculationBases") : n) != null ? r(n, "taxcardValidity") : n, e)) + `</Value>\r
				</Record>\r
`;
}, 26: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), e != null ? u(e, "hasRows") : e, { name: "if", hash: {}, fn: l.program(27, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 185, column: 10 }, end: { line: 237, column: 17 } } })) != null ? r : "";
}, 27: function(l, e, t, s, a, n, o) {
  var r, u = e ?? (l.nullContext || {}), i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return ((r = i(t, "each").call(u, e != null ? i(e, "rows") : e, { name: "each", hash: {}, fn: l.program(28, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 186, column: 12 }, end: { line: 222, column: 21 } } })) != null ? r : "") + ((r = i(t, "if").call(u, e != null ? i(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(49, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 223, column: 12 }, end: { line: 236, column: 19 } } })) != null ? r : "");
}, 28: function(l, e, t, s, a, n, o) {
  var r, u = e ?? (l.nullContext || {}), i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return ((r = i(t, "unless").call(u, o[1] != null ? i(o[1], "isTotals") : o[1], { name: "unless", hash: {}, fn: l.program(29, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 187, column: 14 }, end: { line: 216, column: 25 } } })) != null ? r : "") + ((r = i(t, "if").call(u, (r = e != null ? i(e, "data") : e) != null ? i(r, "comment") : r, { name: "if", hash: {}, fn: l.program(47, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 217, column: 14 }, end: { line: 221, column: 21 } } })) != null ? r : "");
}, 29: function(l, e, t, s, a, n, o) {
  var r, u = e ?? (l.nullContext || {}), i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `                <DetailLine>\r
                  <Description>` + l.escapeExpression((i(t, "t") || e && i(e, "t") || l.hooks.helperMissing).call(u, (r = (r = e != null ? i(e, "data") : e) != null ? i(r, "irRow") : r) != null ? i(r, "message") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 189, column: 31 }, end: { line: 189, column: 56 } } })) + `</Description>\r
` + ((r = i(t, "if").call(u, o[1] != null ? i(o[1], "isDeductions") : o[1], { name: "if", hash: {}, fn: l.program(30, a, 0, n, o), inverse: l.program(35, a, 0, n, o), data: a, loc: { start: { line: 190, column: 18 }, end: { line: 208, column: 25 } } })) != null ? r : "") + ((r = i(t, "if").call(u, (r = e != null ? i(e, "data") : e) != null ? i(r, "isTotalReduced") : r, { name: "if", hash: {}, fn: l.program(43, a, 0, n, o), inverse: l.program(45, a, 0, n, o), data: a, loc: { start: { line: 209, column: 18 }, end: { line: 214, column: 25 } } })) != null ? r : "") + `                </DetailLine>\r
`;
}, 30: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "isUnitPercent") : n, { name: "if", hash: {}, fn: l.program(31, a, 0), inverse: l.program(33, a, 0), data: a, loc: { start: { line: 191, column: 20 }, end: { line: 197, column: 27 } } })) != null ? n : "";
}, 31: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return "                    <Value>" + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "count") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 192, column: 27 }, end: { line: 192, column: 50 } } })) + `</Value>\r
                    <Value>` + u((i(t, "r") || e && i(e, "r") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "price") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 193, column: 27 }, end: { line: 193, column: 50 } } })) + `</Value>\r
`;
}, 33: function(l, e, t, s, a) {
  return `                      <Value></Value>\r
                      <Value></Value>\r
`;
}, 35: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), o[1] != null ? u(o[1], "isTotals") : o[1], { name: "if", hash: {}, fn: l.program(36, a, 0, n, o), inverse: l.program(38, a, 0, n, o), data: a, loc: { start: { line: 198, column: 18 }, end: { line: 208, column: 18 } } })) != null ? r : "";
}, 36: function(l, e, t, s, a) {
  return `                    <Value></Value>\r
                    <Value></Value>\r
`;
}, 38: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return ((n = r(t, "if").call(o, (n = e != null ? r(e, "data") : e) != null ? r(n, "isUnitPercent") : n, { name: "if", hash: {}, fn: l.program(39, a, 0), inverse: l.program(41, a, 0), data: a, loc: { start: { line: 202, column: 20 }, end: { line: 206, column: 27 } } })) != null ? n : "") + "                      <Value>" + l.escapeExpression((r(t, "r") || e && r(e, "r") || l.hooks.helperMissing).call(o, (n = (n = e != null ? r(e, "data") : e) != null ? r(n, "irRow") : n) != null ? r(n, "price") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 207, column: 29 }, end: { line: 207, column: 51 } } })) + `</Value>\r
                  `;
}, 39: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                      <Description>" + l.escapeExpression((o(t, "p") || e && o(e, "p") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "p", hash: { nullChar: " " }, data: a, loc: { start: { line: 203, column: 35 }, end: { line: 203, column: 70 } } })) + `</Description>\r
`;
}, 41: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                      <Value>" + l.escapeExpression((o(t, "r") || e && o(e, "r") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 205, column: 29 }, end: { line: 205, column: 60 } } })) + `</Value>\r
`;
}, 43: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return "                    <Value>" + u((i(t, "r") || e && i(e, "r") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "fullTotal") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 210, column: 27 }, end: { line: 210, column: 48 } } })) + `</Value>\r
                    <Amount>` + u((i(t, "r") || e && i(e, "r") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "total") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 211, column: 28 }, end: { line: 211, column: 51 } } })) + `</Amount>\r
`;
}, 45: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                    <Amount>" + l.escapeExpression((o(t, "r") || e && o(e, "r") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "total") : n, { name: "r", hash: {}, data: a, loc: { start: { line: 213, column: 28 }, end: { line: 213, column: 51 } } })) + `</Amount>\r
`;
}, 47: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `                <DetailLine>\r
                  <Description>&#160;` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "comment") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 219, column: 37 }, end: { line: 219, column: 55 } } })) + `</Description>\r
                </DetailLine>\r
`;
}, 49: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `              <DetailLine>\r
                <Description></Description>\r
                <Value></Value>\r
                <Value></Value>\r
                <Amount></Amount>\r
              </DetailLine>\r
              <DetailLine>\r
                <Description></Description>\r
                <Value></Value>\r
                <Value>` + r((u(t, "u") || e && u(e, "u") || o).call(n, (u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.toBePaid", { name: "t", hash: {}, data: a, loc: { start: { line: 233, column: 27 }, end: { line: 233, column: 71 } } }), { name: "u", hash: {}, data: a, loc: { start: { line: 233, column: 23 }, end: { line: 233, column: 74 } } })) + `</Value>\r
                <Amount>` + r((u(t, "r") || e && u(e, "r") || o).call(n, e != null ? u(e, "total") : e, { name: "r", hash: {}, data: a, loc: { start: { line: 234, column: 24 }, end: { line: 234, column: 36 } } })) + `</Amount>\r
              </DetailLine>\r
`;
}, 51: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `    <EarningsToDate>\r
      <Heading>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "cumulative") : n) != null ? i(n, "heading") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 243, column: 15 }, end: { line: 243, column: 50 } } })) + `</Heading>\r
      <Set>\r
        <SetHeading>\r
					<Heading/>\r
				</SetHeading>\r
        <Line>\r
					<LineHeading>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "cumulative") : n) != null ? i(n, "current") : n) != null ? i(n, "heading") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 249, column: 18 }, end: { line: 249, column: 61 } } })) + `</LineHeading>\r
` + ((n = i(t, "each").call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "cumulative") : n) != null ? i(n, "current") : n) != null ? i(n, "data") : n, { name: "each", hash: {}, fn: l.program(52, a, 0), inverse: l.noop, data: a, loc: { start: { line: 250, column: 10 }, end: { line: 255, column: 19 } } })) != null ? n : "") + `        </Line>\r
        <Line>\r
					<LineHeading>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "cumulative") : n) != null ? i(n, "previous") : n) != null ? i(n, "heading") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 258, column: 18 }, end: { line: 258, column: 62 } } })) + `</LineHeading>\r
` + ((n = i(t, "each").call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "cumulative") : n) != null ? i(n, "previous") : n) != null ? i(n, "data") : n, { name: "each", hash: {}, fn: l.program(52, a, 0), inverse: l.noop, data: a, loc: { start: { line: 259, column: 10 }, end: { line: 264, column: 19 } } })) != null ? n : "") + `        </Line>\r
      </Set>\r
    </EarningsToDate>\r
`;
}, 52: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <Cell>\r
              <Label>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "label") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 252, column: 21 }, end: { line: 252, column: 32 } } })) + `</Label>\r
              <Value>` + r((u(t, "r") || e && u(e, "r") || o).call(n, e != null ? u(e, "value") : e, { name: "r", hash: {}, data: a, loc: { start: { line: 253, column: 21 }, end: { line: 253, column: 32 } } })) + `</Value>\r
            </Cell>\r
`;
}, 54: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `        <Permanent>\r
          <Label>` + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = (n = e != null ? r(e, "eSalaryHbs") : e) != null ? r(n, "messages") : n) != null ? r(n, "salarySlipMessage") : n) != null ? r(n, "label") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 273, column: 17 }, end: { line: 273, column: 67 } } })) + `</Label>\r
          <Value>` + o(l.lambda((n = (n = (n = e != null ? r(e, "eSalaryHbs") : e) != null ? r(n, "messages") : n) != null ? r(n, "salarySlipMessage") : n) != null ? r(n, "message") : n, e)) + `</Value>\r
        </Permanent>\r
`;
}, 56: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `      <Permanent>\r
        <Label>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "heading") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 279, column: 15 }, end: { line: 279, column: 29 } } })) + `</Label>\r
        <Value>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "text") : e, e != null ? u(e, "parameters") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 280, column: 15 }, end: { line: 280, column: 37 } } })) + `</Value>\r
      </Permanent>\r
`;
}, 58: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `      <Transient>\r
        <Label>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = (n = e != null ? i(e, "eSalaryHbs") : e) != null ? i(n, "messages") : n) != null ? i(n, "transient") : n) != null ? i(n, "heading") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 285, column: 15 }, end: { line: 285, column: 58 } } })) + `</Label>\r
        <Value>` + u((i(t, "t") || e && i(e, "t") || r).call(o, e != null ? i(e, "text") : e, e != null ? i(e, "parameters") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 286, column: 15 }, end: { line: 286, column: 37 } } })) + `</Value>\r
      </Transient>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a, n, o) {
  var r, u = l.lambda, i = l.escapeExpression, c = e ?? (l.nullContext || {}), f = l.hooks.helperMissing, m = l.lookupProperty || function(p, w) {
    if (Object.prototype.hasOwnProperty.call(p, w))
      return p[w];
  };
  return `<?xml version="1.0" encoding="ISO-8859-15"?>\r
<?xml-stylesheet type="text/xsl" href="PayslipCommon20.xsl"?>\r
<Payslips>\r
  <Payslip>\r
    <Version>` + i(u((r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "version") : r, e)) + `</Version>\r
    <HeaderData>\r
      <MessageId>` + i(u((r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "messageId") : r, e)) + `</MessageId>\r
      <Timestamp>` + i((m(t, "d") || e && m(e, "d") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "timestamp") : r, { name: "d", hash: { format: "YYYY-MM-DD[T]HH:mm:ss" }, data: a, loc: { start: { line: 8, column: 17 }, end: { line: 8, column: 85 } } })) + `</Timestamp>\r
      <DocumentTitle>\r
        <Value>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "documentTitle") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 15 }, end: { line: 10, column: 56 } } })) + `</Value>\r
      </DocumentTitle>\r
      <PayDate>` + i(u((r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "payDate") : r, e)) + `</PayDate>\r
      <NetPayment>\r
        <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "netPayment") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 15 }, end: { line: 14, column: 59 } } })) + `</Label>\r
        <Value>` + i((m(t, "r") || e && m(e, "r") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "netPayment") : r) != null ? m(r, "value") : r, { name: "r", hash: {}, data: a, loc: { start: { line: 15, column: 15 }, end: { line: 15, column: 59 } } })) + `</Value>\r
      </NetPayment>\r
      <Payer>` + i(u((r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "payer") : r, e)) + `</Payer>\r
      <PartyIdentifications>\r
` + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "partyIdentifications") : r, { name: "each", hash: {}, fn: l.program(1, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 19, column: 8 }, end: { line: 24, column: 17 } } })) != null ? r : "") + `      </PartyIdentifications>\r
      <DeliveryChannels>\r
` + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "headerData") : r) != null ? m(r, "deliveryChannels") : r, { name: "each", hash: {}, fn: l.program(3, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 27, column: 8 }, end: { line: 34, column: 17 } } })) != null ? r : "") + `      </DeliveryChannels>\r
      <Attachments>\r
				<Attachment>\r
					<AttachmentIndex>1</AttachmentIndex>\r
					<FileType>pdf</FileType>\r
					<Filename>salarySlip.pdf</Filename>\r
				</Attachment>\r
			</Attachments>\r
    </HeaderData>\r
    <PayPeriod>\r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 45, column: 15 }, end: { line: 45, column: 49 } } })) + `</Heading>\r
      <DateOfPayment>\r
        <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "dateOfPayment") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 47, column: 15 }, end: { line: 47, column: 61 } } })) + `</Label>\r
        <Date>` + i((m(t, "d") || e && m(e, "d") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "dateOfPayment") : r) != null ? m(r, "date") : r, { name: "d", hash: {}, data: a, loc: { start: { line: 48, column: 14 }, end: { line: 48, column: 59 } } })) + `</Date>\r
      </DateOfPayment> \r
      <PeriodDates>\r
        <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "periodDates") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 51, column: 15 }, end: { line: 51, column: 59 } } })) + `</Label>\r
` + ((r = m(t, "if").call(c, (r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "periodDates") : r) != null ? m(r, "startDate") : r) != null ? m(r, "date") : r, { name: "if", hash: {}, fn: l.program(5, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 52, column: 8 }, end: { line: 57, column: 15 } } })) != null ? r : "") + ((r = m(t, "if").call(c, (r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payPeriod") : r) != null ? m(r, "periodDates") : r) != null ? m(r, "termDate") : r) != null ? m(r, "date") : r, { name: "if", hash: {}, fn: l.program(7, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 58, column: 8 }, end: { line: 63, column: 15 } } })) != null ? r : "") + `      </PeriodDates>\r
    </PayPeriod>\r
    <Delivery>\r
      <Sender>\r
        <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 68, column: 17 }, end: { line: 68, column: 57 } } })) + `</Heading>\r
        <Name>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "name") : r, e)) + `</Name>\r
        <AddressLine>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "addressLine") : r, e)) + `</AddressLine>\r
        <PostalCode>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "postalCode") : r, e)) + `</PostalCode>\r
        <PostOffice>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "postOffice") : r, e)) + `</PostOffice>\r
        <CountryCode>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "countryCode") : r, e)) + `</CountryCode>\r
        <Country>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "country") : r, e)) + `</Country>\r
` + ((r = m(t, "each").call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "sender") : r) != null ? m(r, "telephone") : r, { name: "each", hash: {}, fn: l.program(9, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 75, column: 8 }, end: { line: 79, column: 17 } } })) != null ? r : "") + `        <EmailAddress />\r
      </Sender>\r
      <Recipient>\r
        <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 83, column: 17 }, end: { line: 83, column: 60 } } })) + `</Heading>\r
        <RecipientName>\r
          <ForeName>` + i(u((r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "recipientName") : r) != null ? m(r, "foreName") : r, e)) + `</ForeName>\r
          <SurName>` + i(u((r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "recipientName") : r) != null ? m(r, "surName") : r, e)) + `</SurName>\r
        </RecipientName>\r
        <AddressLine>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "addressLine") : r, e)) + `</AddressLine>\r
        <PostalCode>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "postalCode") : r, e)) + `</PostalCode>\r
        <PostOffice>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "postOffice") : r, e)) + `</PostOffice>\r
        <CountryCode>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "countryCode") : r, e)) + `</CountryCode>\r
        <Country>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "delivery") : r) != null ? m(r, "recipient") : r) != null ? m(r, "country") : r, e)) + `</Country>\r
      </Recipient>\r
    </Delivery>\r
    <Employee>\r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 96, column: 15 }, end: { line: 96, column: 48 } } })) + `</Heading>\r
      <Identity>\r
        <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "identity") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 98, column: 15 }, end: { line: 98, column: 55 } } })) + `</Label>\r
        <EmployeeIdentity>\r
          <PersonID>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "identity") : r) != null ? m(r, "item") : r, e)) + `</PersonID>\r
        </EmployeeIdentity>\r
      </Identity>\r
      <EmployeeName>\r
        <ForeName>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "employeeName") : r) != null ? m(r, "foreName") : r, e)) + `</ForeName>\r
        <SurName>` + i(u((r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "employeeName") : r) != null ? m(r, "surName") : r, e)) + `</SurName>\r
      </EmployeeName>\r
` + ((r = m(t, "if").call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "employmentDate") : r) != null ? m(r, "value") : r, { name: "if", hash: {}, fn: l.program(11, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 107, column: 6 }, end: { line: 112, column: 13 } } })) != null ? r : "") + `      <Classification>\r
        <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "classification") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 114, column: 17 }, end: { line: 114, column: 65 } } })) + `</Heading>\r
        <JobTitle>\r
          <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "classification") : r) != null ? m(r, "jobTitle") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 116, column: 17 }, end: { line: 116, column: 72 } } })) + `</Label>\r
          <Value>` + i(u((r = (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "employee") : r) != null ? m(r, "classification") : r) != null ? m(r, "jobTitle") : r) != null ? m(r, "value") : r, e)) + `</Value>\r
        </JobTitle>\r
      </Classification>\r
    </Employee>\r
    <BankAccount>\r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "bankAccount") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 122, column: 15 }, end: { line: 122, column: 51 } } })) + `</Heading>\r
      <AccountCode>\r
        <Label>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "bankAccount") : r) != null ? m(r, "label") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 124, column: 15 }, end: { line: 124, column: 49 } } })) + `</Label>\r
        <Value Type="IBAN">` + i(u((r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "bankAccount") : r) != null ? m(r, "value") : r, e)) + `</Value>\r
        <BIC>` + i(u((r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "bankAccount") : r) != null ? m(r, "bic") : r, e)) + `</BIC>\r
      </AccountCode>\r
    </BankAccount>\r
    <CalculationBases>      \r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "calculationBases") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 130, column: 15 }, end: { line: 130, column: 56 } } })) + `</Heading>\r
      <SalaryRates>\r
				<Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "calculationBases") : r) != null ? m(r, "salaryRates") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 132, column: 13 }, end: { line: 132, column: 66 } } })) + `</Heading>\r
` + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "rowGroups") : r, { name: "each", hash: {}, fn: l.program(13, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 133, column: 8 }, end: { line: 144, column: 17 } } })) != null ? r : "") + `			</SalaryRates>\r
      <TaxationRates>\r
        <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "calculationBases") : r) != null ? m(r, "taxationRates") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 147, column: 17 }, end: { line: 147, column: 72 } } })) + `</Heading>\r
` + ((r = m(t, "if").call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "header") : r) != null ? m(r, "taxcardTaxPercent") : r, { name: "if", hash: {}, fn: l.program(18, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 148, column: 8 }, end: { line: 153, column: 15 } } })) != null ? r : "") + ((r = m(t, "if").call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "header") : r) != null ? m(r, "taxcardTaxPercent2") : r, { name: "if", hash: {}, fn: l.program(20, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 154, column: 8 }, end: { line: 159, column: 15 } } })) != null ? r : "") + ((r = m(t, "if").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "calculationBases") : r) != null ? m(r, "incomeLimit") : r, { name: "if", hash: {}, fn: l.program(22, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 160, column: 8 }, end: { line: 165, column: 15 } } })) != null ? r : "") + ((r = m(t, "if").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "calculationBases") : r) != null ? m(r, "taxcardValidity") : r, { name: "if", hash: {}, fn: l.program(24, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 166, column: 8 }, end: { line: 171, column: 15 } } })) != null ? r : "") + `      </TaxationRates>\r
    </CalculationBases>\r
    <PayDetails>\r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "payDetails") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 175, column: 15 }, end: { line: 175, column: 50 } } })) + `</Heading>\r
      <Heading />\r
      <DetailLines>\r
        <HeadingLine>\r
          <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, "SALAXY.REPORTS.salary.heading.description", { name: "t", hash: {}, data: a, loc: { start: { line: 179, column: 19 }, end: { line: 179, column: 69 } } })) + `</Heading>             \r
          <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, "SALAXY.REPORTS.salary.heading.amount", { name: "t", hash: {}, data: a, loc: { start: { line: 180, column: 19 }, end: { line: 180, column: 64 } } })) + `</Heading>\r
          <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, "SALAXY.REPORTS.salary.heading.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 181, column: 19 }, end: { line: 181, column: 64 } } })) + `</Heading>\r
          <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 182, column: 19 }, end: { line: 182, column: 63 } } })) + `</Heading>             \r
        </HeadingLine>\r
` + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "rowGroups") : r, { name: "each", hash: {}, fn: l.program(26, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 184, column: 8 }, end: { line: 238, column: 17 } } })) != null ? r : "") + `      </DetailLines>\r
    </PayDetails>\r
` + ((r = m(t, "if").call(c, (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "cumulative") : r, { name: "if", hash: {}, fn: l.program(51, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 241, column: 4 }, end: { line: 268, column: 11 } } })) != null ? r : "") + `    <Messages>\r
      <Heading>` + i((m(t, "t") || e && m(e, "t") || f).call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "messages") : r) != null ? m(r, "heading") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 270, column: 15 }, end: { line: 270, column: 48 } } })) + `</Heading>\r
` + ((r = m(t, "if").call(c, (r = (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "messages") : r) != null ? m(r, "salarySlipMessage") : r) != null ? m(r, "message") : r, { name: "if", hash: {}, fn: l.program(54, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 271, column: 6 }, end: { line: 276, column: 13 } } })) != null ? r : "") + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "notes") : r, { name: "each", hash: {}, fn: l.program(56, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 277, column: 6 }, end: { line: 282, column: 15 } } })) != null ? r : "") + ((r = m(t, "each").call(c, (r = (r = e != null ? m(e, "eSalaryHbs") : e) != null ? m(r, "report") : r) != null ? m(r, "validationMessages") : r, { name: "each", hash: {}, fn: l.program(58, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 283, column: 6 }, end: { line: 288, column: 15 } } })) != null ? r : "") + `    </Messages>\r
  </Payslip>\r
</Payslips>`;
}, useData: !0, useDepths: !0 }), Mo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `  <style>\r
    tbody {\r
      page-break-inside: avoid;\r
    }\r
  </style>\r
    <table class="table">\r
      <thead>\r
        <tr>\r
          <th>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoiceList.receiverAndType", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 14 }, end: { line: 11, column: 64 } } })) + `</th>\r
          <th class="left"></th>\r
          <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoiceList.sum", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 28 }, end: { line: 13, column: 66 } } })) + `</th>\r
          <th></th>\r
        </tr>\r
      </thead>\r
` + ((n = i(t, "each").call(o, e != null ? i(e, "report") : e, { name: "each", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 17, column: 6 }, end: { line: 85, column: 15 } } })) != null ? n : "") + `    </table>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = "function", c = l.escapeExpression, f = l.lookupProperty || function(m, p) {
    if (Object.prototype.hasOwnProperty.call(m, p))
      return m[p];
  };
  return `        <tbody>\r
          <tr>\r
            <td colspan="4" style="background-color: #DDD;">\r
              <h1>` + c((o = (o = f(t, "heading") || (e != null ? f(e, "heading") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "heading", hash: {}, data: a, loc: { start: { line: 21, column: 18 }, end: { line: 21, column: 29 } } }) : o)) + `</h1>\r
            </td>\r
          </tr>\r
          <tr>\r
` + ((n = f(t, "if").call(r, e != null ? f(e, "qrCodeAvailable") : e, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 25, column: 12 }, end: { line: 31, column: 19 } } })) != null ? n : "") + ((n = f(t, "if").call(r, e != null ? f(e, "qrCodeUnavailable") : e, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 32, column: 12 }, end: { line: 40, column: 19 } } })) != null ? n : "") + ((n = f(t, "if").call(r, e != null ? f(e, "isPaid") : e, { name: "if", hash: {}, fn: l.program(8, a, 0), inverse: l.noop, data: a, loc: { start: { line: 41, column: 12 }, end: { line: 50, column: 19 } } })) != null ? n : "") + ((n = f(t, "if").call(r, e != null ? f(e, "isCanceled") : e, { name: "if", hash: {}, fn: l.program(10, a, 0), inverse: l.noop, data: a, loc: { start: { line: 51, column: 12 }, end: { line: 60, column: 19 } } })) != null ? n : "") + `            <td>\r
              <span class="left">` + c((f(t, "t") || e && f(e, "t") || u).call(r, "SALAXY.REPORTS.invoiceList.iban", { name: "t", hash: {}, data: a, loc: { start: { line: 62, column: 33 }, end: { line: 62, column: 72 } } })) + ": " + c((o = (o = f(t, "iban") || (e != null ? f(e, "iban") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "iban", hash: {}, data: a, loc: { start: { line: 62, column: 74 }, end: { line: 62, column: 82 } } }) : o)) + `</span> <br/>\r
              <span class="left">` + c((f(t, "t") || e && f(e, "t") || u).call(r, "SALAXY.REPORTS.invoiceList.name", { name: "t", hash: {}, data: a, loc: { start: { line: 63, column: 33 }, end: { line: 63, column: 72 } } })) + ": " + c((o = (o = f(t, "nameOfReceiver") || (e != null ? f(e, "nameOfReceiver") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "nameOfReceiver", hash: {}, data: a, loc: { start: { line: 63, column: 74 }, end: { line: 63, column: 92 } } }) : o)) + `</span> <br/>\r
              <span class="left">` + c((f(t, "t") || e && f(e, "t") || u).call(r, "SALAXY.REPORTS.invoiceList.dueDate", { name: "t", hash: {}, data: a, loc: { start: { line: 64, column: 33 }, end: { line: 64, column: 75 } } })) + ": " + c((f(t, "d") || e && f(e, "d") || u).call(r, e != null ? f(e, "dueDate") : e, { name: "d", hash: {}, data: a, loc: { start: { line: 64, column: 77 }, end: { line: 64, column: 90 } } })) + `</span> <br/>\r
              <span class="left">` + c((o = (o = f(t, "referenceOrMessageLabel") || (e != null ? f(e, "referenceOrMessageLabel") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "referenceOrMessageLabel", hash: {}, data: a, loc: { start: { line: 65, column: 33 }, end: { line: 65, column: 60 } } }) : o)) + ": " + c((o = (o = f(t, "referenceOrMessageValue") || (e != null ? f(e, "referenceOrMessageValue") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "referenceOrMessageValue", hash: {}, data: a, loc: { start: { line: 65, column: 62 }, end: { line: 65, column: 89 } } }) : o)) + `</span> <br/>\r
             \r
            </td>\r
` + ((n = f(t, "if").call(r, e != null ? f(e, "isTotalPaid") : e, { name: "if", hash: {}, fn: l.program(12, a, 0), inverse: l.program(14, a, 0), data: a, loc: { start: { line: 68, column: 12 }, end: { line: 76, column: 19 } } })) != null ? n : "") + `            <td></td>\r
          </tr>\r
          <tr>\r
            <td colspan="4">\r
              ` + c((f(t, "t") || e && f(e, "t") || u).call(r, "SALAXY.REPORTS.invoiceList.virtualBarcode", { name: "t", hash: {}, data: a, loc: { start: { line: 81, column: 14 }, end: { line: 81, column: 63 } } })) + ": " + c((o = (o = f(t, "barcode") || (e != null ? f(e, "barcode") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "barcode", hash: {}, data: a, loc: { start: { line: 81, column: 65 }, end: { line: 81, column: 78 } } }) : o)) + `\r
            </td>\r
          </tr>\r
        </tbody>\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `              <td>\r
                <div style="width:50mm">\r
                  ` + ((n = (o = (o = r(t, "qrCodeSvg") || (e != null ? r(e, "qrCodeSvg") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "qrCodeSvg", hash: {}, data: a, loc: { start: { line: 28, column: 18 }, end: { line: 28, column: 33 } } }) : o)) != null ? n : "") + `\r
                </div>\r
              </td>\r
`;
}, 6: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return `              <td style="vertical-align: middle; text-align: center; height: 160px;">\r
                <div style="height: 50mm; width: 50mm; display: flex; justify-content: center; align-items: center; background-color: #e9d310; border: 10px solid white;">\r
                  <div>\r
                    <small>` + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.invoiceList.qrCodeNotAvailable", { name: "t", hash: {}, data: a, loc: { start: { line: 36, column: 27 }, end: { line: 36, column: 80 } } })) + `</small>\r
                  </div>\r
                </div>\r
              </td>\r
`;
}, 8: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `              <td style="vertical-align: middle; text-align: center; height: 160px;">\r
                <div style="height: 50mm; width: 50mm; display: flex; align-items: center; justify-content: center; font-size: 1.5em; background-color: #289548; border: 10px solid white;">\r
                  <b>\r
                    ` + i((n = (n = c(t, "statusText") || (e != null ? c(e, "statusText") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "statusText", hash: {}, data: a, loc: { start: { line: 45, column: 20 }, end: { line: 45, column: 34 } } }) : n)) + ` <br/>\r
                    ` + i((n = (n = c(t, "displayDate") || (e != null ? c(e, "displayDate") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "displayDate", hash: {}, data: a, loc: { start: { line: 46, column: 20 }, end: { line: 46, column: 35 } } }) : n)) + `\r
                  </b>\r
                </div>\r
              </td>\r
`;
}, 10: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `            <td style="vertical-align: middle; text-align: center; height: 160px;">\r
              <div style="height: 50mm; width: 50mm; display: flex;align-items: center;justify-content: center; font-size: 1.5em; background-color: #d55552; border: 10px solid white;">\r
                <b>\r
                  ` + i((n = (n = c(t, "statusText") || (e != null ? c(e, "statusText") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "statusText", hash: {}, data: a, loc: { start: { line: 55, column: 18 }, end: { line: 55, column: 32 } } }) : n)) + ` <br/>\r
                  ` + i((n = (n = c(t, "displayDate") || (e != null ? c(e, "displayDate") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "displayDate", hash: {}, data: a, loc: { start: { line: 56, column: 18 }, end: { line: 56, column: 33 } } }) : n)) + `\r
                </b>\r
              </div>\r
            </td> \r
`;
}, 12: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `              <td class="right">\r
                <span style="text-decoration: line-through;">` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.invoiceList.sum", { name: "t", hash: {}, data: a, loc: { start: { line: 70, column: 61 }, end: { line: 70, column: 99 } } })) + " " + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "payment") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 70, column: 100 }, end: { line: 70, column: 114 } } })) + `</span> <br/>\r
                <span>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.invoiceList.alreadyPaid", { name: "t", hash: {}, data: a, loc: { start: { line: 71, column: 22 }, end: { line: 71, column: 68 } } })) + " " + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "totalPaid") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 71, column: 69 }, end: { line: 71, column: 85 } } })) + `</span> <br/>\r
                <span class="total" style="font-weight: bold;">` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.invoiceList.payable", { name: "t", hash: {}, data: a, loc: { start: { line: 72, column: 63 }, end: { line: 72, column: 105 } } })) + " " + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "payable") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 72, column: 106 }, end: { line: 72, column: 120 } } })) + `</span> <br/>\r
              </td>\r
`;
}, 14: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return '              <td class="right"><b>' + l.escapeExpression((n(t, "c") || e && n(e, "c") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), e != null ? n(e, "payment") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 75, column: 35 }, end: { line: 75, column: 48 } } })) + `</b></td>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Xo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "months") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 2, column: 2 }, end: { line: 54, column: 11 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(3, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 3: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `    <style>\r
      tr {\r
      page-break-inside: avoid;\r
    }\r
    </style>\r
      <table class="calendar-report">\r
        <thead>\r
          <tr>\r
            <th class="week-number">` + i((c(t, "t") || e && c(e, "t") || u).call(r, "SALAXY.REPORTS.CalendarReport.week", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 36 }, end: { line: 12, column: 78 } } })) + `</th>\r
` + ((n = c(t, "each").call(r, e != null ? c(e, "weeks") : e, { name: "each", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 13, column: 12 }, end: { line: 17, column: 21 } } })) != null ? n : "") + `          </tr>\r
          <tr>\r
            <th class="calendar-title" rowspan="2">\r
              ` + i((o = (o = c(t, "title") || (e != null ? c(e, "title") : e)) != null ? o : u, typeof o == "function" ? o.call(r, { name: "title", hash: {}, data: a, loc: { start: { line: 21, column: 14 }, end: { line: 21, column: 23 } } }) : o)) + `\r
            </th>\r
          </tr>\r
          <tr>\r
` + ((n = c(t, "each").call(r, e != null ? c(e, "days") : e, { name: "each", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 25, column: 12 }, end: { line: 30, column: 21 } } })) != null ? n : "") + `          </tr>\r
        </thead>\r
        <tbody>\r
` + ((n = c(t, "each").call(r, e != null ? c(e, "series") : e, { name: "each", hash: {}, fn: l.program(8, a, 0), inverse: l.noop, data: a, loc: { start: { line: 34, column: 10 }, end: { line: 49, column: 19 } } })) != null ? n : "") + `        </tbody>\r
      </table>\r
    \r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return '              <th class="week-number" colspan="' + i((n = (n = c(t, "colspan") || (e != null ? c(e, "colspan") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "colspan", hash: {}, data: a, loc: { start: { line: 14, column: 47 }, end: { line: 14, column: 58 } } }) : n)) + `">\r
                ` + i((n = (n = c(t, "weekNumber") || (e != null ? c(e, "weekNumber") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "weekNumber", hash: {}, data: a, loc: { start: { line: 15, column: 16 }, end: { line: 15, column: 30 } } }) : n)) + `\r
              </th>\r
`;
}, 6: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return '            <th class="day day-of-week-' + i((n = (n = c(t, "weekday") || (e != null ? c(e, "weekday") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "weekday", hash: {}, data: a, loc: { start: { line: 26, column: 39 }, end: { line: 26, column: 52 } } }) : n)) + " day-type-" + i((n = (n = c(t, "dayType") || (e != null ? c(e, "dayType") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "dayType", hash: {}, data: a, loc: { start: { line: 26, column: 62 }, end: { line: 26, column: 75 } } }) : n)) + `">\r
              ` + i((n = (n = c(t, "weekdayText") || (e != null ? c(e, "weekdayText") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "weekdayText", hash: {}, data: a, loc: { start: { line: 27, column: 14 }, end: { line: 27, column: 31 } } }) : n)) + `<br />\r
              ` + i((n = (n = c(t, "day") || (e != null ? c(e, "day") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "day", hash: {}, data: a, loc: { start: { line: 28, column: 14 }, end: { line: 28, column: 23 } } }) : n)) + `\r
            </th>\r
`;
}, 8: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = "function", c = l.escapeExpression, f = l.lookupProperty || function(m, p) {
    if (Object.prototype.hasOwnProperty.call(m, p))
      return m[p];
  };
  return `          <tr>\r
            <td class="series-title">\r
              <div><strong>` + c((o = (o = f(t, "title") || (e != null ? f(e, "title") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "title", hash: {}, data: a, loc: { start: { line: 37, column: 27 }, end: { line: 37, column: 38 } } }) : o)) + `</strong></div>\r
              <div>` + c((o = (o = f(t, "description") || (e != null ? f(e, "description") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "description", hash: {}, data: a, loc: { start: { line: 38, column: 19 }, end: { line: 38, column: 36 } } }) : o)) + `</div>\r
            </td>\r
` + ((n = f(t, "each").call(r, e != null ? f(e, "days") : e, { name: "each", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 40, column: 12 }, end: { line: 47, column: 21 } } })) != null ? n : "") + `          </tr>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "hasEvents") : e, { name: "if", hash: {}, fn: l.program(10, a, 0), inverse: l.program(12, a, 0), data: a, loc: { start: { line: 41, column: 14 }, end: { line: 45, column: 21 } } })) != null ? n : "") + `              \r
`;
}, 10: function(l, e, t, s, a) {
  return `              <td class="event-primary"></td>\r
`;
}, 12: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return '              <td class="day day-of-week-' + i((n = (n = c(t, "weekday") || (e != null ? c(e, "weekday") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "weekday", hash: {}, data: a, loc: { start: { line: 44, column: 41 }, end: { line: 44, column: 54 } } }) : n)) + " day-type-" + i((n = (n = c(t, "dayType") || (e != null ? c(e, "dayType") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "dayType", hash: {}, data: a, loc: { start: { line: 44, column: 64 }, end: { line: 44, column: 77 } } }) : n)) + `"></td>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), Yo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "paymentSummaryReportHeadV2"), e, { name: "paymentSummaryReportHeadV2", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "paymentTablesV2"), e, { name: "paymentTablesV2", data: a, indent: "    ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Io = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
<div style="page-break-before: always"></div>\r
\r
` + ((n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(4, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "workerReportHeadV2"), e, { name: "workerReportHeadV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `<br/>\r
` + ((n = l.invokePartial(o(s, "workerCalculationTablesV2"), e, { name: "workerCalculationTablesV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
<h3>` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.moreInfoOnNextPage", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 4 }, end: { line: 8, column: 61 } } })) + `</h3>\r
\r
\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "workerReportHeadV2"), e, { name: "workerReportHeadV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "workerCumulativeTables"), e, { name: "workerCumulativeTables", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
<h2 class="salaxy-content-subheader">` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.salaryAdditionalInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 37 }, end: { line: 21, column: 96 } } })) + `</h2>\r
<p>&nbsp;</p>\r
\r
` + ((n = l.invokePartial(o(s, "workerCalculationAdditionalInfoV2"), e, { name: "workerCalculationAdditionalInfoV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), Ho = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "workerReportHeadV2"), e, { name: "workerReportHeadV2", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + ((n = l.invokePartial(o(s, "workerCalculationTablesV2"), e, { name: "workerCalculationTablesV2", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "");
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), Tt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "period") : n) != null ? o(n, "end") : n, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 42, column: 10 }, end: { line: 47, column: 17 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `            <tr>\r
              <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.period", { name: "t", hash: {}, data: a, loc: { start: { line: 44, column: 18 }, end: { line: 44, column: 63 } } })) + `:</td>\r
              <td class="right">` + u((i(t, "d") || e && i(e, "d") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "period") : n) != null ? i(n, "start") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 45, column: 32 }, end: { line: 45, column: 57 } } })) + " - " + u((i(t, "d") || e && i(e, "d") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "period") : n) != null ? i(n, "end") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 45, column: 60 }, end: { line: 45, column: 83 } } })) + `</td>\r
            </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table>\r
  <tr>\r
    <td>\r
      <table>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.name", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 14 }, end: { line: 6, column: 57 } } })) + `:</td>\r
          <td><strong>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "employer") : n) != null ? c(n, "firstName") : n, e)) + " " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "employer") : n) != null ? c(n, "lastName") : n, e)) + `</strong></td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.officialId", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 14 }, end: { line: 10, column: 63 } } })) + `:</td>\r
          <td>` + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "officialId") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.email", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 14 }, end: { line: 14, column: 58 } } })) + `:</td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "contact") : n) != null ? c(n, "email") : n, e)) + `</td>\r
        </tr>\r
      </table>\r
    </td>\r
    <td>\r
      <table>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.workerCount", { name: "t", hash: {}, data: a, loc: { start: { line: 22, column: 14 }, end: { line: 22, column: 64 } } })) + `:</td>\r
          <td class="right">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "summary") : n) != null ? c(n, "workerCount") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.calculationCount", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 14 }, end: { line: 26, column: 69 } } })) + `:</td>\r
          <td class="right">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "summary") : n) != null ? c(n, "calculationCount") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.totalGrossSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 14 }, end: { line: 30, column: 69 } } })) + `:</td>\r
          <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "summary") : n) != null ? c(n, "totalGrossSalary") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 31, column: 28 }, end: { line: 31, column: 65 } } })) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.totalWorkerPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 14 }, end: { line: 34, column: 71 } } })) + `:</td>\r
          <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "summary") : n) != null ? c(n, "workerCalc") : n) != null ? c(n, "totalWorkerPayment") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 35, column: 28 }, end: { line: 35, column: 78 } } })) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.head.tax", { name: "t", hash: {}, data: a, loc: { start: { line: 38, column: 14 }, end: { line: 38, column: 56 } } })) + `:</td>\r
          <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "summary") : n) != null ? c(n, "workerCalc") : n) != null ? c(n, "tax") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 39, column: 28 }, end: { line: 39, column: 63 } } })) + `</td>\r
        </tr>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "period") : n) != null ? c(n, "start") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 41, column: 8 }, end: { line: 48, column: 15 } } })) != null ? n : "") + `      </table>\r
    </td>\r
  </tr>\r
</table>\r
`;
}, useData: !0 });
P.registerPartial("accountingReportHead", Tt);
const xt = P.template({ 1: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "                <th>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), e, { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 20 }, end: { line: 8, column: 30 } } })) + `</th>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = "function", c = l.escapeExpression, f = l.lookupProperty || function(m, p) {
    if (Object.prototype.hasOwnProperty.call(m, p))
      return m[p];
  };
  return `            <tr>\r
              <td>` + c((o = (o = f(t, "accountNumber") || (e != null ? f(e, "accountNumber") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "accountNumber", hash: {}, data: a, loc: { start: { line: 16, column: 18 }, end: { line: 16, column: 35 } } }) : o)) + `</td>\r
              <td>` + c((o = (o = f(t, "accountName") || (e != null ? f(e, "accountName") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "accountName", hash: {}, data: a, loc: { start: { line: 17, column: 18 }, end: { line: 17, column: 33 } } }) : o)) + `</td>\r
              <td class="right">` + c((f(t, "p") || e && f(e, "p") || u).call(r, e != null ? f(e, "vatPercent") : e, { name: "p", hash: {}, data: a, loc: { start: { line: 18, column: 32 }, end: { line: 18, column: 48 } } })) + `</td>\r
` + ((n = f(t, "each").call(r, e != null ? f(e, "dimensions") : e, { name: "each", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 19, column: 14 }, end: { line: 21, column: 23 } } })) != null ? n : "") + '              <td class="right">' + c((f(t, "c") || e && f(e, "c") || u).call(r, e != null ? f(e, "sum") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 22, column: 32 }, end: { line: 22, column: 41 } } })) + `</td>\r
            </tr>\r
`;
}, 4: function(l, e, t, s, a) {
  return "                <td>" + l.escapeExpression(l.lambda(e, e)) + `</td>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `  <table class="table table-striped table-condensed">\r
      <thead style="display: table-header-group;">\r
           <tr>\r
             <th>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.heading.accountNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 4, column: 17 }, end: { line: 4, column: 72 } } })) + `</th>\r
             <th>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.heading.accountName", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 17 }, end: { line: 5, column: 70 } } })) + `</th>\r
             <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.heading.vatPercent", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 31 }, end: { line: 6, column: 83 } } })) + `</th>\r
` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "dimensionHeaders") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 7, column: 12 }, end: { line: 9, column: 21 } } })) != null ? n : "") + '            <th class="right">' + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.accounting.heading.sum", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 30 }, end: { line: 10, column: 75 } } })) + `</th>      \r
          </tr>\r
      </thead>\r
      <tbody>\r
` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n, { name: "each", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 14, column: 10 }, end: { line: 24, column: 19 } } })) != null ? n : "") + `      </tbody>\r
  </table>\r
`;
}, useData: !0 });
P.registerPartial("accountingTable", xt);
const Lt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `    <div style="margin-top: 4mm; margin-left: 10mm">\r
        <div class="uppercase">` + r(o((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "worker") : n) != null ? u(n, "avatar") : n) != null ? u(n, "sortableName") : n, e)) + `</div>\r
        ` + r(o((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "worker") : n) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
        ` + r(o((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "worker") : n) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + r(o((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "worker") : n) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
    </div>\r
`;
}, 3: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "    <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.noWorkerDetails", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 7 }, end: { line: 8, column: 58 } } })) + `</p>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lambda, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `    <div class="margin-top" style="margin-left: 10mm">\r
        <b>` + o((u(t, "t") || e && u(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.employer", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 11 }, end: { line: 15, column: 58 } } })) + `:</b>\r
        <div class="uppercase">` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "avatar") : n) != null ? u(n, "sortableName") : n, e)) + `</div>\r
        ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
        ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
    </div>\r
`;
}, 7: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "    <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.noEmployerDetails", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 7 }, end: { line: 21, column: 60 } } })) + `</p>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return ((n = r(t, "if").call(o, (n = (n = (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "worker") : n) != null ? r(n, "avatar") : n) != null ? r(n, "firstName") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 1, column: 0 }, end: { line: 9, column: 7 } } })) != null ? n : "") + `<br/>\r
<br/>\r
<br/>\r
` + ((n = r(t, "if").call(o, (n = (n = (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "employer") : n) != null ? r(n, "avatar") : n) != null ? r(n, "firstName") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 13, column: 0 }, end: { line: 22, column: 7 } } })) != null ? n : "");
}, useData: !0 });
P.registerPartial("contractPartiesContactDetailsV2", Lt);
const _t = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return '    <link type="text/css" rel="stylesheet" href="' + r(o((n = e != null ? u(e, "layout") : e) != null ? u(n, "baseUrl") : n, e)) + `css/salaxy-lib-reports.css">\r
` + ((n = u(t, "if").call(e ?? (l.nullContext || {}), (n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "branding") : n) != null ? u(n, "hasCss") : n, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 6, column: 6 }, end: { line: 8, column: 13 } } })) != null ? n : "") + '    <base href="' + r(o((n = e != null ? u(e, "layout") : e) != null ? u(n, "baseUrl") : n, e)) + `" />\r
`;
}, 2: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return '    <link type="text/css" rel="stylesheet" href="' + r(o((n = e != null ? u(e, "layout") : e) != null ? u(n, "baseUrl") : n, e)) + r(o((n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "branding") : n) != null ? u(n, "css") : n, e)) + `" />\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `    <style type="text/css">\r
      ` + l.escapeExpression(l.lambda((n = e != null ? o(e, "layout") : e) != null ? o(n, "customCss") : n, e)) + `\r
    </style>\r
`;
}, 6: function(l, e, t, s, a) {
  return "-pdf";
}, 8: function(l, e, t, s, a) {
  return "-preview";
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `\r
<html>\r
  <head>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModePdf") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 4, column: 4 }, end: { line: 10, column: 11 } } })) != null ? n : "") + `    \r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "hasCustomCss") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 12, column: 4 }, end: { line: 16, column: 11 } } })) != null ? n : "") + `  </head>\r
  <body>\r
\r
    <div class="salaxy-rpt salaxy-component">\r
     \r
     <div class="document` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModePdf") : n, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.program(8, a, 0), data: a, loc: { start: { line: 22, column: 25 }, end: { line: 22, column: 76 } } })) != null ? n : "") + `">\r
` + ((n = l.invokePartial(r(s, "@partial-block"), e, { name: "@partial-block", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `      </div>\r
    </div>\r
  </body>\r
</html>\r
`;
}, usePartial: !0, useData: !0 });
P.registerPartial("document", _t);
const Dt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "notes") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 4, column: 0 }, end: { line: 7, column: 9 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "<h3>" + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "heading") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 4 }, end: { line: 5, column: 18 } } })) + `</h3>\r
<p>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "text") : e, e != null ? u(e, "parameters") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 3 }, end: { line: 6, column: 25 } } })) + `</p>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "workerDeductionWarningsV2"), e, { name: "workerDeductionWarningsV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "hasNotes") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 3, column: 0 }, end: { line: 8, column: 7 } } })) != null ? n : "");
}, usePartial: !0, useData: !0 });
P.registerPartial("employerCalculationAdditionalInfoV2", Dt);
const Mt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "hasRows") : e, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 2, column: 0 }, end: { line: 67, column: 7 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `\r
  <table class="salaxy-report-table report-table columns-four">\r
` + ((n = r(t, "unless").call(o, e != null ? r(e, "isHidden") : e, { name: "unless", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 5, column: 4 }, end: { line: 55, column: 17 } } })) != null ? n : "") + ((n = r(t, "if").call(o, e != null ? r(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(18, a, 0), inverse: l.noop, data: a, loc: { start: { line: 56, column: 6 }, end: { line: 65, column: 13 } } })) != null ? n : "") + `  </table>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `      <thead style="display: table-header-group;">\r
` + ((n = r(t, "if").call(o, e != null ? r(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.program(6, a, 0), data: a, loc: { start: { line: 7, column: 10 }, end: { line: 28, column: 17 } } })) != null ? n : "") + `      </thead>\r
      <tbody>\r
` + ((n = r(t, "each").call(o, e != null ? r(e, "rows") : e, { name: "each", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 31, column: 12 }, end: { line: 45, column: 21 } } })) != null ? n : "") + ((n = r(t, "unless").call(o, e != null ? r(e, "isTotals") : e, { name: "unless", hash: {}, fn: l.program(16, a, 0), inverse: l.noop, data: a, loc: { start: { line: 46, column: 12 }, end: { line: 53, column: 23 } } })) != null ? n : "") + `      </tbody>\r
`;
}, 4: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `          <tr>\r
              <th><h3>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "groupingTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 22 }, end: { line: 9, column: 40 } } })) + `</h3></th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.percentOf", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 18 }, end: { line: 10, column: 66 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.fromSum", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 18 }, end: { line: 11, column: 64 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 18 }, end: { line: 12, column: 62 } } })) + `</th>\r
          </tr>\r
`;
}, 6: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "isUndefined") : e, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 14, column: 10 }, end: { line: 28, column: 10 } } })) != null ? n : "";
}, 7: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `          <tr>\r
              <th><h3>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "groupingTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 23, column: 22 }, end: { line: 23, column: 40 } } })) + `</h3></th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.amount", { name: "t", hash: {}, data: a, loc: { start: { line: 24, column: 18 }, end: { line: 24, column: 63 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 18 }, end: { line: 25, column: 63 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 18 }, end: { line: 26, column: 62 } } })) + `</th>\r
          </tr>\r
          `;
}, 9: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `            <tr>\r
                <td>\r
                    ` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "message") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 20 }, end: { line: 34, column: 45 } } })) + ((n = i(t, "if").call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "comment") : n, { name: "if", hash: {}, fn: l.program(10, a, 0), inverse: l.noop, data: a, loc: { start: { line: 34, column: 45 }, end: { line: 35, column: 90 } } })) != null ? n : "") + `\r
                </td>\r
` + ((n = i(t, "if").call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "isUnitPercent") : n, { name: "if", hash: {}, fn: l.program(12, a, 0), inverse: l.program(14, a, 0), data: a, loc: { start: { line: 37, column: 16 }, end: { line: 41, column: 23 } } })) != null ? n : "") + "                <td>" + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "price") : n, { name: "c", hash: { nullChar: " " }, data: a, loc: { start: { line: 42, column: 20 }, end: { line: 42, column: 55 } } })) + `</td>\r
                <td>` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "subTotal") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 43, column: 20 }, end: { line: 43, column: 34 } } })) + `</td>\r
            </tr>\r
`;
}, 10: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
                    <span style="font-size: 0.8em;">&nbsp;` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "comment") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 35, column: 58 }, end: { line: 35, column: 76 } } })) + "</span>";
}, 12: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                <td>" + l.escapeExpression((o(t, "p") || e && o(e, "p") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "p", hash: { nullChar: " " }, data: a, loc: { start: { line: 38, column: 20 }, end: { line: 38, column: 55 } } })) + `</td>\r
`;
}, 14: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                <td>" + l.escapeExpression((o(t, "r") || e && o(e, "r") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 40, column: 20 }, end: { line: 40, column: 51 } } })) + `</td>\r
`;
}, 16: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <tr class="total">\r
                <td>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "totalTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 48, column: 20 }, end: { line: 48, column: 36 } } })) + `</td>\r
                <td></td>\r
                <td></td>\r
                <td>` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 51, column: 20 }, end: { line: 51, column: 32 } } })) + `</td>\r
            </tr>\r
`;
}, 18: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "hasTotalValue") : e, { name: "if", hash: {}, fn: l.program(19, a, 0), inverse: l.noop, data: a, loc: { start: { line: 57, column: 8 }, end: { line: 64, column: 15 } } })) != null ? n : "";
}, 19: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `      <tfoot>\r
          <tr class="total">\r
              <th colspan="3">` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.palkkausFee", { name: "t", hash: {}, data: a, loc: { start: { line: 60, column: 30 }, end: { line: 60, column: 80 } } })) + `</th>\r
              <th>` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 61, column: 18 }, end: { line: 61, column: 30 } } })) + `</th>\r
          </tr>\r
      </tfoot>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "rowGroups") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 68, column: 9 } } })) != null ? n : "";
}, useData: !0 });
P.registerPartial("employerCalculationTablesV2", Mt);
const Xt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "paidAt") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 16, column: 41 }, end: { line: 16, column: 68 } } }));
}, 3: function(l, e, t, s, a) {
  return "-";
}, 5: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.requestedSalaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 54 }, end: { line: 19, column: 112 } } }));
}, 7: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.salaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 120 }, end: { line: 19, column: 169 } } }));
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "salaryDate") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 20, column: 45 }, end: { line: 20, column: 76 } } }));
}, 11: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "            <span>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.noTaxcard", { name: "t", hash: {}, data: a, loc: { start: { line: 36, column: 18 }, end: { line: 36, column: 63 } } })) + `</span>\r
`;
}, 13: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return "            <span>" + l.escapeExpression((r(t, "p") || e && r(e, "p") || l.hooks.helperMissing).call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 38, column: 18 }, end: { line: 38, column: 49 } } })) + `</span>\r
            ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardTaxPercent") : n, { name: "if", hash: {}, fn: l.program(14, a, 0), inverse: l.noop, data: a, loc: { start: { line: 39, column: 12 }, end: { line: 39, column: 172 } } })) != null ? n : "") + `\r
            ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardTaxPercent2") : n, { name: "if", hash: {}, fn: l.program(16, a, 0), inverse: l.noop, data: a, loc: { start: { line: 40, column: 12 }, end: { line: 40, column: 175 } } })) != null ? n : "") + `\r
`;
}, 14: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return "<br /><span>" + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.taxcardTaxPercent", { name: "t", hash: {}, data: a, loc: { start: { line: 39, column: 64 }, end: { line: 39, column: 119 } } })) + " " + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "header") : n) != null ? i(n, "taxcardTaxPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 39, column: 120 }, end: { line: 39, column: 158 } } })) + "</span>";
}, 16: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return "<br /><span>" + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.taxcardTaxPercent2", { name: "t", hash: {}, data: a, loc: { start: { line: 40, column: 65 }, end: { line: 40, column: 121 } } })) + " " + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "header") : n) != null ? i(n, "taxcardTaxPercent2") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 40, column: 122 }, end: { line: 40, column: 161 } } })) + "</span>";
}, 18: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `    <tr>\r
        <td>` + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.workDescription", { name: "t", hash: {}, data: a, loc: { start: { line: 46, column: 12 }, end: { line: 46, column: 66 } } })) + `:</td>\r
        <td>` + o(l.lambda((n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "workDescription") : n, e)) + `</td>\r
    </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table class="report-table-compact">\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.worker", { name: "t", hash: {}, data: a, loc: { start: { line: 3, column: 12 }, end: { line: 3, column: 57 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "avatar") : n) != null ? c(n, "sortableName") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.socialSecurityNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 12 }, end: { line: 7, column: 71 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "socialSecurityNumberValid") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.bankAccountNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 12 }, end: { line: 11, column: 68 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "ibanNumber") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.paidAt", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 12 }, end: { line: 15, column: 57 } } })) + `:</td>\r
        <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "paidAt") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 16, column: 12 }, end: { line: 16, column: 84 } } })) != null ? n : "") + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "requestedSalaryDate") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 19, column: 12 }, end: { line: 19, column: 176 } } })) != null ? n : "") + `:</td>\r
        <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "salaryDate") : n, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 20, column: 12 }, end: { line: 20, column: 92 } } })) != null ? n : "") + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.workPeriod", { name: "t", hash: {}, data: a, loc: { start: { line: 23, column: 12 }, end: { line: 23, column: 61 } } })) + `:</td>\r
        <td>` + u((c(t, "d") || e && c(e, "d") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workStartDate") : n, { name: "d", hash: { end: (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workEndDate") : n }, data: a, loc: { start: { line: 24, column: 12 }, end: { line: 24, column: 76 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.numberOfWorkDays", { name: "t", hash: {}, data: a, loc: { start: { line: 27, column: 12 }, end: { line: 27, column: 67 } } })) + `:</td>\r
        <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "numberOfDays") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>\r
            ` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.withholdingTax", { name: "t", hash: {}, data: a, loc: { start: { line: 32, column: 12 }, end: { line: 32, column: 65 } } })) + `:\r
        </td>\r
        <td>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workerHasNoTaxcard") : n, { name: "if", hash: {}, fn: l.program(11, a, 0), inverse: l.program(13, a, 0), data: a, loc: { start: { line: 35, column: 12 }, end: { line: 41, column: 20 } } })) != null ? n : "") + `        </td>\r
    </tr>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workDescription") : n, { name: "if", hash: {}, fn: l.program(18, a, 0), inverse: l.noop, data: a, loc: { start: { line: 44, column: 4 }, end: { line: 49, column: 11 } } })) != null ? n : "") + "</table>";
}, useData: !0 });
P.registerPartial("employerContractDetailsV2", Xt);
const Yt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lambda, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <div>\r
                <b>` + o((u(t, "t") || e && u(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.employer", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 19 }, end: { line: 9, column: 66 } } })) + `</b>\r
                <div class="uppercase">` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "avatar") : n) != null ? u(n, "sortableName") : n, e)) + `</div>\r
                ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
                ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
            </div>\r
`;
}, 3: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "            <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.noEmployerDetails", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 15 }, end: { line: 15, column: 68 } } })) + `</p>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
        <td>\r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = (n = (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "employer") : n) != null ? o(n, "avatar") : n) != null ? o(n, "firstName") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 7, column: 12 }, end: { line: 16, column: 19 } } })) != null ? n : "") + `        </td>\r
        <td>\r
` + ((n = l.invokePartial(o(s, "employerContractDetailsV2"), e, { name: "employerContractDetailsV2", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `        </td>\r
    </tr>\r
</table>`;
}, usePartial: !0, useData: !0 });
P.registerPartial("employerReportHeadV2", Yt);
const It = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return 'style="height:auto;min-height:' + ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "layout") : e) != null ? o(n, "isLayoutA4Portrait") : n, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.program(4, a, 0), data: a, loc: { start: { line: 1, column: 101 }, end: { line: 1, column: 159 } } })) != null ? n : "") + '"';
}, 2: function(l, e, t, s, a) {
  return "297mm";
}, 4: function(l, e, t, s, a) {
  return "210mm";
}, 6: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return '      <div class="watermark">' + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "layout") : e) != null ? o(n, "watermark") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 3, column: 29 }, end: { line: 3, column: 52 } } })) + `</div>\r
`;
}, 8: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `      <div class="document-header" style="\r
      width: 100%;\r
      position: absolute;\r
      overflow: hidden;\r
      height: ` + l.escapeExpression(l.lambda((n = (n = e != null ? o(e, "layout") : e) != null ? o(n, "margin") : n) != null ? o(n, "top") : n, e)) + `mm;">\r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "headerHtml") : e, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.program(11, a, 0), data: a, loc: { start: { line: 12, column: 8 }, end: { line: 18, column: 15 } } })) != null ? n : "") + `      </div>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return "          " + ((n = (o = (o = r(t, "headerHtml") || (e != null ? r(e, "headerHtml") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "headerHtml", hash: {}, data: a, loc: { start: { line: 13, column: 10 }, end: { line: 13, column: 26 } } }) : o)) != null ? n : "") + `\r
`;
}, 11: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "with").call(e ?? (l.nullContext || {}), e != null ? o(e, "headerFooter") : e, { name: "with", hash: {}, fn: l.program(12, a, 0), inverse: l.noop, data: a, loc: { start: { line: 15, column: 10 }, end: { line: 17, column: 19 } } })) != null ? n : "";
}, 12: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "defaultHeader"), e, { name: "defaultHeader", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 14: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `    position: relative;\r
    padding-top: ` + r(o((n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "margin") : n) != null ? u(n, "top") : n, e)) + `mm;\r
    padding-right: ` + r(o((n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "margin") : n) != null ? u(n, "right") : n, e)) + `mm;\r
    padding-bottom: ` + r(o((n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "margin") : n) != null ? u(n, "bottom") : n, e)) + `mm;\r
    padding-left: ` + r(o((n = (n = e != null ? u(e, "layout") : e) != null ? u(n, "margin") : n) != null ? u(n, "left") : n, e)) + `mm;\r
`;
}, 16: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `      <div class="document-footer" style="\r
      width: 100%;\r
      position: absolute;\r
      height: ` + l.escapeExpression(l.lambda((n = (n = e != null ? o(e, "layout") : e) != null ? o(n, "margin") : n) != null ? o(n, "bottom") : n, e)) + `mm;\r
      bottom: 0;\r
      overflow: hidden;\r
      ">\r
       \r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "footerHtml") : e, { name: "if", hash: {}, fn: l.program(17, a, 0), inverse: l.program(19, a, 0), data: a, loc: { start: { line: 45, column: 8 }, end: { line: 51, column: 15 } } })) != null ? n : "") + `      </div>\r
`;
}, 17: function(l, e, t, s, a) {
  var n, o, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return "          " + ((n = (o = (o = r(t, "footerHtml") || (e != null ? r(e, "footerHtml") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "footerHtml", hash: {}, data: a, loc: { start: { line: 46, column: 10 }, end: { line: 46, column: 26 } } }) : o)) != null ? n : "") + `\r
`;
}, 19: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "with").call(e ?? (l.nullContext || {}), e != null ? o(e, "headerFooter") : e, { name: "with", hash: {}, fn: l.program(20, a, 0), inverse: l.noop, data: a, loc: { start: { line: 48, column: 11 }, end: { line: 50, column: 17 } } })) != null ? n : "";
}, 20: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "defaultFooter"), e, { name: "defaultFooter", data: a, indent: "          ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return '<div class="document ' + l.escapeExpression(l.lambda((n = e != null ? r(e, "layout") : e) != null ? r(n, "layout") : n, e)) + '" ' + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModeHtmlPage") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 42 }, end: { line: 1, column: 167 } } })) != null ? n : "") + `>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isPreview") : n, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 2, column: 4 }, end: { line: 4, column: 11 } } })) != null ? n : "") + `      \r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModeHtmlPage") : n, { name: "if", hash: {}, fn: l.program(8, a, 0), inverse: l.noop, data: a, loc: { start: { line: 6, column: 4 }, end: { line: 20, column: 11 } } })) != null ? n : "") + `      \r
    <div class="document-body" style="\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModeHtmlPage") : n, { name: "if", hash: {}, fn: l.program(14, a, 0), inverse: l.noop, data: a, loc: { start: { line: 23, column: 4 }, end: { line: 29, column: 11 } } })) != null ? n : "") + "    width:" + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isLayoutA4Portrait") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.program(2, a, 0), data: a, loc: { start: { line: 30, column: 10 }, end: { line: 30, column: 68 } } })) != null ? n : "") + `\r
    ">\r
 \r
` + ((n = l.invokePartial(r(s, "@partial-block"), e, { name: "@partial-block", data: a, indent: "      ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `    </div>\r
   \r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "layout") : e) != null ? r(n, "isModeHtmlPage") : n, { name: "if", hash: {}, fn: l.program(16, a, 0), inverse: l.noop, data: a, loc: { start: { line: 36, column: 4 }, end: { line: 53, column: 11 } } })) != null ? n : "") + `</div>\r
\r
        `;
}, usePartial: !0, useData: !0 });
P.registerPartial("page", It);
const Ht = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return '<link href="' + l.escapeExpression(l.lambda((n = e != null ? o(e, "layout") : e) != null ? o(n, "baseUrl") : n, e)) + `/Content/css/salaxy-lib-ng1/salaxy-rpt.css?v=20190506" type="text/css" rel="stylesheet" />\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "layout") : e) != null ? o(n, "isPartial") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 3, column: 7 } } })) != null ? n : "";
}, useData: !0 });
P.registerPartial("partial", Ht);
const $t = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
        <td>\r
` + ((n = l.invokePartial(o(s, "contractPartiesContactDetailsV2"), e, { name: "contractPartiesContactDetailsV2", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `        </td>\r
        <td>\r
` + ((n = l.invokePartial(o(s, "employerContractDetailsV2"), e, { name: "employerContractDetailsV2", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `        </td>\r
    </tr>\r
</table>\r
`;
}, usePartial: !0, useData: !0 });
P.registerPartial("paymentReportHeadV2", $t);
const Bt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lambda, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <div>\r
                <b>` + o((u(t, "t") || e && u(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.employer", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 19 }, end: { line: 9, column: 66 } } })) + `</b>\r
                <div class="uppercase">` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "avatar") : n) != null ? u(n, "sortableName") : n, e)) + `</div>\r
                <br>\r
                 ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `\r
                ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
                ` + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + o(r((n = (n = (n = (n = e != null ? u(e, "report") : e) != null ? u(n, "header") : n) != null ? u(n, "employer") : n) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
            </div>\r
`;
}, 3: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "            <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.noEmployerDetails", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 15 }, end: { line: 17, column: 68 } } })) + `</p>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "paidAt") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 27, column: 65 }, end: { line: 27, column: 92 } } }));
}, 7: function(l, e, t, s, a) {
  return "-";
}, 9: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.requestedSalaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 64 }, end: { line: 30, column: 122 } } }));
}, 11: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.salaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 130 }, end: { line: 30, column: 179 } } }));
}, 13: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "salaryDate") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 31, column: 69 }, end: { line: 31, column: 100 } } }));
}, 15: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `              <tr>\r
                <td>` + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.workDescription", { name: "t", hash: {}, data: a, loc: { start: { line: 63, column: 20 }, end: { line: 63, column: 74 } } })) + `:</td>\r
                <td>` + o(l.lambda((n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "workDescription") : n, e)) + `</td>\r
              </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
        <td>\r
` + ((n = c(t, "if").call(o, (n = (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "employer") : n) != null ? c(n, "avatar") : n) != null ? c(n, "firstName") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 7, column: 12 }, end: { line: 18, column: 19 } } })) != null ? n : "") + `        </td>\r
        <td>\r
           \r
            <table class="report-table-compact">\r
           \r
             \r
              <tr>\r
                  <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.paidAt", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 22 }, end: { line: 26, column: 67 } } })) + `:</td>\r
                  <td class="right">` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "paidAt") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 27, column: 36 }, end: { line: 27, column: 108 } } })) != null ? n : "") + `</td>\r
              </tr>\r
              <tr>\r
                  <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "requestedSalaryDate") : n, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.program(11, a, 0), data: a, loc: { start: { line: 30, column: 22 }, end: { line: 30, column: 186 } } })) != null ? n : "") + `:</td>\r
                  <td class="right">` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "salaryDate") : n, { name: "if", hash: {}, fn: l.program(13, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 31, column: 36 }, end: { line: 31, column: 116 } } })) != null ? n : "") + `</td>\r
              </tr>\r
              <tr>\r
                  <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.workPeriod", { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 22 }, end: { line: 34, column: 71 } } })) + `:</td>\r
                  <td class="right">` + u((c(t, "d") || e && c(e, "d") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workStartDate") : n, { name: "d", hash: { end: (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workEndDate") : n }, data: a, loc: { start: { line: 35, column: 36 }, end: { line: 35, column: 100 } } })) + `</td>\r
              </tr>\r
              <tr>\r
                  <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.numberOfWorkDays", { name: "t", hash: {}, data: a, loc: { start: { line: 38, column: 22 }, end: { line: 38, column: 77 } } })) + `:</td>\r
                  <td class="right">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "numberOfDays") : n, e)) + `</td>\r
              </tr>\r
              <tr>\r
                <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.workerCount", { name: "t", hash: {}, data: a, loc: { start: { line: 42, column: 20 }, end: { line: 42, column: 69 } } })) + `:</td>\r
                <td class="right">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workerCount") : n, e)) + `</td>\r
              </tr>\r
              <tr>\r
                <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.calculationCount", { name: "t", hash: {}, data: a, loc: { start: { line: 46, column: 20 }, end: { line: 46, column: 74 } } })) + `:</td>\r
                <td class="right">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "calculationCount") : n, e)) + `</td>\r
              </tr>\r
              <tr>\r
                <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.totalCost", { name: "t", hash: {}, data: a, loc: { start: { line: 50, column: 20 }, end: { line: 50, column: 67 } } })) + `:</td>\r
                <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "totalSalaryCost") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 51, column: 34 }, end: { line: 51, column: 69 } } })) + `</td>\r
              </tr>\r
              <tr>\r
                <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.totalGrossSalaryAlt", { name: "t", hash: {}, data: a, loc: { start: { line: 54, column: 20 }, end: { line: 54, column: 77 } } })) + `:</td>\r
                <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "totalGrossSalary") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 55, column: 34 }, end: { line: 55, column: 70 } } })) + `</td>\r
              </tr>\r
              <tr>\r
                <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.totalWorkerPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 58, column: 20 }, end: { line: 58, column: 76 } } })) + `:</td>\r
                <td class="right">` + u((c(t, "c") || e && c(e, "c") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "totalWorkerPaymentLegacy") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 59, column: 34 }, end: { line: 59, column: 78 } } })) + `</td>\r
              </tr>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workDescription") : n, { name: "if", hash: {}, fn: l.program(15, a, 0), inverse: l.noop, data: a, loc: { start: { line: 61, column: 14 }, end: { line: 66, column: 21 } } })) != null ? n : "") + `            </table>\r
        </td>\r
    </tr>\r
</table>\r
`;
}, useData: !0 });
P.registerPartial("paymentSummaryReportHeadV2", Bt);
const Ft = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "hasRows") : e, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 2, column: 0 }, end: { line: 55, column: 7 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `\r
  <table class="salaxy-report-table report-table columns-six">\r
` + ((n = r(t, "unless").call(o, e != null ? r(e, "isHidden") : e, { name: "unless", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 5, column: 4 }, end: { line: 42, column: 17 } } })) != null ? n : "") + ((n = r(t, "if").call(o, e != null ? r(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(13, a, 0), inverse: l.noop, data: a, loc: { start: { line: 43, column: 6 }, end: { line: 52, column: 13 } } })) != null ? n : "") + `  </table>\r
\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `      <thead style="display: table-header-group;">\r
          <tr>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "params") : e) != null ? r(n, "hideColumnHeaders") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.program(6, a, 0), data: a, loc: { start: { line: 8, column: 14 }, end: { line: 18, column: 21 } } })) != null ? n : "") + `          </tr>\r
      </thead>\r
      <tbody>\r
` + ((n = r(t, "each").call(o, e != null ? r(e, "rows") : e, { name: "each", hash: {}, fn: l.program(8, a, 0), inverse: l.noop, data: a, loc: { start: { line: 22, column: 10 }, end: { line: 34, column: 19 } } })) != null ? n : "") + ((n = r(t, "unless").call(o, e != null ? r(e, "isTotals") : e, { name: "unless", hash: {}, fn: l.program(11, a, 0), inverse: l.noop, data: a, loc: { start: { line: 35, column: 10 }, end: { line: 40, column: 21 } } })) != null ? n : "") + `      </tbody>\r
`;
}, 4: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return '              <th colspan="5"><h3>' + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "groupingTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 34 }, end: { line: 9, column: 52 } } })) + `</h3></th>\r
              <th style="text-align:right">` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 43 }, end: { line: 10, column: 87 } } })) + `</th>\r
`;
}, 6: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "              <th><h3>" + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "groupingTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 22 }, end: { line: 12, column: 40 } } })) + `</h3></th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.receiver", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 18 }, end: { line: 13, column: 65 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.fromSum", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 18 }, end: { line: 14, column: 64 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.fromWorker", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 18 }, end: { line: 15, column: 67 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.fromEmployer", { name: "t", hash: {}, data: a, loc: { start: { line: 16, column: 18 }, end: { line: 16, column: 69 } } })) + `</th>\r
              <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 18 }, end: { line: 17, column: 62 } } })) + `</th>\r
`;
}, 8: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `          <tr>\r
              <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "label") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 24, column: 18 }, end: { line: 24, column: 35 } } })) + `</td>\r
              <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "receiver") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 18 }, end: { line: 25, column: 38 } } })) + `</td>\r
              <td>` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "baseAmount") : n, { name: "c", hash: { nullChar: " " }, data: a, loc: { start: { line: 26, column: 18 }, end: { line: 26, column: 52 } } })) + `</td>\r
              <td>` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "workerPercent") : n, { name: "p", hash: { nullChar: " " }, data: a, loc: { start: { line: 27, column: 18 }, end: { line: 27, column: 55 } } })) + `</td>\r
              <td>` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "employerPercent") : n, { name: "p", hash: { nullChar: " " }, data: a, loc: { start: { line: 28, column: 18 }, end: { line: 28, column: 57 } } })) + `</td>\r
              <td>` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "subTotal") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 29, column: 18 }, end: { line: 29, column: 33 } } })) + `</td>\r
          </tr>\r
` + ((n = i(t, "if").call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "comment") : n, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 31, column: 10 }, end: { line: 33, column: 17 } } })) != null ? n : "");
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return '          <tr><td colspan="6" style="padding-left: 10px;font-size: 0.8em">' + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "comment") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 32, column: 74 }, end: { line: 32, column: 92 } } })) + `</td></tr>\r
`;
}, 11: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `          <tr class="total">\r
              <td colspan="5">` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "totalTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 37, column: 30 }, end: { line: 37, column: 46 } } })) + `</td>\r
              <td style="text-align:right">` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 38, column: 43 }, end: { line: 38, column: 55 } } })) + `</td>\r
          </tr>\r
`;
}, 13: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "hasTotalValue") : e, { name: "if", hash: {}, fn: l.program(14, a, 0), inverse: l.noop, data: a, loc: { start: { line: 44, column: 8 }, end: { line: 51, column: 15 } } })) != null ? n : "";
}, 14: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `      <tfoot>\r
          <tr class="total">\r
              <th colspan="3">` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.palkkausFee", { name: "t", hash: {}, data: a, loc: { start: { line: 47, column: 30 }, end: { line: 47, column: 80 } } })) + `</th>\r
              <th colspan="3" style="text-align:right">` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 48, column: 55 }, end: { line: 48, column: 67 } } })) + `</th>\r
          </tr>\r
      </tfoot>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "rowGroups") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 56, column: 9 } } })) != null ? n : "";
}, useData: !0 });
P.registerPartial("paymentTablesV2", Ft);
const jt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "notes") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 4, column: 0 }, end: { line: 7, column: 9 } } })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "<h3>" + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "heading") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 4 }, end: { line: 5, column: 18 } } })) + `</h3>\r
<p>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "text") : e, e != null ? u(e, "parameters") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 3 }, end: { line: 6, column: 25 } } })) + `</p>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "workerDeductionWarningsV2"), e, { name: "workerDeductionWarningsV2", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "hasNotes") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 3, column: 0 }, end: { line: 8, column: 7 } } })) != null ? n : "");
}, usePartial: !0, useData: !0 });
P.registerPartial("workerCalculationAdditionalInfoV2", jt);
const Vt = P.template({ 1: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), e != null ? u(e, "hasRows") : e, { name: "if", hash: {}, fn: l.program(2, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 4, column: 0 }, end: { line: 83, column: 7 } } })) != null ? r : "";
}, 2: function(l, e, t, s, a, n, o) {
  var r, u = e ?? (l.nullContext || {}), i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `\r
<table class="salaxy-report-table report-table columns-four">\r
    <thead style="display: table-header-group;">\r
     \r
        <tr>\r
            <th><h3>` + l.escapeExpression((i(t, "t") || e && i(e, "t") || l.hooks.helperMissing).call(u, e != null ? i(e, "groupingTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 20 }, end: { line: 10, column: 38 } } })) + `</h3></th>\r
` + ((r = i(t, "if").call(u, e != null ? i(e, "isDeductions") : e, { name: "if", hash: {}, fn: l.program(3, a, 0, n, o), inverse: l.program(5, a, 0, n, o), data: a, loc: { start: { line: 11, column: 12 }, end: { line: 23, column: 19 } } })) != null ? r : "") + `        </tr>\r
    </thead>\r
    <tbody>\r
` + ((r = i(t, "each").call(u, e != null ? i(e, "rows") : e, { name: "each", hash: {}, fn: l.program(10, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 27, column: 8 }, end: { line: 61, column: 17 } } })) != null ? r : "") + ((r = i(t, "unless").call(u, e != null ? i(e, "isTotals") : e, { name: "unless", hash: {}, fn: l.program(28, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 62, column: 8 }, end: { line: 69, column: 19 } } })) != null ? r : "") + `    </tbody>\r
` + ((r = i(t, "if").call(u, e != null ? i(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(30, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 71, column: 4 }, end: { line: 80, column: 11 } } })) != null ? r : "") + `</table>\r
\r
`;
}, 3: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "            <th>" + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.percentOf", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 16 }, end: { line: 12, column: 64 } } })) + `</th>\r
            <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.fromSum", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 16 }, end: { line: 13, column: 62 } } })) + `</th>\r
            <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 16 }, end: { line: 14, column: 60 } } })) + `</th>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), e != null ? o(e, "isTotals") : e, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.program(8, a, 0), data: a, loc: { start: { line: 15, column: 12 }, end: { line: 23, column: 12 } } })) != null ? n : "";
}, 6: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return `            <th></th>\r
            <th></th>\r
            <th>` + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 16 }, end: { line: 18, column: 60 } } })) + `</th>\r
`;
}, 8: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return "            <th>" + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.amount", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 16 }, end: { line: 20, column: 61 } } })) + `</th>\r
            <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 16 }, end: { line: 21, column: 61 } } })) + `</th>\r
            <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.euros", { name: "t", hash: {}, data: a, loc: { start: { line: 22, column: 16 }, end: { line: 22, column: 60 } } })) + `</th>\r
            `;
}, 10: function(l, e, t, s, a, n, o) {
  var r, u = e ?? (l.nullContext || {}), i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td>` + l.escapeExpression((i(t, "t") || e && i(e, "t") || l.hooks.helperMissing).call(u, (r = (r = e != null ? i(e, "data") : e) != null ? i(r, "irRow") : r) != null ? i(r, "message") : r, { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 16 }, end: { line: 29, column: 41 } } })) + `</td>\r
` + ((r = i(t, "if").call(u, o[1] != null ? i(o[1], "isDeductions") : o[1], { name: "if", hash: {}, fn: l.program(11, a, 0, n, o), inverse: l.program(16, a, 0, n, o), data: a, loc: { start: { line: 30, column: 12 }, end: { line: 48, column: 19 } } })) != null ? r : "") + ((r = i(t, "if").call(u, (r = e != null ? i(e, "data") : e) != null ? i(r, "isTotalReduced") : r, { name: "if", hash: {}, fn: l.program(22, a, 0, n, o), inverse: l.program(24, a, 0, n, o), data: a, loc: { start: { line: 49, column: 12 }, end: { line: 56, column: 19 } } })) != null ? r : "") + `        </tr>\r
` + ((r = i(t, "if").call(u, (r = e != null ? i(e, "data") : e) != null ? i(r, "comment") : r, { name: "if", hash: {}, fn: l.program(26, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 58, column: 8 }, end: { line: 60, column: 15 } } })) != null ? r : "");
}, 11: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "isUnitPercent") : n, { name: "if", hash: {}, fn: l.program(12, a, 0), inverse: l.program(14, a, 0), data: a, loc: { start: { line: 31, column: 14 }, end: { line: 37, column: 21 } } })) != null ? n : "";
}, 12: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return "              <td>" + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "count") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 32, column: 18 }, end: { line: 32, column: 41 } } })) + `</td>\r
              <td>` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "price") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 33, column: 18 }, end: { line: 33, column: 41 } } })) + `</td>\r
`;
}, 14: function(l, e, t, s, a) {
  return `              <td></td>\r
              <td></td>\r
`;
}, 16: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return (r = u(t, "if").call(e ?? (l.nullContext || {}), o[1] != null ? u(o[1], "isTotals") : o[1], { name: "if", hash: {}, fn: l.program(14, a, 0, n, o), inverse: l.program(17, a, 0, n, o), data: a, loc: { start: { line: 38, column: 12 }, end: { line: 48, column: 12 } } })) != null ? r : "";
}, 17: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return ((n = r(t, "if").call(o, (n = e != null ? r(e, "data") : e) != null ? r(n, "isUnitPercent") : n, { name: "if", hash: {}, fn: l.program(18, a, 0), inverse: l.program(20, a, 0), data: a, loc: { start: { line: 42, column: 14 }, end: { line: 46, column: 23 } } })) != null ? n : "") + "              <td>" + l.escapeExpression((r(t, "c") || e && r(e, "c") || l.hooks.helperMissing).call(o, (n = (n = e != null ? r(e, "data") : e) != null ? r(n, "irRow") : n) != null ? r(n, "price") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 47, column: 18 }, end: { line: 47, column: 40 } } })) + `</td>\r
            `;
}, 18: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                <td>" + l.escapeExpression((o(t, "p") || e && o(e, "p") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "p", hash: { nullChar: " " }, data: a, loc: { start: { line: 43, column: 20 }, end: { line: 43, column: 55 } } })) + `</td>\r
`;
}, 20: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "                <td>" + l.escapeExpression((o(t, "r") || e && o(e, "r") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "count") : n, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 45, column: 20 }, end: { line: 45, column: 51 } } })) + `</td>\r
`;
}, 22: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `            <td>\r
                <span style="text-decoration: line-through">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = e != null ? i(e, "data") : e) != null ? i(n, "fullTotal") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 51, column: 60 }, end: { line: 51, column: 81 } } })) + `</span><br />\r
                ` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "data") : e) != null ? i(n, "irRow") : n) != null ? i(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 52, column: 16 }, end: { line: 52, column: 39 } } })) + `\r
            </td>\r
`;
}, 24: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "            <td>" + l.escapeExpression((o(t, "c") || e && o(e, "c") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "data") : e) != null ? o(n, "irRow") : n) != null ? o(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 55, column: 16 }, end: { line: 55, column: 39 } } })) + `</td>\r
`;
}, 26: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return '        <tr colspan="4"><td style="padding-left: 10px;font-size: 0.8em">' + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "comment") : n, { name: "t", hash: {}, data: a, loc: { start: { line: 59, column: 72 }, end: { line: 59, column: 90 } } })) + `</td></tr>\r
`;
}, 28: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `        <tr class="total">\r
            <td>` + r((u(t, "t") || e && u(e, "t") || o).call(n, e != null ? u(e, "totalTerm") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 64, column: 16 }, end: { line: 64, column: 32 } } })) + `</td>\r
            <td></td>\r
            <td></td>\r
            <td>` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 67, column: 16 }, end: { line: 67, column: 28 } } })) + `</td>\r
        </tr>\r
`;
}, 30: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `    <tfoot>\r
        <tr class="total">\r
            <th>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.toBePaid", { name: "t", hash: {}, data: a, loc: { start: { line: 74, column: 16 }, end: { line: 74, column: 63 } } })) + `</th>\r
            <th></th>\r
            <th></th>\r
            <th>` + r((u(t, "c") || e && u(e, "c") || o).call(n, e != null ? u(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 77, column: 16 }, end: { line: 77, column: 28 } } })) + `</th>\r
        </tr>\r
    </tfoot>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a, n, o) {
  var r, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `\r
<div class="additional-message pre-line">` + l.escapeExpression(l.lambda((r = (r = e != null ? u(e, "report") : e) != null ? u(r, "header") : r) != null ? u(r, "salarySlipMessage") : r, e)) + `</div>\r
` + ((r = u(t, "each").call(e ?? (l.nullContext || {}), (r = e != null ? u(e, "report") : e) != null ? u(r, "rowGroups") : r, { name: "each", hash: {}, fn: l.program(1, a, 0, n, o), inverse: l.noop, data: a, loc: { start: { line: 3, column: 0 }, end: { line: 84, column: 9 } } })) != null ? r : "");
}, useData: !0, useDepths: !0 });
P.registerPartial("workerCalculationTablesV2", Vt);
const Ut = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `    <tr>\r
        <td>` + ((n = r(t, "if").call(o, (n = (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "employmentPeriod") : n) != null ? r(n, "end") : n, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.program(4, a, 0), data: a, loc: { start: { line: 8, column: 12 }, end: { line: 8, column: 196 } } })) != null ? n : "") + `:</td>\r
        <td>` + l.escapeExpression((r(t, "d") || e && r(e, "d") || l.hooks.helperMissing).call(o, (n = (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "employmentPeriod") : n) != null ? r(n, "start") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 9, column: 12 }, end: { line: 9, column: 55 } } })) + " " + ((n = r(t, "if").call(o, (n = (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "employmentPeriod") : n) != null ? r(n, "end") : n, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 9, column: 56 }, end: { line: 9, column: 150 } } })) != null ? n : "") + `</td>\r
    </tr>\r
`;
}, 2: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.employmentPeriodStartAndEnd", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 55 }, end: { line: 8, column: 121 } } }));
}, 4: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.employmentPeriodStart", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 129 }, end: { line: 8, column: 189 } } }));
}, 6: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return " - " + l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "employmentPeriod") : n) != null ? o(n, "end") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 9, column: 102 }, end: { line: 9, column: 143 } } }));
}, 8: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.requestedSalaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 54 }, end: { line: 21, column: 112 } } }));
}, 10: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.salaryDate", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 120 }, end: { line: 21, column: 169 } } }));
}, 12: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return l.escapeExpression((o(t, "d") || e && o(e, "d") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "salaryDate") : n, { name: "d", hash: {}, data: a, loc: { start: { line: 22, column: 45 }, end: { line: 22, column: 76 } } }));
}, 14: function(l, e, t, s, a) {
  return "-";
}, 16: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `    <tr>\r
        <td>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.withholdingTax", { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 12 }, end: { line: 34, column: 65 } } })) + `:</td>\r
        <td><span>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.text.noTaxcard", { name: "t", hash: {}, data: a, loc: { start: { line: 35, column: 18 }, end: { line: 35, column: 63 } } })) + `</span></td>\r
    </tr>\r
`;
}, 18: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "noWithholdingHousehold") : n, { name: "if", hash: {}, fn: l.program(19, a, 0), inverse: l.program(21, a, 0), data: a, loc: { start: { line: 38, column: 8 }, end: { line: 68, column: 15 } } })) != null ? n : "";
}, 19: function(l, e, t, s, a) {
  var n = e ?? (l.nullContext || {}), o = l.hooks.helperMissing, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `        <tr>\r
            <td>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.heading.withholdingTax", { name: "t", hash: {}, data: a, loc: { start: { line: 40, column: 16 }, end: { line: 40, column: 69 } } })) + `:</td>\r
            <td><span>` + r((u(t, "t") || e && u(e, "t") || o).call(n, "SALAXY.REPORTS.salary.text.noWithholdingHousehold", { name: "t", hash: {}, data: a, loc: { start: { line: 41, column: 22 }, end: { line: 41, column: 80 } } })) + `</span></td>\r
        </tr>\r
`;
}, 21: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `        <tr>\r
            <td>` + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, "SALAXY.REPORTS.salary.text.percents", { name: "t", hash: {}, data: a, loc: { start: { line: 45, column: 16 }, end: { line: 45, column: 60 } } })) + `:</td>\r
` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "isTaxAtSource") : n, { name: "if", hash: {}, fn: l.program(22, a, 0), inverse: l.program(24, a, 0), data: a, loc: { start: { line: 46, column: 12 }, end: { line: 56, column: 19 } } })) != null ? n : "") + `            \r
        </tr>\r
        <tr>\r
            <td>\r
                ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardCumulativeIncome") : n, { name: "if", hash: {}, fn: l.program(33, a, 0), inverse: l.program(35, a, 0), data: a, loc: { start: { line: 61, column: 16 }, end: { line: 61, column: 225 } } })) != null ? n : "") + `\r
            </td>\r
            <td>\r
                ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardIncomeLimit") : n, { name: "if", hash: {}, fn: l.program(37, a, 0), inverse: l.program(27, a, 0), data: a, loc: { start: { line: 64, column: 16 }, end: { line: 64, column: 138 } } })) != null ? n : "") + `\r
                ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardCumulativeIncome") : n, { name: "if", hash: {}, fn: l.program(39, a, 0), inverse: l.noop, data: a, loc: { start: { line: 65, column: 16 }, end: { line: 65, column: 129 } } })) != null ? n : "") + `\r
            </td>\r
        </tr>\r
`;
}, 22: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `              <td>\r
                <span>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.taxAtSource", { name: "t", hash: {}, data: a, loc: { start: { line: 48, column: 22 }, end: { line: 48, column: 72 } } })) + `</span>\r
                <span>(` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "header") : n) != null ? i(n, "taxAtSourceDeductionPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 49, column: 23 }, end: { line: 49, column: 70 } } })) + `)</span>\r
              </td>\r
`;
}, 24: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `            <td>\r
                ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardTaxPercent") : n, { name: "if", hash: {}, fn: l.program(25, a, 0), inverse: l.program(27, a, 0), data: a, loc: { start: { line: 53, column: 16 }, end: { line: 53, column: 136 } } })) != null ? n : "") + `\r
                ` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "taxcardTaxPercent2") : n, { name: "if", hash: {}, fn: l.program(29, a, 0), inverse: l.program(31, a, 0), data: a, loc: { start: { line: 54, column: 16 }, end: { line: 54, column: 144 } } })) != null ? n : "") + `\r
            </td>\r
`;
}, 25: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "<span>" + l.escapeExpression((o(t, "p") || e && o(e, "p") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "taxcardTaxPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 53, column: 62 }, end: { line: 53, column: 100 } } })) + "</span>";
}, 27: function(l, e, t, s, a) {
  return "<span>-</span>";
}, 29: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "<span> (" + l.escapeExpression((o(t, "p") || e && o(e, "p") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "taxcardTaxPercent2") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 54, column: 65 }, end: { line: 54, column: 104 } } })) + ")</span>";
}, 31: function(l, e, t, s, a) {
  return "<span> (-)</span>";
}, 33: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "<span>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.taxcardCumulativeIncome", { name: "t", hash: {}, data: a, loc: { start: { line: 61, column: 68 }, end: { line: 61, column: 127 } } })) + ":</span>";
}, 35: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "<span>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.text.taxcardNoCumulativeIncome", { name: "t", hash: {}, data: a, loc: { start: { line: 61, column: 149 }, end: { line: 61, column: 210 } } })) + ":</span>";
}, 37: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "<span>" + l.escapeExpression((o(t, "c") || e && o(e, "c") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "taxcardIncomeLimit") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 64, column: 63 }, end: { line: 64, column: 102 } } })) + "</span>";
}, 39: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "<span> (" + l.escapeExpression((o(t, "c") || e && o(e, "c") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "report") : e) != null ? o(n, "header") : n) != null ? o(n, "taxcardCumulativeIncome") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 65, column: 70 }, end: { line: 65, column: 114 } } })) + ")</span>";
}, 41: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `    <tr>\r
        <td>` + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.salary.heading.workDescription", { name: "t", hash: {}, data: a, loc: { start: { line: 72, column: 12 }, end: { line: 72, column: 66 } } })) + `:</td>\r
        <td>` + o(l.lambda((n = (n = e != null ? r(e, "report") : e) != null ? r(n, "header") : n) != null ? r(n, "workDescription") : n, e)) + `</td>\r
    </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table class="report-table-compact" style="margin-left: 50px;">\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.worker", { name: "t", hash: {}, data: a, loc: { start: { line: 3, column: 12 }, end: { line: 3, column: 57 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "avatar") : n) != null ? c(n, "sortableName") : n, e)) + `</td>\r
    </tr>\r
` + ((n = c(t, "if").call(o, (n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "employmentPeriod") : n) != null ? c(n, "start") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 6, column: 4 }, end: { line: 11, column: 11 } } })) != null ? n : "") + `    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.socialSecurityNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 12 }, end: { line: 13, column: 71 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "socialSecurityNumberValid") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.bankAccountNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 12 }, end: { line: 17, column: 68 } } })) + `:</td>\r
        <td>` + u(i((n = (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "worker") : n) != null ? c(n, "ibanNumber") : n, e)) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "requestedSalaryDate") : n, { name: "if", hash: {}, fn: l.program(8, a, 0), inverse: l.program(10, a, 0), data: a, loc: { start: { line: 21, column: 12 }, end: { line: 21, column: 176 } } })) != null ? n : "") + `:</td>\r
        <td>` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "salaryDate") : n, { name: "if", hash: {}, fn: l.program(12, a, 0), inverse: l.program(14, a, 0), data: a, loc: { start: { line: 22, column: 12 }, end: { line: 22, column: 92 } } })) != null ? n : "") + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.workPeriod", { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 12 }, end: { line: 25, column: 61 } } })) + `:</td>\r
        <td>` + u((c(t, "d") || e && c(e, "d") || r).call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workStartDate") : n, { name: "d", hash: { end: (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workEndDate") : n }, data: a, loc: { start: { line: 26, column: 12 }, end: { line: 26, column: 76 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.numberOfWorkDays", { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 12 }, end: { line: 29, column: 67 } } })) + `:</td>\r
        <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "numberOfDays") : n, e)) + `</td>\r
    </tr>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workerHasNoTaxcard") : n, { name: "if", hash: {}, fn: l.program(16, a, 0), inverse: l.program(18, a, 0), data: a, loc: { start: { line: 32, column: 4 }, end: { line: 69, column: 11 } } })) != null ? n : "") + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "workDescription") : n, { name: "if", hash: {}, fn: l.program(41, a, 0), inverse: l.noop, data: a, loc: { start: { line: 70, column: 4 }, end: { line: 75, column: 11 } } })) != null ? n : "") + "</table>";
}, useData: !0 });
P.registerPartial("workerContractDetailsV2", Ut);
const Nt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return '<h2 class="salaxy-content-subheader">' + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.cumulativeData", { name: "t", hash: {}, data: a, loc: { start: { line: 2, column: 37 }, end: { line: 2, column: 90 } } })) + `</h2>\r
<p>&nbsp;</p>\r
<table>\r
    <tr>\r
        <th colspan="2">\r
            <h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.thisYear", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 16 }, end: { line: 7, column: 62 } } })) + `</h3>\r
        </th>\r
    </tr>\r
    <tr>\r
        <td style="width: 50%">\r
            <table>\r
                ` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "cumulative") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 13, column: 16 }, end: { line: 22, column: 39 } } })) != null ? n : "") + `\r
            </table>\r
        </td>\r
        <td style="width: 50%">\r
            <table>\r
                ` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "cumulative") : n, { name: "each", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 27, column: 16 }, end: { line: 36, column: 39 } } })) != null ? n : "") + `\r
            </table>\r
        </td>\r
    </tr>\r
    <tr>\r
        <th colspan="2">\r
            <p>&nbsp;</p>\r
            <h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.salary.heading.previousYear", { name: "t", hash: {}, data: a, loc: { start: { line: 43, column: 16 }, end: { line: 43, column: 67 } } })) + `</h3>\r
        </th>\r
    </tr>\r
    <tr>\r
        <td style="width: 50%">\r
            <table>\r
                ` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "cumulative") : n, { name: "each", hash: {}, fn: l.program(12, a, 0), inverse: l.noop, data: a, loc: { start: { line: 49, column: 16 }, end: { line: 58, column: 39 } } })) != null ? n : "") + `\r
            </table>\r
        </td>\r
        <td style="width: 50%">\r
            <table>\r
                ` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "cumulative") : n, { name: "each", hash: {}, fn: l.program(14, a, 0), inverse: l.noop, data: a, loc: { start: { line: 63, column: 16 }, end: { line: 72, column: 39 } } })) != null ? n : "") + `\r
            </table>\r
        </td>\r
    </tr>\r
</table>\r
<p>&nbsp;</p>\r
`;
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "current") : n, { name: "if", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 13, column: 43 }, end: { line: 22, column: 30 } } })) != null ? n : "";
}, 3: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "left") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 13, column: 63 }, end: { line: 22, column: 23 } } })) != null ? n : "";
}, 4: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `\r
                <tr>\r
                    <th>` + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, e != null ? r(e, "label") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 24 }, end: { line: 15, column: 36 } } })) + `</th>\r
` + ((n = r(t, "if").call(o, (n = (n = e != null ? r(e, "data") : e) != null ? r(n, "unit") : n) != null ? r(n, "days") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 16, column: 20 }, end: { line: 20, column: 27 } } })) != null ? n : "") + `                </tr>\r
                `;
}, 5: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return '                      <td class="right">' + l.escapeExpression((n(t, "r") || e && n(e, "r") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), e != null ? n(e, "total") : e, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 17, column: 40 }, end: { line: 17, column: 60 } } })) + `</td>\r
`;
}, 7: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return '                      <td class="right">' + l.escapeExpression((n(t, "c") || e && n(e, "c") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), e != null ? n(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 19, column: 40 }, end: { line: 19, column: 52 } } })) + `</td>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "current") : n, { name: "if", hash: {}, fn: l.program(10, a, 0), inverse: l.noop, data: a, loc: { start: { line: 27, column: 43 }, end: { line: 36, column: 30 } } })) != null ? n : "";
}, 10: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "right") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 27, column: 63 }, end: { line: 36, column: 23 } } })) != null ? n : "";
}, 12: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "previous") : n, { name: "if", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 49, column: 43 }, end: { line: 58, column: 30 } } })) != null ? n : "";
}, 14: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "data") : e) != null ? o(n, "previous") : n, { name: "if", hash: {}, fn: l.program(10, a, 0), inverse: l.noop, data: a, loc: { start: { line: 63, column: 43 }, end: { line: 72, column: 30 } } })) != null ? n : "";
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "cumulative") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 78, column: 7 } } })) != null ? n : "";
}, useData: !0 });
P.registerPartial("workerCumulativeTables", Nt);
const zt = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return "<h3>" + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, "SALAXY.REPORTS.salary.heading.insufficientSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 2, column: 4 }, end: { line: 2, column: 61 } } })) + `</h3>\r
<ul>\r
` + ((n = r(t, "each").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "validationMessages") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 4, column: 0 }, end: { line: 8, column: 9 } } })) != null ? n : "") + `</ul>\r
`;
}, 2: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return `    <li>\r
        ` + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), e != null ? n(e, "text") : e, e != null ? n(e, "parameters") : e, { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 8 }, end: { line: 6, column: 30 } } })) + `\r
    </li>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "hasValidationMessages") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 10, column: 7 } } })) != null ? n : "") + `\r
`;
}, useData: !0 });
P.registerPartial("workerDeductionWarningsV2", zt);
const Gt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
        <td>\r
` + ((n = l.invokePartial(o(s, "contractPartiesContactDetailsV2"), e, { name: "contractPartiesContactDetailsV2", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `        </td>\r
        <td>\r
` + ((n = l.invokePartial(o(s, "workerContractDetailsV2"), e, { name: "workerContractDetailsV2", data: a, indent: "            ", helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `        </td>\r
    </tr>\r
</table>\r
`;
}, usePartial: !0, useData: !0 });
P.registerPartial("workerReportHeadV2", Gt);
const Wt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `<div style="\r
margin-top:5mm;\r
    padding-top: 3mm;\r
    border-top: 0.75mm solid #009fd8;\r
    margin-left: 10mm;\r
    margin-right: 10mm;" class="default-footer-inner">\r
\r
  ` + l.escapeExpression((o(t, "t") || e && o(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.document.footerInfo.html", { name: "t", hash: { date: e != null ? o(e, "today") : e }, data: a, loc: { start: { line: 8, column: 2 }, end: { line: 8, column: 61 } } })) + `\r
 \r
  <div style="position: absolute;top: 8mm; right: 10mm">\r
          ` + ((n = l.invokePartial(o(s, "pageNumber"), e, { name: "pageNumber", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + " / " + ((n = l.invokePartial(o(s, "totalPages"), e, { name: "totalPages", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
          \r
  </div>\r
</div>\r
`;
}, usePartial: !0, useData: !0 });
P.registerPartial("defaultFooter", Wt);
const qt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `\r
<div style="color: #808080;\r
    margin-right: 10mm;\r
    margin-left: 10mm;\r
    border-bottom: 0.75mm solid #009fd8;\r
    padding: 10mm 0mm 0mm 0mm;" class="default-header-inner">\r
    <table style="">\r
      <tr>\r
        <td width="40%" class="logo-container"> \r
          <svg width="175px" height="40px" viewBox="0 0 668 152" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\r
            <title>Palkkaus.fi</title>\r
            <g id="Palkkaus_logo_rgb" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">\r
              <g>\r
                <path d="M495.195,118.538 C493.118,118.538 491.43,116.85 491.43,114.775 L491.43,53.743 C491.43,51.701 493.154,49.976 495.195,49.976 C497.296,49.976 499.071,51.701 499.071,53.743 L499.071,114.775 C499.071,116.886 497.368,118.538 495.195,118.538 Z M495.195,44.781 C493.118,44.781 491.43,43.092 491.43,41.016 L491.43,39.384 C491.43,37.344 493.154,35.62 495.195,35.62 C497.296,35.62 499.071,37.344 499.071,39.384 L499.071,41.016 C499.071,43.127 497.368,44.781 495.195,44.781 Z" id="Fill-5" fill="#2F3231"></path>\r
                <path d="M476.738,57.194 L468.645,57.194 L468.626,51.982 C468.626,45.466 469.175,43.165 470.711,43.165 C472.884,43.165 474.587,41.512 474.587,39.401 C474.587,37.289 472.884,35.635 470.711,35.635 C468.267,35.635 462.462,36.836 461.325,47.949 L461.321,47.991 L461.318,48.032 L461.097,52.226 L461.096,52.27 L461.096,57.194 L453.056,57.194 C451.014,57.194 449.289,58.968 449.289,61.07 C449.289,63.111 451.014,64.836 453.056,64.836 L461.096,64.836 L461.096,113.67 C461.096,115.711 462.82,117.436 464.861,117.436 C466.963,117.436 468.737,115.711 468.737,113.667 L468.66,64.836 L476.738,64.836 C478.814,64.836 480.502,63.148 480.502,61.07 C480.502,58.897 478.848,57.194 476.738,57.194" id="Fill-13" fill="#2F3231"></path>\r
                <path d="M444.976,117.415 C442.899,117.415 441.21,115.727 441.21,113.649 L441.21,112.019 C441.21,109.977 442.934,108.253 444.976,108.253 C447.077,108.253 448.851,109.977 448.851,112.019 L448.851,113.649 C448.851,115.761 447.149,117.415 444.976,117.415" id="Fill-7" fill="#2F3231"></path>\r
                <path d="M407.851,117.989 C390.358,117.989 384.949,107.462 383.281,101.186 C383.007,100.271 383.121,99.247 383.616,98.356 C384.126,97.437 384.972,96.78 386.001,96.499 L386.111,96.473 C386.36,96.423 386.614,96.398 386.866,96.398 C388.56,96.398 390.086,97.541 390.577,99.175 C392.606,106.783 398.251,110.456 407.851,110.456 C419.706,110.456 425.717,106.155 425.717,97.669 C425.717,87.376 413.67,86.319 413.548,86.312 L413.509,86.31 L413.43,86.305 L402.062,85.202 C395.571,84.722 383.225,80.546 383.225,68.2 C383.225,60.816 386.525,48.429 408.622,48.429 C418.997,48.429 426.382,52.003 430.577,59.052 C431.685,60.782 431.172,63.12 429.415,64.292 L429.298,64.362 C428.739,64.672 428.1,64.836 427.449,64.836 C426.109,64.836 424.865,64.171 424.12,63.056 L424.097,63.02 L424.075,62.985 C421.304,58.334 416.249,56.073 408.622,56.073 C392.61,56.073 390.758,62.994 390.758,68.2 C390.758,76.838 402.466,77.675 402.584,77.68 L402.624,77.681 L402.698,77.686 L414.065,78.679 C420.702,79.271 433.25,84.002 433.25,97.669 C433.25,103.779 430.775,117.989 407.851,117.989" id="Fill-12" fill="#2F3231"></path>\r
                <path d="M346.699,118.097 C324.513,118.097 321.523,102.581 321.523,87.404 L321.523,53.742 C321.523,51.594 323.14,49.976 325.288,49.976 C327.365,49.976 329.052,51.666 329.052,53.742 L329.052,87.404 C329.052,102.427 331.866,110.568 346.699,110.568 C362.311,110.568 365.449,101.704 365.449,87.404 L365.449,53.742 C365.449,51.594 367.066,49.976 369.213,49.976 C371.361,49.976 372.979,51.594 372.979,53.742 L372.979,87.404 C372.979,101.694 369.992,118.097 346.699,118.097" id="Fill-9" fill="#2F3231"></path>\r
                <path d="M284.47,57.398 C269.637,57.398 266.823,65.539 266.823,80.561 L266.823,86.632 C266.823,101.724 269.671,109.904 284.691,109.904 C297.773,109.904 303.109,104.025 303.109,89.612 L303.219,80.54 C303.289,71.105 301.763,65.326 298.272,61.808 C295.327,58.839 290.811,57.398 284.47,57.398 Z M306.874,117.436 C304.834,117.436 303.109,115.711 303.109,113.671 L303.109,111.479 C298.869,115.479 292.796,117.436 284.691,117.436 C262.307,117.436 259.289,101.863 259.289,86.632 L259.289,80.561 C259.289,65.328 262.282,49.754 284.47,49.754 C292.9,49.754 299.366,51.964 303.686,56.318 C310.063,62.742 310.811,72.654 310.752,80.574 L310.752,113.671 C310.752,115.711 308.975,117.436 306.874,117.436 Z" id="Fill-8" fill="#2F3231"></path>\r
                <path d="M209.297,117.436 C207.221,117.436 205.531,115.747 205.531,113.671 L205.531,39.37 C205.531,37.329 207.257,35.605 209.297,35.605 C211.398,35.605 213.175,37.329 213.175,39.37 L213.175,79.607 L219.828,79.607 C219.833,79.607 222.523,79.615 224.091,79.615 C239.712,79.598 242.84,70.741 242.84,56.454 L242.84,53.742 C242.84,51.594 244.46,49.974 246.605,49.974 C248.752,49.974 250.371,51.594 250.371,53.742 L250.371,56.454 C250.371,66.101 249.093,77.586 239.787,83.382 C249.093,89.177 250.371,100.662 250.371,110.309 L250.371,113.656 C250.371,115.803 248.752,117.422 246.605,117.422 C244.46,117.422 242.84,115.803 242.84,113.656 L242.84,110.309 C242.84,96.022 239.712,87.163 224.135,87.148 C222.523,87.149 219.833,87.157 219.833,87.157 L213.175,87.157 L213.175,113.671 C213.175,115.783 211.471,117.436 209.297,117.436" id="Fill-11" fill="#2F3231"></path>\r
                <path d="M152.456,117.436 C150.379,117.436 148.689,115.747 148.689,113.671 L148.689,39.37 C148.689,37.329 150.414,35.605 152.456,35.605 C154.557,35.605 156.332,37.329 156.332,39.37 L156.332,79.607 L162.986,79.607 C162.99,79.607 165.68,79.615 167.248,79.615 C182.869,79.598 185.998,70.741 185.998,56.454 L185.998,53.742 C185.998,51.594 187.617,49.974 189.763,49.974 C191.909,49.974 193.528,51.594 193.528,53.742 L193.528,56.454 C193.528,66.101 192.251,77.586 182.944,83.382 C192.251,89.177 193.528,100.662 193.528,110.309 L193.528,113.656 C193.528,115.803 191.909,117.422 189.763,117.422 C187.617,117.422 185.998,115.803 185.998,113.656 L185.998,110.309 C185.998,96.022 182.869,87.163 167.292,87.148 C165.68,87.149 162.99,87.157 162.99,87.157 L156.332,87.157 L156.332,113.671 C156.332,115.783 154.628,117.436 152.456,117.436" id="Fill-10" fill="#2F3231"></path>\r
                <path d="M131.935,101.06 C131.935,107.575 132.484,109.876 134.02,109.876 C136.192,109.876 137.896,111.529 137.896,113.64 C137.896,115.752 136.192,117.407 134.02,117.407 C131.576,117.407 125.771,116.205 124.634,105.092 L124.63,105.05 L124.626,105.009 L124.406,100.816 L124.404,100.771 L124.404,39.372 C124.404,37.33 126.129,35.605 128.17,35.605 C130.271,35.605 132.046,37.33 132.046,39.374 L131.935,101.06" id="Fill-14" fill="#2F3231"></path>\r
                <path d="M85.293,57.398 C70.461,57.398 67.649,65.539 67.649,80.561 L67.649,86.632 C67.649,101.724 70.495,109.904 85.515,109.904 C98.597,109.904 103.932,104.025 103.932,89.612 L104.043,80.54 C104.113,71.105 102.587,65.326 99.096,61.808 C96.15,58.839 91.635,57.398 85.293,57.398 Z M107.699,117.436 C105.657,117.436 103.932,115.711 103.932,113.671 L103.932,111.479 C99.693,115.479 93.619,117.436 85.515,117.436 C63.134,117.436 60.116,101.863 60.116,86.632 L60.116,80.561 C60.116,65.328 63.109,49.754 85.293,49.754 C93.724,49.754 100.19,51.964 104.51,56.318 C110.886,62.74 111.634,72.654 111.575,80.574 L111.575,113.671 C111.575,115.711 109.8,117.436 107.699,117.436 Z" id="Fill-4" fill="#2F3231"></path>\r
                <path d="M25.066,56.625 C10.325,56.625 7.532,64.727 7.532,79.677 L7.532,86.961 C7.532,101.985 10.361,110.126 25.287,110.126 C40.771,110.126 43.706,101.985 43.706,86.961 L43.706,79.677 C43.706,65.077 40.657,56.625 25.066,56.625 Z M3.766,132.867 C1.725,132.867 0,131.142 0,129.101 L0,79.677 C0,64.553 2.979,49.094 25.066,49.094 C48.361,49.094 51.348,65.438 51.348,79.677 L51.348,86.961 C51.348,101.253 48.385,117.658 25.287,117.658 C17.558,117.658 11.702,115.774 7.532,111.923 L7.532,129.101 C7.532,131.178 5.843,132.867 3.766,132.867 Z" id="Fill-1" fill="#2F3231"></path>\r
                <g id="GraphicLogo" transform="translate(527.000000, 0.000000)">\r
                  <path d="M18.633,90.281 C13.09,93.033 8.269,97.393 4.944,103.157 C-4.049,118.726 1.281,138.638 16.858,147.632 C21.986,150.593 27.584,152 33.108,152 C44.362,152 55.308,146.158 61.34,135.712 C64.677,129.929 66.038,123.545 65.635,117.345 C63.095,117.821 60.537,118.056 57.991,118.056 C43.576,118.056 29.556,110.574 21.831,97.19 C20.535,94.947 19.472,92.636 18.633,90.281" id="Fill-15" fill="#BF196F"></path>\r
                  <path d="M107.683,43.881 C101.036,43.881 94.859,45.87 89.707,49.285 C91.319,51.182 92.784,53.25 94.073,55.483 C103.167,71.241 100.814,90.458 89.598,103.519 C94.771,106.98 100.989,108.997 107.683,108.997 C125.662,108.997 140.237,94.421 140.237,76.443 C140.237,58.457 125.662,43.881 107.683,43.881" id="Fill-16" fill="#1795C5"></path>\r
                  <path d="M65.576,35.334 C64.902,45.837 59.157,55.819 49.353,61.475 C44.228,64.433 38.633,65.839 33.111,65.839 C28.084,65.839 23.116,64.672 18.62,62.452 C15.508,71.278 15.366,81.102 18.633,90.28 C23.139,88.042 28.124,86.869 33.169,86.868 C38.693,86.868 44.291,88.275 49.419,91.237 C59.208,96.889 64.951,106.855 65.634,117.346 C70.149,116.5 74.6,114.887 78.802,112.461 C82.995,110.038 86.611,106.996 89.598,103.519 C80.868,97.68 75.119,87.732 75.119,76.443 C75.119,65.102 80.916,55.116 89.708,49.285 C83.386,41.848 74.793,37.05 65.576,35.334" id="Fill-17" fill="#82BE44"></path>\r
                  <path d="M33.169,86.868 C28.124,86.868 23.139,88.042 18.633,90.281 C19.472,92.635 20.535,94.948 21.831,97.19 C29.556,110.574 43.576,118.055 57.991,118.055 C60.537,118.055 63.096,117.821 65.635,117.345 C64.951,106.855 59.208,96.889 49.419,91.237 C44.291,88.275 38.693,86.868 33.169,86.868" id="Fill-18" fill="#66292B"></path>\r
                  <path d="M89.707,49.286 C80.916,55.116 75.119,65.101 75.119,76.442 C75.119,87.732 80.868,97.679 89.598,103.519 C100.814,90.458 103.167,71.241 94.073,55.482 C92.784,53.25 91.319,51.182 89.707,49.286" id="Fill-19" fill="#2C9250"></path>\r
                  <path d="M33.05,0.712 C27.527,0.712 21.925,2.12 16.798,5.08 C1.222,14.074 -4.109,33.981 4.877,49.555 C8.216,55.333 13.054,59.701 18.62,62.452 C21.812,53.397 28.13,45.395 37.095,40.219 C43.665,36.427 50.837,34.626 57.912,34.624 C60.492,34.624 63.057,34.864 65.576,35.334 C65.972,29.141 64.608,22.771 61.274,16.993 C55.247,6.55 44.303,0.711 33.05,0.712" id="Fill-21" fill="#EA893F"></path>\r
                  <path d="M57.913,34.624 C50.837,34.626 43.665,36.427 37.095,40.219 C28.13,45.395 21.812,53.398 18.62,62.452 C23.116,64.672 28.084,65.839 33.111,65.839 C38.633,65.839 44.228,64.433 49.353,61.475 C59.157,55.818 64.903,45.837 65.576,35.334 C63.057,34.864 60.492,34.624 57.913,34.624" id="Fill-23" fill="#55663D"></path>\r
                </g>\r
              </g>\r
            </g>\r
          </svg>\r
        </td>\r
        <td width="60%" style="font-weight: bold">\r
          <div style="font-size: 1.3em; margin-left: 50px;">` + i((n = (n = c(t, "title") || (e != null ? c(e, "title") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "title", hash: {}, data: a, loc: { start: { line: 39, column: 60 }, end: { line: 39, column: 71 } } }) : n)) + `</div>\r
          <div style="font-size: 1.1em;padding-bottom: 2mm; margin-left: 50px;">` + i((n = (n = c(t, "subTitle") || (e != null ? c(e, "subTitle") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "subTitle", hash: {}, data: a, loc: { start: { line: 40, column: 80 }, end: { line: 40, column: 94 } } }) : n)) + `</div>\r
        </td>\r
      </tr>\r
    </table>\r
  </div>`;
}, useData: !0 });
P.registerPartial("defaultHeader", qt);
const Kt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return (n = (o = (o = r(t, "img2") || (e != null ? r(e, "img2") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "img2", hash: {}, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 12 } } }) : o)) != null ? n : "";
}, useData: !0 });
P.registerPartial("img2", Kt);
const Jt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return (n = (o = (o = r(t, "logo") || (e != null ? r(e, "logo") : e)) != null ? o : l.hooks.helperMissing, typeof o == "function" ? o.call(e ?? (l.nullContext || {}), { name: "logo", hash: {}, data: a, loc: { start: { line: 1, column: 0 }, end: { line: 1, column: 12 } } }) : o)) != null ? n : "";
}, useData: !0 });
P.registerPartial("logo", Jt);
const Qt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  return '<span class="pageNumber">1</span>';
}, useData: !0 });
P.registerPartial("pageNumber", Qt);
const Zt = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  return '<span class="totalPages">1</span>';
}, useData: !0 });
P.registerPartial("totalPages", Zt);
const er = P.template({ compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table>\r
  <tr>\r
    <td>\r
      <table>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.summary.heading.name", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 14 }, end: { line: 6, column: 57 } } })) + `:</td>\r
          <td><strong>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "employer") : n) != null ? c(n, "firstName") : n, e)) + " " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "employer") : n) != null ? c(n, "lastName") : n, e)) + `</strong></td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.summary.heading.businessId", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 14 }, end: { line: 10, column: 63 } } })) + `:</td>\r
          <td>` + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "businessId") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.summary.heading.email", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 14 }, end: { line: 14, column: 58 } } })) + `:</td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "contact") : n) != null ? c(n, "email") : n, e)) + `</td>\r
        </tr>\r
      </table>\r
    </td>\r
  </tr>\r
</table>\r
`;
}, useData: !0 });
P.registerPartial("summaryReportHead", er);
const nr = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `      <tr>\r
        <td colspan="16" style="border-right: 1px solid #000"><strong>` + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, "SALAXY.REPORTS.summary.table.entrepreneurSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 70 }, end: { line: 34, column: 125 } } })) + `</strong></td>\r
        <td colspan="7"></td>\r
      </tr>\r
` + ((n = r(t, "each").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "result") : n) != null ? r(n, "entrepreneurResult") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 37, column: 6 }, end: { line: 64, column: 15 } } })) != null ? n : "");
}, 2: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `        <tr>\r
          <td class="right">` + i((n = (n = c(t, "worker") || (e != null ? c(e, "worker") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "worker", hash: {}, data: a, loc: { start: { line: 39, column: 28 }, end: { line: 39, column: 38 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "workStartDate") || (e != null ? c(e, "workStartDate") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "workStartDate", hash: {}, data: a, loc: { start: { line: 40, column: 28 }, end: { line: 40, column: 45 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "workStartEndDate") || (e != null ? c(e, "workStartEndDate") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "workStartEndDate", hash: {}, data: a, loc: { start: { line: 41, column: 28 }, end: { line: 41, column: 48 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalGrossSalary") || (e != null ? c(e, "totalGrossSalary") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalGrossSalary", hash: {}, data: a, loc: { start: { line: 42, column: 28 }, end: { line: 42, column: 48 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalRowCategory") || (e != null ? c(e, "totalRowCategory") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalRowCategory", hash: {}, data: a, loc: { start: { line: 43, column: 28 }, end: { line: 43, column: 48 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "benefits") || (e != null ? c(e, "benefits") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "benefits", hash: {}, data: a, loc: { start: { line: 44, column: 28 }, end: { line: 44, column: 40 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "irCode") || (e != null ? c(e, "irCode") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "irCode", hash: {}, data: a, loc: { start: { line: 45, column: 28 }, end: { line: 45, column: 38 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalTaxable") || (e != null ? c(e, "totalTaxable") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalTaxable", hash: {}, data: a, loc: { start: { line: 46, column: 28 }, end: { line: 46, column: 44 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "tax") || (e != null ? c(e, "tax") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "tax", hash: {}, data: a, loc: { start: { line: 47, column: 28 }, end: { line: 47, column: 35 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "pension") || (e != null ? c(e, "pension") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "pension", hash: {}, data: a, loc: { start: { line: 48, column: 28 }, end: { line: 48, column: 39 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "unemploymentInsurance") || (e != null ? c(e, "unemploymentInsurance") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "unemploymentInsurance", hash: {}, data: a, loc: { start: { line: 49, column: 28 }, end: { line: 49, column: 53 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "unionPayment") || (e != null ? c(e, "unionPayment") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "unionPayment", hash: {}, data: a, loc: { start: { line: 50, column: 28 }, end: { line: 50, column: 44 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "foreclosure") || (e != null ? c(e, "foreclosure") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "foreclosure", hash: {}, data: a, loc: { start: { line: 51, column: 28 }, end: { line: 51, column: 43 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "otherDeductions") || (e != null ? c(e, "otherDeductions") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "otherDeductions", hash: {}, data: a, loc: { start: { line: 52, column: 28 }, end: { line: 52, column: 47 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalExpenses") || (e != null ? c(e, "totalExpenses") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalExpenses", hash: {}, data: a, loc: { start: { line: 53, column: 28 }, end: { line: 53, column: 45 } } }) : n)) + `</td>\r
          <td class="right" style="border-right: 1px solid #000">` + i((n = (n = c(t, "totalWorkerPayment") || (e != null ? c(e, "totalWorkerPayment") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalWorkerPayment", hash: {}, data: a, loc: { start: { line: 54, column: 65 }, end: { line: 54, column: 87 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalPayment") || (e != null ? c(e, "totalPayment") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalPayment", hash: {}, data: a, loc: { start: { line: 55, column: 28 }, end: { line: 55, column: 44 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "palkkaus") || (e != null ? c(e, "palkkaus") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "palkkaus", hash: {}, data: a, loc: { start: { line: 56, column: 28 }, end: { line: 56, column: 40 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "service") || (e != null ? c(e, "service") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "service", hash: {}, data: a, loc: { start: { line: 57, column: 28 }, end: { line: 57, column: 39 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "socialSecurity") || (e != null ? c(e, "socialSecurity") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "socialSecurity", hash: {}, data: a, loc: { start: { line: 58, column: 28 }, end: { line: 58, column: 46 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "totalPensions") || (e != null ? c(e, "totalPensions") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "totalPensions", hash: {}, data: a, loc: { start: { line: 59, column: 28 }, end: { line: 59, column: 45 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "employerPension") || (e != null ? c(e, "employerPension") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "employerPension", hash: {}, data: a, loc: { start: { line: 60, column: 28 }, end: { line: 60, column: 47 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "unemployment") || (e != null ? c(e, "unemployment") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "unemployment", hash: {}, data: a, loc: { start: { line: 61, column: 28 }, end: { line: 61, column: 44 } } }) : n)) + `</td>\r
          <td class="right">` + i((n = (n = c(t, "employerUnemployment") || (e != null ? c(e, "employerUnemployment") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "employerUnemployment", hash: {}, data: a, loc: { start: { line: 62, column: 28 }, end: { line: 62, column: 52 } } }) : n)) + `</td>\r
        </tr>\r
`;
}, 4: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `      <tr>\r
        <td colspan="16" style="border-right: 1px solid #000"><strong>` + l.escapeExpression((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(o, "SALAXY.REPORTS.summary.table.workerSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 68, column: 70 }, end: { line: 68, column: 119 } } })) + `</strong></td>\r
        <td colspan="8"></td>\r
      </tr>\r
` + ((n = r(t, "each").call(o, (n = (n = e != null ? r(e, "report") : e) != null ? r(n, "result") : n) != null ? r(n, "workerResult") : n, { name: "each", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 71, column: 6 }, end: { line: 98, column: 15 } } })) != null ? n : "");
}, 6: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = o(t, "each").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "totalResult") : n, { name: "each", hash: {}, fn: l.program(7, a, 0), inverse: l.noop, data: a, loc: { start: { line: 101, column: 6 }, end: { line: 128, column: 15 } } })) != null ? n : "";
}, 7: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = "function", c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `      <tr>\r
        <td class="right"><strong>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 103, column: 34 }, end: { line: 103, column: 76 } } })) + `:</strong></td>\r
        <td class="right"></td>\r
        <td class="right"></td>\r
        <td class="right">` + u((n = (n = c(t, "totalGrossSalary") || (e != null ? c(e, "totalGrossSalary") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalGrossSalary", hash: {}, data: a, loc: { start: { line: 106, column: 26 }, end: { line: 106, column: 46 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "totalRowCategory") || (e != null ? c(e, "totalRowCategory") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalRowCategory", hash: {}, data: a, loc: { start: { line: 107, column: 26 }, end: { line: 107, column: 46 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "benefits") || (e != null ? c(e, "benefits") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "benefits", hash: {}, data: a, loc: { start: { line: 108, column: 26 }, end: { line: 108, column: 38 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "irCode") || (e != null ? c(e, "irCode") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "irCode", hash: {}, data: a, loc: { start: { line: 109, column: 26 }, end: { line: 109, column: 36 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "totalTaxable") || (e != null ? c(e, "totalTaxable") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalTaxable", hash: {}, data: a, loc: { start: { line: 110, column: 26 }, end: { line: 110, column: 42 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "tax") || (e != null ? c(e, "tax") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "tax", hash: {}, data: a, loc: { start: { line: 111, column: 26 }, end: { line: 111, column: 33 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "pension") || (e != null ? c(e, "pension") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "pension", hash: {}, data: a, loc: { start: { line: 112, column: 26 }, end: { line: 112, column: 37 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "unemploymentInsurance") || (e != null ? c(e, "unemploymentInsurance") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "unemploymentInsurance", hash: {}, data: a, loc: { start: { line: 113, column: 26 }, end: { line: 113, column: 51 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "unionPayment") || (e != null ? c(e, "unionPayment") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "unionPayment", hash: {}, data: a, loc: { start: { line: 114, column: 26 }, end: { line: 114, column: 42 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "foreclosure") || (e != null ? c(e, "foreclosure") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "foreclosure", hash: {}, data: a, loc: { start: { line: 115, column: 26 }, end: { line: 115, column: 41 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "otherDeductions") || (e != null ? c(e, "otherDeductions") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "otherDeductions", hash: {}, data: a, loc: { start: { line: 116, column: 26 }, end: { line: 116, column: 45 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "totalExpenses") || (e != null ? c(e, "totalExpenses") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalExpenses", hash: {}, data: a, loc: { start: { line: 117, column: 26 }, end: { line: 117, column: 43 } } }) : n)) + `</td>\r
        <td class="right" style="border-right: 1px solid #000">` + u((n = (n = c(t, "totalWorkerPayment") || (e != null ? c(e, "totalWorkerPayment") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalWorkerPayment", hash: {}, data: a, loc: { start: { line: 118, column: 63 }, end: { line: 118, column: 85 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "totalPayment") || (e != null ? c(e, "totalPayment") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalPayment", hash: {}, data: a, loc: { start: { line: 119, column: 26 }, end: { line: 119, column: 42 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "palkkaus") || (e != null ? c(e, "palkkaus") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "palkkaus", hash: {}, data: a, loc: { start: { line: 120, column: 26 }, end: { line: 120, column: 38 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "service") || (e != null ? c(e, "service") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "service", hash: {}, data: a, loc: { start: { line: 121, column: 26 }, end: { line: 121, column: 37 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "socialSecurity") || (e != null ? c(e, "socialSecurity") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "socialSecurity", hash: {}, data: a, loc: { start: { line: 122, column: 26 }, end: { line: 122, column: 44 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "totalPensions") || (e != null ? c(e, "totalPensions") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "totalPensions", hash: {}, data: a, loc: { start: { line: 123, column: 26 }, end: { line: 123, column: 43 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "employerPension") || (e != null ? c(e, "employerPension") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "employerPension", hash: {}, data: a, loc: { start: { line: 124, column: 26 }, end: { line: 124, column: 45 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "unemployment") || (e != null ? c(e, "unemployment") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "unemployment", hash: {}, data: a, loc: { start: { line: 125, column: 26 }, end: { line: 125, column: 42 } } }) : n)) + `</td>\r
        <td class="right">` + u((n = (n = c(t, "employerUnemployment") || (e != null ? c(e, "employerUnemployment") : e)) != null ? n : r, typeof n === i ? n.call(o, { name: "employerUnemployment", hash: {}, data: a, loc: { start: { line: 126, column: 26 }, end: { line: 126, column: 50 } } }) : n)) + `</td>\r
      </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `<p>&nbsp;</p>\r
<table class="table table-striped table-condensed">\r
  <thead style="display: table-header-group;">\r
    <tr>\r
      <th></th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.workStartDate", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 24 }, end: { line: 6, column: 74 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.workStartEndDate", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 24 }, end: { line: 7, column: 77 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalGrossSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 24 }, end: { line: 8, column: 77 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalRowCategory", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 24 }, end: { line: 9, column: 77 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.benefits", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 24 }, end: { line: 10, column: 69 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.irCode", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 24 }, end: { line: 11, column: 67 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalTaxable", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 24 }, end: { line: 12, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.tax", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 24 }, end: { line: 13, column: 64 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.pension", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 24 }, end: { line: 14, column: 68 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.unemploymentInsurance", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 24 }, end: { line: 15, column: 82 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.unionPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 16, column: 24 }, end: { line: 16, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.foreclosure", { name: "t", hash: {}, data: a, loc: { start: { line: 17, column: 24 }, end: { line: 17, column: 72 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.otherDeductions", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 24 }, end: { line: 18, column: 76 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalExpenses", { name: "t", hash: {}, data: a, loc: { start: { line: 19, column: 24 }, end: { line: 19, column: 74 } } })) + `</th>\r
      <th class="right" style="border-right: 1px solid #000">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalWorkerPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 61 }, end: { line: 20, column: 116 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 21, column: 24 }, end: { line: 21, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.palkkaus", { name: "t", hash: {}, data: a, loc: { start: { line: 22, column: 24 }, end: { line: 22, column: 69 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.service", { name: "t", hash: {}, data: a, loc: { start: { line: 23, column: 24 }, end: { line: 23, column: 68 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.socialSecurity", { name: "t", hash: {}, data: a, loc: { start: { line: 24, column: 24 }, end: { line: 24, column: 75 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.totalPensions", { name: "t", hash: {}, data: a, loc: { start: { line: 25, column: 24 }, end: { line: 25, column: 74 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.employerPension", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 24 }, end: { line: 26, column: 76 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.unemployment", { name: "t", hash: {}, data: a, loc: { start: { line: 27, column: 24 }, end: { line: 27, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.table.employerUnemployment", { name: "t", hash: {}, data: a, loc: { start: { line: 28, column: 24 }, end: { line: 28, column: 81 } } })) + `</th>\r
    </tr>\r
  </thead>\r
  <tbody>    \r
` + ((n = i(t, "if").call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "entrepreneurResult") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 32, column: 4 }, end: { line: 65, column: 11 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerResult") : n, { name: "if", hash: {}, fn: l.program(4, a, 0), inverse: l.noop, data: a, loc: { start: { line: 66, column: 4 }, end: { line: 99, column: 11 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "totalResult") : n, { name: "if", hash: {}, fn: l.program(6, a, 0), inverse: l.noop, data: a, loc: { start: { line: 100, column: 4 }, end: { line: 129, column: 11 } } })) != null ? n : "") + `  </tbody>\r
</table>\r
<small>\r
  <small>\r
    <div>\r
      <span>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.infoText.tt", { name: "t", hash: {}, data: a, loc: { start: { line: 135, column: 12 }, end: { line: 135, column: 54 } } })) + `</span><br />\r
      <span>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.infoText.ta", { name: "t", hash: {}, data: a, loc: { start: { line: 136, column: 12 }, end: { line: 136, column: 54 } } })) + `</span><br />\r
      <span>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.summary.infoText.lo", { name: "t", hash: {}, data: a, loc: { start: { line: 137, column: 12 }, end: { line: 137, column: 54 } } })) + `</span><br />\r
    </div>\r
  </small>\r
</small>`;
}, useData: !0 });
P.registerPartial("summaryReportTable", nr);
const lr = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return " " + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.iamPerson.dateOfBirth", { name: "t", hash: {}, data: a, loc: { start: { line: 3, column: 25 }, end: { line: 3, column: 69 } } })) + ": " + o(l.lambda((n = e != null ? r(e, "kyc") : e) != null ? r(n, "dateOfBirth") : n, e)) + " ";
}, 3: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return " " + o((r(t, "t") || e && r(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.iamPerson.yes", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 61 }, end: { line: 6, column: 97 } } })) + ": " + o(l.lambda((n = e != null ? r(e, "kyc") : e) != null ? r(n, "pepReason") : n, e)) + " ";
}, 5: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return " " + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.iamPerson.no", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 128 }, end: { line: 6, column: 163 } } })) + " ";
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = "function", c = l.escapeExpression, f = l.lambda, m = l.lookupProperty || function(p, w) {
    if (Object.prototype.hasOwnProperty.call(p, w))
      return p[w];
  };
  return "<h3>" + c((o = (o = m(t, "name") || (e != null ? m(e, "name") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "name", hash: {}, data: a, loc: { start: { line: 1, column: 4 }, end: { line: 1, column: 12 } } }) : o)) + " (" + c((o = (o = m(t, "officialId") || (e != null ? m(e, "officialId") : e)) != null ? o : u, typeof o === i ? o.call(r, { name: "officialId", hash: {}, data: a, loc: { start: { line: 1, column: 14 }, end: { line: 1, column: 28 } } }) : o)) + `)</h3>\r
\r
` + ((n = m(t, "if").call(r, (n = e != null ? m(e, "kyc") : e) != null ? m(n, "dateOfBirth") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 3, column: 0 }, end: { line: 3, column: 98 } } })) != null ? n : "") + `</div>\r
\r
<div>` + c((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.iamPerson.updatedAt", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 5 }, end: { line: 5, column: 47 } } })) + ": " + c(f((n = e != null ? m(e, "kyc") : e) != null ? m(n, "updatedAt") : n, e)) + `</div>\r
<div>` + c((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.iamPerson.pep", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 5 }, end: { line: 6, column: 41 } } })) + ": " + ((n = m(t, "if").call(r, (n = e != null ? m(e, "kyc") : e) != null ? m(n, "isPep") : n, { name: "if", hash: {}, fn: l.program(3, a, 0), inverse: l.program(5, a, 0), data: a, loc: { start: { line: 6, column: 43 }, end: { line: 6, column: 171 } } })) != null ? n : "") + `</div>\r
<div>` + c((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.iamPerson.ownership", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 5 }, end: { line: 7, column: 47 } } })) + ": " + c(f((n = e != null ? m(e, "kyc") : e) != null ? m(n, "ownership") : n, e)) + `</div>\r
<div>` + c((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.iamPerson.citizenship", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 5 }, end: { line: 8, column: 49 } } })) + ": " + c(f((n = e != null ? m(e, "kyc") : e) != null ? m(n, "citizenship") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "kyc") : e) != null ? m(n, "citizenshipOtherName") : n, e)) + `</div>\r
\r
<div><strong>` + c((m(t, "t") || e && m(e, "t") || u).call(r, "SALAXY.REPORTS.iamPerson.contactInfo", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 13 }, end: { line: 11, column: 57 } } })) + `</strong></div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "email") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "telephone") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "street") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "postalCode") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "city") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "country") : n, e)) + `</div>\r
<div>` + c(f((n = e != null ? m(e, "contact") : e) != null ? m(n, "countryOtherName") : n, e)) + "</div>";
}, useData: !0 });
P.registerPartial("iamPerson", lr);
const tr = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return "          " + l.escapeExpression(l.lambda((n = (n = e != null ? o(e, "report") : e) != null ? o(n, "recipient") : n) != null ? o(n, "officialId") : n, e)) + `<br />\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `<table>\r
  <colgroup>\r
    <col width="40%" />\r
    <col width="60%" />\r
  </colgroup>\r
  <tr>\r
    <td>\r
      <div style="margin-top: 4mm; margin-left: 10mm">\r
         <b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.payer", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 12 }, end: { line: 9, column: 57 } } })) + `:</b>\r
        <div class="uppercase">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "payer") : n) != null ? c(n, "name") : n, e)) + `</div>\r
        ` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "payer") : n) != null ? c(n, "officialId") : n, e)) + `<br />\r
        ` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "payer") : n) != null ? c(n, "street") : n, e)) + `<br />\r
        ` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "payer") : n) != null ? c(n, "postalCode") : n, e)) + " " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "payer") : n) != null ? c(n, "city") : n, e)) + `\r
      </div>\r
    </td>\r
    <td>\r
       <div style="margin-top: 4mm; margin-left: 50px;">\r
        <b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.recipient", { name: "t", hash: {}, data: a, loc: { start: { line: 18, column: 11 }, end: { line: 18, column: 60 } } })) + `:</b>\r
        <div class="uppercase">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "name") : n, e)) + `</div>\r
` + ((n = c(t, "if").call(o, (n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "officialId") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 20, column: 8 }, end: { line: 22, column: 15 } } })) != null ? n : "") + "        " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "street") : n, e)) + `<br />\r
        ` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "postalCode") : n, e)) + " " + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "city") : n, e)) + `\r
      </div>\r
      <br/>\r
      <br/>\r
      <table class="report-table-compact" style="margin-left: 50px;">\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.date", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 17 }, end: { line: 30, column: 61 } } })) + `:</b></td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "date") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.dueDate", { name: "t", hash: {}, data: a, loc: { start: { line: 34, column: 17 }, end: { line: 34, column: 64 } } })) + `:</b></td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "dueDate") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.referenceNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 38, column: 17 }, end: { line: 38, column: 72 } } })) + `:</b></td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "referenceNumber") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.iban", { name: "t", hash: {}, data: a, loc: { start: { line: 42, column: 17 }, end: { line: 42, column: 61 } } })) + `:</b></td>\r
          <td><small>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "iban") : n, e)) + `</small></td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.bic", { name: "t", hash: {}, data: a, loc: { start: { line: 46, column: 17 }, end: { line: 46, column: 60 } } })) + `:</b></td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "recipient") : n) != null ? c(n, "bic") : n, e)) + `</td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.heading.message", { name: "t", hash: {}, data: a, loc: { start: { line: 50, column: 17 }, end: { line: 50, column: 64 } } })) + `:</b></td>\r
          <td>` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "header") : n) != null ? c(n, "message") : n, e)) + `</td>\r
        </tr>\r
      </table>\r
    </td>\r
  </tr>\r
</table>\r
<br/>\r
<br/>`;
}, useData: !0 });
P.registerPartial("invoiceHead", tr);
const rr = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = "function", i = l.escapeExpression, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `    <tr>\r
      <td class="left">` + i((n = (n = c(t, "message") || (e != null ? c(e, "message") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "message", hash: {}, data: a, loc: { start: { line: 16, column: 23 }, end: { line: 16, column: 34 } } }) : n)) + `</td>\r
      <td class="left">\r
        ` + i((n = (n = c(t, "articleName") || (e != null ? c(e, "articleName") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "articleName", hash: {}, data: a, loc: { start: { line: 18, column: 8 }, end: { line: 18, column: 23 } } }) : n)) + ` <br />\r
        ` + i((n = (n = c(t, "accountingAccountNumber") || (e != null ? c(e, "accountingAccountNumber") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "accountingAccountNumber", hash: {}, data: a, loc: { start: { line: 19, column: 8 }, end: { line: 19, column: 35 } } }) : n)) + " " + i((n = (n = c(t, "accountingCode") || (e != null ? c(e, "accountingCode") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "accountingCode", hash: {}, data: a, loc: { start: { line: 19, column: 36 }, end: { line: 19, column: 54 } } }) : n)) + `\r
      </td>\r
      <td class="right">` + i((n = (n = c(t, "count") || (e != null ? c(e, "count") : e)) != null ? n : r, typeof n === u ? n.call(o, { name: "count", hash: {}, data: a, loc: { start: { line: 21, column: 24 }, end: { line: 21, column: 33 } } }) : n)) + `</td>\r
      <td class="right">` + i((c(t, "c") || e && c(e, "c") || r).call(o, e != null ? c(e, "price") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 22, column: 24 }, end: { line: 22, column: 35 } } })) + `</td>\r
      <td class="right">` + i((c(t, "p") || e && c(e, "p") || r).call(o, e != null ? c(e, "vatPercent") : e, { name: "p", hash: { dec: null }, data: a, loc: { start: { line: 23, column: 24 }, end: { line: 23, column: 49 } } })) + `</td>\r
      <td class="right">` + i((c(t, "c") || e && c(e, "c") || r).call(o, e != null ? c(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 24, column: 24 }, end: { line: 24, column: 35 } } })) + `</td>\r
    </tr>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `          <tr>\r
            <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.taxSocialSecurity", { name: "t", hash: {}, data: a, loc: { start: { line: 41, column: 16 }, end: { line: 41, column: 71 } } })) + `:</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "taxSocialSecurity") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 42, column: 30 }, end: { line: 42, column: 68 } } })) + `</td>\r
          </tr>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `          <tr>\r
            <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.taxWithholding", { name: "t", hash: {}, data: a, loc: { start: { line: 47, column: 16 }, end: { line: 47, column: 68 } } })) + `:</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "taxWithholding") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 48, column: 30 }, end: { line: 48, column: 65 } } })) + `</td>\r
          </tr>\r
`;
}, 7: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
          <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "Maksettu", { name: "t", hash: {}, data: a, loc: { start: { line: 62, column: 14 }, end: { line: 62, column: 31 } } })) + `:</td>\r
          <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalPaid") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 63, column: 28 }, end: { line: 63, column: 58 } } })) + `</td>\r
        </tr>\r
        <tr>\r
          <td><b>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "Jäljellä", { name: "t", hash: {}, data: a, loc: { start: { line: 66, column: 17 }, end: { line: 66, column: 34 } } })) + `:</b></td>\r
          <td class="right"><b>` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "toBePaid") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 67, column: 31 }, end: { line: 67, column: 60 } } })) + `</b></td>\r
        </tr>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
          <td><b>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.totalPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 71, column: 17 }, end: { line: 71, column: 67 } } })) + `:</b></td>\r
          <td class="right"><b>` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 72, column: 31 }, end: { line: 72, column: 57 } } })) + `</b></td>\r
        </tr>\r
`;
}, 11: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return ((n = r(t, "if").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "barcode") : n, { name: "if", hash: {}, fn: l.program(12, a, 0), inverse: l.noop, data: a, loc: { start: { line: 80, column: 2 }, end: { line: 88, column: 9 } } })) != null ? n : "") + ((n = r(t, "if").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "qrCode") : n, { name: "if", hash: {}, fn: l.program(14, a, 0), inverse: l.noop, data: a, loc: { start: { line: 89, column: 2 }, end: { line: 99, column: 9 } } })) != null ? n : "");
}, 12: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `  <table>\r
    <tr>\r
      <td>\r
        ` + ((n = l.lambda((n = e != null ? o(e, "report") : e) != null ? o(n, "barcode") : n, e)) != null ? n : "") + `\r
      </td>\r
    </tr>\r
  </table>\r
`;
}, 14: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `    <table>\r
      <tr>\r
        <td>\r
          <div style="width:45mm; float: right;">\r
            ` + ((n = l.lambda((n = e != null ? o(e, "report") : e) != null ? o(n, "qrCode") : n, e)) != null ? n : "") + `\r
          </div>\r
        </td>\r
      </tr>\r
    </table>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `<hr />\r
<table class="table table-condensed">\r
  <thead style="display: table-header-group;">\r
    <tr>\r
      <th class="left">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.message", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 23 }, end: { line: 5, column: 67 } } })) + `</th>\r
      <th class="left">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.articleName", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 23 }, end: { line: 6, column: 71 } } })) + " <br /> " + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.accounting", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 79 }, end: { line: 6, column: 126 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.count", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 24 }, end: { line: 7, column: 66 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.price", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 24 }, end: { line: 8, column: 66 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.vatPercent", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 24 }, end: { line: 9, column: 71 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 24 }, end: { line: 10, column: 66 } } })) + `.</th>\r
    </tr>\r
  </thead>\r
  <tbody>\r
` + ((n = i(t, "each").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "rows") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 14, column: 4 }, end: { line: 26, column: 13 } } })) != null ? n : "") + `  </tbody>\r
</table>\r
<hr />\r
<table>\r
  <colgroup>\r
    <col width="45%" />\r
    <col width="55%" />\r
  </colgroup>\r
  <tr>\r
    <td></td>\r
    <td>\r
      <table class="report-table-compact">\r
` + ((n = i(t, "if").call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "taxSocialSecurity") : n, { name: "if", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 39, column: 8 }, end: { line: 44, column: 15 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "taxWithholding") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.noop, data: a, loc: { start: { line: 45, column: 8 }, end: { line: 50, column: 15 } } })) != null ? n : "") + `\r
        <tr>\r
          <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.totalExVat", { name: "t", hash: {}, data: a, loc: { start: { line: 53, column: 14 }, end: { line: 53, column: 62 } } })) + `:</td>\r
          <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalExVat") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 54, column: 28 }, end: { line: 54, column: 59 } } })) + `</td>\r
        </tr>\r
        <tr>\r
          <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.invoice.table.totalVat", { name: "t", hash: {}, data: a, loc: { start: { line: 57, column: 14 }, end: { line: 57, column: 60 } } })) + `:</td>\r
          <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalVat") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 58, column: 28 }, end: { line: 58, column: 57 } } })) + `</td>\r
        </tr>\r
` + ((n = i(t, "if").call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "totals") : n) != null ? i(n, "showTotalPaid") : n, { name: "if", hash: {}, fn: l.program(7, a, 0), inverse: l.program(9, a, 0), data: a, loc: { start: { line: 60, column: 8 }, end: { line: 74, column: 15 } } })) != null ? n : "") + `      </table>\r
    </td>\r
  </tr>\r
</table>\r
` + ((n = i(t, "unless").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "isPreview") : n, { name: "unless", hash: {}, fn: l.program(11, a, 0), inverse: l.noop, data: a, loc: { start: { line: 79, column: 0 }, end: { line: 100, column: 11 } } })) != null ? n : "");
}, useData: !0 });
P.registerPartial("invoiceTable", rr);
const $o = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `\r
` + ((n = l.invokePartial(o(s, "totalsHead"), e, { name: "totalsHead", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + ((n = l.invokePartial(o(s, "totalsTables"), e, { name: "totalsTables", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, usePartial: !0, useData: !0 }), ar = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = e ?? (l.nullContext || {}), u = l.hooks.helperMissing, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `      <tr>\r
        <td>\r
          <strong>` + o(l.lambda((n = (n = e != null ? i(e, "worker") : e) != null ? i(n, "avatar") : n) != null ? i(n, "sortableName") : n, e)) + `</strong>\r
        </td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalGrossSalary") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 25, column: 26 }, end: { line: 25, column: 62 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "benefits") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 26, column: 26 }, end: { line: 26, column: 58 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalTaxable") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 27, column: 26 }, end: { line: 27, column: 58 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "tax") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 28, column: 26 }, end: { line: 28, column: 53 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalExpenses") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 29, column: 26 }, end: { line: 29, column: 59 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "unionPayment") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 30, column: 26 }, end: { line: 30, column: 62 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "pension") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 31, column: 26 }, end: { line: 31, column: 57 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "unemploymentInsurance") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 32, column: 26 }, end: { line: 32, column: 71 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "otherDeductions") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 33, column: 26 }, end: { line: 33, column: 65 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (i(t, "sum") || e && i(e, "sum") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "totals") : n) != null ? i(n, "totalPayable") : n, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "unionPayment") : n, { name: "sum", hash: {}, data: a, loc: { start: { line: 34, column: 30 }, end: { line: 34, column: 93 } } }), { name: "c", hash: {}, data: a, loc: { start: { line: 34, column: 26 }, end: { line: 34, column: 95 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "deductions") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 35, column: 26 }, end: { line: 35, column: 60 } } })) + `</td>\r
        <td class="right">` + o((i(t, "c") || e && i(e, "c") || u).call(r, (n = (n = e != null ? i(e, "result") : e) != null ? i(n, "workerCalc") : n) != null ? i(n, "totalWorkerPayment") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 36, column: 26 }, end: { line: 36, column: 68 } } })) + `</td>\r
      </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `<table class="salaxy-report-table table table-striped table-condensed">\r
  <thead style="display: table-header-group;">\r
    <tr>\r
      <th>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.worker", { name: "t", hash: {}, data: a, loc: { start: { line: 4, column: 10 }, end: { line: 4, column: 53 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.baseSalary", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 24 }, end: { line: 5, column: 71 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.benefits", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 24 }, end: { line: 6, column: 69 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.totalTaxable", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 24 }, end: { line: 7, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.tax", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 24 }, end: { line: 8, column: 64 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.totalExpenses", { name: "t", hash: {}, data: a, loc: { start: { line: 9, column: 24 }, end: { line: 9, column: 74 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.unionPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 24 }, end: { line: 10, column: 73 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.pension", { name: "t", hash: {}, data: a, loc: { start: { line: 11, column: 24 }, end: { line: 11, column: 68 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.unemploymentInsurance", { name: "t", hash: {}, data: a, loc: { start: { line: 12, column: 24 }, end: { line: 12, column: 82 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.otherDeductions", { name: "t", hash: {}, data: a, loc: { start: { line: 13, column: 24 }, end: { line: 13, column: 76 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.earnings", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 24 }, end: { line: 14, column: 69 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.totalDeductions", { name: "t", hash: {}, data: a, loc: { start: { line: 15, column: 24 }, end: { line: 15, column: 76 } } })) + `</th>\r
      <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.totals.table.totalWorkerPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 16, column: 24 }, end: { line: 16, column: 79 } } })) + `</th>\r
    </tr>\r
  </thead>\r
  <tbody>\r
` + ((n = i(t, "each").call(o, e != null ? i(e, "report") : e, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 20, column: 4 }, end: { line: 38, column: 13 } } })) != null ? n : "") + `  </tbody>\r
</table>\r
`;
}, useData: !0 });
P.registerPartial("totalsTables", ar);
const or = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `        <td>\r
` + ((n = o(t, "if").call(e ?? (l.nullContext || {}), (n = (n = e != null ? o(e, "employer") : e) != null ? o(n, "avatar") : n) != null ? o(n, "firstName") : n, { name: "if", hash: {}, fn: l.program(2, a, 0), inverse: l.noop, data: a, loc: { start: { line: 8, column: 12 }, end: { line: 15, column: 19 } } })) != null ? n : "") + `        </td>\r
`;
}, 2: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lambda, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <div>\r
                <b>` + o((u(t, "t") || e && u(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.totals.heading.employer", { name: "t", hash: {}, data: a, loc: { start: { line: 10, column: 19 }, end: { line: 10, column: 66 } } })) + `</b>\r
                <div class="uppercase">` + o(r((n = (n = e != null ? u(e, "employer") : e) != null ? u(n, "avatar") : n) != null ? u(n, "sortableName") : n, e)) + `</div>\r
                ` + o(r((n = (n = e != null ? u(e, "employer") : e) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
                ` + o(r((n = (n = e != null ? u(e, "employer") : e) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + o(r((n = (n = e != null ? u(e, "employer") : e) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
            </div>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
` + ((n = o(t, "with").call(e ?? (l.nullContext || {}), (n = e != null ? o(e, "report") : e) != null ? o(n, "0") : n, { name: "with", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 6, column: 6 }, end: { line: 17, column: 15 } } })) != null ? n : "") + `    </tr>\r
</table>`;
}, useData: !0 });
P.registerPartial("totalsHead", or);
const Bo = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "page"), e, { name: "page", fn: l.program(2, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, 2: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return ((n = l.invokePartial(o(s, "workerSummaryReportHead"), e, { name: "workerSummaryReportHead", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
` + ((n = l.invokePartial(o(s, "workerSummaryReportTable"), e, { name: "workerSummaryReportTable", data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "") + `\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = l.lookupProperty || function(r, u) {
    if (Object.prototype.hasOwnProperty.call(r, u))
      return r[u];
  };
  return (n = l.invokePartial(o(s, "document"), e, { name: "document", fn: l.program(1, a, 0), inverse: l.noop, data: a, helpers: t, partials: s, decorators: l.decorators })) != null ? n : "";
}, usePartial: !0, useData: !0 }), ur = P.template({ 1: function(l, e, t, s, a) {
  var n, o = l.lambda, r = l.escapeExpression, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <div>\r
                <div class="uppercase">` + r(o((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "worker") : n) != null ? u(n, "displayName") : n, e)) + `</div>\r
                ` + r(o((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "workerContact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
                ` + r(o((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "workerContact") : n) != null ? u(n, "postalCode") : n, e)) + " " + r(o((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "workerContact") : n) != null ? u(n, "city") : n, e)) + `\r
            </div>\r
`;
}, 3: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "              <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.workerSummaryReport.heading.noWorker", { name: "t", hash: {}, data: a, loc: { start: { line: 14, column: 17 }, end: { line: 14, column: 76 } } })) + `</p>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = l.escapeExpression, r = l.lambda, u = l.lookupProperty || function(i, c) {
    if (Object.prototype.hasOwnProperty.call(i, c))
      return i[c];
  };
  return `            <div>\r
                <b>` + o((u(t, "t") || e && u(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.workerSummaryReport.heading.employer", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 19 }, end: { line: 20, column: 78 } } })) + `:</b>\r
                <div class="uppercase">` + o(r((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "employer") : n) != null ? u(n, "displayName") : n, e)) + `</div>\r
                ` + o(r((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "contact") : n) != null ? u(n, "street") : n, e)) + `<br />\r
                ` + o(r((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "contact") : n) != null ? u(n, "postalCode") : n, e)) + " " + o(r((n = (n = e != null ? u(e, "report") : e) != null ? u(n, "contact") : n) != null ? u(n, "city") : n, e)) + `\r
            </div>\r
`;
}, 7: function(l, e, t, s, a) {
  var n = l.lookupProperty || function(o, r) {
    if (Object.prototype.hasOwnProperty.call(o, r))
      return o[r];
  };
  return "              <p>" + l.escapeExpression((n(t, "t") || e && n(e, "t") || l.hooks.helperMissing).call(e ?? (l.nullContext || {}), "SALAXY.REPORTS.workerSummaryReport.heading.noEmployer", { name: "t", hash: {}, data: a, loc: { start: { line: 26, column: 17 }, end: { line: 26, column: 78 } } })) + `</p>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lambda, c = l.lookupProperty || function(f, m) {
    if (Object.prototype.hasOwnProperty.call(f, m))
      return f[m];
  };
  return `            <table class="report-table-compact">\r
                <tr>\r
                    <td class="col-md-4">` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.heading.workerName", { name: "t", hash: {}, data: a, loc: { start: { line: 33, column: 41 }, end: { line: 33, column: 102 } } })) + `:</td>\r
                    <td class="col-md-8">` + u(i((n = (n = e != null ? c(e, "report") : e) != null ? c(n, "worker") : n) != null ? c(n, "displayName") : n, e)) + `</td>\r
                </tr>\r
                <tr>\r
                    <td class="col-md-4">` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.heading.workerSocialSecurityNumber", { name: "t", hash: {}, data: a, loc: { start: { line: 37, column: 41 }, end: { line: 37, column: 118 } } })) + `:</td>\r
                    <td class="col-md-8">` + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "workerSocialSecurityNumber") : n, e)) + `</td>\r
                </tr>\r
                <tr>\r
                    <td class="col-md-4">` + u((c(t, "t") || e && c(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.heading.workerIban", { name: "t", hash: {}, data: a, loc: { start: { line: 41, column: 41 }, end: { line: 41, column: 102 } } })) + `:</td>\r
                    <td class="col-md-8">` + u(i((n = e != null ? c(e, "report") : e) != null ? c(n, "workerIbanNumber") : n, e)) + `</td>\r
                </tr>\r
            </table>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.lookupProperty || function(u, i) {
    if (Object.prototype.hasOwnProperty.call(u, i))
      return u[i];
  };
  return `<table>\r
    <colgroup>\r
        <col width="40%" /><col width="60%" />\r
    </colgroup>\r
    <tr>\r
        <td>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "worker") : n, { name: "if", hash: {}, fn: l.program(1, a, 0), inverse: l.program(3, a, 0), data: a, loc: { start: { line: 7, column: 12 }, end: { line: 15, column: 19 } } })) != null ? n : "") + `            <p>&nbsp;</p>\r
            <p>&nbsp;</p>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "employer") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.program(7, a, 0), data: a, loc: { start: { line: 18, column: 12 }, end: { line: 27, column: 19 } } })) != null ? n : "") + `        </td>\r
        <td>\r
` + ((n = r(t, "if").call(o, (n = e != null ? r(e, "report") : e) != null ? r(n, "worker") : n, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 30, column: 10 }, end: { line: 45, column: 17 } } })) != null ? n : "") + `        </td>\r
    </tr>\r
</table>`;
}, useData: !0 });
P.registerPartial("workerSummaryReportHead", ur);
const ir = P.template({ 1: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td>` + u((n = (n = i(t, "message") || (e != null ? i(e, "message") : e)) != null ? n : r, typeof n == "function" ? n.call(o, { name: "message", hash: {}, data: a, loc: { start: { line: 13, column: 16 }, end: { line: 13, column: 27 } } }) : n)) + `</td>\r
            <td class="right">` + u((i(t, "r") || e && i(e, "r") || r).call(o, e != null ? i(e, "count") : e, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 14, column: 30 }, end: { line: 14, column: 50 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "price") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 15, column: 30 }, end: { line: 15, column: 41 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 16, column: 30 }, end: { line: 16, column: 41 } } })) + `</td>\r
        </tr>\r
`;
}, 3: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.unionPayment", { name: "t", hash: {}, data: a, loc: { start: { line: 84, column: 16 }, end: { line: 84, column: 77 } } })) + `</td>\r
            <td class="right">` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "statistics") : n) != null ? i(n, "unionPaymentPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 85, column: 30 }, end: { line: 85, column: 73 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalTaxable") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 86, column: 30 }, end: { line: 86, column: 69 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "unionPayment") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 87, column: 30 }, end: { line: 87, column: 73 } } })) + `</td>\r
        </tr>\r
`;
}, 5: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.foreclosure", { name: "t", hash: {}, data: a, loc: { start: { line: 92, column: 28 }, end: { line: 92, column: 88 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "foreclosue") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 93, column: 30 }, end: { line: 93, column: 71 } } })) + `</td>\r
        </tr>\r
`;
}, 7: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.prepaidExpenses", { name: "t", hash: {}, data: a, loc: { start: { line: 98, column: 28 }, end: { line: 98, column: 92 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "prepaidExpenses") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 99, column: 30 }, end: { line: 99, column: 76 } } })) + `</td>\r
        </tr>\r
`;
}, 9: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `        <tr>\r
            <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.otherDeductions", { name: "t", hash: {}, data: a, loc: { start: { line: 104, column: 28 }, end: { line: 104, column: 92 } } })) + `</td>\r
            <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "otherDeductions") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 105, column: 30 }, end: { line: 105, column: 76 } } })) + `</td>\r
        </tr>\r
`;
}, 11: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `      <tr>\r
        <td>` + u((n = (n = i(t, "message") || (e != null ? i(e, "message") : e)) != null ? n : r, typeof n == "function" ? n.call(o, { name: "message", hash: {}, data: a, loc: { start: { line: 126, column: 12 }, end: { line: 126, column: 23 } } }) : n)) + `</td>\r
        <td class="right">` + u((i(t, "r") || e && i(e, "r") || r).call(o, e != null ? i(e, "count") : e, { name: "r", hash: { dec: null }, data: a, loc: { start: { line: 127, column: 26 }, end: { line: 127, column: 46 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "price") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 128, column: 26 }, end: { line: 128, column: 37 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, e != null ? i(e, "total") : e, { name: "c", hash: {}, data: a, loc: { start: { line: 129, column: 26 }, end: { line: 129, column: 37 } } })) + `</td>\r
      </tr>\r
`;
}, compiler: [8, ">= 4.3.0"], main: function(l, e, t, s, a) {
  var n, o = e ?? (l.nullContext || {}), r = l.hooks.helperMissing, u = l.escapeExpression, i = l.lookupProperty || function(c, f) {
    if (Object.prototype.hasOwnProperty.call(c, f))
      return c[f];
  };
  return `<div>&nbsp;</div>\r
<table class="table table-condensed">\r
    <thead>\r
        <tr>\r
            <th class="col-md-6"><h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.salary.heading", { name: "t", hash: {}, data: a, loc: { start: { line: 5, column: 37 }, end: { line: 5, column: 100 } } })) + `</h3></th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.count", { name: "t", hash: {}, data: a, loc: { start: { line: 6, column: 39 }, end: { line: 6, column: 93 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 7, column: 39 }, end: { line: 7, column: 94 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 8, column: 39 }, end: { line: 8, column: 93 } } })) + `</th>\r
        </tr>\r
    </thead>\r
` + ((n = i(t, "each").call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "cashSalary") : n) != null ? i(n, "rows") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 11, column: 4 }, end: { line: 18, column: 13 } } })) != null ? n : "") + `    <tr class="total">\r
        <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totals", { name: "t", hash: {}, data: a, loc: { start: { line: 20, column: 24 }, end: { line: 20, column: 79 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "cashSalary") : n) != null ? i(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 21, column: 26 }, end: { line: 21, column: 68 } } })) + `</td>\r
    </tr>\r
</table>\r
<!-- Benefits -->\r
<div>&nbsp;</div>\r
<table class="table table-condensed">\r
    <thead>\r
        <tr>\r
            <th class="col-md-6"><h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.benefits.heading", { name: "t", hash: {}, data: a, loc: { start: { line: 29, column: 37 }, end: { line: 29, column: 102 } } })) + `</h3></th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.count", { name: "t", hash: {}, data: a, loc: { start: { line: 30, column: 39 }, end: { line: 30, column: 93 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 31, column: 39 }, end: { line: 31, column: 94 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 32, column: 39 }, end: { line: 32, column: 93 } } })) + `</th>\r
        </tr>\r
    </thead>\r
` + ((n = i(t, "each").call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "benefitsInKind") : n) != null ? i(n, "rows") : n, { name: "each", hash: {}, fn: l.program(1, a, 0), inverse: l.noop, data: a, loc: { start: { line: 35, column: 4 }, end: { line: 42, column: 13 } } })) != null ? n : "") + `    <tr class="total">\r
        <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totals", { name: "t", hash: {}, data: a, loc: { start: { line: 44, column: 24 }, end: { line: 44, column: 79 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "benefitsInKind") : n) != null ? i(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 45, column: 26 }, end: { line: 45, column: 72 } } })) + `</td>\r
    </tr>\r
</table>\r
<div>&nbsp;</div>\r
<table class="table table-condensed">\r
    <thead>\r
        <tr>\r
            <th class="col-md-6"><h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.deductions.title", { name: "t", hash: {}, data: a, loc: { start: { line: 52, column: 37 }, end: { line: 52, column: 102 } } })) + `</h3></th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.percent", { name: "t", hash: {}, data: a, loc: { start: { line: 53, column: 39 }, end: { line: 53, column: 95 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.sum", { name: "t", hash: {}, data: a, loc: { start: { line: 54, column: 39 }, end: { line: 54, column: 91 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 55, column: 39 }, end: { line: 55, column: 93 } } })) + `</th>\r
        </tr>\r
    </thead>\r
    <tr>\r
        <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totalTaxable", { name: "t", hash: {}, data: a, loc: { start: { line: 59, column: 12 }, end: { line: 59, column: 73 } } })) + `</td>\r
        <td class="right"></td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalTaxable") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 61, column: 26 }, end: { line: 61, column: 65 } } })) + `</td>\r
        <td class="right"></td>\r
    </tr>\r
    <tr>\r
        <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.tax", { name: "t", hash: {}, data: a, loc: { start: { line: 65, column: 12 }, end: { line: 65, column: 64 } } })) + `</td>\r
        <td class="right">` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "statistics") : n) != null ? i(n, "taxPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 66, column: 26 }, end: { line: 66, column: 60 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalTaxable") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 67, column: 26 }, end: { line: 67, column: 65 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "tax") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 68, column: 26 }, end: { line: 68, column: 60 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.pension", { name: "t", hash: {}, data: a, loc: { start: { line: 71, column: 12 }, end: { line: 71, column: 68 } } })) + `</td>\r
        <td class="right">` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "statistics") : n) != null ? i(n, "pensionWorkerPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 72, column: 26 }, end: { line: 72, column: 70 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalSocialSecurityBase") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 73, column: 26 }, end: { line: 73, column: 76 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "pension") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 74, column: 26 }, end: { line: 74, column: 64 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.unemploymentInsurancePayment", { name: "t", hash: {}, data: a, loc: { start: { line: 77, column: 12 }, end: { line: 77, column: 89 } } })) + `</td>\r
        <td class="right">` + u((i(t, "p") || e && i(e, "p") || r).call(o, (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "statistics") : n) != null ? i(n, "unemploymentWorkerPercent") : n, { name: "p", hash: {}, data: a, loc: { start: { line: 78, column: 26 }, end: { line: 78, column: 75 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalSocialSecurityBase") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 79, column: 26 }, end: { line: 79, column: 76 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "unemploymentInsurance") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 80, column: 26 }, end: { line: 80, column: 78 } } })) + `</td>\r
    </tr>\r
` + ((n = i(t, "if").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "showUnionPayment") : n, { name: "if", hash: {}, fn: l.program(3, a, 0), inverse: l.noop, data: a, loc: { start: { line: 82, column: 4 }, end: { line: 89, column: 11 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "showForeclosure") : n, { name: "if", hash: {}, fn: l.program(5, a, 0), inverse: l.noop, data: a, loc: { start: { line: 90, column: 4 }, end: { line: 95, column: 11 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "showPrepaidExpenses") : n, { name: "if", hash: {}, fn: l.program(7, a, 0), inverse: l.noop, data: a, loc: { start: { line: 96, column: 4 }, end: { line: 101, column: 11 } } })) != null ? n : "") + ((n = i(t, "if").call(o, (n = e != null ? i(e, "report") : e) != null ? i(n, "showOtherDeductions") : n, { name: "if", hash: {}, fn: l.program(9, a, 0), inverse: l.noop, data: a, loc: { start: { line: 102, column: 4 }, end: { line: 107, column: 11 } } })) != null ? n : "") + `    <tr class="total">\r
        <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totals", { name: "t", hash: {}, data: a, loc: { start: { line: 109, column: 24 }, end: { line: 109, column: 79 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (i(t, "sum") || e && i(e, "sum") || r).call(o, (i(t, "sub") || e && i(e, "sub") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "deductions") : n, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "salaryAdvance") : n, { name: "sub", hash: {}, data: a, loc: { start: { line: 110, column: 35 }, end: { line: 110, column: 115 } } }), (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "prepaidExpenses") : n, { name: "sum", hash: {}, data: a, loc: { start: { line: 110, column: 30 }, end: { line: 110, column: 157 } } }), { name: "c", hash: {}, data: a, loc: { start: { line: 110, column: 26 }, end: { line: 110, column: 159 } } })) + `</td>\r
    </tr>\r
</table>\r
<br />\r
<table class="table table-condensed">\r
    <thead>\r
        <tr>\r
            <th class="col-md-6"><h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.expenses.heading", { name: "t", hash: {}, data: a, loc: { start: { line: 117, column: 37 }, end: { line: 117, column: 102 } } })) + `</h3></th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.count", { name: "t", hash: {}, data: a, loc: { start: { line: 118, column: 39 }, end: { line: 118, column: 93 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.aPrice", { name: "t", hash: {}, data: a, loc: { start: { line: 119, column: 39 }, end: { line: 119, column: 94 } } })) + `</th>\r
            <th class="right col-md-2">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 120, column: 39 }, end: { line: 120, column: 93 } } })) + `</th>\r
        </tr>\r
    </thead>\r
    \r
` + ((n = i(t, "each").call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "expenses") : n) != null ? i(n, "rows") : n, { name: "each", hash: {}, fn: l.program(11, a, 0), inverse: l.noop, data: a, loc: { start: { line: 124, column: 4 }, end: { line: 131, column: 13 } } })) != null ? n : "") + `    <tr class="total">\r
        <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totals", { name: "t", hash: {}, data: a, loc: { start: { line: 133, column: 24 }, end: { line: 133, column: 79 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "workerResult") : n) != null ? i(n, "expenses") : n) != null ? i(n, "total") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 134, column: 26 }, end: { line: 134, column: 66 } } })) + `</td>\r
    </tr>\r
</table>\r
<br />\r
<table class="table table-condensed">\r
    <thead>\r
        <tr>\r
            <th colspan="3"><h3>` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.totals", { name: "t", hash: {}, data: a, loc: { start: { line: 141, column: 32 }, end: { line: 141, column: 87 } } })) + `</h3></th>\r
            <th class="right">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.total", { name: "t", hash: {}, data: a, loc: { start: { line: 142, column: 30 }, end: { line: 142, column: 84 } } })) + `</th>\r
        </tr>\r
    </thead>\r
    <tr>\r
        <td colspan="3">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.salary.heading", { name: "t", hash: {}, data: a, loc: { start: { line: 146, column: 24 }, end: { line: 146, column: 87 } } })) + `</td>\r
        <td class="right">` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalGrossSalary") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 147, column: 26 }, end: { line: 147, column: 69 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td colspan="3">- ` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.deductions.title", { name: "t", hash: {}, data: a, loc: { start: { line: 150, column: 26 }, end: { line: 150, column: 91 } } })) + `</td>\r
        <td class="right">- ` + u((i(t, "c") || e && i(e, "c") || r).call(o, (i(t, "sum") || e && i(e, "sum") || r).call(o, (i(t, "sub") || e && i(e, "sub") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "deductions") : n, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "salaryAdvance") : n, { name: "sub", hash: {}, data: a, loc: { start: { line: 151, column: 37 }, end: { line: 151, column: 117 } } }), (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "prepaidExpenses") : n, { name: "sum", hash: {}, data: a, loc: { start: { line: 151, column: 32 }, end: { line: 151, column: 159 } } }), { name: "c", hash: {}, data: a, loc: { start: { line: 151, column: 28 }, end: { line: 151, column: 161 } } })) + `</td>\r
    </tr>\r
    <tr>\r
        <td colspan="3">+ ` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.expenses.title", { name: "t", hash: {}, data: a, loc: { start: { line: 154, column: 26 }, end: { line: 154, column: 89 } } })) + `</td>\r
        <td class="right">+ ` + u((i(t, "c") || e && i(e, "c") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "totals") : n) != null ? i(n, "totalExpenses") : n, { name: "c", hash: {}, data: a, loc: { start: { line: 155, column: 28 }, end: { line: 155, column: 68 } } })) + `</td>\r
    </tr>\r
    <tr class="total">\r
        <th colspan="3" class="uppercase" style="padding-top: 5px;">` + u((i(t, "t") || e && i(e, "t") || r).call(o, "SALAXY.REPORTS.workerSummaryReport.table.paid", { name: "t", hash: {}, data: a, loc: { start: { line: 158, column: 68 }, end: { line: 158, column: 121 } } })) + `</th>\r
        <th class="right" style="padding-top: 5px;"><b>` + u((i(t, "c") || e && i(e, "c") || r).call(o, (i(t, "sum") || e && i(e, "sum") || r).call(o, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "totalWorkerPayment") : n, (n = (n = (n = e != null ? i(e, "report") : e) != null ? i(n, "result") : n) != null ? i(n, "workerCalc") : n) != null ? i(n, "salaryAdvance") : n, { name: "sum", hash: {}, data: a, loc: { start: { line: 159, column: 59 }, end: { line: 159, column: 147 } } }), { name: "c", hash: {}, data: a, loc: { start: { line: 159, column: 55 }, end: { line: 159, column: 149 } } })) + `</b></th>\r
    </tr>\r
</table>`;
}, useData: !0 });
P.registerPartial("workerSummaryReportTable", ir);
const tt = {
  heartbeat: wo,
  accountingReport: Ro,
  employerReportV2: Ao,
  employerReportV2Page1: bo,
  paymentReportV2: Eo,
  paymentSummaryReportV2: Yo,
  salarySlipV2: Io,
  salarySlipV2Page1: Ho,
  accountingReportHead: Tt,
  accountingTable: xt,
  contractPartiesContactDetailsV2: Lt,
  document: _t,
  employerCalculationAdditionalInfoV2: Dt,
  employerCalculationTablesV2: Mt,
  employerContractDetailsV2: Xt,
  employerReportHeadV2: Yt,
  page: It,
  partial: Ht,
  paymentReportHeadV2: $t,
  paymentSummaryReportHeadV2: Bt,
  paymentTablesV2: Ft,
  workerCalculationAdditionalInfoV2: jt,
  workerCalculationTablesV2: Vt,
  workerContractDetailsV2: Ut,
  workerCumulativeTables: Nt,
  workerDeductionWarningsV2: zt,
  workerReportHeadV2: Gt,
  defaultFooter: Wt,
  defaultHeader: qt,
  img2: Kt,
  logo: Jt,
  pageNumber: Qt,
  totalPages: Zt,
  summaryReport: Oo,
  summaryReportHead: er,
  summaryReportTable: nr,
  authorizationPerson: Co,
  authorizationCompany: To,
  authorizationRaksa: xo,
  iamPerson: lr,
  invoice: Lo,
  invoiceHead: tr,
  invoiceTable: rr,
  kycCompany: _o,
  eSalary: Do,
  totalsReport: $o,
  totalsTables: ar,
  totalsHead: or,
  workerSummaryReport: Bo,
  workerSummaryReportHead: ur,
  workerSummaryReportTable: ir,
  invoiceList: Mo,
  calendar: Xo
};
function On(l, e, t) {
  const s = (r, u) => r && r.indexOf(u, r.length - u.length) !== -1, a = t && t.hash ? t.hash : t, n = d.get(e, a, l);
  return s(e, ".html") ? new P.SafeString(n) : n;
}
function Fo(l, e) {
  const t = e && e.hash ? e.hash : e;
  return t && t.end ? g.getFormattedRange(l, t.end) ?? "-" : l ? t.format ? g.format(l, t.format) ?? "-" : g.format(l) ?? "-" : "-";
}
function jo(l, e) {
  const t = e && e.hash ? e.hash : e;
  return l ? t && (t.dec || t.dec === 0 || t.dec === null) ? y.formatNumber(l, t.dec) : y.formatNumber(l) : t && t.nullChar ? t.nullChar : "-";
}
function Vo(l, e) {
  const t = e && e.hash ? e.hash : e;
  return l || l === 0 ? t && (t.dec || t.dec === 0 || t.dec === null) ? y.formatPercent((y.parseNumber(l) ?? 0) * 100, t.dec) : y.formatPercent((y.parseNumber(l) ?? 0) * 100) : t && t.nullChar ? t.nullChar : "-";
}
function Uo(l, e) {
  const t = e && e.hash ? e.hash : e;
  return l || l === 0 ? y.formatPrice(l) : t && t.nullChar ? t.nullChar : "-";
}
function No(l) {
  return JSON.stringify(l);
}
function zo(l) {
  return l.toUpperCase();
}
function Go(...l) {
  return l.filter((t) => !isNaN(parseFloat(t)) && isFinite(t)).reduce((t, s) => t + s, 0);
}
function Wo(l, e) {
  return isNaN(parseFloat(l)) || isNaN(parseFloat(e)) ? new Error("Invalid values") : parseFloat(l) - parseFloat(e);
}
function qo(l, e) {
  return isNaN(parseFloat(l)) || isNaN(parseFloat(e)) ? new Error("Invalid values") : parseFloat(e) === 0 ? " " : parseFloat(l) / parseFloat(e);
}
function Ko(...l) {
  return l.filter((t) => !isNaN(parseFloat(t)) && isFinite(t)).reduce((t, s) => t + s, 1);
}
class bf {
  /**
   * Creates a new instance of the service.
   */
  constructor() {
    this.registerHelpers();
  }
  /**
   * Gets the HTML using the Handlebars template.
   * @param templateName Name of the template to render.
   * @param data Data for the template.
   * @param lang Translation language
   * @returns HTML as string
   */
  getHtml(e, t, s = "fi") {
    if (!tt[e])
      throw new Error(`Cannot find report template: ${e || "null"}. See debug for list of registered templates.`);
    const a = (n, o) => On(s, n, o);
    return tt[e](t, { allowProtoPropertiesByDefault: !0, helpers: { t: a } });
  }
  /**
   * Gets HTML from provided templateContent and data
   * @param templateContent Template as handlebars HTML / string.
   * @param data Data for the rendering.
   * @param lang Translation language
   * @returns HTML as string
   */
  getHtmlDynamic(e, t, s = "fi") {
    const a = /\{\{\s*\(\s*(\S+)\s*\(\s*\}\}|\{\{\s*(\S+)\s*\}\}|\{\{\s*>\s*(\S+)\s*\}\}|\{\{\s*([t|d|r|p|c])\s+(.*)\s*\}\}/g;
    return e.replace(a, (n, o, r, u, i, c) => o ?? r ? this.readValue(t, o ?? r, "") : u ? this.getHtml(u, t, s) : this.runHelper(t, i, c, "", s));
  }
  /**
   * Register helpers.
   */
  registerHelpers() {
    P.registerHelper("t", (e, t) => On("en", e, t)), P.registerHelper("d", (e, t) => Fo(e, t)), P.registerHelper("r", (e, t) => jo(e, t)), P.registerHelper("p", (e, t) => Vo(e, t)), P.registerHelper("c", (e, t) => Uo(e, t)), P.registerHelper("json", (e) => No(e)), P.registerHelper("u", (e) => zo(e)), P.registerHelper("sum", (...e) => Go(...e)), P.registerHelper("sub", (e, t) => Wo(e, t)), P.registerHelper("div", (e, t) => qo(e, t)), P.registerHelper("mul", (...e) => Ko(...e));
  }
  readValue(e, t, s) {
    if (!e || !t)
      return s;
    const a = t.split(".");
    let n = e;
    for (const o of a)
      if (ul.has(n, o))
        n = n[o];
      else
        return s;
    return n;
  }
  runHelper(e, t, s, a, n) {
    const o = this.splitParameters(s);
    o.forEach((u) => {
      u.value = this.readValueOrConstantOrHelper(e, u.value, a, n);
    });
    const r = this.getHelperArgs(o);
    return t === "t" ? ((i, c) => On(n, i, c))(r.first, r.options) : P.helpers[t].call(this, r.first, r.options);
  }
  readValueOrConstant(e, t, s) {
    return t && (t.startsWith('"') && t.endsWith('"') || t.startsWith("'") && t.endsWith("'")) ? t.slice(1, t.length - 1) : this.readValue(e, t, s);
  }
  readValueOrConstantOrHelper(e, t, s, a) {
    const n = /\(\s*([t|d|r|p|c])\s+(.*)\s*\)|\(\s*(\S+)\s*\)|(\s*(\S+)\s*)/g;
    return t.replace(n, (o, r, u, i, c) => r ? this.runHelper(e, r, u, s, a) : this.readValueOrConstant(e, i ?? c, s));
  }
  getHelperArgs(e) {
    return {
      first: e.length ? e[0].value : null,
      options: this.getHelperOptions(e)
    };
  }
  getHelperOptions(e) {
    const t = {};
    for (const s of e)
      s.key && (t.hash = t.hash ?? {}, t.hash[s.key] = s.value);
    return t;
  }
  splitParameters(e) {
    const t = /((\S+)=\((\s*([t|d|r|p|c| ])*\s*\S+)\))|((\S+)=(\S+))|(\S+)/g, s = e.match(t);
    return s ? s.map((a) => {
      const n = a.split("=");
      return n.length === 2 ? { key: n[0], value: n[1] } : { key: null, value: n[0] };
    }) : [];
  }
}
class Jo {
  /**
   * Creates a new report.
   * @param reportType Report type for the report.
   */
  constructor(e) {
    this.reportType = e, this.header = {}, this.rowGroups = new Array(), this.validationMessages = new Array(), this.notes = new Array();
  }
  /** Returns true if the report has validation messages. */
  get hasValidationMessages() {
    return this.validationMessages.length > 0;
  }
  /** Returns true if the report has notes. */
  get hasNotes() {
    return this.notes.length > 0;
  }
}
class R {
  /**
   * Creates a new report row based on given row data.
   * @param data The data for the row.
   */
  constructor(e) {
    this.data = e, this._mainRow = void 0;
  }
  /** Level of the row in the row hierarchy. */
  get level() {
    return this.mainRow ? this.mainRow.level + 1 : 0;
  }
  /** Returns true if level is 0. */
  get isLevel0() {
    return this.level === 0;
  }
  /** Returns true if level is 1. */
  get isLevel1() {
    return this.level === 1;
  }
  /** Returns true if level is 2. */
  get isLevel2() {
    return this.level === 2;
  }
  /** Returns true if level is 3. */
  get isLevel3() {
    return this.level === 3;
  }
  /** Returns true if level is 4. */
  get isLevel4() {
    return this.level === 4;
  }
  /** Boolean to indicate if this row has sub rows */
  get hasSubRows() {
    return this.subRows != null && this.subRows.length > 0;
  }
  /** Sum of sub row totals. */
  get subTotal() {
    return this.subRows ? this.subRows.reduce((e, t) => e + (t.subTotal ?? 0), 0) : this.data.total;
  }
  /** Parent row for this row. */
  get mainRow() {
    return this._mainRow;
  }
  /** Parent row for this row. */
  set mainRow(e) {
    this._mainRow = e, this._mainRow != null && (this._mainRow.subRows == null && (this._mainRow.subRows = new Array()), this._mainRow.subRows.push(this));
  }
}
class K {
  /** Constructor */
  constructor(e) {
    this.grouping = void 0, this.params = null, this.rows = new Array(), this.isHidden = void 0, this._groupingTerm = void 0, this._totalTerm = void 0, this._total = void 0, e && (this.grouping = e.grouping, this.groupingTerm = e.groupingTerm, this.params = e.params, this.total = e.total, this.totalTerm = e.totalTerm, e.rows && (this.rows = e.rows), this.isHidden = e.isHidden);
  }
  /** Grouping term */
  get groupingTerm() {
    return this._groupingTerm || "SALAXY.REPORTS.ENUM.CalcGroup." + this.grouping + ".label";
  }
  /** Grouping term */
  set groupingTerm(e) {
    this._groupingTerm = e;
  }
  /** Total term */
  get totalTerm() {
    return this._totalTerm || "SALAXY.REPORTS.salary.heading.total";
  }
  /** Total term */
  set totalTerm(e) {
    this._totalTerm = e;
  }
  /** Returns true if the group has rows. */
  get hasRows() {
    return this.rows.length > 0;
  }
  /** Returns true if this is Deductions group. */
  get isDeductions() {
    return this.grouping === C.Deductions;
  }
  /** Returns true if this is Totals group. */
  get isTotals() {
    return this.grouping === C.Totals;
  }
  /** Returns true if this is Benefits group. */
  get isBenefits() {
    return this.grouping === C.Benefits;
  }
  /** Returns true if this is Expenses group. */
  get isExpenses() {
    return this.grouping === C.Expenses;
  }
  /** Returns true if this is SalaryAdditions group. */
  get isSalaryAdditions() {
    return this.grouping === C.SalaryAdditions;
  }
  /** Returns true if this is BaseSalary group. */
  get isBaseSalary() {
    return this.grouping === C.BaseSalary;
  }
  /** Returns true if this is Disabled group. */
  get isDisabled() {
    return this.grouping === C.Disabled;
  }
  /** Returns true if this is OtherNoPayment group. */
  get isOtherNoPayment() {
    return this.grouping === C.OtherNoPayment;
  }
  /** Returns true if this is Undefined group. */
  get isUndefined() {
    return this.grouping === C.Undefined;
  }
  /** Group total. */
  get total() {
    return this._total || this.rows.filter((e) => e.level === 0).reduce((e, t) => e + (t.subTotal ?? 0), 0);
  }
  /** Group total. */
  set total(e) {
    this._total = e;
  }
  /** Returns true if this the total field has value greater than 0. */
  get hasTotalValue() {
    return (y.round(this.total, 2) ?? 0) > 0;
  }
}
class x {
  /** Constructor for creating row. */
  constructor(e, t) {
    if (this.irRow = {}, this._comment = void 0, !!e) {
      if (this.fullTotal = e.fullTotal, this.comment = e.comment, this.irRow = e.irRow || {}, !this.irRow.message) {
        let s = this.irRow.data?.calculationRowType || v.Unknown;
        s = s.substr(0, 1).toLowerCase() + s.substr(1);
        const a = this.irRow.irData?.code, n = this.irRow.data?.kind;
        let o = "";
        s === v.IrIncomeType ? o = V.getAll(t).find((r) => n && r.transactionCode === n || a > 0 && r.code === a)?.label : s === v.MealBenefit && a !== 334 ? o = V.getAll(t).find((r) => a > 0 && r.code === a)?.label : [
          v.Unknown,
          v.CarBenefit,
          v.BicycleBenefit,
          v.SubsidisedCommute,
          v.TaxAtSource,
          v.HourlySalaryWithWorkingTimeCompensation
        ].includes(s) ? o = V.getAll(t).find((r) => a > 0 && r.code === a)?.label : [
          v.DailyAllowance,
          v.EmploymentTermination,
          v.WorkingTimeCompensation,
          v.Remuneration,
          v.OtherCompensation,
          v.NonProfitOrg,
          v.MealBenefit,
          // main MealBenefit
          v.Training,
          v.PaidSickLeave
        ].includes(s) && n && (o = G.getEnumLabel(`${this.irRow.data?.calculationRowType}Kind`, n, void 0, t)), this.irRow.message = o || G.getEnumLabel("CalculationRowType", s, void 0, t);
      }
      this.isTotalReduced = e.isTotalReduced;
    }
  }
  /** Total amount. */
  get total() {
    return this.irRow.total || 0;
  }
  /** Total amount. */
  set total(e) {
    this.irRow.total = e;
  }
  /** Returns true if the unit is percentage */
  get isUnitPercent() {
    return this.irRow.unit === L.Percent;
  }
  /** Row further information. */
  get comment() {
    if (this._comment)
      return this._comment;
    if (this.irRow.data != null && this.irRow.data.sxySalarySlipRowComment)
      return this.irRow.data.sxySalarySlipRowComment;
  }
  /** Row further information. */
  set comment(e) {
    this._comment = e;
  }
  getEnum(e) {
    if (!e)
      return e;
    let t = `${e}`;
    return t = t.charAt(0).toLowerCase() + t.slice(1), t;
  }
}
class _ {
  /** Constructor */
  constructor(e) {
    this.label = void 0, this.receiver = void 0, this.total = void 0, e && (this.baseAmount = e.baseAmount, this.comment = e.comment, this.employerPercent = e.employerPercent, this.label = e.label, this.receiver = e.receiver, this.total = e.total, this.workerPercent = e.workerPercent);
  }
}
class Qo {
  /**
   * Creates a new CalculationReport from the fiven Calculation.
   * @param calc Calcuation for the report.
   * @param reportType Report type.
   */
  static getCalculationReport(e, t, s) {
    if (!e)
      return;
    const a = ul.copy(e);
    (a.partner == "FI81POYS0016206791" || a.employer?.avatar?.partner == "FI81POYS0016206791") && a.result?.irRows?.forEach((o) => {
      (o.data ?? {}).calculationRowType != "Remuneration" && (o.data ?? {}).calculationRowType != "HolidayBonus" && (o.data ?? {}).calculationRowType != "HolidayCompensation" && o.unit == L.Percent && (o.unit = L.Count);
    });
    const n = new Jo(t);
    if (this.createHeader(n, a), !a.result?.totals)
      return n;
    switch (t) {
      case Se.SalarySlip:
        this.createValidationMessages(n, a), this.createSalarySlipRowGroups(n, a, s), this.createSalarySlipNotes(n, a), this.createCumulativeData(n, a);
        break;
      case Se.EmployerReport:
        this.createValidationMessages(n, a), this.createEmployerReportRowGroups(n, a, s), this.createEmployerReportNotes(n, a);
        break;
      case Se.PaymentReport:
        this.createPaymentReportRowGroups(n, a, s);
        break;
    }
    return n;
  }
  /**
   * Creates a new CalculationSummaryReport from the given calculations.
   * @param calcs Calculations for the report.
   * @param lang Language.
   */
  static getCalculationSummaryReport(e, t) {
    if (!e)
      return;
    const s = { rowGroups: [] }, a = this.calculateCalculationsResultsSummary(e), n = Jr.getBlank();
    return n.result ?? (n.result = {}), n.result.employerCalc = a.employerCalc, n.result.totals = a.totals, n.result.workerCalc = a.workerCalc, this.createSummaryHeader(s, a, e), this.createPaymentReportRowGroups(s, n, t), s;
  }
  /**
   * Creates HeaderFooterData from provided parameters
   * @param type ReportType
   * @param calc Calculation BusinessObject
   * @param options ReportOptions
   * @param lang gets translation with this lang, if null use current lang
   * @returns Created HeaderFooterData
   */
  static getHeaderFooter(e, t, s, a = void 0) {
    return {
      logo: s?.logo,
      img2: s?.img2,
      title: e === Se.EmployerReport ? d.get("SALAXY.REPORTS.employer.title", null, a) : e === Se.PaymentReport ? d.get("SALAXY.REPORTS.payment.title", null, a) : d.get("SALAXY.REPORTS.salary.title", null, a),
      subTitle: `${d.get("SALAXY.REPORTS.salary.subtitle", null, a)}: ${g.getFormattedDate(t.workflow?.salaryDate)}`,
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(t.workflow?.salaryDate)
    };
  }
  /**
   * Creates HeaderFooterData from provided parameters
   * @param calc Calculation BusinessObject
   * @param options ReportOptions
   * @param lang gets translation with this lang, if null use current lang
   * @returns Created HeaderFooterData
   */
  static getTotalReportHeaderFooter(e, t, s = void 0) {
    const a = Array.isArray(e) ? e[0] : e;
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: d.get("SALAXY.ENUM.ReportType.totalsReport.label", null, s),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(a.workflow?.salaryDate)
    };
  }
  /**
   * Get ReportLayout for calculation
   * @param isLandscape If true, the layout is rendered as landscape.
   * @param pdf By default the mode is htmlPage. Set this to true to use pdf mode. This may affect some rendering details.
   * @param watermark If provided, the watermark is shown in the report. Use "default" to show the default watermark ("SALAXY.REPORTS.document.preview").
   * @returns Report task
   */
  static getReportLayout(e = !1, t = !1, s) {
    return {
      isPreview: !!s,
      watermark: s == "default" ? "SALAXY.REPORTS.document.preview" : s,
      layout: e ? "a4Landscape" : "a4Portrait",
      isLayoutA4Portrait: !e,
      isLayoutA4Landscape: e,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    };
  }
  /**
   * Creates HeaderFooterData (for summaryreport) from provided parameters
   * @param calcs Array of Calculation BusinessObjects
   * @param reportOptions ReportOptions
   * @param lang gets translation with this lang, if null use current lang
   * @returns Created HeaderFooterData
   */
  static getCalculationSummaryReportHeaderFooter(e, t, s) {
    const a = this.getCalculationSummaryReport(e, s);
    return {
      date: a?.header?.salaryDate,
      title: d.get("SALAXY.REPORTS.payment.summaryTitle", null, s),
      subTitle: `${d.get("SALAXY.REPORTS.payment.summarySubTitle", null, s)}: ${g.getFormattedDate(a?.header?.salaryDate)}`,
      today: g.getToday(),
      logo: t?.logo,
      img2: t?.img2
    };
  }
  static createSalarySlipRowGroups(e, t, s) {
    const n = [
      C.BaseSalary,
      C.SalaryAdditions,
      C.OtherNoPayment,
      C.Benefits,
      C.Deductions,
      C.Expenses,
      C.Totals
      // CalcGroup.Disabled,
    ].map((i) => {
      const c = t.result?.irRows?.filter((f) => f.calcData?.grouping === i);
      return new K(
        {
          grouping: i,
          rows: c?.map((f) => new R(new x({ irRow: f }, s)))
        }
      );
    });
    e.rowGroups?.push(...n);
    const o = n.find((i) => i.grouping === C.Deductions), r = n.find((i) => i.grouping === C.Expenses);
    r.rows.push(...o.rows.filter((i) => this.getEnum(i.data.irRow.data.calculationRowType) === v.PrepaidExpenses)), o.rows = o.rows.filter((i) => this.getEnum(i.data.irRow.data.calculationRowType) !== v.PrepaidExpenses);
    for (const i of o.rows)
      switch (this.getEnum(i.data.irRow.data.calculationRowType)) {
        case v.Advance:
          t.result.workerCalc.fullSalaryAdvance > t.result.workerCalc.salaryAdvance && (i.data.fullTotal = i.data.irRow.total, i.data.irRow.total = 0, i.data.isTotalReduced = !0);
          break;
        case v.UnionPayment:
          i.data.irRow.count = i.data.irRow.total / i.data.irRow.price, t.result.workerCalc.fullUnionPayment > t.result.workerCalc.unionPayment && (i.data.fullTotal = i.data.irRow.total, i.data.irRow.total = 0, i.data.isTotalReduced = !0);
          break;
        case v.TaxAtSource: {
          const f = t.result.irRows.flat().find((m) => m.irData.code === 405);
          f && (i.data.comment = `${d.get("SALAXY.REPORTS.salary.heading.taxAtSourceComment", null, s)} ${y.formatPrice(f.price)}`);
          break;
        }
        default:
          t.result.workerCalc.fullOtherDeductions > t.result.workerCalc.otherDeductions && i.data.irRow?.irData?.code >= 400 && !([402, 412, 413, 414, 417].indexOf(i.data.irRow.irData.code) >= 0) && (i.data.fullTotal = i.data.irRow.total, i.data.irRow.total = 0, i.data.isTotalReduced = !0);
          break;
      }
    for (const i of r.rows)
      switch (this.getEnum(i.data.irRow.data.calculationRowType)) {
        case v.PrepaidExpenses:
          i.data.irRow.price = -1 * i.data.irRow.price, i.data.irRow.total = -1 * i.data.irRow.total, t.result.workerCalc.fullPrepaidExpenses > t.result.workerCalc.prepaidExpenses && (i.data.fullTotal = i.data.irRow.total, i.data.irRow.total = 0, i.data.isTotalReduced = !0);
          break;
      }
    o.rows.unshift(
      // Tax
      new R(
        new x(
          {
            irRow: {
              message: "SALAXY.REPORTS.salary.heading.withholdingTax",
              count: t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.tax / t.result.totals.totalTaxable : 0,
              price: t.result.totals.totalTaxable,
              total: t.result.workerCalc.tax,
              unit: L.Percent
            },
            fullTotal: t.result.workerCalc.fullTax,
            isTotalReduced: t.result.workerCalc.fullTax > t.result.workerCalc.tax
          }
        )
      )
    ), o.rows.push(
      // Pension
      new R(
        new x(
          {
            irRow: {
              message: "SALAXY.REPORTS.salary.heading.pensionPayment",
              //
              count: t.result.totals.totalPensionInsuranceBase !== 0 ? t.result.workerCalc.pension / t.result.totals.totalPensionInsuranceBase : 0,
              price: t.result.totals.totalPensionInsuranceBase,
              total: t.result.workerCalc.pension,
              unit: L.Percent
            },
            comment: t.result.workerCalc.fullPension > 0 ? this.getPensionCompanyName(t) : "",
            fullTotal: t.result.workerCalc.fullPension,
            isTotalReduced: t.result.workerCalc.fullPension > t.result.workerCalc.pension
          }
        )
      )
    ), o.rows.push(
      // Unemployment
      new R(
        new x(
          {
            irRow: {
              message: "SALAXY.REPORTS.salary.heading.unemploymentInsurancePayment",
              count: t.result.totals.totalUnemploymentInsuranceBase !== 0 ? t.result.workerCalc.unemploymentInsurance / t.result.totals.totalUnemploymentInsuranceBase : 0,
              price: t.result.totals.totalUnemploymentInsuranceBase,
              total: t.result.workerCalc.unemploymentInsurance,
              unit: L.Percent
            },
            fullTotal: t.result.workerCalc.fullUnemploymentInsurance,
            isTotalReduced: t.result.workerCalc.fullUnemploymentInsurance > t.result.workerCalc.unemploymentInsurance
          }
        )
      )
    ), t.result.workerCalc.fullSocialSecurity > 0 && o.rows.push(
      // Worker's social security
      new R(
        new x(
          {
            irRow: {
              message: "SALAXY.REPORTS.salary.heading.workersSocialInsurancePayment",
              count: t.result.totals.totalHealthInsuranceBase !== 0 ? t.result.workerCalc.socialSecurity / t.result.totals.totalHealthInsuranceBase : 0,
              price: t.result.totals.totalHealthInsuranceBase,
              total: t.result.workerCalc.socialSecurity,
              unit: L.Percent
            },
            fullTotal: t.result.workerCalc.fullSocialSecurity,
            isTotalReduced: t.result.workerCalc.fullSocialSecurity > t.result.workerCalc.socialSecurity
          }
        )
      )
    );
    const u = n.find((i) => i.grouping === C.Totals);
    u.rows.push(
      // Gross salary
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.ENUM.CalcGroup.baseSalary.label",
            total: t.result.totals.totalGrossSalary
          }
        }
      ))
    ), u.rows.push(
      // Deductions
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.ENUM.CalcGroup.deductions.label",
            total: -1 * t.result.workerCalc.deductions
          }
        }
      ))
    ), u.rows.push(
      // Expenses
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.ENUM.CalcGroup.expenses.label",
            total: t.result.totals.totalExpenses - t.result.workerCalc.prepaidExpenses
          }
        }
      ))
    );
  }
  static createEmployerReportRowGroups(e, t, s) {
    const a = t.info.paymentChannel || X.Undefined, n = !(a === X.Undefined || a === X.PalkkausCfaReference || a === X.PalkkausEcfaReference || a === X.PalkkausCfaFinvoice || a === X.PalkkausEcfaFinvoice || a === X.PalkkausCfaPaytrail || a === X.PalkkausEcfaPaytrail || a === X.HolviCfa || a === X.TalenomCfa), r = [
      C.BaseSalary,
      C.SalaryAdditions,
      C.OtherNoPayment,
      C.Expenses
    ].map((O) => {
      const k = t.result.irRows.filter((h) => h.calcData.grouping === O);
      return new K(
        {
          grouping: O,
          rows: k.map((h) => new R(new x({ irRow: h }, s)))
        }
      );
    });
    t.result.workerCalc.prepaidExpenses !== 0 && r.find((k) => k.grouping === C.Expenses).rows.push(...t.result.irRows.filter((k) => this.getEnum(k.data.calculationRowType) === v.PrepaidExpenses).map((k) => {
      const h = new R(new x({ irRow: k }, s));
      return h.data.irRow.price = -1 * h.data.irRow.price, h.data.irRow.total = -1 * h.data.irRow.total, h;
    })), e.rowGroups.push(...r);
    const u = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.mandatorySideCosts"
      }
    ), i = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.salaryCost"
      }
    ), c = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.totalCost"
      }
    ), f = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.totalCostAfterTax"
      }
    ), m = new K(
      {
        grouping: C.Totals,
        isHidden: n
      }
    );
    u.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.pensionPayment",
            total: t.result.employerCalc.pension,
            count: t.result.totals.totalPensionInsuranceBase !== 0 ? t.result.employerCalc.pension / t.result.totals.totalPensionInsuranceBase : 0,
            price: t.result.totals.totalPensionInsuranceBase,
            unit: L.Percent
          },
          comment: this.getPensionCompanyName(t)
        }
      ))
    ), u.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.socialInsurancePayment",
            total: t.result.employerCalc.socialSecurity,
            count: t.result.totals.totalHealthInsuranceBase !== 0 ? t.result.employerCalc.socialSecurity / t.result.totals.totalHealthInsuranceBase : 0,
            price: t.result.totals.totalHealthInsuranceBase,
            unit: L.Percent
          }
        }
      ))
    ), u.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.unemploymentInsurancePayment",
            total: t.result.employerCalc.unemployment,
            count: t.result.totals.totalUnemploymentInsuranceBase !== 0 ? t.result.employerCalc.unemployment / t.result.totals.totalUnemploymentInsuranceBase : 0,
            price: t.result.totals.totalUnemploymentInsuranceBase,
            unit: L.Percent
          }
        }
      ))
    ), i.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.grossSalaryLikeBaseSalaryAbove",
            total: t.result.totals.totalGrossSalary,
            count: null,
            unit: L.Percent
          }
        }
      ))
    );
    const p = new R(new x(
      {
        irRow: {
          message: "SALAXY.REPORTS.salary.heading.mandatorySideCosts",
          total: u.total,
          count: null,
          unit: L.Percent
        }
      }
    ));
    if (i.rows.push(p), t.result.employerCalc.palkkaus > 0) {
      const O = Math.max(t.result.totals.totalSocialSecurityBase ?? 0, t.result.totals.totalTaxable ?? 0);
      i.rows.push(new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.palkkausFee",
            total: t.result.employerCalc.palkkaus,
            price: O,
            count: O !== 0 ? this.calculatePriceExclVat(t, t.result.employerCalc.palkkaus) / O : 0,
            unit: L.Percent
          },
          comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, t.result.employerCalc.palkkaus))})`
        }
      )));
    }
    if (t.result.employerCalc.service > 0) {
      const O = t.result.irRows.filter(
        (k) => this.getEnum(k.data.calculationRowType) === v.Service
      );
      O.length > 0 ? i.rows.push(...O.map((k) => {
        const h = new R(new x(
          {
            irRow: k,
            comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, k.total))})`
          },
          s
        ));
        return h.data.irRow.count = null, h.data.irRow.price = null, h;
      })) : i.rows.push(new R(new x(
        {
          irRow: {
            message: d.get("SALAXY.ENUM.CalculationRowType.service.label", null, s),
            total: t.result.employerCalc.service,
            unit: L.Percent
          },
          comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, t.result.employerCalc.service))})`
        }
      )));
    }
    const w = new R(new x(
      {
        irRow: {
          message: "SALAXY.REPORTS.salary.heading.salaryCost",
          total: i.total,
          count: null,
          unit: L.Percent
        }
      }
    ));
    c.rows.push(w), t.result.totals.totalExpenses > 0 && c.rows.push(new R(new x(
      {
        irRow: {
          message: "SALAXY.REPORTS.ENUM.CalcGroup.expenses.label",
          total: t.result.totals.totalExpenses - t.result.workerCalc.prepaidExpenses,
          count: null,
          unit: L.Percent
        }
      }
    )));
    const b = new R(new x(
      {
        irRow: {
          message: c.rows.length > 1 ? "SALAXY.REPORTS.salary.heading.totalCost" : "SALAXY.REPORTS.salary.heading.salaryCost",
          total: c.total,
          count: null,
          unit: L.Percent
        }
      }
    ));
    m.rows.push(b), t.salary.isHouseholdDeductible === !0 && t.result.employerCalc.householdDeduction > 0 && (f.rows.push(b), f.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.householdDeduction",
            total: -1 * t.result.employerCalc.householdDeduction,
            count: null,
            unit: L.Percent
          }
        }
      ))
    )), t.result.employerCalc.deductionSalaryAdvance > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidSalaryAdvance",
            total: -1 * t.result.employerCalc.deductionSalaryAdvance,
            count: null,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionOtherDeductions > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidOtherDeduction",
            total: -1 * t.result.employerCalc.deductionOtherDeductions,
            count: null,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionForeclosure > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidForeclosure",
            total: -1 * t.result.employerCalc.deductionForeclosure,
            count: null,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionPensionSelfPayment > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidPension",
            total: -1 * t.result.employerCalc.deductionPensionSelfPayment,
            count: t.result.totals.totalPensionInsuranceBase !== 0 ? t.result.employerCalc.deductionPensionSelfPayment / t.result.totals.totalPensionInsuranceBase : 0,
            price: t.result.totals.totalPensionInsuranceBase,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionUnemploymentSelfPayment > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidUnemploymentInsurance",
            total: -1 * t.result.employerCalc.deductionUnemploymentSelfPayment,
            count: t.result.totals.totalUnemploymentInsuranceBase !== 0 ? t.result.employerCalc.deductionUnemploymentSelfPayment / t.result.totals.totalUnemploymentInsuranceBase : 0,
            price: t.result.totals.totalUnemploymentInsuranceBase,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionUnionPayment > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidUnion",
            total: -1 * t.result.employerCalc.deductionUnionPayment,
            count: t.result.totals.totalTaxable !== 0 ? t.result.employerCalc.deductionUnionPayment / t.result.totals.totalTaxable : 0,
            price: t.result.totals.totalTaxable,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidTaxAndSocialSecurity",
            total: -1 * t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment,
            count: null,
            unit: L.Percent
          }
        }
      ))
    ), t.result.employerCalc.deductionWorkerSelfPayment > 0 && m.rows.push(
      new R(new x(
        {
          irRow: {
            message: "SALAXY.REPORTS.salary.heading.employerPaidWorker",
            total: -1 * t.result.employerCalc.deductionWorkerSelfPayment,
            count: null,
            unit: L.Percent
          }
        }
      ))
    ), e.rowGroups.push(u), e.rowGroups.push(i), c.rows.length > 1 && e.rowGroups.push(c), f.rows.length > 1 && e.rowGroups.push(f), e.rowGroups.push(m);
  }
  static createPaymentReportRowGroups(e, t, s) {
    const a = t.info.paymentChannel || X.Undefined, n = !(a === X.Undefined || a === X.PalkkausCfaReference || a === X.PalkkausEcfaReference || a === X.PalkkausCfaFinvoice || a === X.PalkkausEcfaFinvoice || a === X.PalkkausCfaPaytrail || a === X.PalkkausEcfaPaytrail || a === X.HolviCfa || a === X.TalenomCfa), o = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.paymentPart",
        params: { hideColumnHeaders: "" }
      }
    ), r = new K(
      {
        grouping: C.Undefined,
        groupingTerm: "SALAXY.REPORTS.salary.heading.totalCostAfterTax",
        params: { hideColumnHeaders: !0 }
      }
    ), u = new K(
      {
        grouping: C.Totals,
        params: { hideColumnHeaders: !0 },
        isHidden: n
      }
    );
    if (t.result.totals.totalExpenses !== 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.ENUM.CalcGroup.expenses.label",
            total: t.result.totals.totalExpenses,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.worker",
            workerPercent: null
          }
        )
      )
    ), t.result.workerCalc.prepaidExpenses !== 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.prepaidExpenses",
            total: -1 * t.result.workerCalc.prepaidExpenses,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.worker",
            workerPercent: null
          }
        )
      )
    ), t.result.workerCalc.salaryAdvance !== 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.salaryAdvance",
            total: t.result.workerCalc.salaryAdvance,
            baseAmount: null,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.worker",
            workerPercent: null
          }
        )
      )
    ), t.result.workerCalc.otherDeductions > 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.otherDeductions",
            total: t.result.workerCalc.otherDeductions,
            baseAmount: null,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.worker"
          }
        )
      )
    ), t.result.workerCalc.foreclosure !== 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.foreclosure",
            total: t.result.workerCalc.foreclosure,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.foreclosureExecutor",
            workerPercent: null
          }
        )
      )
    ), o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.withholdingTax",
            total: t.result.workerCalc.tax,
            baseAmount: t.result.totals.totalTaxable,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.taxman",
            workerPercent: t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.tax / t.result.totals.totalTaxable : 0
          }
        )
      )
    ), t.result.workerCalc.taxAtSource > 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.taxAtSource",
            total: t.result.workerCalc.taxAtSource,
            baseAmount: t.result.totals.totalTaxable - t.result.totals.taxAtSourceDeduction,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.taxman",
            workerPercent: t.result.totals.totalTaxable - t.result.totals.taxAtSourceDeduction !== 0 ? t.result.workerCalc.taxAtSource / (t.result.totals.totalTaxable - t.result.totals.taxAtSourceDeduction) : 0
          }
        )
      )
    ), o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.socialInsurancePayment",
            total: t.result.employerCalc.socialSecurity,
            baseAmount: t.result.totals.totalHealthInsuranceBase,
            employerPercent: t.result.totals.totalHealthInsuranceBase !== 0 ? t.result.employerCalc.socialSecurity / t.result.totals.totalHealthInsuranceBase : null,
            receiver: "SALAXY.REPORTS.salary.heading.taxman",
            workerPercent: null
          }
        )
      )
    ), t.result.workerCalc.socialSecurity > 0 && o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.workersSocialInsurancePayment",
            total: t.result.workerCalc.socialSecurity,
            baseAmount: t.result.totals.totalHealthInsuranceBase,
            workerPercent: t.result.totals.totalHealthInsuranceBase !== 0 ? t.result.workerCalc.socialSecurity / t.result.totals.totalHealthInsuranceBase : null,
            receiver: "SALAXY.REPORTS.salary.heading.taxman",
            employerPercent: null
          }
        )
      )
    ), o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.pensionPayment",
            total: t.result.totals.pension,
            baseAmount: t.result.totals.totalPensionInsuranceBase,
            employerPercent: t.result.totals.totalPensionInsuranceBase !== 0 ? t.result.employerCalc.pension / t.result.totals.totalPensionInsuranceBase : null,
            receiver: this.getPensionCompanyName(t),
            workerPercent: t.result.totals.totalPensionInsuranceBase !== 0 ? t.result.workerCalc.pension / t.result.totals.totalPensionInsuranceBase : null
          }
        )
      )
    ), o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.unemploymentInsurancePayment",
            total: t.result.totals.unemployment,
            baseAmount: t.result.totals.totalUnemploymentInsuranceBase,
            employerPercent: t.result.totals.totalUnemploymentInsuranceBase !== 0 ? t.result.employerCalc.unemployment / t.result.totals.totalUnemploymentInsuranceBase : null,
            receiver: "SALAXY.REPORTS.salary.heading.tvr",
            workerPercent: t.result.totals.totalUnemploymentInsuranceBase !== 0 ? t.result.workerCalc.unemploymentInsurance / t.result.totals.totalUnemploymentInsuranceBase : null
          }
        )
      )
    ), t.result.workerCalc.unionPayment > 0) {
      const i = this.isRaksa(t);
      o.rows.push(
        new R(
          new _(
            {
              label: "SALAXY.REPORTS.salary.heading.unionPayment",
              total: t.result.workerCalc.unionPayment,
              baseAmount: t.result.totals.totalTaxable,
              employerPercent: null,
              receiver: i ? "SALAXY.REPORTS.salary.heading.raksa" : "SALAXY.REPORTS.salary.heading.union",
              workerPercent: t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.unionPayment / t.result.totals.totalTaxable : null,
              comment: t.result.employerCalc.deductionUnionPayment > 0 ? "SALAXY.REPORTS.salary.heading.workersEmployerHandledUnionPayment" : ""
            }
          )
        )
      );
    }
    if (t.result.employerCalc.palkkaus > 0 && o.rows.push(new R(
      new _(
        {
          label: "SALAXY.REPORTS.salary.heading.palkkausFee",
          total: t.result.employerCalc.palkkaus,
          baseAmount: t.result.totals.totalGrossSalary,
          employerPercent: t.result.totals.totalGrossSalary !== 0 ? this.calculatePriceExclVat(t, t.result.employerCalc.palkkaus) / t.result.totals.totalGrossSalary : null,
          receiver: "SALAXY.REPORTS.salary.heading.palkkausfi",
          workerPercent: null,
          comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, t.result.employerCalc.palkkaus))})`
        }
      )
    )), t.result.employerCalc.service > 0) {
      const i = t.result.irRows.filter(
        (c) => this.getEnum(c.data.calculationRowType) === v.Service
      );
      i.length > 0 ? o.rows.push(
        ...i.map((c) => new R(new _(
          {
            label: c.message || d.get("SALAXY.ENUM.CalculationRowType.service.label", null, s),
            total: c.total,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.palkkausfi",
            workerPercent: null,
            comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, c.total))})`
          }
        )))
      ) : o.rows.push(new R(new _(
        {
          label: d.get("SALAXY.ENUM.CalculationRowType.service.label", null, s),
          total: t.result.employerCalc.service,
          employerPercent: null,
          receiver: "SALAXY.REPORTS.salary.heading.palkkausfi",
          workerPercent: null,
          comment: `(ALV ${this.displayVatPercent(t)}, ${y.formatPrice(this.calculateVat(t, t.result.employerCalc.service))})`
        }
      )));
    }
    o.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.netSalary",
            total: t.result.workerCalc.salaryPayment,
            employerPercent: null,
            receiver: "SALAXY.REPORTS.salary.heading.worker",
            workerPercent: null
          }
        )
      )
    ), t.salary.isHouseholdDeductible === !0 && t.result.employerCalc.householdDeduction > 0 && (r.rows.push(new R(
      new _(
        {
          label: "SALAXY.REPORTS.salary.heading.totalCost",
          total: o.total,
          employerPercent: null
        }
      )
    )), r.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.householdDeduction",
            total: -1 * t.result.employerCalc.householdDeduction,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    )), u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.totalCost",
            total: o.total,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionSalaryAdvance > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidSalaryAdvance",
            total: -1 * t.result.employerCalc.deductionSalaryAdvance,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionOtherDeductions > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidOtherDeduction",
            total: -1 * t.result.employerCalc.deductionOtherDeductions,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionForeclosure > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidForeclosure",
            total: -1 * t.result.employerCalc.deductionForeclosure,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionPensionSelfPayment > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidPension",
            total: -1 * t.result.employerCalc.deductionPensionSelfPayment,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionUnemploymentSelfPayment > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidUnemploymentInsurance",
            total: -1 * t.result.employerCalc.deductionUnemploymentSelfPayment,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionUnionPayment > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidUnion",
            total: -1 * t.result.employerCalc.deductionUnionPayment,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidTaxAndSocialSecurity",
            total: -1 * t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), t.result.employerCalc.deductionWorkerSelfPayment > 0 && u.rows.push(
      new R(
        new _(
          {
            label: "SALAXY.REPORTS.salary.heading.employerPaidWorker",
            total: -1 * t.result.employerCalc.deductionWorkerSelfPayment,
            baseAmount: null,
            employerPercent: null
          }
        )
      )
    ), e.rowGroups.push(o), r.rows.length > 1 && e.rowGroups.push(r), e.rowGroups.push(u);
  }
  static createHeader(e, t) {
    if (e.header = {}, e.header.employer = {}, e.header.employer.avatar = t.employer.avatar, e.header.employer.businessId = null, e.header.employer.contact = {
      street: t.employer?.contact?.street,
      postalCode: t.employer?.contact?.postalCode,
      city: t.employer?.contact?.city
    }, e.header.worker = {}, e.header.worker.avatar = t.worker.avatar, e.header.worker.socialSecurityNumberValid = t.worker.paymentData.socialSecurityNumberValid, e.header.worker.ibanNumber = t.worker.paymentData.ibanNumber, e.header.worker.contact = {
      email: t.worker.paymentData.email,
      telephone: t.worker.paymentData.telephone,
      street: t.worker.contact?.street,
      postalCode: t.worker.contact?.postalCode,
      city: t.worker.contact?.city
    }, e.header.numberOfDays = t.framework.numberOfDays, e.header.paidAt = t.workflow.paidAt, e.header.salaryDate = t.workflow.salaryDate, e.header.requestedSalaryDate = t.workflow.requestedSalaryDate, e.header.workDescription = t.info.workDescription, e.header.salarySlipMessage = t.info.salarySlipMessage, e.header.workStartDate = t.info.workStartDate, e.header.workEndDate = t.info.workEndDate, e.header.employmentPeriod = (t.worktime || {}).employmentPeriod, e.header.workerHasNoTaxcard = t.worker.tax.snapshot && t.worker.tax.snapshot.kind === Rn.NoTaxCard, e.header.noWithholdingHousehold = t.worker.tax.snapshot && t.worker.tax.snapshot.kind === Rn.NoWithholdingHousehold, !e.header.workerHasNoTaxcard && t.worker.tax.snapshot != null && t.worker.tax.snapshot.kind !== Rn.Undefined) {
      const a = t.worker.tax.snapshot;
      e.header.taxcardTaxPercent = a.taxPercent / 100, e.header.taxcardTaxPercent2 = a.taxPercent2 / 100, e.header.taxcardIncomeLimit = a.incomeLimit, e.header.taxcardCumulativeIncome = a.cumulativeIncome;
    }
    e.header.isTaxAtSource = !1, t.result.irRows.flat().find((a) => a.irData.code === 405 && a.data?.calculationRowType.substr(0, 1).toLowerCase() + a.data?.calculationRowType.substr(1) === v.TaxAtSource) && (e.header.isTaxAtSource = !0, e.header.taxAtSourceDeductionPercent = t.result.irRows.flat().find((a) => a.irData.code === 404 && a.data?.calculationRowType.substr(0, 1).toLowerCase() + a.data?.calculationRowType.substr(1) === v.TaxAtSource)?.count ?? 0), t.result?.totals && (e.header.taxPercent = t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.tax / t.result.totals.totalTaxable : 0);
  }
  static createSummaryHeader(e, t, s) {
    this.createHeader(e, s[0]), e.header.calculationCount = s.length, e.header.workerCount = s.map((a) => a.worker.accountId).filter((a, n, o) => o.indexOf(a) === n).length, e.header.totalSalaryCost = t.employerCalc.totalSalaryCost, e.header.totalGrossSalary = t.totals.totalGrossSalary, e.header.totalWorkerPaymentLegacy = t.workerCalc.totalWorkerPaymentLegacy;
  }
  static createValidationMessages(e, t) {
    e.validationMessages = [], t.result.workerCalc.fullSalaryAdvance > t.result.workerCalc.salaryAdvance && e.validationMessages.push(
      {
        text: "SALAXY.REPORTS.salary.text.salaryAdvanceError.html",
        parameters: {
          fullAmount: y.formatNumber(t.result.workerCalc.fullSalaryAdvance),
          differenceAmount: y.formatNumber(t.result.workerCalc.fullSalaryAdvance - t.result.workerCalc.salaryAdvance)
        }
      }
    ), t.result.workerCalc.fullPension > t.result.workerCalc.pension && e.validationMessages.push({
      text: "SALAXY.REPORTS.salary.text.pensionError.html",
      parameters: {
        fullAmount: y.formatNumber(t.result.workerCalc.fullPension),
        differenceAmount: y.formatNumber(t.result.workerCalc.fullPension - t.result.workerCalc.pension)
      }
    }), t.result.workerCalc.fullUnemploymentInsurance > t.result.workerCalc.unemploymentInsurance && e.validationMessages.push({
      text: "SALAXY.REPORTS.salary.text.unemploymentInsuranceError.html",
      parameters: {
        fullAmount: y.formatNumber(t.result.workerCalc.fullUnemploymentInsurance),
        differenceAmount: y.formatNumber(t.result.workerCalc.fullUnemploymentInsurance - t.result.workerCalc.unemploymentInsurance)
      }
    }), t.result.workerCalc.fullUnionPayment > t.result.workerCalc.unionPayment && e.validationMessages.push({
      text: "SALAXY.REPORTS.salary.text.unionPaymentError.html",
      parameters: {
        fullAmount: y.formatNumber(t.result.workerCalc.fullUnionPayment),
        differenceAmount: y.formatNumber(t.result.workerCalc.fullUnionPayment - t.result.workerCalc.unionPayment)
      }
    }), t.result.workerCalc.fullOtherDeductions > t.result.workerCalc.otherDeductions && e.validationMessages.push({
      text: "SALAXY.REPORTS.salary.text.otherDeductionsError.html",
      parameters: {
        fullAmount: y.formatNumber(t.result.workerCalc.fullOtherDeductions),
        differenceAmount: y.formatNumber(t.result.workerCalc.fullOtherDeductions - t.result.workerCalc.otherDeductions)
      }
    }), t.result.workerCalc.fullPrepaidExpenses > t.result.workerCalc.prepaidExpenses && e.validationMessages.push({
      text: "SALAXY.REPORTS.salary.text.prepaidExpensesError.html",
      parameters: {
        fullAmount: y.formatNumber(t.result.workerCalc.fullPrepaidExpenses),
        differenceAmount: y.formatNumber(t.result.workerCalc.fullPrepaidExpenses - t.result.workerCalc.prepaidExpenses)
      }
    });
  }
  static createEmployerReportNotes(e, t) {
    if (t.framework.type === ql.Construction && !t.framework.isTesIncludedInSalary && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.framework",
        text: "SALAXY.REPORTS.salary.text.followsRaksaFramework",
        parameters: {}
      }
    ), this.isCompensation(t) ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.compensationPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.entrepreneurPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallFarmer ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.farmerPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Athlete ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.athletePension",
        parameters: {}
      }
    ) : t.result.totals.pension === 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.nullPensionPayment",
        text: "SALAXY.REPORTS.salary.text.nullPensionPayment",
        parameters: {
          amount: y.formatNumber(this.getYearlyChangingNumbers(t.result.responsibilities.calculationPaymentDate || g.getToday())?.sideCosts.tyelIncomeLimit)
        }
      }
    ), t.result.totals.unemployment > 0)
      if (t.result.employerCalc.deductionUnemploymentSelfPayment > 0) {
        let s = "SALAXY.REPORTS.salary.text.employerHandledUnemploymentInsurancePayment";
        t.result.responsibilities.pensionCalculation === E.PartialOwner && (s = "SALAXY.REPORTS.salary.text.employerHandledPartialOwnerUnemploymentInsurancePayment"), e.notes.push(
          {
            heading: "SALAXY.REPORTS.salary.heading.employerHandledUnemploymentInsurancePayment",
            text: s,
            parameters: {
              employerAmount: y.formatNumber(t.result.employerCalc.unemployment),
              workerAmount: y.formatNumber(t.result.workerCalc.unemploymentInsurance)
            }
          }
        );
      } else
        e.notes.push(
          {
            heading: "SALAXY.REPORTS.salary.heading.palkkausHandledUnemploymentInsurancePayment",
            text: "SALAXY.REPORTS.salary.text.palkkausHandledUnemploymentInsurancePayment",
            parameters: {
              employerAmount: y.formatNumber(t.result.employerCalc.unemployment),
              workerAmount: y.formatNumber(t.result.workerCalc.unemploymentInsurance)
            }
          }
        );
    else
      this.isCompensation(t) ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.compensationUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.entrepreneurUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallFarmer ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.farmerUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Athlete ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.athleteUnemploymentInsurance",
          parameters: {}
        }
      ) : e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.nullUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.nullUnemploymentInsurancePayment",
          parameters: {}
        }
      );
    if (t.result.workerCalc.unionPayment > 0) {
      const s = t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.unionPayment / t.result.totals.totalTaxable : 0;
      t.result.employerCalc.deductionUnionPayment > 0 ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.employerHandledUnionPayment",
          text: "SALAXY.REPORTS.salary.text.employerHandledUnionPayment",
          parameters: {
            paymentRound: y.formatNumber(t.result.workerCalc.unionPayment),
            percent: y.formatPercent(s * 100)
          }
        }
      ) : e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.palkkausHandledUnionPayment",
          text: "SALAXY.REPORTS.salary.text.palkkausHandledUnionPayment",
          parameters: {
            paymentRound: y.formatNumber(t.result.workerCalc.unionPayment),
            percent: y.formatPercent(s * 100)
          }
        }
      );
    }
    t.salary.isHouseholdDeductible && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.householdDeduction",
        text: "SALAXY.REPORTS.salary.text.householdDeductionVar",
        parameters: {
          ownRisk: y.formatNumber(this.getHouseholdDeductionDeductible(t), 0),
          ownRiskDouble: y.formatNumber(2 * this.getHouseholdDeductionDeductible(t), 0),
          max: y.formatNumber(this.getHouseholdDeductionMaxAmount(t), 0),
          maxDouble: y.formatNumber(2 * this.getHouseholdDeductionMaxAmount(t), 0)
        }
      }
    ), (this.isCompensation(t) || t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur || t.result.responsibilities.pensionCalculation === E.SmallFarmer || t.result.responsibilities.pensionCalculation === E.Athlete || t.result.responsibilities.pensionCalculation === E.BoardRemuneration || t.result.responsibilities.pensionCalculation === E.Compensation) && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noAccidentInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.noAccidentInsurance",
        parameters: {}
      }
    ), this.isCompensation(t) ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noSocialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.compensationSocialInsurance",
        parameters: {}
      }
    ) : t.result.totals.totalHealthInsuranceBase > 0 ? t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment > 0 ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.socialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.socialSecuritySelfPayment",
        parameters: {}
      }
    ) : e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.socialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.socialInsurancePayment",
        parameters: {}
      }
    ) : e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.nullSocialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.nullSocialInsurancePayment",
        parameters: {}
      }
    ), e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.incomesRegister",
        text: "SALAXY.REPORTS.salary.text.incomesRegisterNote",
        parameters: {}
      }
    ), t.result.employerCalc.deductionWorkerSelfPayment > 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.workerSelfPayment",
        text: "SALAXY.REPORTS.salary.text.workerSelfPayment",
        parameters: {}
      }
    ), t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment > 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.taxSelfPayment",
        text: "SALAXY.REPORTS.salary.text.taxSelfPayment",
        parameters: {}
      }
    );
  }
  static createSalarySlipNotes(e, t) {
    if (t.framework.type === ql.Construction && !t.framework.isTesIncludedInSalary && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.framework",
        text: "SALAXY.REPORTS.salary.text.followsRaksaFramework",
        parameters: {}
      }
    ), this.isCompensation(t) ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.compensationPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.entrepreneurPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallFarmer ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.farmerPension",
        parameters: {}
      }
    ) : t.result.responsibilities.pensionCalculation === E.Athlete ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noPensionPayment",
        text: "SALAXY.REPORTS.salary.text.athletePension",
        parameters: {}
      }
    ) : t.result.totals.pension === 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.nullPensionPayment",
        text: "SALAXY.REPORTS.salary.text.nullPensionPayment",
        parameters: {
          amount: y.formatNumber(this.getYearlyChangingNumbers(t.result.responsibilities.calculationPaymentDate || g.getToday())?.sideCosts.tyelIncomeLimit)
        }
      }
    ), t.result.totals.unemployment > 0)
      if (t.result.employerCalc.deductionUnemploymentSelfPayment > 0) {
        let s = "SALAXY.REPORTS.salary.text.workersEmployerHandledUnemploymentInsurancePayment";
        t.result.responsibilities.pensionCalculation === E.PartialOwner && (s = "SALAXY.REPORTS.salary.text.workersEmployerHandledPartialOwnerUnemploymentInsurancePayment"), e.notes.push(
          {
            heading: "SALAXY.REPORTS.salary.heading.workersEmployerHandledUnemploymentInsurancePayment",
            text: s,
            parameters: {}
          }
        );
      } else
        e.notes.push(
          {
            heading: "SALAXY.REPORTS.salary.heading.workersPalkkausHandledUnemploymentInsurancePayment",
            text: "SALAXY.REPORTS.salary.text.workersPalkkausHandledUnemploymentInsurancePayment",
            parameters: {}
          }
        );
    else
      this.isCompensation(t) ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.compensationUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.entrepreneurUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallFarmer ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.farmerUnemploymentInsurance",
          parameters: {}
        }
      ) : t.result.responsibilities.pensionCalculation === E.Athlete ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.noUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.athleteUnemploymentInsurance",
          parameters: {}
        }
      ) : e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.nullUnemploymentInsurancePayment",
          text: "SALAXY.REPORTS.salary.text.nullUnemploymentInsurancePayment",
          parameters: {}
        }
      );
    if (t.result.workerCalc.unionPayment > 0) {
      const s = t.result.totals.totalTaxable !== 0 ? t.result.workerCalc.unionPayment / t.result.totals.totalTaxable : 0;
      t.result.employerCalc.deductionUnionPayment > 0 ? e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.employerHandledUnionPayment",
          text: "SALAXY.REPORTS.salary.text.employerHandledUnionPayment",
          parameters: {
            paymentRound: y.formatNumber(t.result.workerCalc.unionPayment),
            percent: y.formatPercent(s * 100)
          }
        }
      ) : e.notes.push(
        {
          heading: "SALAXY.REPORTS.salary.heading.palkkausHandledUnionPayment",
          text: "SALAXY.REPORTS.salary.text.palkkausHandledUnionPayment",
          parameters: {
            paymentRound: y.formatNumber(t.result.workerCalc.unionPayment),
            percent: y.formatPercent(s * 100)
          }
        }
      );
    }
    t.salary.isHouseholdDeductible && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.householdDeduction",
        text: "SALAXY.REPORTS.salary.text.householdDeductionVar",
        parameters: {
          ownRisk: y.formatNumber(this.getHouseholdDeductionDeductible(t), 0),
          ownRiskDouble: y.formatNumber(2 * this.getHouseholdDeductionDeductible(t), 0),
          max: y.formatNumber(this.getHouseholdDeductionMaxAmount(t), 0),
          maxDouble: y.formatNumber(2 * this.getHouseholdDeductionMaxAmount(t), 0)
        }
      }
    ), (this.isCompensation(t) || t.result.responsibilities.pensionCalculation === E.Entrepreneur || t.result.responsibilities.pensionCalculation === E.Farmer || t.result.responsibilities.pensionCalculation === E.SmallEntrepreneur || t.result.responsibilities.pensionCalculation === E.SmallFarmer || t.result.responsibilities.pensionCalculation === E.Athlete || t.result.responsibilities.pensionCalculation === E.BoardRemuneration || t.result.responsibilities.pensionCalculation === E.Compensation) && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.noAccidentInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.noAccidentInsurance",
        parameters: {}
      }
    ), t.result.workerCalc.socialSecurity > 0 || (t.result.totals.totalHealthInsuranceBase > 0 ? e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.workersSocialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.workersSocialInsurancePayment",
        parameters: {
          year: g.getYear(t.result.responsibilities.calculationPaymentDate || g.getToday()),
          percent: y.formatNumber(this.getYearlyChangingNumbers(t.result.responsibilities.calculationPaymentDate || g.getToday())?.sideCosts.illnessInsurancePercent * 100),
          totalBaseRound: y.formatNumber(t.result.totals.totalHealthInsuranceBase),
          amountRound: y.formatNumber(t.result.totals.totalHealthInsuranceBase * this.getYearlyChangingNumbers(t.result.responsibilities.calculationPaymentDate || g.getToday())?.sideCosts.illnessInsurancePercent)
        }
      }
    ) : e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.workersNullSocialInsurancePayment",
        text: "SALAXY.REPORTS.salary.text.workersNullSocialInsurancePayment",
        parameters: {}
      }
    )), e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.incomesRegister",
        text: "SALAXY.REPORTS.salary.text.incomesRegisterNote",
        parameters: {}
      }
    ), t.result.employerCalc.deductionWorkerSelfPayment > 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.workerSelfPayment",
        text: "SALAXY.REPORTS.salary.text.workerSelfPayment",
        parameters: {}
      }
    ), t.result.employerCalc.deductionTaxAndSocialSecuritySelfPayment > 0 && e.notes.push(
      {
        heading: "SALAXY.REPORTS.salary.heading.taxSelfPayment",
        text: "SALAXY.REPORTS.salary.text.taxSelfPayment",
        parameters: {}
      }
    );
  }
  static createCumulativeData(e, t) {
    const s = t.cumulative;
    if (s) {
      e.cumulative = [];
      const a = Object.keys(s);
      for (const n of a) {
        let o = 0;
        const r = s[n], u = Object.keys(r.data);
        for (const i of u) {
          const c = {
            key: i,
            label: r.labels[i],
            total: r.data[i],
            data: {
              [n]: !0,
              [o++ % 2 === 0 ? "left" : "right"]: !0,
              unit: {
                [(r.units ?? {})[i] ?? "none"]: !0
              }
            }
          };
          e.cumulative.push(c);
        }
      }
    } else
      e.cumulative = null;
  }
  static getPensionCompanyName(e) {
    if (e.result.responsibilities) {
      const t = e.result.responsibilities.pensionCompany;
      return t ? "SALAXY.ENUM.PensionCompany." + t + ".label" : "";
    }
  }
  static isCompensation(e) {
    return e.result.irRows.some((t) => t.irData.code === 336);
  }
  static getEnum(e) {
    if (!e)
      return e;
    let t = `${e}`;
    return t = t.charAt(0).toLowerCase() + t.slice(1), t;
  }
  static isRaksa(e) {
    let t = !1;
    if (e.framework.unionPayment === Kl.RaksaNormal || e.framework.unionPayment === Kl.RaksaUnemploymentOnly)
      t = !0;
    else
      for (const s of e.rows)
        if (s.rowType === v.UnionPayment) {
          const a = this.getEnum(s.data.kind);
          if (a === Jl.RaksaNormal || a === Jl.RaksaUnemploymentOnly) {
            t = !0;
            break;
          }
        }
    return t;
  }
  static calculateCalculationsResultsSummary(e) {
    return e.map((t) => t.result).reduce(
      (t, s) => ({
        employerCalc: {
          allSideCosts: this.summarizeField(t, s, "employerCalc.allSideCosts"),
          deductionForeclosure: this.summarizeField(t, s, "employerCalc.deductionForeclosure"),
          deductionOtherDeductions: this.summarizeField(t, s, "employerCalc.deductionOtherDeductions"),
          deductionPensionSelfPayment: this.summarizeField(t, s, "employerCalc.deductionPensionSelfPayment"),
          deductionSalaryAdvance: this.summarizeField(t, s, "employerCalc.deductionSalaryAdvance"),
          deductionTaxAndSocialSecuritySelfPayment: this.summarizeField(t, s, "employerCalc.deductionTaxAndSocialSecuritySelfPayment"),
          deductionUnemploymentSelfPayment: this.summarizeField(t, s, "employerCalc.deductionUnemploymentSelfPayment"),
          deductionUnionPayment: this.summarizeField(t, s, "employerCalc.deductionUnionPayment"),
          deductionWorkerSelfPayment: this.summarizeField(t, s, "employerCalc.deductionWorkerSelfPayment"),
          finalCost: this.summarizeField(t, s, "employerCalc.finalCost"),
          foreclosureByPalkkaus: this.summarizeField(t, s, "employerCalc.foreclosureByPalkkaus"),
          householdDeduction: this.summarizeField(t, s, "employerCalc.householdDeduction"),
          mandatorySideCosts: this.summarizeField(t, s, "employerCalc.mandatorySideCosts"),
          palkkaus: this.summarizeField(t, s, "employerCalc.palkkaus"),
          service: this.summarizeField(t, s, "employerCalc.service"),
          pension: this.summarizeField(t, s, "employerCalc.pension"),
          socialSecurity: this.summarizeField(t, s, "employerCalc.socialSecurity"),
          totalDeductions: this.summarizeField(t, s, "employerCalc.totalDeductions"),
          totalPayment: this.summarizeField(t, s, "employerCalc.totalPayment"),
          totalPaymentLegacy: this.summarizeField(t, s, "employerCalc.totalPaymentLegacy"),
          totalSalaryCost: this.summarizeField(t, s, "employerCalc.totalSalaryCost"),
          unemployment: this.summarizeField(t, s, "employerCalc.unemployment")
        },
        totals: {
          pension: this.summarizeField(t, s, "totals.pension"),
          total: this.summarizeField(t, s, "totals.total"),
          totalAccidentInsuranceBase: this.summarizeField(t, s, "totals.totalAccidentInsuranceBase"),
          totalExpenses: this.summarizeField(t, s, "totals.totalExpenses"),
          totalBaseSalary: this.summarizeField(t, s, "totalstotalBaseSalary."),
          totalGrossSalary: this.summarizeField(t, s, "totals.totalGrossSalary"),
          totalHealthInsuranceBase: this.summarizeField(t, s, "totals.totalHealthInsuranceBase"),
          totalPayable: this.summarizeField(t, s, "totals.totalPayable"),
          totalPensionInsuranceBase: this.summarizeField(t, s, "totals.totalPensionInsuranceBase"),
          totalSocialSecurityBase: this.summarizeField(t, s, "totals.totalSocialSecurityBase"),
          totalTaxable: this.summarizeField(t, s, "totals.totalTaxable"),
          totalUnemploymentInsuranceBase: this.summarizeField(t, s, "totals.totalUnemploymentInsuranceBase"),
          unemployment: this.summarizeField(t, s, "totals.unemployment")
        },
        workerCalc: {
          benefits: this.summarizeField(t, s, "workerCalc.benefits"),
          deductions: this.summarizeField(t, s, "workerCalc.deductions"),
          foreclosure: this.summarizeField(t, s, "workerCalc.foreclosure"),
          fullOtherDeductions: this.summarizeField(t, s, "workerCalc.fullOtherDeductions"),
          fullPension: this.summarizeField(t, s, "workerCalc.fullPension"),
          fullPrepaidExpenses: this.summarizeField(t, s, "workerCalc.fullPrepaidExpenses"),
          fullSalaryAdvance: this.summarizeField(t, s, "workerCalc.fullSalaryAdvance"),
          fullTax: this.summarizeField(t, s, "workerCalc.fullTax"),
          fullUnemploymentInsurance: this.summarizeField(t, s, "workerCalc.fullUnemploymentInsurance"),
          fullUnionPayment: this.summarizeField(t, s, "workerCalc.fullUnionPayment"),
          otherDeductions: this.summarizeField(t, s, "workerCalc.otherDeductions"),
          pension: this.summarizeField(t, s, "workerCalc.pension"),
          prepaidExpenses: this.summarizeField(t, s, "workerCalc.prepaidExpenses"),
          salaryAdvance: this.summarizeField(t, s, "workerCalc.salaryAdvance"),
          salaryAfterTax: this.summarizeField(t, s, "workerCalc.salaryAfterTax"),
          salaryAfterTaxAndForeclosure: this.summarizeField(t, s, "workerCalc.salaryAfterTaxAndForeclosure"),
          salaryPayment: this.summarizeField(t, s, "workerCalc.salaryPayment"),
          tax: this.summarizeField(t, s, "workerCalc.tax"),
          totalWorkerPayment: this.summarizeField(t, s, "workerCalc."),
          totalWorkerPaymentLegacy: this.summarizeField(t, s, "workerCalc.totalWorkerPaymentLegacy"),
          unemploymentInsurance: this.summarizeField(t, s, "workerCalc.unemploymentInsurance"),
          unionPayment: this.summarizeField(t, s, "workerCalc.unionPayment"),
          workerSideCosts: this.summarizeField(t, s, "workerCalc.workerSideCosts")
        }
      }),
      {}
    );
  }
  static summarizeField(e, t, s) {
    return s.split(".").forEach((a) => {
      e = e[a] || 0, t = t[a] || 0;
    }), e + t;
  }
  static getYearlyChangingNumbers(e) {
    try {
      return Qr.getYearlyChangingNumbers(e);
    } catch {
      return null;
    }
  }
  /** Current household deduction max amount. */
  static getHouseholdDeductionMaxAmount(e) {
    const t = this.getTaxDeductionWorkCategories(e), s = this.getYearlyChangingNumbers(e.result?.responsibilities?.calculationPaymentDate || g.getToday())?.sideCosts;
    return this.getHouseholdDeductionCategoriesExtended(s).includes(t) ? s?.householdDeductionMaxAmountExtended : s?.householdDeductionMaxAmount;
  }
  static getHouseholdDeductionDeductible(e) {
    return this.getYearlyChangingNumbers(e.result?.responsibilities?.calculationPaymentDate || g.getToday())?.sideCosts?.householdDeductionDeductible;
  }
  static getTaxDeductionWorkCategories(e) {
    return e.usecase?.data?.taxDeductionCategories ?? Zr.None;
  }
  static getHouseholdDeductionCategoriesExtended(e) {
    return e?.householdDeductionCategoriesExtended ?? [];
  }
  static getPalkkausVatPercent(e) {
    return this.getYearlyChangingNumbers(e.workflow?.paidAt || e.result?.responsibilities?.calculationPaymentDate || g.getToday())?.sideCosts.palkkausVatPercent;
  }
  static displayVatPercent(e) {
    return `${this.getPalkkausVatPercent(e) * 100}%`.replace(".", ",");
  }
  static calculateVat(e, t) {
    const s = this.getPalkkausVatPercent(e);
    return t * s / (1 + s);
  }
  static calculatePriceExclVat(e, t) {
    const s = this.getPalkkausVatPercent(e);
    return t / (1 + s);
  }
}
class Ef {
  /**
   * Maps data to hbs supported report format
   * @param data BusinessObject data for mapping
   * @returns Mapped data
   */
  static getAccountingReport(e) {
    const t = e;
    t.result = [], t.dimensionHeaders = [], t.globalDimensions = [];
    const s = (a, n) => {
      a && !t.globalDimensions?.includes(n) && n !== "costCenter" && t.globalDimensions.push(n);
    };
    for (const a of e.ledgerAccounts ?? [])
      for (const n of a.entries ?? []) {
        const o = n.dimension?.costCenter || n.dimension?.dimensions?.costCenter;
        if (s(o, "SALAXY.REPORTS.accounting.heading.costCenter"), n.dimension?.dimensions)
          for (const [r, u] of Object.entries(n.dimension.dimensions))
            s(u, r);
      }
    t.dimensionHeaders = t.globalDimensions;
    for (const a of e.ledgerAccounts ?? []) {
      const n = [];
      for (const o of a.entries ?? []) {
        const r = [];
        for (const c of t.globalDimensions)
          if (c === "SALAXY.REPORTS.accounting.heading.costCenter") {
            const f = o.dimension?.costCenter || o.dimension?.dimensions?.costCenter || "";
            r.push(f);
          } else
            r.push(o.dimension?.dimensions ? o.dimension.dimensions[c] : "");
        const u = o.vatPercent ?? 0;
        let i = n.find((c) => c.vatPercent === u && c.dimensionsId === r.join("-"));
        i == null && (i = { entries: [], vatPercent: u, dimensions: r, dimensionsId: r.join("-") }, n.push(i)), i.entries.push(o);
      }
      for (const o of n) {
        const r = {}, u = {};
        for (let c = 0; c < t.globalDimensions.length; c++) {
          const f = t.globalDimensions[c];
          u[f] = o.dimensions[c];
        }
        r.dimensions = u, r.accountNumber = a.accountNumber, r.accountName = a.accountName, r.vatPercent = o.vatPercent;
        const i = o.entries?.reduce((c, f) => c + (f?.isDebit ? f?.amount ?? 0 : -1 * (f?.amount ?? 0)), 0) ?? 0;
        r.sum = i, t.result.push(r);
      }
    }
    return t;
  }
  /**
   * Creates HeaderFooterData from provided parameters
   * @param businessObject AccountingData that
   * @param options Report options
   * @param lang gets translation with this lang, if null use current lang
   * @returns HeaderFooterData for provided businessObject
   */
  static getHeaderFooter(e, t, s) {
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: d.get("SALAXY.REPORTS.accounting.title", null, s),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Creates ReporLayout object depending on switchToPortrait boolean
   * @param switchToPortrait boolean indicating if layout should be portrait
   * @returns ReportLayout object
   */
  static getReportLayout(e, t = !1) {
    return e ? {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    } : {
      isLayoutA4Portrait: !1,
      isLayoutA4Landscape: !0,
      layout: "a4Landscape",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    };
  }
}
class Of {
  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  static getHeaderFooter(e, t) {
    return {
      logo: e?.logo,
      img2: e?.img2,
      title: d.get("SALAXY.REPORTS.authorization.heading.title", null, t).toUpperCase(),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  static getRaksaHeaderFooter(e, t) {
    return {
      logo: e?.logo,
      img2: e?.img2,
      title: d.get("Palkkamyllyn valtakirja", null, t).toUpperCase(),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Loads report type specific HeaderFooterData.
   * @param reportOptions The AuthorizationPdf entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  static getKycHeaderFooter(e, t) {
    return {
      logo: e?.logo,
      img2: e?.img2,
      title: d.get("SALAXY.REPORTS.kycCompany.heading", null, t).toUpperCase(),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Loads the raw report that is then rendered downstream as an html or pdf report. Also handles if person or company
   * @param businessObject Authorization entity
   * @returns Authorization
   */
  static getAuthorizationReport(e) {
    return e;
  }
  /**
   * Loads the authorization layout for pdf or html reports.
   * @param pdf Are we rendering a pdf report or not.
   * @returns Returns authorization layout.
   */
  static loadReportLayout(e) {
    return {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: e ? "pdf" : "htmlPage",
      isModeHtmlPage: !e,
      isModePdf: e
    };
  }
}
const Wl = class Wl {
  /**
   * Creates HeaderFooterData from provided parameters
   * @param businessObject SummaryReportData that
   * @param options Report options
   * @param lang gets translation with this lang, if null use current lang
   * @returns HeaderFooterData for provided businessObject
   */
  static getSummaryReportHeaderFooter(e, t, s) {
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: d.get("SALAXY.REPORTS.summary.header.title", null, s),
      subTitle: `${d.get("SALAXY.REPORTS.summary.header.subtitle", null, s)} ${g.getFormattedDate(e.startDate)} - ${g.getFormattedDate(e.endDate)}`,
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Creates ReporLayout object depending on switchToPortrait boolean
   * @param switchToPortrait boolean indicating if layout should be portrait
   * @returns ReportLayout object
   */
  static getReportLayout(e, t = !1) {
    return e ? {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    } : {
      isLayoutA4Portrait: !1,
      isLayoutA4Landscape: !0,
      layout: "a4Landscape",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    };
  }
  /**
   * Maps data to hbs supported report format
   * @param data Business Object for mapping
   * @returns Mapped data
   */
  static getSummaryReport(e) {
    var s, a;
    e.result.workerResult = [], e.result.entrepreneurResult = [], e.totalResult = [];
    for (const n of (e.calculations ?? []).filter((o) => !this.isEntrepreneurPensionContract(o.result?.responsibilities?.pensionCalculation))) {
      const o = {};
      o.worker = n.worker?.avatar?.displayName, o.workStartDate = g.getFormattedDate(n.info?.workStartDate), o.workStartEndDate = g.getFormattedDate(n.info?.workEndDate), o.totalGrossSalary = y.formatNumber(n.result?.totals?.totalGrossSalary), o.totalRowCategory = y.formatNumber(this.getTotalByRowCategory(n.result, De.Holidays)), o.benefits = y.formatNumber(n.result?.workerCalc?.benefits), o.irCode = y.formatNumber(this.getTotalByIrCode(n.result, [401, 407, 419])), o.totalTaxable = y.formatNumber(n.result?.totals?.totalTaxable), o.tax = y.formatNumber(n.result?.workerCalc?.tax), o.pension = y.formatNumber(n.result?.workerCalc?.pension), o.unemploymentInsurance = y.formatNumber(n.result?.workerCalc?.unemploymentInsurance), o.unionPayment = y.formatNumber(n.result?.workerCalc?.unionPayment), o.foreclosure = y.formatNumber(n.result?.workerCalc?.foreclosure), o.otherDeductions = y.formatNumber(n.result.workerCalc.salaryAdvance + n.result.workerCalc.otherDeductions + n.result.workerCalc.prepaidExpenses), o.totalExpenses = y.formatNumber(n.result?.totals?.totalExpenses), o.totalWorkerPayment = y.formatNumber(n.result?.workerCalc?.totalWorkerPayment), o.totalPayment = y.formatNumber(n.result?.employerCalc?.totalPayment), o.palkkaus = y.formatNumber(n.result?.employerCalc?.palkkaus), o.service = y.formatNumber(n.result?.employerCalc?.service), o.socialSecurity = y.formatNumber(n.result?.employerCalc?.socialSecurity), o.totalPensions = y.formatNumber(n.result?.totals?.pension), o.employerPension = y.formatNumber(n.result?.employerCalc?.pension), o.unemployment = y.formatNumber(n.result?.totals?.unemployment), o.employerUnemployment = y.formatNumber(n.result?.employerCalc?.unemployment), o.taxAtSource = y.formatNumber((n.result?.workerCalc).taxAtSource), o.workerSocialSecurity = y.formatNumber((n.result?.workerCalc).socialSecurity), e.result.workerResult.push(o);
    }
    for (const n of (e.calculations ?? []).filter((o) => this.isEntrepreneurPensionContract(o.result?.responsibilities?.pensionCalculation))) {
      const o = {};
      o.worker = n.worker?.avatar?.displayName, o.workStartDate = g.getFormattedDate(n.info?.workStartDate), o.workStartEndDate = g.getFormattedDate(n.info?.workEndDate), o.totalGrossSalary = y.formatNumber(n.result?.totals?.totalGrossSalary), o.totalRowCategory = y.formatNumber(this.getTotalByRowCategory(n.result, De.Holidays)), o.benefits = y.formatNumber(n.result?.workerCalc?.benefits), o.irCode = y.formatNumber(this.getTotalByIrCode(n.result, [401, 407, 419])), o.totalTaxable = y.formatNumber(n.result?.totals?.totalTaxable), o.tax = y.formatNumber(n.result?.workerCalc?.tax), o.pension = y.formatNumber(n.result?.workerCalc?.pension), o.unemploymentInsurance = y.formatNumber(n.result?.workerCalc?.unemploymentInsurance), o.unionPayment = y.formatNumber(n.result?.workerCalc?.unionPayment), o.foreclosure = y.formatNumber(n.result?.workerCalc?.foreclosure), o.otherDeductions = y.formatNumber(n.result.workerCalc.salaryAdvance + n.result.workerCalc.otherDeductions + n.result.workerCalc.prepaidExpenses), o.totalExpenses = y.formatNumber(n.result?.totals?.totalExpenses), o.totalWorkerPayment = y.formatNumber(n.result?.workerCalc?.totalWorkerPayment), o.totalPayment = y.formatNumber(n.result?.employerCalc?.totalPayment), o.palkkaus = y.formatNumber(n.result?.employerCalc?.palkkaus), o.service = y.formatNumber(n.result?.employerCalc?.service), o.socialSecurity = y.formatNumber(n.result?.employerCalc?.socialSecurity), o.totalPensions = y.formatNumber(n.result?.totals?.pension), o.employerPension = y.formatNumber(n.result?.employerCalc?.pension), o.unemployment = y.formatNumber(n.result?.totals?.unemployment), o.employerUnemployment = y.formatNumber(n.result?.employerCalc?.unemployment), o.taxAtSource = y.formatNumber((n.result?.workerCalc).taxAtSource), o.workerSocialSecurity = y.formatNumber((n.result?.workerCalc).socialSecurity), e.result.entrepreneurResult.push(o);
    }
    const t = {};
    return e.result ?? (e.result = {}), (s = e.result).employerCalc ?? (s.employerCalc = {}), (a = e.result).totals ?? (a.totals = {}), t.totalGrossSalary = y.formatNumber(e.result?.totals?.totalGrossSalary), t.totalRowCategory = y.formatNumber(this.getTotalByRowCategory(e.result, De.Holidays)), t.benefits = y.formatNumber(e.result?.workerCalc?.benefits), t.irCode = y.formatNumber(this.getTotalByIrCode(e.result, [401, 407, 419])), t.totalTaxable = y.formatNumber(e.result?.totals?.totalTaxable), t.tax = y.formatNumber(e.result?.workerCalc?.tax), t.pension = y.formatNumber(e.result?.workerCalc?.pension), t.unemploymentInsurance = y.formatNumber(e.result?.workerCalc?.unemploymentInsurance), t.unionPayment = y.formatNumber(e.result?.workerCalc?.unionPayment), t.foreclosure = y.formatNumber(e.result?.workerCalc?.foreclosure), t.otherDeductions = y.formatNumber(e.result.workerCalc.salaryAdvance + e.result.workerCalc.otherDeductions + e.result.workerCalc.prepaidExpenses), t.totalExpenses = y.formatNumber(e.result.totals?.totalExpenses), t.totalWorkerPayment = y.formatNumber(e.result.workerCalc?.totalWorkerPayment), t.totalPayment = y.formatNumber(e.result.employerCalc.totalPayment), t.palkkaus = y.formatNumber(e.result.employerCalc.palkkaus), t.service = y.formatNumber(e.result.employerCalc.service), t.socialSecurity = y.formatNumber(e.result.employerCalc.socialSecurity), t.totalPensions = y.formatNumber(e.result.totals.pension), t.employerPension = y.formatNumber(e.result.employerCalc.pension), t.unemployment = y.formatNumber(e.result.totals.unemployment), t.employerUnemployment = y.formatNumber(e.result.employerCalc.unemployment), t.taxAtSource = y.formatNumber(e.result.workerCalc.taxAtSource), t.workerSocialSecurity = y.formatNumber(e.result.workerCalc.socialSecurity), e.totalResult.push(t), e;
  }
  static getTotalByRowCategory(e, t) {
    if (!e)
      return 0;
    let s = [];
    switch (t) {
      case De.Holidays:
        s = e.rows?.filter((a) => this.isInRange(a.rowType, 300, 399)) ?? [];
        break;
      case De.Expenses:
        s = e.rows?.filter((a) => this.isInRange(a.rowType, 201, 299)) ?? [];
        break;
    }
    return nn.sum(s, (a) => a.total ?? 0);
  }
  static getTotalByIrCode(e, t) {
    return e ? nn.sum(e.irRows?.filter((s) => this.isInIrCodes(s.irData?.code, t)) ?? [], (s) => s.total ?? 0) : 0;
  }
  static isEntrepreneurPensionContract(e) {
    return e ? e == E.Entrepreneur || e == E.Farmer || e == E.Athlete || e == E.SmallEntrepreneur || e == E.SmallFarmer : !1;
  }
  static isInRange(e, t, s) {
    if (!e)
      return !1;
    const a = this.calculationTypeMetaData?.values?.find((n) => n.name == e)?.order;
    return a ? a >= t && a <= s : !1;
  }
  static isInIrCodes(e, t) {
    return e ? t.indexOf(e) >= 0 : !1;
  }
};
Wl.calculationTypeMetaData = G.getEnumMetadata("CalculationRowType");
let rt = Wl;
var fl = {}, un = {}, $ = {};
Object.defineProperty($, "__esModule", {
  value: !0
});
function Zo(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var eu = function l(e, t) {
  Zo(this, l), this.data = e, this.text = t.text || e, this.options = t;
};
$.default = eu;
Object.defineProperty(un, "__esModule", {
  value: !0
});
un.CODE39 = void 0;
var nu = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), lu = $, tu = ru(lu);
function ru(l) {
  return l && l.__esModule ? l : { default: l };
}
function au(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ou(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function uu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var iu = function(l) {
  uu(e, l);
  function e(t, s) {
    return au(this, e), t = t.toUpperCase(), s.mod43 && (t += mu(fu(t))), ou(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return nu(e, [{
    key: "encode",
    value: function() {
      for (var s = Cn("*"), a = 0; a < this.data.length; a++)
        s += Cn(this.data[a]) + "0";
      return s += Cn("*"), {
        data: s,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9A-Z\-\.\ \$\/\+\%]+$/) !== -1;
    }
  }]), e;
}(tu.default), sr = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "-", ".", " ", "$", "/", "+", "%", "*"], su = [20957, 29783, 23639, 30485, 20951, 29813, 23669, 20855, 29789, 23645, 29975, 23831, 30533, 22295, 30149, 24005, 21623, 29981, 23837, 22301, 30023, 23879, 30545, 22343, 30161, 24017, 21959, 30065, 23921, 22385, 29015, 18263, 29141, 17879, 29045, 18293, 17783, 29021, 18269, 17477, 17489, 17681, 20753, 35770];
function Cn(l) {
  return cu(cr(l));
}
function cu(l) {
  return su[l].toString(2);
}
function mu(l) {
  return sr[l];
}
function cr(l) {
  return sr.indexOf(l);
}
function fu(l) {
  for (var e = 0, t = 0; t < l.length; t++)
    e += cr(l[t]);
  return e = e % 43, e;
}
un.CODE39 = iu;
var J = {}, yl = {}, Ce = {}, D = {};
Object.defineProperty(D, "__esModule", {
  value: !0
});
var Me;
function Tn(l, e, t) {
  return e in l ? Object.defineProperty(l, e, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : l[e] = t, l;
}
var mr = D.SET_A = 0, fr = D.SET_B = 1, yr = D.SET_C = 2;
D.SHIFT = 98;
var yu = D.START_A = 103, du = D.START_B = 104, gu = D.START_C = 105;
D.MODULO = 103;
D.STOP = 106;
D.FNC1 = 207;
D.SET_BY_CODE = (Me = {}, Tn(Me, yu, mr), Tn(Me, du, fr), Tn(Me, gu, yr), Me);
D.SWAP = {
  101: mr,
  100: fr,
  99: yr
};
D.A_START_CHAR = "Ð";
D.B_START_CHAR = "Ñ";
D.C_START_CHAR = "Ò";
D.A_CHARS = "[\0-_È-Ï]";
D.B_CHARS = "[ -È-Ï]";
D.C_CHARS = "(Ï*[0-9]{2}Ï*)";
D.BARS = [11011001100, 11001101100, 11001100110, 10010011e3, 10010001100, 10001001100, 10011001e3, 10011000100, 10001100100, 11001001e3, 11001000100, 11000100100, 10110011100, 10011011100, 10011001110, 10111001100, 10011101100, 10011100110, 11001110010, 11001011100, 11001001110, 11011100100, 11001110100, 11101101110, 11101001100, 11100101100, 11100100110, 11101100100, 11100110100, 11100110010, 11011011e3, 11011000110, 11000110110, 10100011e3, 10001011e3, 10001000110, 10110001e3, 10001101e3, 10001100010, 11010001e3, 11000101e3, 11000100010, 10110111e3, 10110001110, 10001101110, 10111011e3, 10111000110, 10001110110, 11101110110, 11010001110, 11000101110, 11011101e3, 11011100010, 11011101110, 11101011e3, 11101000110, 11100010110, 11101101e3, 11101100010, 11100011010, 11101111010, 11001000010, 11110001010, 1010011e4, 10100001100, 1001011e4, 10010000110, 10000101100, 10000100110, 1011001e4, 10110000100, 1001101e4, 10011000010, 10000110100, 10000110010, 11000010010, 1100101e4, 11110111010, 11000010100, 10001111010, 10100111100, 10010111100, 10010011110, 10111100100, 10011110100, 10011110010, 11110100100, 11110010100, 11110010010, 11011011110, 11011110110, 11110110110, 10101111e3, 10100011110, 10001011110, 10111101e3, 10111100010, 11110101e3, 11110100010, 10111011110, 10111101110, 11101011110, 11110101110, 11010000100, 1101001e4, 11010011100, 1100011101011];
Object.defineProperty(Ce, "__esModule", {
  value: !0
});
var Pu = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), pu = $, hu = vu(pu), B = D;
function vu(l) {
  return l && l.__esModule ? l : { default: l };
}
function ku(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Su(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function wu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Ru = function(l) {
  wu(e, l);
  function e(t, s) {
    ku(this, e);
    var a = Su(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t.substring(1), s));
    return a.bytes = t.split("").map(function(n) {
      return n.charCodeAt(0);
    }), a;
  }
  return Pu(e, [{
    key: "valid",
    value: function() {
      return /^[\x00-\x7F\xC8-\xD3]+$/.test(this.data);
    }
    // The public encoding function
  }, {
    key: "encode",
    value: function() {
      var s = this.bytes, a = s.shift() - 105, n = B.SET_BY_CODE[a];
      if (n === void 0)
        throw new RangeError("The encoding does not start with a start character.");
      this.shouldEncodeAsEan128() === !0 && s.unshift(B.FNC1);
      var o = e.next(s, 1, n);
      return {
        text: this.text === this.data ? this.text.replace(/[^\x20-\x7E]/g, "") : this.text,
        data: (
          // Add the start bits
          e.getBar(a) + // Add the encoded bits
          o.result + // Add the checksum
          e.getBar((o.checksum + a) % B.MODULO) + // Add the end bits
          e.getBar(B.STOP)
        )
      };
    }
    // GS1-128/EAN-128
  }, {
    key: "shouldEncodeAsEan128",
    value: function() {
      var s = this.options.ean128 || !1;
      return typeof s == "string" && (s = s.toLowerCase() === "true"), s;
    }
    // Get a bar symbol by index
  }], [{
    key: "getBar",
    value: function(s) {
      return B.BARS[s] ? B.BARS[s].toString() : "";
    }
    // Correct an index by a set and shift it from the bytes array
  }, {
    key: "correctIndex",
    value: function(s, a) {
      if (a === B.SET_A) {
        var n = s.shift();
        return n < 32 ? n + 64 : n - 32;
      } else
        return a === B.SET_B ? s.shift() - 32 : (s.shift() - 48) * 10 + s.shift() - 48;
    }
  }, {
    key: "next",
    value: function(s, a, n) {
      if (!s.length)
        return { result: "", checksum: 0 };
      var o = void 0, r = void 0;
      if (s[0] >= 200) {
        r = s.shift() - 105;
        var u = B.SWAP[r];
        u !== void 0 ? o = e.next(s, a + 1, u) : ((n === B.SET_A || n === B.SET_B) && r === B.SHIFT && (s[0] = n === B.SET_A ? s[0] > 95 ? s[0] - 96 : s[0] : s[0] < 32 ? s[0] + 96 : s[0]), o = e.next(s, a + 1, n));
      } else
        r = e.correctIndex(s, n), o = e.next(s, a + 1, n);
      var i = e.getBar(r), c = r * a;
      return {
        result: i + o.result,
        checksum: c + o.checksum
      };
    }
  }]), e;
}(hu.default);
Ce.default = Ru;
var dl = {};
Object.defineProperty(dl, "__esModule", {
  value: !0
});
var ue = D, dr = function(e) {
  return e.match(new RegExp("^" + ue.A_CHARS + "*"))[0].length;
}, gr = function(e) {
  return e.match(new RegExp("^" + ue.B_CHARS + "*"))[0].length;
}, Pr = function(e) {
  return e.match(new RegExp("^" + ue.C_CHARS + "*"))[0];
};
function gl(l, e) {
  var t = e ? ue.A_CHARS : ue.B_CHARS, s = l.match(new RegExp("^(" + t + "+?)(([0-9]{2}){2,})([^0-9]|$)"));
  if (s)
    return s[1] + "Ì" + pr(l.substring(s[1].length));
  var a = l.match(new RegExp("^" + t + "+"))[0];
  return a.length === l.length ? l : a + String.fromCharCode(e ? 205 : 206) + gl(l.substring(a.length), !e);
}
function pr(l) {
  var e = Pr(l), t = e.length;
  if (t === l.length)
    return l;
  l = l.substring(t);
  var s = dr(l) >= gr(l);
  return e + String.fromCharCode(s ? 206 : 205) + gl(l, s);
}
dl.default = function(l) {
  var e = void 0, t = Pr(l).length;
  if (t >= 2)
    e = ue.C_START_CHAR + pr(l);
  else {
    var s = dr(l) > gr(l);
    e = (s ? ue.A_START_CHAR : ue.B_START_CHAR) + gl(l, s);
  }
  return e.replace(
    /[\xCD\xCE]([^])[\xCD\xCE]/,
    // Any sequence between 205 and 206 characters
    function(a, n) {
      return "Ë" + n;
    }
  );
};
Object.defineProperty(yl, "__esModule", {
  value: !0
});
var Au = Ce, bu = hr(Au), Eu = dl, Ou = hr(Eu);
function hr(l) {
  return l && l.__esModule ? l : { default: l };
}
function Cu(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function xn(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Tu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var xu = function(l) {
  Tu(e, l);
  function e(t, s) {
    if (Cu(this, e), /^[\x00-\x7F\xC8-\xD3]+$/.test(t))
      var a = xn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, (0, Ou.default)(t), s));
    else
      var a = xn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    return xn(a);
  }
  return e;
}(bu.default);
yl.default = xu;
var Pl = {};
Object.defineProperty(Pl, "__esModule", {
  value: !0
});
var Lu = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), _u = Ce, Du = Mu(_u), at = D;
function Mu(l) {
  return l && l.__esModule ? l : { default: l };
}
function Xu(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Yu(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Iu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Hu = function(l) {
  Iu(e, l);
  function e(t, s) {
    return Xu(this, e), Yu(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, at.A_START_CHAR + t, s));
  }
  return Lu(e, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + at.A_CHARS + "+$").test(this.data);
    }
  }]), e;
}(Du.default);
Pl.default = Hu;
var pl = {};
Object.defineProperty(pl, "__esModule", {
  value: !0
});
var $u = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Bu = Ce, Fu = ju(Bu), ot = D;
function ju(l) {
  return l && l.__esModule ? l : { default: l };
}
function Vu(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Uu(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Nu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var zu = function(l) {
  Nu(e, l);
  function e(t, s) {
    return Vu(this, e), Uu(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, ot.B_START_CHAR + t, s));
  }
  return $u(e, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + ot.B_CHARS + "+$").test(this.data);
    }
  }]), e;
}(Fu.default);
pl.default = zu;
var hl = {};
Object.defineProperty(hl, "__esModule", {
  value: !0
});
var Gu = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Wu = Ce, qu = Ku(Wu), ut = D;
function Ku(l) {
  return l && l.__esModule ? l : { default: l };
}
function Ju(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Qu(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Zu(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var ei = function(l) {
  Zu(e, l);
  function e(t, s) {
    return Ju(this, e), Qu(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, ut.C_START_CHAR + t, s));
  }
  return Gu(e, [{
    key: "valid",
    value: function() {
      return new RegExp("^" + ut.C_CHARS + "+$").test(this.data);
    }
  }]), e;
}(qu.default);
hl.default = ei;
Object.defineProperty(J, "__esModule", {
  value: !0
});
J.CODE128C = J.CODE128B = J.CODE128A = J.CODE128 = void 0;
var ni = yl, li = sn(ni), ti = Pl, ri = sn(ti), ai = pl, oi = sn(ai), ui = hl, ii = sn(ui);
function sn(l) {
  return l && l.__esModule ? l : { default: l };
}
J.CODE128 = li.default;
J.CODE128A = ri.default;
J.CODE128B = oi.default;
J.CODE128C = ii.default;
var H = {}, vl = {}, N = {};
Object.defineProperty(N, "__esModule", {
  value: !0
});
N.SIDE_BIN = "101";
N.MIDDLE_BIN = "01010";
N.BINARIES = {
  L: [
    // The L (left) type of encoding
    "0001101",
    "0011001",
    "0010011",
    "0111101",
    "0100011",
    "0110001",
    "0101111",
    "0111011",
    "0110111",
    "0001011"
  ],
  G: [
    // The G type of encoding
    "0100111",
    "0110011",
    "0011011",
    "0100001",
    "0011101",
    "0111001",
    "0000101",
    "0010001",
    "0001001",
    "0010111"
  ],
  R: [
    // The R (right) type of encoding
    "1110010",
    "1100110",
    "1101100",
    "1000010",
    "1011100",
    "1001110",
    "1010000",
    "1000100",
    "1001000",
    "1110100"
  ],
  O: [
    // The O (odd) encoding for UPC-E
    "0001101",
    "0011001",
    "0010011",
    "0111101",
    "0100011",
    "0110001",
    "0101111",
    "0111011",
    "0110111",
    "0001011"
  ],
  E: [
    // The E (even) encoding for UPC-E
    "0100111",
    "0110011",
    "0011011",
    "0100001",
    "0011101",
    "0111001",
    "0000101",
    "0010001",
    "0001001",
    "0010111"
  ]
};
N.EAN2_STRUCTURE = ["LL", "LG", "GL", "GG"];
N.EAN5_STRUCTURE = ["GGLLL", "GLGLL", "GLLGL", "GLLLG", "LGGLL", "LLGGL", "LLLGG", "LGLGL", "LGLLG", "LLGLG"];
N.EAN13_STRUCTURE = ["LLLLLL", "LLGLGG", "LLGGLG", "LLGGGL", "LGLLGG", "LGGLLG", "LGGGLL", "LGLGLG", "LGLGGL", "LGGLGL"];
var cn = {}, ge = {};
Object.defineProperty(ge, "__esModule", {
  value: !0
});
var si = N, ci = function(e, t, s) {
  var a = e.split("").map(function(o, r) {
    return si.BINARIES[t[r]];
  }).map(function(o, r) {
    return o ? o[e[r]] : "";
  });
  if (s) {
    var n = e.length - 1;
    a = a.map(function(o, r) {
      return r < n ? o + s : o;
    });
  }
  return a.join("");
};
ge.default = ci;
Object.defineProperty(cn, "__esModule", {
  value: !0
});
var mi = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), he = N, fi = ge, it = vr(fi), yi = $, di = vr(yi);
function vr(l) {
  return l && l.__esModule ? l : { default: l };
}
function gi(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Pi(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function pi(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var hi = function(l) {
  pi(e, l);
  function e(t, s) {
    gi(this, e);
    var a = Pi(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    return a.fontSize = !s.flat && s.fontSize > s.width * 10 ? s.width * 10 : s.fontSize, a.guardHeight = s.height + a.fontSize / 2 + s.textMargin, a;
  }
  return mi(e, [{
    key: "encode",
    value: function() {
      return this.options.flat ? this.encodeFlat() : this.encodeGuarded();
    }
  }, {
    key: "leftText",
    value: function(s, a) {
      return this.text.substr(s, a);
    }
  }, {
    key: "leftEncode",
    value: function(s, a) {
      return (0, it.default)(s, a);
    }
  }, {
    key: "rightText",
    value: function(s, a) {
      return this.text.substr(s, a);
    }
  }, {
    key: "rightEncode",
    value: function(s, a) {
      return (0, it.default)(s, a);
    }
  }, {
    key: "encodeGuarded",
    value: function() {
      var s = { fontSize: this.fontSize }, a = { height: this.guardHeight };
      return [{ data: he.SIDE_BIN, options: a }, { data: this.leftEncode(), text: this.leftText(), options: s }, { data: he.MIDDLE_BIN, options: a }, { data: this.rightEncode(), text: this.rightText(), options: s }, { data: he.SIDE_BIN, options: a }];
    }
  }, {
    key: "encodeFlat",
    value: function() {
      var s = [he.SIDE_BIN, this.leftEncode(), he.MIDDLE_BIN, this.rightEncode(), he.SIDE_BIN];
      return {
        data: s.join(""),
        text: this.text
      };
    }
  }]), e;
}(di.default);
cn.default = hi;
Object.defineProperty(vl, "__esModule", {
  value: !0
});
var vi = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Xe = function l(e, t, s) {
  e === null && (e = Function.prototype);
  var a = Object.getOwnPropertyDescriptor(e, t);
  if (a === void 0) {
    var n = Object.getPrototypeOf(e);
    return n === null ? void 0 : l(n, t, s);
  } else {
    if ("value" in a)
      return a.value;
    var o = a.get;
    return o === void 0 ? void 0 : o.call(s);
  }
}, ki = N, Si = cn, wi = Ri(Si);
function Ri(l) {
  return l && l.__esModule ? l : { default: l };
}
function Ai(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function bi(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Ei(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var st = function(e) {
  var t = e.substr(0, 12).split("").map(function(s) {
    return +s;
  }).reduce(function(s, a, n) {
    return n % 2 ? s + a * 3 : s + a;
  }, 0);
  return (10 - t % 10) % 10;
}, Oi = function(l) {
  Ei(e, l);
  function e(t, s) {
    Ai(this, e), t.search(/^[0-9]{12}$/) !== -1 && (t += st(t));
    var a = bi(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    return a.lastChar = s.lastChar, a;
  }
  return vi(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{13}$/) !== -1 && +this.data[12] === st(this.data);
    }
  }, {
    key: "leftText",
    value: function() {
      return Xe(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "leftText", this).call(this, 1, 6);
    }
  }, {
    key: "leftEncode",
    value: function() {
      var s = this.data.substr(1, 6), a = ki.EAN13_STRUCTURE[this.data[0]];
      return Xe(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "leftEncode", this).call(this, s, a);
    }
  }, {
    key: "rightText",
    value: function() {
      return Xe(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "rightText", this).call(this, 7, 6);
    }
  }, {
    key: "rightEncode",
    value: function() {
      var s = this.data.substr(7, 6);
      return Xe(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "rightEncode", this).call(this, s, "RRRRRR");
    }
    // The "standard" way of printing EAN13 barcodes with guard bars
  }, {
    key: "encodeGuarded",
    value: function() {
      var s = Xe(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "encodeGuarded", this).call(this);
      return this.options.displayValue && (s.unshift({
        data: "000000000000",
        text: this.text.substr(0, 1),
        options: { textAlign: "left", fontSize: this.fontSize }
      }), this.options.lastChar && (s.push({
        data: "00"
      }), s.push({
        data: "00000",
        text: this.options.lastChar,
        options: { fontSize: this.fontSize }
      }))), s;
    }
  }]), e;
}(wi.default);
vl.default = Oi;
var kl = {};
Object.defineProperty(kl, "__esModule", {
  value: !0
});
var Ci = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), We = function l(e, t, s) {
  e === null && (e = Function.prototype);
  var a = Object.getOwnPropertyDescriptor(e, t);
  if (a === void 0) {
    var n = Object.getPrototypeOf(e);
    return n === null ? void 0 : l(n, t, s);
  } else {
    if ("value" in a)
      return a.value;
    var o = a.get;
    return o === void 0 ? void 0 : o.call(s);
  }
}, Ti = cn, xi = Li(Ti);
function Li(l) {
  return l && l.__esModule ? l : { default: l };
}
function _i(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Di(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Mi(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var ct = function(e) {
  var t = e.substr(0, 7).split("").map(function(s) {
    return +s;
  }).reduce(function(s, a, n) {
    return n % 2 ? s + a : s + a * 3;
  }, 0);
  return (10 - t % 10) % 10;
}, Xi = function(l) {
  Mi(e, l);
  function e(t, s) {
    return _i(this, e), t.search(/^[0-9]{7}$/) !== -1 && (t += ct(t)), Di(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return Ci(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{8}$/) !== -1 && +this.data[7] === ct(this.data);
    }
  }, {
    key: "leftText",
    value: function() {
      return We(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "leftText", this).call(this, 0, 4);
    }
  }, {
    key: "leftEncode",
    value: function() {
      var s = this.data.substr(0, 4);
      return We(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "leftEncode", this).call(this, s, "LLLL");
    }
  }, {
    key: "rightText",
    value: function() {
      return We(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "rightText", this).call(this, 4, 4);
    }
  }, {
    key: "rightEncode",
    value: function() {
      var s = this.data.substr(4, 4);
      return We(e.prototype.__proto__ || Object.getPrototypeOf(e.prototype), "rightEncode", this).call(this, s, "RRRR");
    }
  }]), e;
}(xi.default);
kl.default = Xi;
var Sl = {};
Object.defineProperty(Sl, "__esModule", {
  value: !0
});
var Yi = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Ii = N, Hi = ge, $i = kr(Hi), Bi = $, Fi = kr(Bi);
function kr(l) {
  return l && l.__esModule ? l : { default: l };
}
function ji(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Vi(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Ui(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Ni = function(e) {
  var t = e.split("").map(function(s) {
    return +s;
  }).reduce(function(s, a, n) {
    return n % 2 ? s + a * 9 : s + a * 3;
  }, 0);
  return t % 10;
}, zi = function(l) {
  Ui(e, l);
  function e(t, s) {
    return ji(this, e), Vi(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return Yi(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{5}$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var s = Ii.EAN5_STRUCTURE[Ni(this.data)];
      return {
        data: "1011" + (0, $i.default)(this.data, s, "01"),
        text: this.text
      };
    }
  }]), e;
}(Fi.default);
Sl.default = zi;
var wl = {};
Object.defineProperty(wl, "__esModule", {
  value: !0
});
var Gi = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Wi = N, qi = ge, Ki = Sr(qi), Ji = $, Qi = Sr(Ji);
function Sr(l) {
  return l && l.__esModule ? l : { default: l };
}
function Zi(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function es(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function ns(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var ls = function(l) {
  ns(e, l);
  function e(t, s) {
    return Zi(this, e), es(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return Gi(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{2}$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var s = Wi.EAN2_STRUCTURE[parseInt(this.data) % 4];
      return {
        // Start bits + Encode the two digits with 01 in between
        data: "1011" + (0, Ki.default)(this.data, s, "01"),
        text: this.text
      };
    }
  }]), e;
}(Qi.default);
wl.default = ls;
var je = {};
Object.defineProperty(je, "__esModule", {
  value: !0
});
var ts = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}();
je.checksum = el;
var rs = ge, ve = wr(rs), as = $, os = wr(as);
function wr(l) {
  return l && l.__esModule ? l : { default: l };
}
function us(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function is(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function ss(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var cs = function(l) {
  ss(e, l);
  function e(t, s) {
    us(this, e), t.search(/^[0-9]{11}$/) !== -1 && (t += el(t));
    var a = is(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    return a.displayValue = s.displayValue, s.fontSize > s.width * 10 ? a.fontSize = s.width * 10 : a.fontSize = s.fontSize, a.guardHeight = s.height + a.fontSize / 2 + s.textMargin, a;
  }
  return ts(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{12}$/) !== -1 && this.data[11] == el(this.data);
    }
  }, {
    key: "encode",
    value: function() {
      return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
    }
  }, {
    key: "flatEncoding",
    value: function() {
      var s = "";
      return s += "101", s += (0, ve.default)(this.data.substr(0, 6), "LLLLLL"), s += "01010", s += (0, ve.default)(this.data.substr(6, 6), "RRRRRR"), s += "101", {
        data: s,
        text: this.text
      };
    }
  }, {
    key: "guardedEncoding",
    value: function() {
      var s = [];
      return this.displayValue && s.push({
        data: "00000000",
        text: this.text.substr(0, 1),
        options: { textAlign: "left", fontSize: this.fontSize }
      }), s.push({
        data: "101" + (0, ve.default)(this.data[0], "L"),
        options: { height: this.guardHeight }
      }), s.push({
        data: (0, ve.default)(this.data.substr(1, 5), "LLLLL"),
        text: this.text.substr(1, 5),
        options: { fontSize: this.fontSize }
      }), s.push({
        data: "01010",
        options: { height: this.guardHeight }
      }), s.push({
        data: (0, ve.default)(this.data.substr(6, 5), "RRRRR"),
        text: this.text.substr(6, 5),
        options: { fontSize: this.fontSize }
      }), s.push({
        data: (0, ve.default)(this.data[11], "R") + "101",
        options: { height: this.guardHeight }
      }), this.displayValue && s.push({
        data: "00000000",
        text: this.text.substr(11, 1),
        options: { textAlign: "right", fontSize: this.fontSize }
      }), s;
    }
  }]), e;
}(os.default);
function el(l) {
  var e = 0, t;
  for (t = 1; t < 11; t += 2)
    e += parseInt(l[t]);
  for (t = 0; t < 11; t += 2)
    e += parseInt(l[t]) * 3;
  return (10 - e % 10) % 10;
}
je.default = cs;
var Rl = {};
Object.defineProperty(Rl, "__esModule", {
  value: !0
});
var ms = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), fs = ge, ys = Rr(fs), ds = $, gs = Rr(ds), Ps = je;
function Rr(l) {
  return l && l.__esModule ? l : { default: l };
}
function ps(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ln(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function hs(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var vs = ["XX00000XXX", "XX10000XXX", "XX20000XXX", "XXX00000XX", "XXXX00000X", "XXXXX00005", "XXXXX00006", "XXXXX00007", "XXXXX00008", "XXXXX00009"], ks = [["EEEOOO", "OOOEEE"], ["EEOEOO", "OOEOEE"], ["EEOOEO", "OOEEOE"], ["EEOOOE", "OOEEEO"], ["EOEEOO", "OEOOEE"], ["EOOEEO", "OEEOOE"], ["EOOOEE", "OEEEOO"], ["EOEOEO", "OEOEOE"], ["EOEOOE", "OEOEEO"], ["EOOEOE", "OEEOEO"]], Ss = function(l) {
  hs(e, l);
  function e(t, s) {
    ps(this, e);
    var a = Ln(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    if (a.isValid = !1, t.search(/^[0-9]{6}$/) !== -1)
      a.middleDigits = t, a.upcA = mt(t, "0"), a.text = s.text || "" + a.upcA[0] + t + a.upcA[a.upcA.length - 1], a.isValid = !0;
    else if (t.search(/^[01][0-9]{7}$/) !== -1)
      if (a.middleDigits = t.substring(1, t.length - 1), a.upcA = mt(a.middleDigits, t[0]), a.upcA[a.upcA.length - 1] === t[t.length - 1])
        a.isValid = !0;
      else
        return Ln(a);
    else
      return Ln(a);
    return a.displayValue = s.displayValue, s.fontSize > s.width * 10 ? a.fontSize = s.width * 10 : a.fontSize = s.fontSize, a.guardHeight = s.height + a.fontSize / 2 + s.textMargin, a;
  }
  return ms(e, [{
    key: "valid",
    value: function() {
      return this.isValid;
    }
  }, {
    key: "encode",
    value: function() {
      return this.options.flat ? this.flatEncoding() : this.guardedEncoding();
    }
  }, {
    key: "flatEncoding",
    value: function() {
      var s = "";
      return s += "101", s += this.encodeMiddleDigits(), s += "010101", {
        data: s,
        text: this.text
      };
    }
  }, {
    key: "guardedEncoding",
    value: function() {
      var s = [];
      return this.displayValue && s.push({
        data: "00000000",
        text: this.text[0],
        options: { textAlign: "left", fontSize: this.fontSize }
      }), s.push({
        data: "101",
        options: { height: this.guardHeight }
      }), s.push({
        data: this.encodeMiddleDigits(),
        text: this.text.substring(1, 7),
        options: { fontSize: this.fontSize }
      }), s.push({
        data: "010101",
        options: { height: this.guardHeight }
      }), this.displayValue && s.push({
        data: "00000000",
        text: this.text[7],
        options: { textAlign: "right", fontSize: this.fontSize }
      }), s;
    }
  }, {
    key: "encodeMiddleDigits",
    value: function() {
      var s = this.upcA[0], a = this.upcA[this.upcA.length - 1], n = ks[parseInt(a)][parseInt(s)];
      return (0, ys.default)(this.middleDigits, n);
    }
  }]), e;
}(gs.default);
function mt(l, e) {
  for (var t = parseInt(l[l.length - 1]), s = vs[t], a = "", n = 0, o = 0; o < s.length; o++) {
    var r = s[o];
    r === "X" ? a += l[n++] : a += r;
  }
  return a = "" + e + a, "" + a + (0, Ps.checksum)(a);
}
Rl.default = Ss;
Object.defineProperty(H, "__esModule", {
  value: !0
});
H.UPCE = H.UPC = H.EAN2 = H.EAN5 = H.EAN8 = H.EAN13 = void 0;
var ws = vl, Rs = Te(ws), As = kl, bs = Te(As), Es = Sl, Os = Te(Es), Cs = wl, Ts = Te(Cs), xs = je, Ls = Te(xs), _s = Rl, Ds = Te(_s);
function Te(l) {
  return l && l.__esModule ? l : { default: l };
}
H.EAN13 = Rs.default;
H.EAN8 = bs.default;
H.EAN5 = Os.default;
H.EAN2 = Ts.default;
H.UPC = Ls.default;
H.UPCE = Ds.default;
var we = {}, mn = {}, Ve = {};
Object.defineProperty(Ve, "__esModule", {
  value: !0
});
Ve.START_BIN = "1010";
Ve.END_BIN = "11101";
Ve.BINARIES = ["00110", "10001", "01001", "11000", "00101", "10100", "01100", "00011", "10010", "01010"];
Object.defineProperty(mn, "__esModule", {
  value: !0
});
var Ms = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), qe = Ve, Xs = $, Ys = Is(Xs);
function Is(l) {
  return l && l.__esModule ? l : { default: l };
}
function Hs(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function $s(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Bs(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Fs = function(l) {
  Bs(e, l);
  function e() {
    return Hs(this, e), $s(this, (e.__proto__ || Object.getPrototypeOf(e)).apply(this, arguments));
  }
  return Ms(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^([0-9]{2})+$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      var s = this, a = this.data.match(/.{2}/g).map(function(n) {
        return s.encodePair(n);
      }).join("");
      return {
        data: qe.START_BIN + a + qe.END_BIN,
        text: this.text
      };
    }
    // Calculate the data of a number pair
  }, {
    key: "encodePair",
    value: function(s) {
      var a = qe.BINARIES[s[1]];
      return qe.BINARIES[s[0]].split("").map(function(n, o) {
        return (n === "1" ? "111" : "1") + (a[o] === "1" ? "000" : "0");
      }).join("");
    }
  }]), e;
}(Ys.default);
mn.default = Fs;
var Al = {};
Object.defineProperty(Al, "__esModule", {
  value: !0
});
var js = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Vs = mn, Us = Ns(Vs);
function Ns(l) {
  return l && l.__esModule ? l : { default: l };
}
function zs(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Gs(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Ws(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var ft = function(e) {
  var t = e.substr(0, 13).split("").map(function(s) {
    return parseInt(s, 10);
  }).reduce(function(s, a, n) {
    return s + a * (3 - n % 2 * 2);
  }, 0);
  return Math.ceil(t / 10) * 10 - t;
}, qs = function(l) {
  Ws(e, l);
  function e(t, s) {
    return zs(this, e), t.search(/^[0-9]{13}$/) !== -1 && (t += ft(t)), Gs(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return js(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]{14}$/) !== -1 && +this.data[13] === ft(this.data);
    }
  }]), e;
}(Us.default);
Al.default = qs;
Object.defineProperty(we, "__esModule", {
  value: !0
});
we.ITF14 = we.ITF = void 0;
var Ks = mn, Js = Ar(Ks), Qs = Al, Zs = Ar(Qs);
function Ar(l) {
  return l && l.__esModule ? l : { default: l };
}
we.ITF = Js.default;
we.ITF14 = Zs.default;
var U = {}, Pe = {};
Object.defineProperty(Pe, "__esModule", {
  value: !0
});
var ec = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), nc = $, lc = tc(nc);
function tc(l) {
  return l && l.__esModule ? l : { default: l };
}
function rc(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function ac(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function oc(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var uc = function(l) {
  oc(e, l);
  function e(t, s) {
    return rc(this, e), ac(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return ec(e, [{
    key: "encode",
    value: function() {
      for (var s = "110", a = 0; a < this.data.length; a++) {
        var n = parseInt(this.data[a]), o = n.toString(2);
        o = ic(o, 4 - o.length);
        for (var r = 0; r < o.length; r++)
          s += o[r] == "0" ? "100" : "110";
      }
      return s += "1001", {
        data: s,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.data.search(/^[0-9]+$/) !== -1;
    }
  }]), e;
}(lc.default);
function ic(l, e) {
  for (var t = 0; t < e; t++)
    l = "0" + l;
  return l;
}
Pe.default = uc;
var bl = {}, pe = {};
Object.defineProperty(pe, "__esModule", {
  value: !0
});
pe.mod10 = sc;
pe.mod11 = cc;
function sc(l) {
  for (var e = 0, t = 0; t < l.length; t++) {
    var s = parseInt(l[t]);
    (t + l.length) % 2 === 0 ? e += s : e += s * 2 % 10 + Math.floor(s * 2 / 10);
  }
  return (10 - e % 10) % 10;
}
function cc(l) {
  for (var e = 0, t = [2, 3, 4, 5, 6, 7], s = 0; s < l.length; s++) {
    var a = parseInt(l[l.length - 1 - s]);
    e += t[s % t.length] * a;
  }
  return (11 - e % 11) % 11;
}
Object.defineProperty(bl, "__esModule", {
  value: !0
});
var mc = Pe, fc = dc(mc), yc = pe;
function dc(l) {
  return l && l.__esModule ? l : { default: l };
}
function gc(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Pc(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function pc(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var hc = function(l) {
  pc(e, l);
  function e(t, s) {
    return gc(this, e), Pc(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t + (0, yc.mod10)(t), s));
  }
  return e;
}(fc.default);
bl.default = hc;
var El = {};
Object.defineProperty(El, "__esModule", {
  value: !0
});
var vc = Pe, kc = wc(vc), Sc = pe;
function wc(l) {
  return l && l.__esModule ? l : { default: l };
}
function Rc(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Ac(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function bc(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Ec = function(l) {
  bc(e, l);
  function e(t, s) {
    return Rc(this, e), Ac(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t + (0, Sc.mod11)(t), s));
  }
  return e;
}(kc.default);
El.default = Ec;
var Ol = {};
Object.defineProperty(Ol, "__esModule", {
  value: !0
});
var Oc = Pe, Cc = Tc(Oc), yt = pe;
function Tc(l) {
  return l && l.__esModule ? l : { default: l };
}
function xc(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Lc(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function _c(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Dc = function(l) {
  _c(e, l);
  function e(t, s) {
    return xc(this, e), t += (0, yt.mod10)(t), t += (0, yt.mod10)(t), Lc(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return e;
}(Cc.default);
Ol.default = Dc;
var Cl = {};
Object.defineProperty(Cl, "__esModule", {
  value: !0
});
var Mc = Pe, Xc = Yc(Mc), dt = pe;
function Yc(l) {
  return l && l.__esModule ? l : { default: l };
}
function Ic(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Hc(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function $c(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var Bc = function(l) {
  $c(e, l);
  function e(t, s) {
    return Ic(this, e), t += (0, dt.mod11)(t), t += (0, dt.mod10)(t), Hc(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return e;
}(Xc.default);
Cl.default = Bc;
Object.defineProperty(U, "__esModule", {
  value: !0
});
U.MSI1110 = U.MSI1010 = U.MSI11 = U.MSI10 = U.MSI = void 0;
var Fc = Pe, jc = Ue(Fc), Vc = bl, Uc = Ue(Vc), Nc = El, zc = Ue(Nc), Gc = Ol, Wc = Ue(Gc), qc = Cl, Kc = Ue(qc);
function Ue(l) {
  return l && l.__esModule ? l : { default: l };
}
U.MSI = jc.default;
U.MSI10 = Uc.default;
U.MSI11 = zc.default;
U.MSI1010 = Wc.default;
U.MSI1110 = Kc.default;
var fn = {};
Object.defineProperty(fn, "__esModule", {
  value: !0
});
fn.pharmacode = void 0;
var Jc = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Qc = $, Zc = em(Qc);
function em(l) {
  return l && l.__esModule ? l : { default: l };
}
function nm(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function lm(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function tm(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var rm = function(l) {
  tm(e, l);
  function e(t, s) {
    nm(this, e);
    var a = lm(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
    return a.number = parseInt(t, 10), a;
  }
  return Jc(e, [{
    key: "encode",
    value: function() {
      for (var s = this.number, a = ""; !isNaN(s) && s != 0; )
        s % 2 === 0 ? (a = "11100" + a, s = (s - 2) / 2) : (a = "100" + a, s = (s - 1) / 2);
      return a = a.slice(0, -2), {
        data: a,
        text: this.text
      };
    }
  }, {
    key: "valid",
    value: function() {
      return this.number >= 3 && this.number <= 131070;
    }
  }]), e;
}(Zc.default);
fn.pharmacode = rm;
var yn = {};
Object.defineProperty(yn, "__esModule", {
  value: !0
});
yn.codabar = void 0;
var am = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), om = $, um = im(om);
function im(l) {
  return l && l.__esModule ? l : { default: l };
}
function sm(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function cm(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function mm(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var fm = function(l) {
  mm(e, l);
  function e(t, s) {
    sm(this, e), t.search(/^[0-9\-\$\:\.\+\/]+$/) === 0 && (t = "A" + t + "A");
    var a = cm(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t.toUpperCase(), s));
    return a.text = a.options.text || a.text.replace(/[A-D]/g, ""), a;
  }
  return am(e, [{
    key: "valid",
    value: function() {
      return this.data.search(/^[A-D][0-9\-\$\:\.\+\/]+[A-D]$/) !== -1;
    }
  }, {
    key: "encode",
    value: function() {
      for (var s = [], a = this.getEncodings(), n = 0; n < this.data.length; n++)
        s.push(a[this.data.charAt(n)]), n !== this.data.length - 1 && s.push("0");
      return {
        text: this.text,
        data: s.join("")
      };
    }
  }, {
    key: "getEncodings",
    value: function() {
      return {
        0: "101010011",
        1: "101011001",
        2: "101001011",
        3: "110010101",
        4: "101101001",
        5: "110101001",
        6: "100101011",
        7: "100101101",
        8: "100110101",
        9: "110100101",
        "-": "101001101",
        $: "101100101",
        ":": "1101011011",
        "/": "1101101011",
        ".": "1101101101",
        "+": "1011011011",
        A: "1011001001",
        B: "1001001011",
        C: "1010010011",
        D: "1010011001"
      };
    }
  }]), e;
}(um.default);
yn.codabar = fm;
var dn = {};
Object.defineProperty(dn, "__esModule", {
  value: !0
});
dn.GenericBarcode = void 0;
var ym = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), dm = $, gm = Pm(dm);
function Pm(l) {
  return l && l.__esModule ? l : { default: l };
}
function pm(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function hm(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function vm(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var km = function(l) {
  vm(e, l);
  function e(t, s) {
    return pm(this, e), hm(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t, s));
  }
  return ym(e, [{
    key: "encode",
    value: function() {
      return {
        data: "10101010101010101010101010101010101010101",
        text: this.text
      };
    }
    // Resturn true/false if the string provided is valid for this encoder
  }, {
    key: "valid",
    value: function() {
      return !0;
    }
  }]), e;
}(gm.default);
dn.GenericBarcode = km;
Object.defineProperty(fl, "__esModule", {
  value: !0
});
var Sm = un, Ke = J, ke = H, gt = we, Ye = U, wm = fn, Rm = yn, Am = dn;
fl.default = {
  CODE39: Sm.CODE39,
  CODE128: Ke.CODE128,
  CODE128A: Ke.CODE128A,
  CODE128B: Ke.CODE128B,
  CODE128C: Ke.CODE128C,
  EAN13: ke.EAN13,
  EAN8: ke.EAN8,
  EAN5: ke.EAN5,
  EAN2: ke.EAN2,
  UPC: ke.UPC,
  UPCE: ke.UPCE,
  ITF14: gt.ITF14,
  ITF: gt.ITF,
  MSI: Ye.MSI,
  MSI10: Ye.MSI10,
  MSI11: Ye.MSI11,
  MSI1010: Ye.MSI1010,
  MSI1110: Ye.MSI1110,
  pharmacode: wm.pharmacode,
  codabar: Rm.codabar,
  GenericBarcode: Am.GenericBarcode
};
var xe = {};
Object.defineProperty(xe, "__esModule", {
  value: !0
});
var bm = Object.assign || function(l) {
  for (var e = 1; e < arguments.length; e++) {
    var t = arguments[e];
    for (var s in t)
      Object.prototype.hasOwnProperty.call(t, s) && (l[s] = t[s]);
  }
  return l;
};
xe.default = function(l, e) {
  return bm({}, l, e);
};
var Tl = {};
Object.defineProperty(Tl, "__esModule", {
  value: !0
});
Tl.default = Em;
function Em(l) {
  var e = [];
  function t(s) {
    if (Array.isArray(s))
      for (var a = 0; a < s.length; a++)
        t(s[a]);
    else
      s.text = s.text || "", s.data = s.data || "", e.push(s);
  }
  return t(l), e;
}
var xl = {};
Object.defineProperty(xl, "__esModule", {
  value: !0
});
xl.default = Om;
function Om(l) {
  return l.marginTop = l.marginTop || l.margin, l.marginBottom = l.marginBottom || l.margin, l.marginRight = l.marginRight || l.margin, l.marginLeft = l.marginLeft || l.margin, l;
}
var Ll = {}, _l = {}, gn = {};
Object.defineProperty(gn, "__esModule", {
  value: !0
});
gn.default = Cm;
function Cm(l) {
  var e = ["width", "height", "textMargin", "fontSize", "margin", "marginTop", "marginBottom", "marginLeft", "marginRight"];
  for (var t in e)
    e.hasOwnProperty(t) && (t = e[t], typeof l[t] == "string" && (l[t] = parseInt(l[t], 10)));
  return typeof l.displayValue == "string" && (l.displayValue = l.displayValue != "false"), l;
}
var Pn = {};
Object.defineProperty(Pn, "__esModule", {
  value: !0
});
var Tm = {
  width: 2,
  height: 100,
  format: "auto",
  displayValue: !0,
  fontOptions: "",
  font: "monospace",
  text: void 0,
  textAlign: "center",
  textPosition: "bottom",
  textMargin: 2,
  fontSize: 20,
  background: "#ffffff",
  lineColor: "#000000",
  margin: 10,
  marginTop: void 0,
  marginBottom: void 0,
  marginLeft: void 0,
  marginRight: void 0,
  valid: function() {
  }
};
Pn.default = Tm;
Object.defineProperty(_l, "__esModule", {
  value: !0
});
var xm = gn, Lm = br(xm), _m = Pn, Pt = br(_m);
function br(l) {
  return l && l.__esModule ? l : { default: l };
}
function Dm(l) {
  var e = {};
  for (var t in Pt.default)
    Pt.default.hasOwnProperty(t) && (l.hasAttribute("jsbarcode-" + t.toLowerCase()) && (e[t] = l.getAttribute("jsbarcode-" + t.toLowerCase())), l.hasAttribute("data-" + t.toLowerCase()) && (e[t] = l.getAttribute("data-" + t.toLowerCase())));
  return e.value = l.getAttribute("jsbarcode-value") || l.getAttribute("data-value"), e = (0, Lm.default)(e), e;
}
_l.default = Dm;
var Dl = {}, Ml = {}, F = {};
Object.defineProperty(F, "__esModule", {
  value: !0
});
F.getTotalWidthOfEncodings = F.calculateEncodingAttributes = F.getBarcodePadding = F.getEncodingHeight = F.getMaximumHeightOfEncodings = void 0;
var Mm = xe, Xm = Ym(Mm);
function Ym(l) {
  return l && l.__esModule ? l : { default: l };
}
function Er(l, e) {
  return e.height + (e.displayValue && l.text.length > 0 ? e.fontSize + e.textMargin : 0) + e.marginTop + e.marginBottom;
}
function Or(l, e, t) {
  if (t.displayValue && e < l) {
    if (t.textAlign == "center")
      return Math.floor((l - e) / 2);
    if (t.textAlign == "left")
      return 0;
    if (t.textAlign == "right")
      return Math.floor(l - e);
  }
  return 0;
}
function Im(l, e, t) {
  for (var s = 0; s < l.length; s++) {
    var a = l[s], n = (0, Xm.default)(e, a.options), o;
    n.displayValue ? o = Bm(a.text, n, t) : o = 0;
    var r = a.data.length * n.width;
    a.width = Math.ceil(Math.max(o, r)), a.height = Er(a, n), a.barcodePadding = Or(o, r, n);
  }
}
function Hm(l) {
  for (var e = 0, t = 0; t < l.length; t++)
    e += l[t].width;
  return e;
}
function $m(l) {
  for (var e = 0, t = 0; t < l.length; t++)
    l[t].height > e && (e = l[t].height);
  return e;
}
function Bm(l, e, t) {
  var s;
  if (t)
    s = t;
  else if (typeof document < "u")
    s = document.createElement("canvas").getContext("2d");
  else
    return 0;
  s.font = e.fontOptions + " " + e.fontSize + "px " + e.font;
  var a = s.measureText(l);
  if (!a)
    return 0;
  var n = a.width;
  return n;
}
F.getMaximumHeightOfEncodings = $m;
F.getEncodingHeight = Er;
F.getBarcodePadding = Or;
F.calculateEncodingAttributes = Im;
F.getTotalWidthOfEncodings = Hm;
Object.defineProperty(Ml, "__esModule", {
  value: !0
});
var Fm = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), jm = xe, Vm = Um(jm), _n = F;
function Um(l) {
  return l && l.__esModule ? l : { default: l };
}
function Nm(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var zm = function() {
  function l(e, t, s) {
    Nm(this, l), this.canvas = e, this.encodings = t, this.options = s;
  }
  return Fm(l, [{
    key: "render",
    value: function() {
      if (!this.canvas.getContext)
        throw new Error("The browser does not support canvas.");
      this.prepareCanvas();
      for (var t = 0; t < this.encodings.length; t++) {
        var s = (0, Vm.default)(this.options, this.encodings[t].options);
        this.drawCanvasBarcode(s, this.encodings[t]), this.drawCanvasText(s, this.encodings[t]), this.moveCanvasDrawing(this.encodings[t]);
      }
      this.restoreCanvas();
    }
  }, {
    key: "prepareCanvas",
    value: function() {
      var t = this.canvas.getContext("2d");
      t.save(), (0, _n.calculateEncodingAttributes)(this.encodings, this.options, t);
      var s = (0, _n.getTotalWidthOfEncodings)(this.encodings), a = (0, _n.getMaximumHeightOfEncodings)(this.encodings);
      this.canvas.width = s + this.options.marginLeft + this.options.marginRight, this.canvas.height = a, t.clearRect(0, 0, this.canvas.width, this.canvas.height), this.options.background && (t.fillStyle = this.options.background, t.fillRect(0, 0, this.canvas.width, this.canvas.height)), t.translate(this.options.marginLeft, 0);
    }
  }, {
    key: "drawCanvasBarcode",
    value: function(t, s) {
      var a = this.canvas.getContext("2d"), n = s.data, o;
      t.textPosition == "top" ? o = t.marginTop + t.fontSize + t.textMargin : o = t.marginTop, a.fillStyle = t.lineColor;
      for (var r = 0; r < n.length; r++) {
        var u = r * t.width + s.barcodePadding;
        n[r] === "1" ? a.fillRect(u, o, t.width, t.height) : n[r] && a.fillRect(u, o, t.width, t.height * n[r]);
      }
    }
  }, {
    key: "drawCanvasText",
    value: function(t, s) {
      var a = this.canvas.getContext("2d"), n = t.fontOptions + " " + t.fontSize + "px " + t.font;
      if (t.displayValue) {
        var o, r;
        t.textPosition == "top" ? r = t.marginTop + t.fontSize - t.textMargin : r = t.height + t.textMargin + t.marginTop + t.fontSize, a.font = n, t.textAlign == "left" || s.barcodePadding > 0 ? (o = 0, a.textAlign = "left") : t.textAlign == "right" ? (o = s.width - 1, a.textAlign = "right") : (o = s.width / 2, a.textAlign = "center"), a.fillText(s.text, o, r);
      }
    }
  }, {
    key: "moveCanvasDrawing",
    value: function(t) {
      var s = this.canvas.getContext("2d");
      s.translate(t.width, 0);
    }
  }, {
    key: "restoreCanvas",
    value: function() {
      var t = this.canvas.getContext("2d");
      t.restore();
    }
  }]), l;
}();
Ml.default = zm;
var Xl = {};
Object.defineProperty(Xl, "__esModule", {
  value: !0
});
var Gm = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}(), Wm = xe, qm = Km(Wm), Dn = F;
function Km(l) {
  return l && l.__esModule ? l : { default: l };
}
function Jm(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var Je = "http://www.w3.org/2000/svg", Qm = function() {
  function l(e, t, s) {
    Jm(this, l), this.svg = e, this.encodings = t, this.options = s, this.document = s.xmlDocument || document;
  }
  return Gm(l, [{
    key: "render",
    value: function() {
      var t = this.options.marginLeft;
      this.prepareSVG();
      for (var s = 0; s < this.encodings.length; s++) {
        var a = this.encodings[s], n = (0, qm.default)(this.options, a.options), o = this.createGroup(t, n.marginTop, this.svg);
        this.setGroupOptions(o, n), this.drawSvgBarcode(o, n, a), this.drawSVGText(o, n, a), t += a.width;
      }
    }
  }, {
    key: "prepareSVG",
    value: function() {
      for (; this.svg.firstChild; )
        this.svg.removeChild(this.svg.firstChild);
      (0, Dn.calculateEncodingAttributes)(this.encodings, this.options);
      var t = (0, Dn.getTotalWidthOfEncodings)(this.encodings), s = (0, Dn.getMaximumHeightOfEncodings)(this.encodings), a = t + this.options.marginLeft + this.options.marginRight;
      this.setSvgAttributes(a, s), this.options.background && this.drawRect(0, 0, a, s, this.svg).setAttribute("style", "fill:" + this.options.background + ";");
    }
  }, {
    key: "drawSvgBarcode",
    value: function(t, s, a) {
      var n = a.data, o;
      s.textPosition == "top" ? o = s.fontSize + s.textMargin : o = 0;
      for (var r = 0, u = 0, i = 0; i < n.length; i++)
        u = i * s.width + a.barcodePadding, n[i] === "1" ? r++ : r > 0 && (this.drawRect(u - s.width * r, o, s.width * r, s.height, t), r = 0);
      r > 0 && this.drawRect(u - s.width * (r - 1), o, s.width * r, s.height, t);
    }
  }, {
    key: "drawSVGText",
    value: function(t, s, a) {
      var n = this.document.createElementNS(Je, "text");
      if (s.displayValue) {
        var o, r;
        n.setAttribute("style", "font:" + s.fontOptions + " " + s.fontSize + "px " + s.font), s.textPosition == "top" ? r = s.fontSize - s.textMargin : r = s.height + s.textMargin + s.fontSize, s.textAlign == "left" || a.barcodePadding > 0 ? (o = 0, n.setAttribute("text-anchor", "start")) : s.textAlign == "right" ? (o = a.width - 1, n.setAttribute("text-anchor", "end")) : (o = a.width / 2, n.setAttribute("text-anchor", "middle")), n.setAttribute("x", o), n.setAttribute("y", r), n.appendChild(this.document.createTextNode(a.text)), t.appendChild(n);
      }
    }
  }, {
    key: "setSvgAttributes",
    value: function(t, s) {
      var a = this.svg;
      a.setAttribute("width", t + "px"), a.setAttribute("height", s + "px"), a.setAttribute("x", "0px"), a.setAttribute("y", "0px"), a.setAttribute("viewBox", "0 0 " + t + " " + s), a.setAttribute("xmlns", Je), a.setAttribute("version", "1.1"), a.setAttribute("style", "transform: translate(0,0)");
    }
  }, {
    key: "createGroup",
    value: function(t, s, a) {
      var n = this.document.createElementNS(Je, "g");
      return n.setAttribute("transform", "translate(" + t + ", " + s + ")"), a.appendChild(n), n;
    }
  }, {
    key: "setGroupOptions",
    value: function(t, s) {
      t.setAttribute("style", "fill:" + s.lineColor + ";");
    }
  }, {
    key: "drawRect",
    value: function(t, s, a, n, o) {
      var r = this.document.createElementNS(Je, "rect");
      return r.setAttribute("x", t), r.setAttribute("y", s), r.setAttribute("width", a), r.setAttribute("height", n), o.appendChild(r), r;
    }
  }]), l;
}();
Xl.default = Qm;
var Yl = {};
Object.defineProperty(Yl, "__esModule", {
  value: !0
});
var Zm = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}();
function e1(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var n1 = function() {
  function l(e, t, s) {
    e1(this, l), this.object = e, this.encodings = t, this.options = s;
  }
  return Zm(l, [{
    key: "render",
    value: function() {
      this.object.encodings = this.encodings;
    }
  }]), l;
}();
Yl.default = n1;
Object.defineProperty(Dl, "__esModule", {
  value: !0
});
var l1 = Ml, t1 = Il(l1), r1 = Xl, a1 = Il(r1), o1 = Yl, u1 = Il(o1);
function Il(l) {
  return l && l.__esModule ? l : { default: l };
}
Dl.default = { CanvasRenderer: t1.default, SVGRenderer: a1.default, ObjectRenderer: u1.default };
var Le = {};
Object.defineProperty(Le, "__esModule", {
  value: !0
});
function Hl(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function $l(l, e) {
  if (!l)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e && (typeof e == "object" || typeof e == "function") ? e : l;
}
function Bl(l, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function, not " + typeof e);
  l.prototype = Object.create(e && e.prototype, { constructor: { value: l, enumerable: !1, writable: !0, configurable: !0 } }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(l, e) : l.__proto__ = e);
}
var i1 = function(l) {
  Bl(e, l);
  function e(t, s) {
    Hl(this, e);
    var a = $l(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return a.name = "InvalidInputException", a.symbology = t, a.input = s, a.message = '"' + a.input + '" is not a valid input for ' + a.symbology, a;
  }
  return e;
}(Error), s1 = function(l) {
  Bl(e, l);
  function e() {
    Hl(this, e);
    var t = $l(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return t.name = "InvalidElementException", t.message = "Not supported type to render on", t;
  }
  return e;
}(Error), c1 = function(l) {
  Bl(e, l);
  function e() {
    Hl(this, e);
    var t = $l(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this));
    return t.name = "NoElementException", t.message = "No element to render on.", t;
  }
  return e;
}(Error);
Le.InvalidInputException = i1;
Le.InvalidElementException = s1;
Le.NoElementException = c1;
Object.defineProperty(Ll, "__esModule", {
  value: !0
});
var m1 = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(l) {
  return typeof l;
} : function(l) {
  return l && typeof Symbol == "function" && l.constructor === Symbol && l !== Symbol.prototype ? "symbol" : typeof l;
}, f1 = _l, nl = Cr(f1), y1 = Dl, Ie = Cr(y1), d1 = Le;
function Cr(l) {
  return l && l.__esModule ? l : { default: l };
}
function Fl(l) {
  if (typeof l == "string")
    return g1(l);
  if (Array.isArray(l)) {
    for (var e = [], t = 0; t < l.length; t++)
      e.push(Fl(l[t]));
    return e;
  } else {
    if (typeof HTMLCanvasElement < "u" && l instanceof HTMLImageElement)
      return P1(l);
    if (l && l.nodeName && l.nodeName.toLowerCase() === "svg" || typeof SVGElement < "u" && l instanceof SVGElement)
      return {
        element: l,
        options: (0, nl.default)(l),
        renderer: Ie.default.SVGRenderer
      };
    if (typeof HTMLCanvasElement < "u" && l instanceof HTMLCanvasElement)
      return {
        element: l,
        options: (0, nl.default)(l),
        renderer: Ie.default.CanvasRenderer
      };
    if (l && l.getContext)
      return {
        element: l,
        renderer: Ie.default.CanvasRenderer
      };
    if (l && (typeof l > "u" ? "undefined" : m1(l)) === "object" && !l.nodeName)
      return {
        element: l,
        renderer: Ie.default.ObjectRenderer
      };
    throw new d1.InvalidElementException();
  }
}
function g1(l) {
  var e = document.querySelectorAll(l);
  if (e.length !== 0) {
    for (var t = [], s = 0; s < e.length; s++)
      t.push(Fl(e[s]));
    return t;
  }
}
function P1(l) {
  var e = document.createElement("canvas");
  return {
    element: e,
    options: (0, nl.default)(l),
    renderer: Ie.default.CanvasRenderer,
    afterRender: function() {
      l.setAttribute("src", e.toDataURL());
    }
  };
}
Ll.default = Fl;
var jl = {};
Object.defineProperty(jl, "__esModule", {
  value: !0
});
var p1 = /* @__PURE__ */ function() {
  function l(e, t) {
    for (var s = 0; s < t.length; s++) {
      var a = t[s];
      a.enumerable = a.enumerable || !1, a.configurable = !0, "value" in a && (a.writable = !0), Object.defineProperty(e, a.key, a);
    }
  }
  return function(e, t, s) {
    return t && l(e.prototype, t), s && l(e, s), e;
  };
}();
function h1(l, e) {
  if (!(l instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
var v1 = function() {
  function l(e) {
    h1(this, l), this.api = e;
  }
  return p1(l, [{
    key: "handleCatch",
    value: function(t) {
      if (t.name === "InvalidInputException")
        if (this.api._options.valid !== this.api._defaults.valid)
          this.api._options.valid(!1);
        else
          throw t.message;
      else
        throw t;
      this.api.render = function() {
      };
    }
  }, {
    key: "wrapBarcodeCall",
    value: function(t) {
      try {
        var s = t.apply(void 0, arguments);
        return this.api._options.valid(!0), s;
      } catch (a) {
        return this.handleCatch(a), this.api;
      }
    }
  }]), l;
}();
jl.default = v1;
var k1 = fl, fe = se(k1), S1 = xe, Ne = se(S1), w1 = Tl, Tr = se(w1), R1 = xl, pt = se(R1), A1 = Ll, b1 = se(A1), E1 = gn, O1 = se(E1), C1 = jl, T1 = se(C1), xr = Le, x1 = Pn, Lr = se(x1);
function se(l) {
  return l && l.__esModule ? l : { default: l };
}
var te = function() {
}, pn = function(e, t, s) {
  var a = new te();
  if (typeof e > "u")
    throw Error("No element to render on was provided.");
  return a._renderProperties = (0, b1.default)(e), a._encodings = [], a._options = Lr.default, a._errorHandler = new T1.default(a), typeof t < "u" && (s = s || {}, s.format || (s.format = Dr()), a.options(s)[s.format](t, s).render()), a;
};
pn.getModule = function(l) {
  return fe.default[l];
};
for (var ht in fe.default)
  fe.default.hasOwnProperty(ht) && L1(fe.default, ht);
function L1(l, e) {
  te.prototype[e] = te.prototype[e.toUpperCase()] = te.prototype[e.toLowerCase()] = function(t, s) {
    var a = this;
    return a._errorHandler.wrapBarcodeCall(function() {
      s.text = typeof s.text > "u" ? void 0 : "" + s.text;
      var n = (0, Ne.default)(a._options, s);
      n = (0, O1.default)(n);
      var o = l[e], r = _r(t, o, n);
      return a._encodings.push(r), a;
    });
  };
}
function _r(l, e, t) {
  l = "" + l;
  var s = new e(l, t);
  if (!s.valid())
    throw new xr.InvalidInputException(s.constructor.name, l);
  var a = s.encode();
  a = (0, Tr.default)(a);
  for (var n = 0; n < a.length; n++)
    a[n].options = (0, Ne.default)(t, a[n].options);
  return a;
}
function Dr() {
  return fe.default.CODE128 ? "CODE128" : Object.keys(fe.default)[0];
}
te.prototype.options = function(l) {
  return this._options = (0, Ne.default)(this._options, l), this;
};
te.prototype.blank = function(l) {
  var e = new Array(l + 1).join("0");
  return this._encodings.push({ data: e }), this;
};
te.prototype.init = function() {
  if (this._renderProperties) {
    Array.isArray(this._renderProperties) || (this._renderProperties = [this._renderProperties]);
    var l;
    for (var e in this._renderProperties) {
      l = this._renderProperties[e];
      var t = (0, Ne.default)(this._options, l.options);
      t.format == "auto" && (t.format = Dr()), this._errorHandler.wrapBarcodeCall(function() {
        var s = t.value, a = fe.default[t.format.toUpperCase()], n = _r(s, a, t);
        ll(l, n, t);
      });
    }
  }
};
te.prototype.render = function() {
  if (!this._renderProperties)
    throw new xr.NoElementException();
  if (Array.isArray(this._renderProperties))
    for (var l = 0; l < this._renderProperties.length; l++)
      ll(this._renderProperties[l], this._encodings, this._options);
  else
    ll(this._renderProperties, this._encodings, this._options);
  return this;
};
te.prototype._defaults = Lr.default;
function ll(l, e, t) {
  e = (0, Tr.default)(e);
  for (var s = 0; s < e.length; s++)
    e[s].options = (0, Ne.default)(t, e[s].options), (0, pt.default)(e[s].options);
  (0, pt.default)(t);
  var a = l.renderer, n = new a(l.element, e, t);
  n.render(), l.afterRender && l.afterRender();
}
typeof window < "u" && (window.JsBarcode = pn);
typeof jQuery < "u" && (jQuery.fn.JsBarcode = function(l, e) {
  var t = [];
  return jQuery(this).each(function() {
    t.push(this);
  }), pn(t, l, e);
});
var _1 = pn;
const D1 = /* @__PURE__ */ wt(_1);
class $e {
  /**
   * Creates a value for barcode labels. Does not calculate the checksum by default.
   * Most libraries, which generate barcode labels, add the checksum and start and stop sequences automatically,
   * and those are not needed to be calculated externally.
   * @param iban - IBAN bank account number. Must be a Finnish IBAN. Can have whitespace.
   * @param ref - Reference number as a string. Either fully numeric (max len 20), or starting with RF (max len 2+23).
   * Can have whitespace.
   * @param dueDate - Date as ISO date (yyyy-MM-dd). False fills values with zeros.
   * @param euroAmount - Euro amount. If string, e.g. 3030,33€, is converted to cents amount 303033.
   * Alternative can be passed cents amount as number.
   * @param includeChecksum - Calculates and appends the checksum to the end of the barcode value.
   * @returns The barcode value (without start and end characters). The checksum is only calculated and appended to the value if the includeChecksum-parameter is true.
   */
  static getValue(e, t, s, a, n = !1) {
    e = (e + "").replace(/\s/g, ""), t = (t + "").replace(/\s/g, ""), s && (s = g.format(s, "YYMMDD") ?? "");
    const o = typeof a == "string" ? a.replace(/[, ]+/g, "") : a.toString();
    let r = "";
    const u = t.substring(0, 2).toUpperCase() === "RF" ? "5" : "4";
    r += u, r += e.length === 18 ? e.substr(2) : "0".repeat(18);
    let i = o.slice(0, -2);
    for (; i.length < 6; )
      i = "0" + i;
    r += i;
    const c = o.slice(-2);
    if (r += c.length === 1 ? "0" + c : c, u === "4") {
      r += "000";
      let f = t.substr(0);
      for (; f.length < 20; )
        f = "0" + f;
      r += f;
    } else {
      r += t.substr(2, 2);
      let f = t.substr(4);
      for (; f.length < 21; )
        f = "0" + f;
      r += f;
    }
    if (r += s || "000000", n) {
      let f = this.modulo103(r).toString();
      f = f.length === 1 ? "0" + f : f, r += f;
    }
    return r;
  }
  /**
   * Takes in 54 characters string value and calculates modulo 103 value.
   * @param val - 54 characters long string of numbers
   * @returns A Number within range of 0-99. Reminder of dividing the sum total of weighted value pairs with 103.
   */
  static modulo103(e) {
    const t = e.match(/(..?)/g);
    let s = 105;
    for (let a = 1; a <= 27; a++) {
      const n = Number(t?.[a - 1]);
      s += n * a;
    }
    return s % 103;
  }
  /**
   * Creates a barcode SVG string based on the provided parameters.
   * @param getDocumentAndSvgNode - The document and SVG node to render the barcode on.
   * @param iban - The IBAN number.
   * @param ref - The reference number.
   * @param dueDate - The due date.
   * @param euroAmount - The euro amount.
   * @param barcodeOptions - The options for the barcode (width, height, displayValue, fontSize).
   * @param barcodeOptions.width - Width of the barcode.
   * @param barcodeOptions.height - Height of the barcode
   * @param barcodeOptions.displayValue - Whether to display the value of the barcode.
   * @param barcodeOptions.fontSize - Fontsize of the barcode.
   * @returns The SVG string of the created barcode.
   */
  static createBarcode(e, t, s, a, n, o) {
    if (s && !/^(?:RF\d+|\d+)$/i.test(s))
      return "";
    const r = e();
    try {
      D1(r?.svgNode, $e.getValue(t, s, a, n), {
        xmlDocument: r.document,
        format: "CODE128C",
        ...o
      });
    } catch (u) {
      return console.error(u), "";
    }
    return r?.svgNode;
  }
}
var ze = {}, M1 = function() {
  return typeof Promise == "function" && Promise.prototype && Promise.prototype.then;
}, Mr = {}, j = {};
let Vl;
const X1 = [
  0,
  // Not used
  26,
  44,
  70,
  100,
  134,
  172,
  196,
  242,
  292,
  346,
  404,
  466,
  532,
  581,
  655,
  733,
  815,
  901,
  991,
  1085,
  1156,
  1258,
  1364,
  1474,
  1588,
  1706,
  1828,
  1921,
  2051,
  2185,
  2323,
  2465,
  2611,
  2761,
  2876,
  3034,
  3196,
  3362,
  3532,
  3706
];
j.getSymbolSize = function(e) {
  if (!e)
    throw new Error('"version" cannot be null or undefined');
  if (e < 1 || e > 40)
    throw new Error('"version" should be in range from 1 to 40');
  return e * 4 + 17;
};
j.getSymbolTotalCodewords = function(e) {
  return X1[e];
};
j.getBCHDigit = function(l) {
  let e = 0;
  for (; l !== 0; )
    e++, l >>>= 1;
  return e;
};
j.setToSJISFunction = function(e) {
  if (typeof e != "function")
    throw new Error('"toSJISFunc" is not a valid function.');
  Vl = e;
};
j.isKanjiModeEnabled = function() {
  return typeof Vl < "u";
};
j.toSJIS = function(e) {
  return Vl(e);
};
var hn = {};
(function(l) {
  l.L = { bit: 1 }, l.M = { bit: 0 }, l.Q = { bit: 3 }, l.H = { bit: 2 };
  function e(t) {
    if (typeof t != "string")
      throw new Error("Param is not a string");
    switch (t.toLowerCase()) {
      case "l":
      case "low":
        return l.L;
      case "m":
      case "medium":
        return l.M;
      case "q":
      case "quartile":
        return l.Q;
      case "h":
      case "high":
        return l.H;
      default:
        throw new Error("Unknown EC Level: " + t);
    }
  }
  l.isValid = function(s) {
    return s && typeof s.bit < "u" && s.bit >= 0 && s.bit < 4;
  }, l.from = function(s, a) {
    if (l.isValid(s))
      return s;
    try {
      return e(s);
    } catch {
      return a;
    }
  };
})(hn);
function Xr() {
  this.buffer = [], this.length = 0;
}
Xr.prototype = {
  get: function(l) {
    const e = Math.floor(l / 8);
    return (this.buffer[e] >>> 7 - l % 8 & 1) === 1;
  },
  put: function(l, e) {
    for (let t = 0; t < e; t++)
      this.putBit((l >>> e - t - 1 & 1) === 1);
  },
  getLengthInBits: function() {
    return this.length;
  },
  putBit: function(l) {
    const e = Math.floor(this.length / 8);
    this.buffer.length <= e && this.buffer.push(0), l && (this.buffer[e] |= 128 >>> this.length % 8), this.length++;
  }
};
var Y1 = Xr;
function Ge(l) {
  if (!l || l < 1)
    throw new Error("BitMatrix size must be defined and greater than 0");
  this.size = l, this.data = new Uint8Array(l * l), this.reservedBit = new Uint8Array(l * l);
}
Ge.prototype.set = function(l, e, t, s) {
  const a = l * this.size + e;
  this.data[a] = t, s && (this.reservedBit[a] = !0);
};
Ge.prototype.get = function(l, e) {
  return this.data[l * this.size + e];
};
Ge.prototype.xor = function(l, e, t) {
  this.data[l * this.size + e] ^= t;
};
Ge.prototype.isReserved = function(l, e) {
  return this.reservedBit[l * this.size + e];
};
var I1 = Ge, Yr = {};
(function(l) {
  const e = j.getSymbolSize;
  l.getRowColCoords = function(s) {
    if (s === 1)
      return [];
    const a = Math.floor(s / 7) + 2, n = e(s), o = n === 145 ? 26 : Math.ceil((n - 13) / (2 * a - 2)) * 2, r = [n - 7];
    for (let u = 1; u < a - 1; u++)
      r[u] = r[u - 1] - o;
    return r.push(6), r.reverse();
  }, l.getPositions = function(s) {
    const a = [], n = l.getRowColCoords(s), o = n.length;
    for (let r = 0; r < o; r++)
      for (let u = 0; u < o; u++)
        r === 0 && u === 0 || // top-left
        r === 0 && u === o - 1 || // bottom-left
        r === o - 1 && u === 0 || a.push([n[r], n[u]]);
    return a;
  };
})(Yr);
var Ir = {};
const H1 = j.getSymbolSize, vt = 7;
Ir.getPositions = function(e) {
  const t = H1(e);
  return [
    // top-left
    [0, 0],
    // top-right
    [t - vt, 0],
    // bottom-left
    [0, t - vt]
  ];
};
var Hr = {};
(function(l) {
  l.Patterns = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
  };
  const e = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
  };
  l.isValid = function(a) {
    return a != null && a !== "" && !isNaN(a) && a >= 0 && a <= 7;
  }, l.from = function(a) {
    return l.isValid(a) ? parseInt(a, 10) : void 0;
  }, l.getPenaltyN1 = function(a) {
    const n = a.size;
    let o = 0, r = 0, u = 0, i = null, c = null;
    for (let f = 0; f < n; f++) {
      r = u = 0, i = c = null;
      for (let m = 0; m < n; m++) {
        let p = a.get(f, m);
        p === i ? r++ : (r >= 5 && (o += e.N1 + (r - 5)), i = p, r = 1), p = a.get(m, f), p === c ? u++ : (u >= 5 && (o += e.N1 + (u - 5)), c = p, u = 1);
      }
      r >= 5 && (o += e.N1 + (r - 5)), u >= 5 && (o += e.N1 + (u - 5));
    }
    return o;
  }, l.getPenaltyN2 = function(a) {
    const n = a.size;
    let o = 0;
    for (let r = 0; r < n - 1; r++)
      for (let u = 0; u < n - 1; u++) {
        const i = a.get(r, u) + a.get(r, u + 1) + a.get(r + 1, u) + a.get(r + 1, u + 1);
        (i === 4 || i === 0) && o++;
      }
    return o * e.N2;
  }, l.getPenaltyN3 = function(a) {
    const n = a.size;
    let o = 0, r = 0, u = 0;
    for (let i = 0; i < n; i++) {
      r = u = 0;
      for (let c = 0; c < n; c++)
        r = r << 1 & 2047 | a.get(i, c), c >= 10 && (r === 1488 || r === 93) && o++, u = u << 1 & 2047 | a.get(c, i), c >= 10 && (u === 1488 || u === 93) && o++;
    }
    return o * e.N3;
  }, l.getPenaltyN4 = function(a) {
    let n = 0;
    const o = a.data.length;
    for (let u = 0; u < o; u++)
      n += a.data[u];
    return Math.abs(Math.ceil(n * 100 / o / 5) - 10) * e.N4;
  };
  function t(s, a, n) {
    switch (s) {
      case l.Patterns.PATTERN000:
        return (a + n) % 2 === 0;
      case l.Patterns.PATTERN001:
        return a % 2 === 0;
      case l.Patterns.PATTERN010:
        return n % 3 === 0;
      case l.Patterns.PATTERN011:
        return (a + n) % 3 === 0;
      case l.Patterns.PATTERN100:
        return (Math.floor(a / 2) + Math.floor(n / 3)) % 2 === 0;
      case l.Patterns.PATTERN101:
        return a * n % 2 + a * n % 3 === 0;
      case l.Patterns.PATTERN110:
        return (a * n % 2 + a * n % 3) % 2 === 0;
      case l.Patterns.PATTERN111:
        return (a * n % 3 + (a + n) % 2) % 2 === 0;
      default:
        throw new Error("bad maskPattern:" + s);
    }
  }
  l.applyMask = function(a, n) {
    const o = n.size;
    for (let r = 0; r < o; r++)
      for (let u = 0; u < o; u++)
        n.isReserved(u, r) || n.xor(u, r, t(a, u, r));
  }, l.getBestMask = function(a, n) {
    const o = Object.keys(l.Patterns).length;
    let r = 0, u = 1 / 0;
    for (let i = 0; i < o; i++) {
      n(i), l.applyMask(i, a);
      const c = l.getPenaltyN1(a) + l.getPenaltyN2(a) + l.getPenaltyN3(a) + l.getPenaltyN4(a);
      l.applyMask(i, a), c < u && (u = c, r = i);
    }
    return r;
  };
})(Hr);
var vn = {};
const oe = hn, Qe = [
  // L  M  Q  H
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  1,
  2,
  2,
  1,
  2,
  2,
  4,
  1,
  2,
  4,
  4,
  2,
  4,
  4,
  4,
  2,
  4,
  6,
  5,
  2,
  4,
  6,
  6,
  2,
  5,
  8,
  8,
  4,
  5,
  8,
  8,
  4,
  5,
  8,
  11,
  4,
  8,
  10,
  11,
  4,
  9,
  12,
  16,
  4,
  9,
  16,
  16,
  6,
  10,
  12,
  18,
  6,
  10,
  17,
  16,
  6,
  11,
  16,
  19,
  6,
  13,
  18,
  21,
  7,
  14,
  21,
  25,
  8,
  16,
  20,
  25,
  8,
  17,
  23,
  25,
  9,
  17,
  23,
  34,
  9,
  18,
  25,
  30,
  10,
  20,
  27,
  32,
  12,
  21,
  29,
  35,
  12,
  23,
  34,
  37,
  12,
  25,
  34,
  40,
  13,
  26,
  35,
  42,
  14,
  28,
  38,
  45,
  15,
  29,
  40,
  48,
  16,
  31,
  43,
  51,
  17,
  33,
  45,
  54,
  18,
  35,
  48,
  57,
  19,
  37,
  51,
  60,
  19,
  38,
  53,
  63,
  20,
  40,
  56,
  66,
  21,
  43,
  59,
  70,
  22,
  45,
  62,
  74,
  24,
  47,
  65,
  77,
  25,
  49,
  68,
  81
], Ze = [
  // L  M  Q  H
  7,
  10,
  13,
  17,
  10,
  16,
  22,
  28,
  15,
  26,
  36,
  44,
  20,
  36,
  52,
  64,
  26,
  48,
  72,
  88,
  36,
  64,
  96,
  112,
  40,
  72,
  108,
  130,
  48,
  88,
  132,
  156,
  60,
  110,
  160,
  192,
  72,
  130,
  192,
  224,
  80,
  150,
  224,
  264,
  96,
  176,
  260,
  308,
  104,
  198,
  288,
  352,
  120,
  216,
  320,
  384,
  132,
  240,
  360,
  432,
  144,
  280,
  408,
  480,
  168,
  308,
  448,
  532,
  180,
  338,
  504,
  588,
  196,
  364,
  546,
  650,
  224,
  416,
  600,
  700,
  224,
  442,
  644,
  750,
  252,
  476,
  690,
  816,
  270,
  504,
  750,
  900,
  300,
  560,
  810,
  960,
  312,
  588,
  870,
  1050,
  336,
  644,
  952,
  1110,
  360,
  700,
  1020,
  1200,
  390,
  728,
  1050,
  1260,
  420,
  784,
  1140,
  1350,
  450,
  812,
  1200,
  1440,
  480,
  868,
  1290,
  1530,
  510,
  924,
  1350,
  1620,
  540,
  980,
  1440,
  1710,
  570,
  1036,
  1530,
  1800,
  570,
  1064,
  1590,
  1890,
  600,
  1120,
  1680,
  1980,
  630,
  1204,
  1770,
  2100,
  660,
  1260,
  1860,
  2220,
  720,
  1316,
  1950,
  2310,
  750,
  1372,
  2040,
  2430
];
vn.getBlocksCount = function(e, t) {
  switch (t) {
    case oe.L:
      return Qe[(e - 1) * 4 + 0];
    case oe.M:
      return Qe[(e - 1) * 4 + 1];
    case oe.Q:
      return Qe[(e - 1) * 4 + 2];
    case oe.H:
      return Qe[(e - 1) * 4 + 3];
    default:
      return;
  }
};
vn.getTotalCodewordsCount = function(e, t) {
  switch (t) {
    case oe.L:
      return Ze[(e - 1) * 4 + 0];
    case oe.M:
      return Ze[(e - 1) * 4 + 1];
    case oe.Q:
      return Ze[(e - 1) * 4 + 2];
    case oe.H:
      return Ze[(e - 1) * 4 + 3];
    default:
      return;
  }
};
var $r = {}, kn = {};
const He = new Uint8Array(512), an = new Uint8Array(256);
(function() {
  let e = 1;
  for (let t = 0; t < 255; t++)
    He[t] = e, an[e] = t, e <<= 1, e & 256 && (e ^= 285);
  for (let t = 255; t < 512; t++)
    He[t] = He[t - 255];
})();
kn.log = function(e) {
  if (e < 1)
    throw new Error("log(" + e + ")");
  return an[e];
};
kn.exp = function(e) {
  return He[e];
};
kn.mul = function(e, t) {
  return e === 0 || t === 0 ? 0 : He[an[e] + an[t]];
};
(function(l) {
  const e = kn;
  l.mul = function(s, a) {
    const n = new Uint8Array(s.length + a.length - 1);
    for (let o = 0; o < s.length; o++)
      for (let r = 0; r < a.length; r++)
        n[o + r] ^= e.mul(s[o], a[r]);
    return n;
  }, l.mod = function(s, a) {
    let n = new Uint8Array(s);
    for (; n.length - a.length >= 0; ) {
      const o = n[0];
      for (let u = 0; u < a.length; u++)
        n[u] ^= e.mul(a[u], o);
      let r = 0;
      for (; r < n.length && n[r] === 0; )
        r++;
      n = n.slice(r);
    }
    return n;
  }, l.generateECPolynomial = function(s) {
    let a = new Uint8Array([1]);
    for (let n = 0; n < s; n++)
      a = l.mul(a, new Uint8Array([1, e.exp(n)]));
    return a;
  };
})($r);
const Br = $r;
function Ul(l) {
  this.genPoly = void 0, this.degree = l, this.degree && this.initialize(this.degree);
}
Ul.prototype.initialize = function(e) {
  this.degree = e, this.genPoly = Br.generateECPolynomial(this.degree);
};
Ul.prototype.encode = function(e) {
  if (!this.genPoly)
    throw new Error("Encoder not initialized");
  const t = new Uint8Array(e.length + this.degree);
  t.set(e);
  const s = Br.mod(t, this.genPoly), a = this.degree - s.length;
  if (a > 0) {
    const n = new Uint8Array(this.degree);
    return n.set(s, a), n;
  }
  return s;
};
var $1 = Ul, Fr = {}, ce = {}, Nl = {};
Nl.isValid = function(e) {
  return !isNaN(e) && e >= 1 && e <= 40;
};
var Q = {};
const jr = "[0-9]+", B1 = "[A-Z $%*+\\-./:]+";
let Be = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
Be = Be.replace(/u/g, "\\u");
const F1 = "(?:(?![A-Z0-9 $%*+\\-./:]|" + Be + `)(?:.|[\r
]))+`;
Q.KANJI = new RegExp(Be, "g");
Q.BYTE_KANJI = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
Q.BYTE = new RegExp(F1, "g");
Q.NUMERIC = new RegExp(jr, "g");
Q.ALPHANUMERIC = new RegExp(B1, "g");
const j1 = new RegExp("^" + Be + "$"), V1 = new RegExp("^" + jr + "$"), U1 = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
Q.testKanji = function(e) {
  return j1.test(e);
};
Q.testNumeric = function(e) {
  return V1.test(e);
};
Q.testAlphanumeric = function(e) {
  return U1.test(e);
};
(function(l) {
  const e = Nl, t = Q;
  l.NUMERIC = {
    id: "Numeric",
    bit: 1,
    ccBits: [10, 12, 14]
  }, l.ALPHANUMERIC = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [9, 11, 13]
  }, l.BYTE = {
    id: "Byte",
    bit: 4,
    ccBits: [8, 16, 16]
  }, l.KANJI = {
    id: "Kanji",
    bit: 8,
    ccBits: [8, 10, 12]
  }, l.MIXED = {
    bit: -1
  }, l.getCharCountIndicator = function(n, o) {
    if (!n.ccBits)
      throw new Error("Invalid mode: " + n);
    if (!e.isValid(o))
      throw new Error("Invalid version: " + o);
    return o >= 1 && o < 10 ? n.ccBits[0] : o < 27 ? n.ccBits[1] : n.ccBits[2];
  }, l.getBestModeForData = function(n) {
    return t.testNumeric(n) ? l.NUMERIC : t.testAlphanumeric(n) ? l.ALPHANUMERIC : t.testKanji(n) ? l.KANJI : l.BYTE;
  }, l.toString = function(n) {
    if (n && n.id)
      return n.id;
    throw new Error("Invalid mode");
  }, l.isValid = function(n) {
    return n && n.bit && n.ccBits;
  };
  function s(a) {
    if (typeof a != "string")
      throw new Error("Param is not a string");
    switch (a.toLowerCase()) {
      case "numeric":
        return l.NUMERIC;
      case "alphanumeric":
        return l.ALPHANUMERIC;
      case "kanji":
        return l.KANJI;
      case "byte":
        return l.BYTE;
      default:
        throw new Error("Unknown mode: " + a);
    }
  }
  l.from = function(n, o) {
    if (l.isValid(n))
      return n;
    try {
      return s(n);
    } catch {
      return o;
    }
  };
})(ce);
(function(l) {
  const e = j, t = vn, s = hn, a = ce, n = Nl, o = 7973, r = e.getBCHDigit(o);
  function u(m, p, w) {
    for (let b = 1; b <= 40; b++)
      if (p <= l.getCapacity(b, w, m))
        return b;
  }
  function i(m, p) {
    return a.getCharCountIndicator(m, p) + 4;
  }
  function c(m, p) {
    let w = 0;
    return m.forEach(function(b) {
      const O = i(b.mode, p);
      w += O + b.getBitsLength();
    }), w;
  }
  function f(m, p) {
    for (let w = 1; w <= 40; w++)
      if (c(m, w) <= l.getCapacity(w, p, a.MIXED))
        return w;
  }
  l.from = function(p, w) {
    return n.isValid(p) ? parseInt(p, 10) : w;
  }, l.getCapacity = function(p, w, b) {
    if (!n.isValid(p))
      throw new Error("Invalid QR Code version");
    typeof b > "u" && (b = a.BYTE);
    const O = e.getSymbolTotalCodewords(p), k = t.getTotalCodewordsCount(p, w), h = (O - k) * 8;
    if (b === a.MIXED)
      return h;
    const A = h - i(b, p);
    switch (b) {
      case a.NUMERIC:
        return Math.floor(A / 10 * 3);
      case a.ALPHANUMERIC:
        return Math.floor(A / 11 * 2);
      case a.KANJI:
        return Math.floor(A / 13);
      case a.BYTE:
      default:
        return Math.floor(A / 8);
    }
  }, l.getBestVersionForData = function(p, w) {
    let b;
    const O = s.from(w, s.M);
    if (Array.isArray(p)) {
      if (p.length > 1)
        return f(p, O);
      if (p.length === 0)
        return 1;
      b = p[0];
    } else
      b = p;
    return u(b.mode, b.getLength(), O);
  }, l.getEncodedBits = function(p) {
    if (!n.isValid(p) || p < 7)
      throw new Error("Invalid QR Code version");
    let w = p << 12;
    for (; e.getBCHDigit(w) - r >= 0; )
      w ^= o << e.getBCHDigit(w) - r;
    return p << 12 | w;
  };
})(Fr);
var Vr = {};
const tl = j, Ur = 1335, N1 = 21522, kt = tl.getBCHDigit(Ur);
Vr.getEncodedBits = function(e, t) {
  const s = e.bit << 3 | t;
  let a = s << 10;
  for (; tl.getBCHDigit(a) - kt >= 0; )
    a ^= Ur << tl.getBCHDigit(a) - kt;
  return (s << 10 | a) ^ N1;
};
var Nr = {};
const z1 = ce;
function Re(l) {
  this.mode = z1.NUMERIC, this.data = l.toString();
}
Re.getBitsLength = function(e) {
  return 10 * Math.floor(e / 3) + (e % 3 ? e % 3 * 3 + 1 : 0);
};
Re.prototype.getLength = function() {
  return this.data.length;
};
Re.prototype.getBitsLength = function() {
  return Re.getBitsLength(this.data.length);
};
Re.prototype.write = function(e) {
  let t, s, a;
  for (t = 0; t + 3 <= this.data.length; t += 3)
    s = this.data.substr(t, 3), a = parseInt(s, 10), e.put(a, 10);
  const n = this.data.length - t;
  n > 0 && (s = this.data.substr(t), a = parseInt(s, 10), e.put(a, n * 3 + 1));
};
var G1 = Re;
const W1 = ce, Mn = [
  "0",
  "1",
  "2",
  "3",
  "4",
  "5",
  "6",
  "7",
  "8",
  "9",
  "A",
  "B",
  "C",
  "D",
  "E",
  "F",
  "G",
  "H",
  "I",
  "J",
  "K",
  "L",
  "M",
  "N",
  "O",
  "P",
  "Q",
  "R",
  "S",
  "T",
  "U",
  "V",
  "W",
  "X",
  "Y",
  "Z",
  " ",
  "$",
  "%",
  "*",
  "+",
  "-",
  ".",
  "/",
  ":"
];
function Ae(l) {
  this.mode = W1.ALPHANUMERIC, this.data = l;
}
Ae.getBitsLength = function(e) {
  return 11 * Math.floor(e / 2) + 6 * (e % 2);
};
Ae.prototype.getLength = function() {
  return this.data.length;
};
Ae.prototype.getBitsLength = function() {
  return Ae.getBitsLength(this.data.length);
};
Ae.prototype.write = function(e) {
  let t;
  for (t = 0; t + 2 <= this.data.length; t += 2) {
    let s = Mn.indexOf(this.data[t]) * 45;
    s += Mn.indexOf(this.data[t + 1]), e.put(s, 11);
  }
  this.data.length % 2 && e.put(Mn.indexOf(this.data[t]), 6);
};
var q1 = Ae, K1 = function(e) {
  for (var t = [], s = e.length, a = 0; a < s; a++) {
    var n = e.charCodeAt(a);
    if (n >= 55296 && n <= 56319 && s > a + 1) {
      var o = e.charCodeAt(a + 1);
      o >= 56320 && o <= 57343 && (n = (n - 55296) * 1024 + o - 56320 + 65536, a += 1);
    }
    if (n < 128) {
      t.push(n);
      continue;
    }
    if (n < 2048) {
      t.push(n >> 6 | 192), t.push(n & 63 | 128);
      continue;
    }
    if (n < 55296 || n >= 57344 && n < 65536) {
      t.push(n >> 12 | 224), t.push(n >> 6 & 63 | 128), t.push(n & 63 | 128);
      continue;
    }
    if (n >= 65536 && n <= 1114111) {
      t.push(n >> 18 | 240), t.push(n >> 12 & 63 | 128), t.push(n >> 6 & 63 | 128), t.push(n & 63 | 128);
      continue;
    }
    t.push(239, 191, 189);
  }
  return new Uint8Array(t).buffer;
};
const J1 = K1, Q1 = ce;
function be(l) {
  this.mode = Q1.BYTE, typeof l == "string" && (l = J1(l)), this.data = new Uint8Array(l);
}
be.getBitsLength = function(e) {
  return e * 8;
};
be.prototype.getLength = function() {
  return this.data.length;
};
be.prototype.getBitsLength = function() {
  return be.getBitsLength(this.data.length);
};
be.prototype.write = function(l) {
  for (let e = 0, t = this.data.length; e < t; e++)
    l.put(this.data[e], 8);
};
var Z1 = be;
const ef = ce, nf = j;
function Ee(l) {
  this.mode = ef.KANJI, this.data = l;
}
Ee.getBitsLength = function(e) {
  return e * 13;
};
Ee.prototype.getLength = function() {
  return this.data.length;
};
Ee.prototype.getBitsLength = function() {
  return Ee.getBitsLength(this.data.length);
};
Ee.prototype.write = function(l) {
  let e;
  for (e = 0; e < this.data.length; e++) {
    let t = nf.toSJIS(this.data[e]);
    if (t >= 33088 && t <= 40956)
      t -= 33088;
    else if (t >= 57408 && t <= 60351)
      t -= 49472;
    else
      throw new Error(
        "Invalid SJIS character: " + this.data[e] + `
Make sure your charset is UTF-8`
      );
    t = (t >>> 8 & 255) * 192 + (t & 255), l.put(t, 13);
  }
};
var lf = Ee, zr = { exports: {} };
(function(l) {
  var e = {
    single_source_shortest_paths: function(t, s, a) {
      var n = {}, o = {};
      o[s] = 0;
      var r = e.PriorityQueue.make();
      r.push(s, 0);
      for (var u, i, c, f, m, p, w, b, O; !r.empty(); ) {
        u = r.pop(), i = u.value, f = u.cost, m = t[i] || {};
        for (c in m)
          m.hasOwnProperty(c) && (p = m[c], w = f + p, b = o[c], O = typeof o[c] > "u", (O || b > w) && (o[c] = w, r.push(c, w), n[c] = i));
      }
      if (typeof a < "u" && typeof o[a] > "u") {
        var k = ["Could not find a path from ", s, " to ", a, "."].join("");
        throw new Error(k);
      }
      return n;
    },
    extract_shortest_path_from_predecessor_list: function(t, s) {
      for (var a = [], n = s; n; )
        a.push(n), t[n], n = t[n];
      return a.reverse(), a;
    },
    find_path: function(t, s, a) {
      var n = e.single_source_shortest_paths(t, s, a);
      return e.extract_shortest_path_from_predecessor_list(
        n,
        a
      );
    },
    /**
     * A very naive priority queue implementation.
     */
    PriorityQueue: {
      make: function(t) {
        var s = e.PriorityQueue, a = {}, n;
        t = t || {};
        for (n in s)
          s.hasOwnProperty(n) && (a[n] = s[n]);
        return a.queue = [], a.sorter = t.sorter || s.default_sorter, a;
      },
      default_sorter: function(t, s) {
        return t.cost - s.cost;
      },
      /**
       * Add a new item to the queue and ensure the highest priority element
       * is at the front of the queue.
       */
      push: function(t, s) {
        var a = { value: t, cost: s };
        this.queue.push(a), this.queue.sort(this.sorter);
      },
      /**
       * Return the highest priority element in the queue.
       */
      pop: function() {
        return this.queue.shift();
      },
      empty: function() {
        return this.queue.length === 0;
      }
    }
  };
  l.exports = e;
})(zr);
var tf = zr.exports;
(function(l) {
  const e = ce, t = G1, s = q1, a = Z1, n = lf, o = Q, r = j, u = tf;
  function i(k) {
    return unescape(encodeURIComponent(k)).length;
  }
  function c(k, h, A) {
    const S = [];
    let T;
    for (; (T = k.exec(A)) !== null; )
      S.push({
        data: T[0],
        index: T.index,
        mode: h,
        length: T[0].length
      });
    return S;
  }
  function f(k) {
    const h = c(o.NUMERIC, e.NUMERIC, k), A = c(o.ALPHANUMERIC, e.ALPHANUMERIC, k);
    let S, T;
    return r.isKanjiModeEnabled() ? (S = c(o.BYTE, e.BYTE, k), T = c(o.KANJI, e.KANJI, k)) : (S = c(o.BYTE_KANJI, e.BYTE, k), T = []), h.concat(A, S, T).sort(function(I, z) {
      return I.index - z.index;
    }).map(function(I) {
      return {
        data: I.data,
        mode: I.mode,
        length: I.length
      };
    });
  }
  function m(k, h) {
    switch (h) {
      case e.NUMERIC:
        return t.getBitsLength(k);
      case e.ALPHANUMERIC:
        return s.getBitsLength(k);
      case e.KANJI:
        return n.getBitsLength(k);
      case e.BYTE:
        return a.getBitsLength(k);
    }
  }
  function p(k) {
    return k.reduce(function(h, A) {
      const S = h.length - 1 >= 0 ? h[h.length - 1] : null;
      return S && S.mode === A.mode ? (h[h.length - 1].data += A.data, h) : (h.push(A), h);
    }, []);
  }
  function w(k) {
    const h = [];
    for (let A = 0; A < k.length; A++) {
      const S = k[A];
      switch (S.mode) {
        case e.NUMERIC:
          h.push([
            S,
            { data: S.data, mode: e.ALPHANUMERIC, length: S.length },
            { data: S.data, mode: e.BYTE, length: S.length }
          ]);
          break;
        case e.ALPHANUMERIC:
          h.push([
            S,
            { data: S.data, mode: e.BYTE, length: S.length }
          ]);
          break;
        case e.KANJI:
          h.push([
            S,
            { data: S.data, mode: e.BYTE, length: i(S.data) }
          ]);
          break;
        case e.BYTE:
          h.push([
            { data: S.data, mode: e.BYTE, length: i(S.data) }
          ]);
      }
    }
    return h;
  }
  function b(k, h) {
    const A = {}, S = { start: {} };
    let T = ["start"];
    for (let M = 0; M < k.length; M++) {
      const I = k[M], z = [];
      for (let re = 0; re < I.length; re++) {
        const q = I[re], _e = "" + M + re;
        z.push(_e), A[_e] = { node: q, lastCount: 0 }, S[_e] = {};
        for (let wn = 0; wn < T.length; wn++) {
          const Z = T[wn];
          A[Z] && A[Z].node.mode === q.mode ? (S[Z][_e] = m(A[Z].lastCount + q.length, q.mode) - m(A[Z].lastCount, q.mode), A[Z].lastCount += q.length) : (A[Z] && (A[Z].lastCount = q.length), S[Z][_e] = m(q.length, q.mode) + 4 + e.getCharCountIndicator(q.mode, h));
        }
      }
      T = z;
    }
    for (let M = 0; M < T.length; M++)
      S[T[M]].end = 0;
    return { map: S, table: A };
  }
  function O(k, h) {
    let A;
    const S = e.getBestModeForData(k);
    if (A = e.from(h, S), A !== e.BYTE && A.bit < S.bit)
      throw new Error('"' + k + '" cannot be encoded with mode ' + e.toString(A) + `.
 Suggested mode is: ` + e.toString(S));
    switch (A === e.KANJI && !r.isKanjiModeEnabled() && (A = e.BYTE), A) {
      case e.NUMERIC:
        return new t(k);
      case e.ALPHANUMERIC:
        return new s(k);
      case e.KANJI:
        return new n(k);
      case e.BYTE:
        return new a(k);
    }
  }
  l.fromArray = function(h) {
    return h.reduce(function(A, S) {
      return typeof S == "string" ? A.push(O(S, null)) : S.data && A.push(O(S.data, S.mode)), A;
    }, []);
  }, l.fromString = function(h, A) {
    const S = f(h, r.isKanjiModeEnabled()), T = w(S), M = b(T, A), I = u.find_path(M.map, "start", "end"), z = [];
    for (let re = 1; re < I.length - 1; re++)
      z.push(M.table[I[re]].node);
    return l.fromArray(p(z));
  }, l.rawSplit = function(h) {
    return l.fromArray(
      f(h, r.isKanjiModeEnabled())
    );
  };
})(Nr);
const Sn = j, Xn = hn, rf = Y1, af = I1, of = Yr, uf = Ir, rl = Hr, al = vn, sf = $1, on = Fr, cf = Vr, mf = ce, Yn = Nr;
function ff(l, e) {
  const t = l.size, s = uf.getPositions(e);
  for (let a = 0; a < s.length; a++) {
    const n = s[a][0], o = s[a][1];
    for (let r = -1; r <= 7; r++)
      if (!(n + r <= -1 || t <= n + r))
        for (let u = -1; u <= 7; u++)
          o + u <= -1 || t <= o + u || (r >= 0 && r <= 6 && (u === 0 || u === 6) || u >= 0 && u <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && u >= 2 && u <= 4 ? l.set(n + r, o + u, !0, !0) : l.set(n + r, o + u, !1, !0));
  }
}
function yf(l) {
  const e = l.size;
  for (let t = 8; t < e - 8; t++) {
    const s = t % 2 === 0;
    l.set(t, 6, s, !0), l.set(6, t, s, !0);
  }
}
function df(l, e) {
  const t = of.getPositions(e);
  for (let s = 0; s < t.length; s++) {
    const a = t[s][0], n = t[s][1];
    for (let o = -2; o <= 2; o++)
      for (let r = -2; r <= 2; r++)
        o === -2 || o === 2 || r === -2 || r === 2 || o === 0 && r === 0 ? l.set(a + o, n + r, !0, !0) : l.set(a + o, n + r, !1, !0);
  }
}
function gf(l, e) {
  const t = l.size, s = on.getEncodedBits(e);
  let a, n, o;
  for (let r = 0; r < 18; r++)
    a = Math.floor(r / 3), n = r % 3 + t - 8 - 3, o = (s >> r & 1) === 1, l.set(a, n, o, !0), l.set(n, a, o, !0);
}
function In(l, e, t) {
  const s = l.size, a = cf.getEncodedBits(e, t);
  let n, o;
  for (n = 0; n < 15; n++)
    o = (a >> n & 1) === 1, n < 6 ? l.set(n, 8, o, !0) : n < 8 ? l.set(n + 1, 8, o, !0) : l.set(s - 15 + n, 8, o, !0), n < 8 ? l.set(8, s - n - 1, o, !0) : n < 9 ? l.set(8, 15 - n - 1 + 1, o, !0) : l.set(8, 15 - n - 1, o, !0);
  l.set(s - 8, 8, 1, !0);
}
function Pf(l, e) {
  const t = l.size;
  let s = -1, a = t - 1, n = 7, o = 0;
  for (let r = t - 1; r > 0; r -= 2)
    for (r === 6 && r--; ; ) {
      for (let u = 0; u < 2; u++)
        if (!l.isReserved(a, r - u)) {
          let i = !1;
          o < e.length && (i = (e[o] >>> n & 1) === 1), l.set(a, r - u, i), n--, n === -1 && (o++, n = 7);
        }
      if (a += s, a < 0 || t <= a) {
        a -= s, s = -s;
        break;
      }
    }
}
function pf(l, e, t) {
  const s = new rf();
  t.forEach(function(u) {
    s.put(u.mode.bit, 4), s.put(u.getLength(), mf.getCharCountIndicator(u.mode, l)), u.write(s);
  });
  const a = Sn.getSymbolTotalCodewords(l), n = al.getTotalCodewordsCount(l, e), o = (a - n) * 8;
  for (s.getLengthInBits() + 4 <= o && s.put(0, 4); s.getLengthInBits() % 8 !== 0; )
    s.putBit(0);
  const r = (o - s.getLengthInBits()) / 8;
  for (let u = 0; u < r; u++)
    s.put(u % 2 ? 17 : 236, 8);
  return hf(s, l, e);
}
function hf(l, e, t) {
  const s = Sn.getSymbolTotalCodewords(e), a = al.getTotalCodewordsCount(e, t), n = s - a, o = al.getBlocksCount(e, t), r = s % o, u = o - r, i = Math.floor(s / o), c = Math.floor(n / o), f = c + 1, m = i - c, p = new sf(m);
  let w = 0;
  const b = new Array(o), O = new Array(o);
  let k = 0;
  const h = new Uint8Array(l.buffer);
  for (let I = 0; I < o; I++) {
    const z = I < u ? c : f;
    b[I] = h.slice(w, w + z), O[I] = p.encode(b[I]), w += z, k = Math.max(k, z);
  }
  const A = new Uint8Array(s);
  let S = 0, T, M;
  for (T = 0; T < k; T++)
    for (M = 0; M < o; M++)
      T < b[M].length && (A[S++] = b[M][T]);
  for (T = 0; T < m; T++)
    for (M = 0; M < o; M++)
      A[S++] = O[M][T];
  return A;
}
function vf(l, e, t, s) {
  let a;
  if (Array.isArray(l))
    a = Yn.fromArray(l);
  else if (typeof l == "string") {
    let i = e;
    if (!i) {
      const c = Yn.rawSplit(l);
      i = on.getBestVersionForData(c, t);
    }
    a = Yn.fromString(l, i || 40);
  } else
    throw new Error("Invalid data");
  const n = on.getBestVersionForData(a, t);
  if (!n)
    throw new Error("The amount of data is too big to be stored in a QR Code");
  if (!e)
    e = n;
  else if (e < n)
    throw new Error(
      `
The chosen QR Code version cannot contain this amount of data.
Minimum version required to store current data is: ` + n + `.
`
    );
  const o = pf(e, t, a), r = Sn.getSymbolSize(e), u = new af(r);
  return ff(u, e), yf(u), df(u, e), In(u, t, 0), e >= 7 && gf(u, e), Pf(u, o), isNaN(s) && (s = rl.getBestMask(
    u,
    In.bind(null, u, t)
  )), rl.applyMask(s, u), In(u, t, s), {
    modules: u,
    version: e,
    errorCorrectionLevel: t,
    maskPattern: s,
    segments: a
  };
}
Mr.create = function(e, t) {
  if (typeof e > "u" || e === "")
    throw new Error("No input text");
  let s = Xn.M, a, n;
  return typeof t < "u" && (s = Xn.from(t.errorCorrectionLevel, Xn.M), a = on.from(t.version), n = rl.from(t.maskPattern), t.toSJISFunc && Sn.setToSJISFunction(t.toSJISFunc)), vf(e, a, s, n);
};
var Gr = {}, zl = {};
(function(l) {
  function e(t) {
    if (typeof t == "number" && (t = t.toString()), typeof t != "string")
      throw new Error("Color should be defined as hex string");
    let s = t.slice().replace("#", "").split("");
    if (s.length < 3 || s.length === 5 || s.length > 8)
      throw new Error("Invalid hex color: " + t);
    (s.length === 3 || s.length === 4) && (s = Array.prototype.concat.apply([], s.map(function(n) {
      return [n, n];
    }))), s.length === 6 && s.push("F", "F");
    const a = parseInt(s.join(""), 16);
    return {
      r: a >> 24 & 255,
      g: a >> 16 & 255,
      b: a >> 8 & 255,
      a: a & 255,
      hex: "#" + s.slice(0, 6).join("")
    };
  }
  l.getOptions = function(s) {
    s || (s = {}), s.color || (s.color = {});
    const a = typeof s.margin > "u" || s.margin === null || s.margin < 0 ? 4 : s.margin, n = s.width && s.width >= 21 ? s.width : void 0, o = s.scale || 4;
    return {
      width: n,
      scale: n ? 4 : o,
      margin: a,
      color: {
        dark: e(s.color.dark || "#000000ff"),
        light: e(s.color.light || "#ffffffff")
      },
      type: s.type,
      rendererOpts: s.rendererOpts || {}
    };
  }, l.getScale = function(s, a) {
    return a.width && a.width >= s + a.margin * 2 ? a.width / (s + a.margin * 2) : a.scale;
  }, l.getImageWidth = function(s, a) {
    const n = l.getScale(s, a);
    return Math.floor((s + a.margin * 2) * n);
  }, l.qrToImageData = function(s, a, n) {
    const o = a.modules.size, r = a.modules.data, u = l.getScale(o, n), i = Math.floor((o + n.margin * 2) * u), c = n.margin * u, f = [n.color.light, n.color.dark];
    for (let m = 0; m < i; m++)
      for (let p = 0; p < i; p++) {
        let w = (m * i + p) * 4, b = n.color.light;
        if (m >= c && p >= c && m < i - c && p < i - c) {
          const O = Math.floor((m - c) / u), k = Math.floor((p - c) / u);
          b = f[r[O * o + k] ? 1 : 0];
        }
        s[w++] = b.r, s[w++] = b.g, s[w++] = b.b, s[w] = b.a;
      }
  };
})(zl);
(function(l) {
  const e = zl;
  function t(a, n, o) {
    a.clearRect(0, 0, n.width, n.height), n.style || (n.style = {}), n.height = o, n.width = o, n.style.height = o + "px", n.style.width = o + "px";
  }
  function s() {
    try {
      return document.createElement("canvas");
    } catch {
      throw new Error("You need to specify a canvas element");
    }
  }
  l.render = function(n, o, r) {
    let u = r, i = o;
    typeof u > "u" && (!o || !o.getContext) && (u = o, o = void 0), o || (i = s()), u = e.getOptions(u);
    const c = e.getImageWidth(n.modules.size, u), f = i.getContext("2d"), m = f.createImageData(c, c);
    return e.qrToImageData(m.data, n, u), t(f, i, c), f.putImageData(m, 0, 0), i;
  }, l.renderToDataURL = function(n, o, r) {
    let u = r;
    typeof u > "u" && (!o || !o.getContext) && (u = o, o = void 0), u || (u = {});
    const i = l.render(n, o, u), c = u.type || "image/png", f = u.rendererOpts || {};
    return i.toDataURL(c, f.quality);
  };
})(Gr);
var Wr = {};
const kf = zl;
function St(l, e) {
  const t = l.a / 255, s = e + '="' + l.hex + '"';
  return t < 1 ? s + " " + e + '-opacity="' + t.toFixed(2).slice(1) + '"' : s;
}
function Hn(l, e, t) {
  let s = l + e;
  return typeof t < "u" && (s += " " + t), s;
}
function Sf(l, e, t) {
  let s = "", a = 0, n = !1, o = 0;
  for (let r = 0; r < l.length; r++) {
    const u = Math.floor(r % e), i = Math.floor(r / e);
    !u && !n && (n = !0), l[r] ? (o++, r > 0 && u > 0 && l[r - 1] || (s += n ? Hn("M", u + t, 0.5 + i + t) : Hn("m", a, 0), a = 0, n = !1), u + 1 < e && l[r + 1] || (s += Hn("h", o), o = 0)) : a++;
  }
  return s;
}
Wr.render = function(e, t, s) {
  const a = kf.getOptions(t), n = e.modules.size, o = e.modules.data, r = n + a.margin * 2, u = a.color.light.a ? "<path " + St(a.color.light, "fill") + ' d="M0 0h' + r + "v" + r + 'H0z"/>' : "", i = "<path " + St(a.color.dark, "stroke") + ' d="' + Sf(o, n, a.margin) + '"/>', c = 'viewBox="0 0 ' + r + " " + r + '"', m = '<svg xmlns="http://www.w3.org/2000/svg" ' + (a.width ? 'width="' + a.width + '" height="' + a.width + '" ' : "") + c + ' shape-rendering="crispEdges">' + u + i + `</svg>
`;
  return typeof s == "function" && s(null, m), m;
};
const wf = M1, ol = Mr, qr = Gr, Rf = Wr;
function Gl(l, e, t, s, a) {
  const n = [].slice.call(arguments, 1), o = n.length, r = typeof n[o - 1] == "function";
  if (!r && !wf())
    throw new Error("Callback required as last argument");
  if (r) {
    if (o < 2)
      throw new Error("Too few arguments provided");
    o === 2 ? (a = t, t = e, e = s = void 0) : o === 3 && (e.getContext && typeof a > "u" ? (a = s, s = void 0) : (a = s, s = t, t = e, e = void 0));
  } else {
    if (o < 1)
      throw new Error("Too few arguments provided");
    return o === 1 ? (t = e, e = s = void 0) : o === 2 && !e.getContext && (s = t, t = e, e = void 0), new Promise(function(u, i) {
      try {
        const c = ol.create(t, s);
        u(l(c, e, s));
      } catch (c) {
        i(c);
      }
    });
  }
  try {
    const u = ol.create(t, s);
    a(null, l(u, e, s));
  } catch (u) {
    a(u);
  }
}
ze.create = ol.create;
ze.toCanvas = Gl.bind(null, qr.render);
ze.toDataURL = Gl.bind(null, qr.renderToDataURL);
ze.toString = Gl.bind(null, function(l, e, t) {
  return Rf.render(l, t);
});
class Kr {
  /**
   * Get the value as svg.
   * @param bic The BIC code.
   * @param nameOfReceiver The name of the receiver.
   * @param iban The IBAN.
   * @param ref The reference.
   * @param message The message.
   * @param amount The amount.
   * @param dueDate The due date.
   * @returns The value as svg.
   */
  static async getValue(e, t, s, a, n, o, r) {
    if (!e || !t || !s || !a && !n || o === void 0 || o === null)
      return Promise.resolve("");
    const u = "BCD", i = "001", c = "1", f = "SCT";
    s = (s + "").replace(/\s/g, ""), a && (a = (a + "").replace(/\s/g, ""));
    let m = `${u}
${i}
${c}
${f}
${e}
${t}
${s}
`;
    return o >= 0.01 && o <= 99999999999e-2 && (a ? m += `EUR${o}

` : m += `EUR${o}


`), a && (m += `${a}

`), a || (m += `${n}
`), r && (m += `ReqdExctnDt/${g.format(r, "YYYY-MM-DD")}`), new Promise((w, b) => {
      ze.toString(m, { type: "svg", errorCorrectionLevel: "L", version: 13 }, function(O, k) {
        O ? (console.error(O), w("")) : w(k);
      });
    });
  }
}
class Cf {
  /**
   * Loads report type specific HeaderFooterData.
   * @param businessObject The Invoice entity used to load the HeaderFooterData.
   * @param reportOptions The ReportOptions entity used to load the HeaderFooterData.
   * @param lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  static getHeaderFooter(e, t, s = void 0) {
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: d.get("SALAXY.REPORTS.invoice.title", null, s),
      subTitle: d.get(
        "SALAXY.ENUM.InvoiceType." + e.header?.type + ".label"
      ),
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Loads the raw report that is then rendered downstream as an html or pdf report.
   * @param businessObject Invoice entity
   * @returns Authorization
   */
  static async getInvoice(e, t) {
    var n, o, r;
    const s = (u) => u <= 1 ? u : u / 100;
    e.header ?? (e.header = {}), e.payer ?? (e.payer = {}), (n = e.payer).avatar ?? (n.avatar = {}), (o = e.payer).contact ?? (o.contact = {}), e.recipient ?? (e.recipient = {}), (r = e.recipient).contact ?? (r.contact = {});
    const a = {
      header: {
        date: g.getFormattedDate(e.header?.date ?? ""),
        dueDate: g.getFormattedDate(e.header?.dueDate ?? ""),
        referenceNumber: this.getReferenceNumber(e),
        message: e.header?.message
      },
      totals: {
        totalExVat: e.header?.totalExVat,
        totalVat: (e.header?.total ?? 0) - (e.header?.totalExVat ?? 0),
        total: e?.header?.total,
        taxSocialSecurity: nn.sum(e.rows?.filter((u) => u.articleId === ae.TaxSocialSecurity) ?? [], (u) => u.total ?? 0),
        taxWithholding: nn.sum(e.rows?.filter((u) => u.articleId === ae.TaxWithholding) ?? [], (u) => u.total ?? 0),
        totalPaid: e.header?.totalPaid,
        toBePaid: (e.header?.total ?? 0) - e.header?.totalPaid,
        showTotalPaid: e.header?.totalPaid && e.header?.totalPaid != e.header?.total
      },
      rows: [],
      isPreview: !1,
      payer: {
        name: e.payer.avatar.displayName,
        officialId: e.payer.officialId,
        street: e.payer.contact.street,
        postalCode: e.payer.contact.postalCode,
        city: e.payer.contact.city
      },
      recipient: {
        name: e.recipient.fullName,
        officialId: e.header.type === ae.Net ? "" : e.recipient.officialId,
        street: e.recipient.contact.street,
        postalCode: e.recipient.contact.postalCode,
        city: e.recipient.contact.city,
        iban: e.recipient.iban,
        bic: ln.getBicForIban(e.recipient.iban ?? "undefined")
      },
      barcode: ea.isInternationalIban(e.recipient.iban ?? "") ? null : this.createBarCode(t, e.recipient.iban ?? "", this.getReferenceNumber(e), g.asDate(e.header.dueDate), y.round(this.getPayment(e) * 100, 0)),
      qrCode: await this.createQrCode(e.recipient.iban ?? "", this.getReferenceNumber(e), g.asDate(e.header.dueDate), y.round(this.getPayment(e) ?? 0), e.recipient.fullName ?? void 0)
    };
    return e.rows?.forEach((u) => {
      const i = {};
      i.message = u.message, i.articleName = u.articleName, i.count = u.count, i.price = u.price, i.priceExVat = u.priceExVat, i.total = u.total, i.totalExVat = u.totalExVat, i.vatPercent = s(u.vatPercent ?? 0), i.accountingAccountNumber = u.accountingAccountNumber, i.accountingCode = u.accountingCode, a.rows?.push(i);
    }), this.isPreviewInvoice(e) && (a.recipient.iban = d.get("SALAXY.REPORTS.invoice.heading.preview"), a.recipient.bic = d.get("SALAXY.REPORTS.invoice.heading.preview"), a.isPreview = !0), a;
  }
  static getReferenceNumber(e) {
    return e.header?.type === ae.Net && e.header.channel === X.PalkkausInvoices ? "" : e.header?.referenceNumber ?? "";
  }
  static getPayment(e) {
    if (e)
      return e.header?.totalPaid && e.header?.totalPaid != e.header?.total ? (e.header?.total ?? 0) - e.header?.totalPaid : e.header?.total ?? void 0;
  }
  static createBarCode(e, t, s, a, n) {
    if (!/^(?:RF\d+|\d+)$/i.test(s) || !t || !a || !n)
      return "";
    try {
      return $e.createBarcode(e, t, s, a, n, { width: 1.5, height: 20, displayValue: !0, fontSize: 15 });
    } catch (r) {
      return console.error(r), "";
    }
  }
  static async createQrCode(e, t, s, a, n) {
    if (!/^(?:RF\d+|\d+)$/i.test(t) || !e || !n || !s || !a || !n)
      return "";
    try {
      return await Kr.getValue(ln.getBicForIban(e) ?? "", n, e, t, null, a, s);
    } catch (r) {
      return console.error(r), "";
    }
  }
  static isPreviewInvoice(e) {
    return e.header?.channel === X.PalkkausInvoices ? !1 : [ae.Pension, ae.Unemployment].includes(e.header?.type ?? ae.Undefined) && [An.Preview, An.Forecast].includes(e.header?.status ?? An.Undefined);
  }
  /**
   * Loads the invoice layout for pdf or html reports.
   * @param pdf Are we rendering a pdf report or not.
   * @returns Returns invoice layout.
   */
  static loadReportLayout(e) {
    return {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: e ? "pdf" : "htmlPage",
      isModeHtmlPage: !e,
      isModePdf: e
    };
  }
  /**
   * Loads Invoice specific ReportOptions
   * @returns ReportOptions for report
   */
  static loadReportOptions(e) {
    return e.header?.type === ae.Gross ? {
      css: void 0,
      printBackground: !1,
      margin: {
        top: 30,
        bottom: 30,
        left: 10,
        right: 10
      },
      headerTemplate: `
        <div style=" color:#808080; margin:10mm 10mm 0 10mm; font-family: Helvetica, Arial, sans-serif;">
          <table style="width: 100%; border-bottom: 0.75mm solid #009fd8;">
            <tr>
              <td width="40%">{{> logo }}</td>
              <td width="60%" style="font-weight: bold">
                <div style="font-size: 1.3em">{{ title }}</div>
                <div style="font-size: 1.1em;padding-bottom: 2mm">{{ subTitle }}</div>
              </td>
            </tr>
          </table>
        </div>
        `,
      footerTemplate: `
          <div style="margin:5mm 10mm 0 10mm; padding-top: 3mm; border-top: 0.75mm solid #009fd8;font-family: Helvetica, Arial, sans-serif;">
          {{t "SALAXY.REPORTS.document.footerInfo.html" date=( today) }}
            <div style="position: absolute;top: 8mm; right: 10mm">
            {{> pageNumber }} / {{> totalPages }}
            </div>
          </div>
        `,
      logo: `<svg width="175px" height="40px" viewBox="0 0 668 152" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <title>Palkkaus.fi</title>
        <g id="Palkkaus_logo_rgb" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
            <g>
                <path d="M495.195,118.538 C493.118,118.538 491.43,116.85 491.43,114.775 L491.43,53.743 C491.43,51.701 493.154,49.976 495.195,49.976 C497.296,49.976 499.071,51.701 499.071,53.743 L499.071,114.775 C499.071,116.886 497.368,118.538 495.195,118.538 Z M495.195,44.781 C493.118,44.781 491.43,43.092 491.43,41.016 L491.43,39.384 C491.43,37.344 493.154,35.62 495.195,35.62 C497.296,35.62 499.071,37.344 499.071,39.384 L499.071,41.016 C499.071,43.127 497.368,44.781 495.195,44.781 Z" id="Fill-5" fill="#2F3231"></path>
                <path d="M476.738,57.194 L468.645,57.194 L468.626,51.982 C468.626,45.466 469.175,43.165 470.711,43.165 C472.884,43.165 474.587,41.512 474.587,39.401 C474.587,37.289 472.884,35.635 470.711,35.635 C468.267,35.635 462.462,36.836 461.325,47.949 L461.321,47.991 L461.318,48.032 L461.097,52.226 L461.096,52.27 L461.096,57.194 L453.056,57.194 C451.014,57.194 449.289,58.968 449.289,61.07 C449.289,63.111 451.014,64.836 453.056,64.836 L461.096,64.836 L461.096,113.67 C461.096,115.711 462.82,117.436 464.861,117.436 C466.963,117.436 468.737,115.711 468.737,113.667 L468.66,64.836 L476.738,64.836 C478.814,64.836 480.502,63.148 480.502,61.07 C480.502,58.897 478.848,57.194 476.738,57.194" id="Fill-13" fill="#2F3231"></path>
                <path d="M444.976,117.415 C442.899,117.415 441.21,115.727 441.21,113.649 L441.21,112.019 C441.21,109.977 442.934,108.253 444.976,108.253 C447.077,108.253 448.851,109.977 448.851,112.019 L448.851,113.649 C448.851,115.761 447.149,117.415 444.976,117.415" id="Fill-7" fill="#2F3231"></path>
                <path d="M407.851,117.989 C390.358,117.989 384.949,107.462 383.281,101.186 C383.007,100.271 383.121,99.247 383.616,98.356 C384.126,97.437 384.972,96.78 386.001,96.499 L386.111,96.473 C386.36,96.423 386.614,96.398 386.866,96.398 C388.56,96.398 390.086,97.541 390.577,99.175 C392.606,106.783 398.251,110.456 407.851,110.456 C419.706,110.456 425.717,106.155 425.717,97.669 C425.717,87.376 413.67,86.319 413.548,86.312 L413.509,86.31 L413.43,86.305 L402.062,85.202 C395.571,84.722 383.225,80.546 383.225,68.2 C383.225,60.816 386.525,48.429 408.622,48.429 C418.997,48.429 426.382,52.003 430.577,59.052 C431.685,60.782 431.172,63.12 429.415,64.292 L429.298,64.362 C428.739,64.672 428.1,64.836 427.449,64.836 C426.109,64.836 424.865,64.171 424.12,63.056 L424.097,63.02 L424.075,62.985 C421.304,58.334 416.249,56.073 408.622,56.073 C392.61,56.073 390.758,62.994 390.758,68.2 C390.758,76.838 402.466,77.675 402.584,77.68 L402.624,77.681 L402.698,77.686 L414.065,78.679 C420.702,79.271 433.25,84.002 433.25,97.669 C433.25,103.779 430.775,117.989 407.851,117.989" id="Fill-12" fill="#2F3231"></path>
                <path d="M346.699,118.097 C324.513,118.097 321.523,102.581 321.523,87.404 L321.523,53.742 C321.523,51.594 323.14,49.976 325.288,49.976 C327.365,49.976 329.052,51.666 329.052,53.742 L329.052,87.404 C329.052,102.427 331.866,110.568 346.699,110.568 C362.311,110.568 365.449,101.704 365.449,87.404 L365.449,53.742 C365.449,51.594 367.066,49.976 369.213,49.976 C371.361,49.976 372.979,51.594 372.979,53.742 L372.979,87.404 C372.979,101.694 369.992,118.097 346.699,118.097" id="Fill-9" fill="#2F3231"></path>
                <path d="M284.47,57.398 C269.637,57.398 266.823,65.539 266.823,80.561 L266.823,86.632 C266.823,101.724 269.671,109.904 284.691,109.904 C297.773,109.904 303.109,104.025 303.109,89.612 L303.219,80.54 C303.289,71.105 301.763,65.326 298.272,61.808 C295.327,58.839 290.811,57.398 284.47,57.398 Z M306.874,117.436 C304.834,117.436 303.109,115.711 303.109,113.671 L303.109,111.479 C298.869,115.479 292.796,117.436 284.691,117.436 C262.307,117.436 259.289,101.863 259.289,86.632 L259.289,80.561 C259.289,65.328 262.282,49.754 284.47,49.754 C292.9,49.754 299.366,51.964 303.686,56.318 C310.063,62.742 310.811,72.654 310.752,80.574 L310.752,113.671 C310.752,115.711 308.975,117.436 306.874,117.436 Z" id="Fill-8" fill="#2F3231"></path>
                <path d="M209.297,117.436 C207.221,117.436 205.531,115.747 205.531,113.671 L205.531,39.37 C205.531,37.329 207.257,35.605 209.297,35.605 C211.398,35.605 213.175,37.329 213.175,39.37 L213.175,79.607 L219.828,79.607 C219.833,79.607 222.523,79.615 224.091,79.615 C239.712,79.598 242.84,70.741 242.84,56.454 L242.84,53.742 C242.84,51.594 244.46,49.974 246.605,49.974 C248.752,49.974 250.371,51.594 250.371,53.742 L250.371,56.454 C250.371,66.101 249.093,77.586 239.787,83.382 C249.093,89.177 250.371,100.662 250.371,110.309 L250.371,113.656 C250.371,115.803 248.752,117.422 246.605,117.422 C244.46,117.422 242.84,115.803 242.84,113.656 L242.84,110.309 C242.84,96.022 239.712,87.163 224.135,87.148 C222.523,87.149 219.833,87.157 219.833,87.157 L213.175,87.157 L213.175,113.671 C213.175,115.783 211.471,117.436 209.297,117.436" id="Fill-11" fill="#2F3231"></path>
                <path d="M152.456,117.436 C150.379,117.436 148.689,115.747 148.689,113.671 L148.689,39.37 C148.689,37.329 150.414,35.605 152.456,35.605 C154.557,35.605 156.332,37.329 156.332,39.37 L156.332,79.607 L162.986,79.607 C162.99,79.607 165.68,79.615 167.248,79.615 C182.869,79.598 185.998,70.741 185.998,56.454 L185.998,53.742 C185.998,51.594 187.617,49.974 189.763,49.974 C191.909,49.974 193.528,51.594 193.528,53.742 L193.528,56.454 C193.528,66.101 192.251,77.586 182.944,83.382 C192.251,89.177 193.528,100.662 193.528,110.309 L193.528,113.656 C193.528,115.803 191.909,117.422 189.763,117.422 C187.617,117.422 185.998,115.803 185.998,113.656 L185.998,110.309 C185.998,96.022 182.869,87.163 167.292,87.148 C165.68,87.149 162.99,87.157 162.99,87.157 L156.332,87.157 L156.332,113.671 C156.332,115.783 154.628,117.436 152.456,117.436" id="Fill-10" fill="#2F3231"></path>
                <path d="M131.935,101.06 C131.935,107.575 132.484,109.876 134.02,109.876 C136.192,109.876 137.896,111.529 137.896,113.64 C137.896,115.752 136.192,117.407 134.02,117.407 C131.576,117.407 125.771,116.205 124.634,105.092 L124.63,105.05 L124.626,105.009 L124.406,100.816 L124.404,100.771 L124.404,39.372 C124.404,37.33 126.129,35.605 128.17,35.605 C130.271,35.605 132.046,37.33 132.046,39.374 L131.935,101.06" id="Fill-14" fill="#2F3231"></path>
                <path d="M85.293,57.398 C70.461,57.398 67.649,65.539 67.649,80.561 L67.649,86.632 C67.649,101.724 70.495,109.904 85.515,109.904 C98.597,109.904 103.932,104.025 103.932,89.612 L104.043,80.54 C104.113,71.105 102.587,65.326 99.096,61.808 C96.15,58.839 91.635,57.398 85.293,57.398 Z M107.699,117.436 C105.657,117.436 103.932,115.711 103.932,113.671 L103.932,111.479 C99.693,115.479 93.619,117.436 85.515,117.436 C63.134,117.436 60.116,101.863 60.116,86.632 L60.116,80.561 C60.116,65.328 63.109,49.754 85.293,49.754 C93.724,49.754 100.19,51.964 104.51,56.318 C110.886,62.74 111.634,72.654 111.575,80.574 L111.575,113.671 C111.575,115.711 109.8,117.436 107.699,117.436 Z" id="Fill-4" fill="#2F3231"></path>
                <path d="M25.066,56.625 C10.325,56.625 7.532,64.727 7.532,79.677 L7.532,86.961 C7.532,101.985 10.361,110.126 25.287,110.126 C40.771,110.126 43.706,101.985 43.706,86.961 L43.706,79.677 C43.706,65.077 40.657,56.625 25.066,56.625 Z M3.766,132.867 C1.725,132.867 0,131.142 0,129.101 L0,79.677 C0,64.553 2.979,49.094 25.066,49.094 C48.361,49.094 51.348,65.438 51.348,79.677 L51.348,86.961 C51.348,101.253 48.385,117.658 25.287,117.658 C17.558,117.658 11.702,115.774 7.532,111.923 L7.532,129.101 C7.532,131.178 5.843,132.867 3.766,132.867 Z" id="Fill-1" fill="#2F3231"></path>
                <g id="GraphicLogo" transform="translate(527.000000, 0.000000)">
                    <path d="M18.633,90.281 C13.09,93.033 8.269,97.393 4.944,103.157 C-4.049,118.726 1.281,138.638 16.858,147.632 C21.986,150.593 27.584,152 33.108,152 C44.362,152 55.308,146.158 61.34,135.712 C64.677,129.929 66.038,123.545 65.635,117.345 C63.095,117.821 60.537,118.056 57.991,118.056 C43.576,118.056 29.556,110.574 21.831,97.19 C20.535,94.947 19.472,92.636 18.633,90.281" id="Fill-15" fill="#BF196F"></path>
                    <path d="M107.683,43.881 C101.036,43.881 94.859,45.87 89.707,49.285 C91.319,51.182 92.784,53.25 94.073,55.483 C103.167,71.241 100.814,90.458 89.598,103.519 C94.771,106.98 100.989,108.997 107.683,108.997 C125.662,108.997 140.237,94.421 140.237,76.443 C140.237,58.457 125.662,43.881 107.683,43.881" id="Fill-16" fill="#1795C5"></path>
                    <path d="M65.576,35.334 C64.902,45.837 59.157,55.819 49.353,61.475 C44.228,64.433 38.633,65.839 33.111,65.839 C28.084,65.839 23.116,64.672 18.62,62.452 C15.508,71.278 15.366,81.102 18.633,90.28 C23.139,88.042 28.124,86.869 33.169,86.868 C38.693,86.868 44.291,88.275 49.419,91.237 C59.208,96.889 64.951,106.855 65.634,117.346 C70.149,116.5 74.6,114.887 78.802,112.461 C82.995,110.038 86.611,106.996 89.598,103.519 C80.868,97.68 75.119,87.732 75.119,76.443 C75.119,65.102 80.916,55.116 89.708,49.285 C83.386,41.848 74.793,37.05 65.576,35.334" id="Fill-17" fill="#82BE44"></path>
                    <path d="M33.169,86.868 C28.124,86.868 23.139,88.042 18.633,90.281 C19.472,92.635 20.535,94.948 21.831,97.19 C29.556,110.574 43.576,118.055 57.991,118.055 C60.537,118.055 63.096,117.821 65.635,117.345 C64.951,106.855 59.208,96.889 49.419,91.237 C44.291,88.275 38.693,86.868 33.169,86.868" id="Fill-18" fill="#66292B"></path>
                    <path d="M89.707,49.286 C80.916,55.116 75.119,65.101 75.119,76.442 C75.119,87.732 80.868,97.679 89.598,103.519 C100.814,90.458 103.167,71.241 94.073,55.482 C92.784,53.25 91.319,51.182 89.707,49.286" id="Fill-19" fill="#2C9250"></path>
                    <path d="M33.05,0.712 C27.527,0.712 21.925,2.12 16.798,5.08 C1.222,14.074 -4.109,33.981 4.877,49.555 C8.216,55.333 13.054,59.701 18.62,62.452 C21.812,53.397 28.13,45.395 37.095,40.219 C43.665,36.427 50.837,34.626 57.912,34.624 C60.492,34.624 63.057,34.864 65.576,35.334 C65.972,29.141 64.608,22.771 61.274,16.993 C55.247,6.55 44.303,0.711 33.05,0.712" id="Fill-21" fill="#EA893F"></path>
                    <path d="M57.913,34.624 C50.837,34.626 43.665,36.427 37.095,40.219 C28.13,45.395 21.812,53.398 18.62,62.452 C23.116,64.672 28.084,65.839 33.111,65.839 C38.633,65.839 44.228,64.433 49.353,61.475 C59.157,55.818 64.903,45.837 65.576,35.334 C63.057,34.864 60.492,34.624 57.913,34.624" id="Fill-23" fill="#55663D"></path>
                </g>
            </g>
        </g>
      </svg>`
    } : {
      css: "",
      printBackground: !1,
      margin: {
        top: 30,
        bottom: 20,
        left: 10,
        right: 10
      },
      headerTemplate: `
      <div style="color:#808080; margin:10mm 10mm 0 10mm;font-family: Helvetica, Arial, sans-serif;">
      <table style="width: 100%; border-bottom: 0.75mm solid #000;">
        <tr align="center">
          <td style="font-weight: bold; text-align: center">
            <div style="font-size: 1.3em">{{ title }}</div>
            <div style="font-size: 1.1em;padding-bottom: 2mm">{{ subTitle }}</div>
          </td>
        </tr>
      </table>
    </div>
  `,
      footerTemplate: e.header?.channel === X.Askelma ? `
          <div style="margin:0mm 10mm 0 10mm; padding-top: 3mm; border-top: 0.75mm solid #000;font-family: Helvetica, Arial, sans-serif;">
            <div style="position: absolute;top: 3mm; right: 10mm">
            {{> pageNumber }} / {{> totalPages }}
            </div>
          </div>
        ` : `
          <div style="margin:0mm 10mm 0 10mm; padding-top: 3mm; border-top: 0.75mm solid #000;font-family: Helvetica, Arial, sans-serif;">
            {{t "SALAXY.REPORTS.invoice.footer.html" date=( today) }}
            <div style="position: absolute;top: 3mm; right: 10mm">
              {{> pageNumber }} / {{> totalPages }}
            </div>
          </div>
        `,
      logo: ""
    };
  }
}
class Tf {
  /**
   * Maps input calc to hbs supported format
   * @param businessObject calculation to be mapped
   * @returns Extended calculation with eSalary property
   */
  static getESalary(e) {
    const t = e;
    t.eSalaryHbs = {}, t.eSalaryHbs.version = "2.0";
    const s = e.workflow?.salaryDate ?? e.workflow?.salaryPaidAt ?? e.workflow?.paidAt ?? g.getDate("today", "today", "today");
    return t.eSalaryHbs.headerData = {
      messageId: e.id,
      timestamp: g.getToday(),
      documentTitle: "SALAXY.REPORTS.eSalary.headerData.documentTitle",
      payDate: g.format(s, "YYYYMMDD"),
      netPayment: {
        label: "SALAXY.REPORTS.eSalary.headerData.netPayment.label",
        value: e.result?.workerCalc?.totalWorkerPayment?.toString()
      },
      payer: e.employer?.avatar?.displayName,
      partyIdentifications: [
        { authority: "Y-tunnus", value: e.employer?.officialId }
      ],
      deliveryChannels: [
        {
          deliveryMethodCode: "01",
          deliveryInfo: {
            bankCode: e.worker?.paymentData?.ibanNumber?.slice(4, 10) ?? ""
          }
        }
      ]
    }, t.eSalaryHbs.payPeriod = {
      heading: "SALAXY.REPORTS.eSalary.payPeriod.heading",
      dateOfPayment: {
        label: "SALAXY.REPORTS.eSalary.payPeriod.dateOfPayment.label",
        date: e.workflow?.salaryDate ?? e.workflow?.salaryPaidAt ?? e.workflow?.paidAt ?? g.getDate("today", "today", "today")
      },
      periodDates: {
        label: "SALAXY.REPORTS.eSalary.payPeriod.periodDates.label",
        startDate: {
          label: "SALAXY.REPORTS.eSalary.payPeriod.periodDates.startDate.label",
          date: e.worktime?.workDays?.start
        },
        termDate: {
          label: "SALAXY.REPORTS.eSalary.payPeriod.periodDates.termDate.label",
          date: e.worktime?.workDays?.end
        }
      }
    }, t.eSalaryHbs.delivery = {
      sender: {
        heading: "SALAXY.REPORTS.eSalary.delivery.sender.heading",
        name: e.employer?.avatar?.displayName,
        addressLine: e.employer?.contact?.street,
        postalCode: e.employer?.contact?.city,
        postOffice: e.employer?.contact?.postalCode,
        countryCode: e.employer?.contact?.countryCode,
        country: "Suomi - Finland",
        telephone: [
          {
            phoneNumber: e.employer?.contact?.telephone
          }
        ],
        emailAddress: e.employer?.contact?.email
      },
      recipient: {
        heading: "SALAXY.REPORTS.eSalary.delivery.recipient.heading",
        recipientName: {
          foreName: e.worker?.avatar?.firstName,
          surName: e.worker?.avatar?.lastName
        },
        addressLine: e.worker?.contact?.street,
        postalCode: e.worker?.contact?.city,
        postOffice: e.worker?.contact?.postalCode,
        countryCode: e.worker?.contact?.countryCode,
        country: "Suomi - Finland"
      },
      payOffice: {
        fullName: "Suomen Palkanlaskenta Oy",
        addressLine: "Kirkkokatu 1 A",
        postalCode: "00170",
        postOffice: "Helsinki",
        countryCode: "FI",
        telephone: [
          { phoneNumber: "09 425 50603" }
        ],
        emailAddress: "aspa@palkkaus.fi"
      }
    }, t.eSalaryHbs.employee = {
      heading: "SALAXY.REPORTS.eSalary.employee.heading",
      identity: {
        label: "SALAXY.REPORTS.eSalary.employee.identity.label",
        item: e.worker?.paymentData?.socialSecurityNumber
      },
      employmentDate: {
        label: "SALAXY.REPORTS.eSalary.employee.employmentDate.label",
        value: e.worktime?.employmentPeriod?.start
      },
      classification: {
        heading: "SALAXY.REPORTS.eSalary.employee.classification.heading",
        jobTitle: {
          label: "SALAXY.REPORTS.eSalary.employee.classification.jobTitle.label",
          value: e.info?.workDescription
        }
      },
      employeeName: {
        foreName: e.worker?.paymentData?.firstName,
        surName: e.worker?.paymentData?.lastName
      }
    }, t.eSalaryHbs.bankAccount = {
      heading: "SALAXY.REPORTS.eSalary.bankAccount.heading",
      label: "SALAXY.REPORTS.eSalary.bankAccount.label",
      value: e.worker?.paymentData?.ibanNumber,
      bic: ln.getBicForIban(e.worker?.paymentData?.ibanNumber ?? "")
    }, t.eSalaryHbs.calculationBases = {
      heading: "SALAXY.REPORTS.eSalary.calculationBases.heading",
      salaryRates: {
        heading: "SALAXY.REPORTS.eSalary.calculationBases.salaryRates.heading"
      },
      taxationRates: {
        heading: "SALAXY.REPORTS.eSalary.calculationBases.taxationRates.heading",
        recordLabels: {
          taxPercent: "SALAXY.REPORTS.eSalary.calculationBases.taxationRates.recordLabels.taxPercent",
          taxPercent2: "SALAXY.REPORTS.eSalary.calculationBases.taxationRates.recordLabels.taxPercent2"
        }
      },
      incomeLimitLabel: "SALAXY.REPORTS.eSalary.calculationBases.incomeLimitLabel",
      incomeLimit: e.worker?.tax?.snapshot?.incomeLimit?.toString(),
      taxcardValidityLabel: "SALAXY.REPORTS.eSalary.calculationBases.taxcardValidityLabel",
      taxcardValidity: e.worker?.tax?.snapshot?.validity?.start && e.worker?.tax?.snapshot?.validity?.end ? `${g.format(e.worker?.tax?.snapshot?.validity?.start)} - ${g.format(e.worker?.tax?.snapshot?.validity?.end)}` : null
    }, t.eSalaryHbs.payDetails = {
      heading: "SALAXY.REPORTS.eSalary.payDetails.heading"
    }, t.eSalaryHbs.report = Qo.getCalculationReport(e, Se.SalarySlip, void 0), this.addBenefitsToReportTotals(t.eSalaryHbs.report), t.eSalaryHbs.messages = {
      heading: "SALAXY.REPORTS.eSalary.messages.heading",
      salarySlipMessage: {
        label: "SALAXY.NG1.CalcDetailsWorkerComponent.salarySlipMessage",
        message: e.info?.salarySlipMessage
      },
      transient: {
        heading: "SALAXY.REPORTS.eSalary.messages.transient.heading"
      }
    }, t.eSalaryHbs.cumulative = this.getCumulativeData(e), t;
  }
  /**
   * get xml file name
   * @returns name of eSalary xml name
   */
  static getXmlFileName() {
    return "PayslipXML";
  }
  /**
   * Maps cumulative calculation to hbs supported format
   * @param calc cumulative calculation
   * @returns object containing array of current and previous earnings
   */
  static getCumulativeData(e) {
    const t = e.cumulative;
    if (t) {
      const s = {
        heading: "SALAXY.REPORTS.eSalary.cumulative.heading",
        current: {
          heading: "SALAXY.REPORTS.eSalary.cumulative.current.heading",
          data: []
        },
        previous: {
          heading: "SALAXY.REPORTS.eSalary.cumulative.previous.heading",
          data: []
        }
      }, a = Object.keys(t);
      for (const n of a) {
        const o = t[n], r = Object.keys(o.data ?? []);
        for (const u of r)
          n === "current" ? s.current.data.push(
            {
              label: t[n].labels[u],
              value: t[n].data[u]
            }
          ) : s.previous.data.push(
            {
              label: t[n].labels[u],
              value: t[n][u]
            }
          );
      }
      return s;
    } else
      return;
  }
  static addBenefitsToReportTotals(e) {
    if (!e)
      return;
    let t = 0;
    const s = e.rowGroups?.find((n) => n.grouping === "totals"), a = e.rowGroups?.find((n) => n.grouping === "benefits");
    a && a.rows.length && (a.rows.forEach((n) => {
      t += n.data.irRow.total;
    }), s.rows.push({ data: { irRow: { message: "SALAXY.REPORTS.ENUM.CalcGroup.benefits.label", total: t } } }));
  }
}
class xf {
  /**
   * Creates HeaderFooterData from provided parameters
   * @param businessObject WorkerSummaryReportData used to get neede data for header
   * @param options Report options
   * @param lang gets translation with this lang, if null use current lang
   * @returns HeaderFooterData for provided businessObject
   */
  static getWorkerSummaryReportHeaderFooter(e, t, s = void 0) {
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: `${d.get("SALAXY.REPORTS.workerSummaryReport.title", null, s)} ${g.getYear(e.startDate) ?? "-"}`,
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Creates ReporLayout object depending on switchToPortrait boolean
   * @param switchToPortrait boolean indicating if layout should be portrait
   * @param pdf mode for report
   * @returns ReportLayout object
   */
  static getReportLayout(e, t = !1) {
    return e ? {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    } : {
      isLayoutA4Portrait: !1,
      isLayoutA4Landscape: !0,
      layout: "a4Landscape",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: t ? "pdf" : "htmlPage",
      isModeHtmlPage: !t,
      isModePdf: t
    };
  }
  /**
   * Maps data to hbs supported report format
   * @param businessObject businessObject used to create WorkerSummaryReportDataExtended
   * @returns WorkerSummaryReportData with 4 added boolean fields as WorkerSummaryReportDataExtended
   */
  static getWorkerSummaryReport(e, t = void 0) {
    [
      ...e.workerResult?.cashSalary?.rows ?? [],
      ...e.workerResult?.benefitsInKind?.rows ?? [],
      ...e.workerResult?.expenses?.rows ?? []
    ].forEach((a) => {
      a.message = this.translateMessage(a, t);
    });
    const s = e;
    return s.showUnionPayment = (e.result?.workerCalc?.unionPayment ?? 0) > 0, s.showForeclosure = (e.result?.workerCalc?.foreclosure ?? 0) > 0, s.showPrepaidExpenses = (e.result?.workerCalc?.prepaidExpenses ?? 0) > 0, s.showOtherDeductions = (e.result?.workerCalc?.otherDeductions ?? 0) > 0, s;
  }
  static translateMessage(e, t) {
    const s = e;
    if (!s.data)
      return s.message;
    let a, n = s.data.calculationRowType || v.Unknown;
    n = n.substr(0, 1).toLowerCase() + n.substr(1);
    const o = s.data.code, r = s.data.kind;
    return n === v.IrIncomeType ? a = V.getAll(t).find((u) => r && u.transactionCode === r || o > 0 && u.code === o)?.label : n === v.MealBenefit && o !== 334 ? a = V.getAll(t).find((u) => o > 0 && u.code === o)?.label : [
      v.Unknown,
      v.CarBenefit,
      v.BicycleBenefit,
      v.SubsidisedCommute,
      v.TaxAtSource,
      v.HourlySalaryWithWorkingTimeCompensation
    ].includes(n) ? a = V.getAll(t).find((u) => o > 0 && u.code === o)?.label : [
      v.DailyAllowance,
      v.EmploymentTermination,
      v.WorkingTimeCompensation,
      v.Remuneration,
      v.OtherCompensation,
      v.NonProfitOrg,
      v.MealBenefit,
      // main MealBenefit
      v.Training,
      v.PaidSickLeave
    ].includes(n) && r && (a = G.getEnumLabel(`${s.data.calculationRowType}Kind`, r, void 0, t)), a || G.getEnumLabel("CalculationRowType", n, void 0, t);
  }
}
class Lf {
  /**
   * Loads report type specific HeaderFooterData.
   * @param businessObject - The array of invoice list items.
   * @param reportOptions The ReportOptions entity used to load the HeaderFooterData.
   * @param _lang gets translation with this lang, if null use current lang
   * @returns Returns HeaderFooterData.
   */
  static getHeaderFooter(e, t, s) {
    return {
      logo: t?.logo,
      img2: t?.img2,
      title: e[0].ownerInfo?.avatar?.displayName,
      today: g.getFormattedDate(g.getToday()),
      date: g.getFormattedDate(g.getToday())
    };
  }
  /**
   * Loads the invoice layout for pdf or html reports.
   * @param pdf Are we rendering a pdf report or not.
   * @returns Returns invoice layout.
   */
  static loadReportLayout(e) {
    return {
      isLayoutA4Portrait: !0,
      isLayoutA4Landscape: !1,
      layout: "a4Portrait",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: e ? "pdf" : "htmlPage",
      isModeHtmlPage: !e,
      isModePdf: e
    };
  }
  /**
   * Retrieves a invoice list based on the provided business object.
   * @param businessObject - The array of invoice list items.
   * @param getDocumentAndSvgNode - A function that returns the document and SVG node.
   * @returns A promise that resolves to an array of mapped invoices.
   */
  static async getInvoiceList(e, t) {
    const s = [];
    for (const a of e) {
      const n = {
        heading: this.getHeadingText(a),
        iban: a.otherPartyInfo?.ibanNumber || "",
        nameOfReceiver: a.otherPartyInfo?.avatar?.displayName,
        dueDate: a.endAt,
        referenceOrMessageLabel: a.entityType === "net" || a.entityType === "gross" ? d.get("SALAXY.REPORTS.invoiceList.message") : d.get("SALAXY.REPORTS.invoiceList.reference"),
        referenceOrMessageValue: a.entityType === "net" || a.entityType === "gross" ? `${d.get(`SALAXY.ENUM.InvoiceType.${a.entityType}.label`)} ${g.getFormattedRange(a.data.periodStart, a.data.periodEnd)}` : a.reference,
        payment: a.payment,
        totalPaid: a.data?.totalPaid,
        isTotalPaid: a.data?.totalPaid && a.data?.totalPaid !== a.payment,
        payable: a.payment ? a.payment - a.data?.totalPaid : void 0,
        statusText: `${d.get(`SALAXY.ENUM.InvoiceStatus.${a.status}.label`)}`,
        isPaid: a.status === "paid",
        isCanceled: a.status === "canceled",
        isPreview: a.status === "preview",
        displayDate: g.getFormattedDate(a.data?.statusAt || a.updatedAt),
        unPaidText: `${(a.businessObjects?.length ?? 0) - (a.data?.paidBusinessObjectsCount || 0)} ${d.get("SALAXY.REPORTS.invoiceList.unpaidNetSalaries")} <br/> ${g.getFormattedRange(a.data.periodStart, a.data.periodEnd)}`,
        qrCodeAvailable: !1,
        qrCodeUnavailable: !1,
        qrCodeSvg: await this.createQrCode(a),
        barcode: $e.getValue(
          a.otherPartyInfo?.ibanNumber || "",
          a.entityType === "net" ? "" : a.reference || "",
          g.asDate(a.data?.dueDate) || "",
          y.round((this.getInvoicePayment(a) ?? 0) * 100, 0) ?? ""
        ),
        barcodeSvg: this.createBarCode(t, a.otherPartyInfo?.ibanNumber || "", a.reference || "", g.asDate(a.data?.dueDate) || "", y.round(this.getInvoicePayment(a) ?? 0, 0) ?? 0),
        endAt: a.endAt
      };
      n.qrCodeAvailable = !!(n.qrCodeSvg && a.status != "paid" && a.status != "canceled"), n.qrCodeUnavailable = !(n.isPaid || n.isCanceled) && !n.qrCodeSvg, s.push(n);
    }
    return s;
  }
  /**
   * Loads InvoiceList specific ReportOptions
   * @returns ReportOptions for report
   */
  static loadReportOptions() {
    return {
      css: "",
      printBackground: !0,
      margin: {
        top: 30,
        bottom: 20,
        left: 10,
        right: 10
      },
      headerTemplate: `
        <div style="color:#808080; margin:10mm 10mm 0 10mm;font-family: Helvetica, Arial, sans-serif;">
          <table style="width: 100%; border-bottom: 0.75mm solid #000;">
            <tr align="center">
              <td style="font-weight: bold; text-align: center">
                <div style="font-size: 1.3em">{{ title }}</div>
                <div style="font-size: 1.1em;padding-bottom: 2mm">{{ subTitle }}</div>
              </td>
            </tr>
          </table>
        </div>
      `,
      footerTemplate: `
          <div style="margin:0mm 10mm 0 10mm; padding-top: 3mm; border-top: 0.75mm solid #000;font-family: Helvetica, Arial, sans-serif;">
            {{t "SALAXY.REPORTS.invoice.footer.html" date=( today) }}
            <div style="position: absolute;top: 3mm; right: 10mm">
              {{> pageNumber }} / {{> totalPages }}
            </div>
          </div>
        `,
      logo: ""
    };
  }
  /**
   * Calculates the invoice payment amount for a given invoice item.
   * If the invoice item is of type "tax" or "union" and the total paid amount
   * is different from the payment amount, it returns the rounded difference
   * between the payment amount and the total paid amount.
   * Otherwise, it returns the payment amount.
   * @param {InvoiceListItem} item - The invoice item to calculate the payment for.
   * @returns {number} - The calculated payment amount.
   */
  static getInvoicePayment(e) {
    return (e.entityType == "tax" || e.entityType == "union") && e.data?.totalPaid && e.data.totalPaid != e.payment ? y.round((e.payment ?? 0) - e.data.totalPaid) : e.payment ?? void 0;
  }
  static getHeadingText(e) {
    return `${e.otherPartyInfo?.avatar?.displayName}: 
      ${e.entityType === "net" || e.entityType === "gross" || e.entityType === "foreclosure" || e.entityType === "verification" ? `${d.get(`SALAXY.ENUM.InvoiceType.${e.entityType}.label`)} ${g.getFormattedDate(e.logicalDate)}` : `${d.get(`SALAXY.ENUM.InvoiceType.${e.entityType}.label`)} ${g.getFormattedRange(e.data.periodStart, e.data.periodEnd)}`}
    `;
  }
  static createBarCode(e, t, s, a, n) {
    if (!/^(?:RF\d+|\d+)$/i.test(s))
      return "";
    try {
      return $e.createBarcode(e, t, s, a, n, { width: 1.5, height: 20, displayValue: !0, fontSize: 15 });
    } catch (r) {
      return console.error(r), "";
    }
  }
  static async createQrCode(e) {
    if (!e.reference || e.otherPartyInfo?.ibanNumber || !/^(?:RF\d+|\d+)$/i.test(e.reference))
      return "";
    try {
      return await Kr.getValue(
        ln.getBicForIban(e.otherPartyInfo?.ibanNumber?.replace(/\s+/g, "") ?? "") ?? "",
        e.otherPartyInfo?.avatar?.displayName ?? "",
        e.otherPartyInfo?.ibanNumber ?? "",
        e.entityType === "net" ? null : e.reference,
        e.entityType === "net" ? `${d.get(`SALAXY.ENUM.InvoiceType.${e.entityType}.label`)} ${g.getFormattedRange(e.data.periodStart, e.data.periodEnd)}` : void 0,
        this.getInvoicePayment(e),
        e.endAt ?? ""
      );
    } catch (s) {
      return console.error(s), "";
    }
  }
}
class _f {
  /**
   * Generates calendar data by mapping months and series to a structured result.
   * @param {CalendarMonth[]} months - An array of calendar months to be processed.
   * @param {CalendarSeries[]} series - An array of calendar series to be mapped to each month.
   * @returns {CalendarResult} The structured calendar result containing mapped months with their respective days, series, title, and weeks.
   */
  static getCalendarData(e, t) {
    const s = { months: [] };
    return e.forEach((a) => {
      const n = { days: void 0, series: void 0, title: void 0, weeks: void 0 };
      n.title = `${a.title} ${a.year}`, n.days = a.days, n.series = t.map((o, r) => {
        const u = {
          ...o,
          days: ul.copy(a.days)
        };
        return u.days.forEach((i) => {
          i.hasEvents = !1, i.periods[r].length > 0 && (i.hasEvents = !0);
        }), u;
      }), n.weeks = this.getWeekNumbersForMonth(a.days), s.months?.push(n);
    }), s;
  }
  /**
   * Loads the invoice layout for pdf or html reports.
   * @param pdf Are we rendering a pdf report or not.
   * @returns Returns invoice layout.
   */
  static loadReportLayout(e) {
    return {
      isLayoutA4Portrait: !1,
      isLayoutA4Landscape: !0,
      layout: "a4Landscape",
      date: g.getFormattedDate(g.getToday()),
      isPreview: !1,
      mode: e ? "pdf" : "htmlPage",
      isModeHtmlPage: !e,
      isModePdf: e
    };
  }
  /**
   * Loads Invoice specific ReportOptions
   * @returns ReportOptions for report
   */
  static loadReportOptions() {
    return {
      css: "",
      printBackground: !0,
      margin: {
        top: 30,
        bottom: 20,
        left: 10,
        right: 10
      },
      headerTemplate: void 0,
      footerTemplate: void 0,
      logo: ""
    };
  }
  static getWeekNumbersForMonth(e) {
    const t = [], s = (a) => {
      const n = t.find((r) => r.weekNumber === a);
      if (n)
        return n;
      const o = { weekNumber: a, colspan: 0 };
      return t.push(o), o;
    };
    return e.forEach((a) => {
      const n = g.getWeekNumber(a.date);
      n && ++s(n).colspan;
    }), t;
  }
}
class Df {
  /**
   * Generates config for SxyTable component
   * @param calcs Calculations for report
   * @param lang Language for report
   * @returns Configuration for SxyTable component
   */
  static getConfig(e, t) {
    const s = () => {
      const r = [];
      return e.forEach((u) => {
        u.rows?.forEach((i) => {
          const c = {};
          c.worker = u.worker?.avatar?.displayName, c.socSec = u.worker?.paymentData?.socialSecurityNumber, c.message = i.message, c.rowType = i.rowType, c.rowTypeKind = this.getKind(i, t), c.type = i.type, c.sourceId = i.sourceId, c.count = i.count, c.price = i.price, c.total = (i.count ?? 1) * (i.price ?? 0), a().forEach((f) => {
            c[f] = i.accounting?.dimensions?.filter((m) => m.id === f).map((m) => m.value).join(", ");
          }), r.push(c);
        });
      }), r;
    }, a = () => {
      const r = [];
      return e.map((i) => i.rows && i.rows.map((c) => c.accounting && c.accounting.dimensions).flat()).flat().forEach((i) => {
        i && !r.includes(i.id) && r.push(i.id);
      }), r;
    }, n = (r) => r.map((u) => ({ title: u, field: u }));
    return {
      include: [
        { title: d.get("SALAXY.REPORTS.rowsReport.worker", null, t), field: "worker", frozen: !0, minWidth: 100 },
        { title: d.get("SALAXY.REPORTS.rowsReport.socsec", null, t), field: "socSec" },
        { title: d.get("SALAXY.REPORTS.rowsReport.message", null, t), field: "message" },
        { title: d.get("SALAXY.REPORTS.rowsReport.rowType", null, t), field: "rowType", formatter: (r) => G.getEnumLabel("CalculationRowType", r.getValue(), void 0, t) ?? "" },
        { title: d.get("SALAXY.REPORTS.rowsReport.rowTypeKind", null, t), field: "rowTypeKind" },
        { title: d.get("SALAXY.REPORTS.rowsReport.type", null, t), field: "type" },
        { title: d.get("SALAXY.REPORTS.rowsReport.sourceId", null, t), field: "sourceId" },
        { title: d.get("SALAXY.REPORTS.rowsReport.count", null, t), field: "count" },
        { title: d.get("SALAXY.REPORTS.rowsReport.price", null, t), field: "price", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.rowsReport.total", null, t), field: "total", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        ...n(a())
      ],
      options: {
        selectable: !1,
        layout: "fitColumns"
      },
      data: s()
    };
  }
  static getKind(e, t) {
    if (!e.data?.kind)
      return "";
    if (e.rowType === v.IrIncomeType)
      return V.getAll(t).find((a) => e.data?.kind && a.transactionCode === e.data?.kind || e?.data?.code && a.code === e?.data?.code)?.label ?? "";
    {
      const a = e.rowType.charAt(0).toUpperCase() + e.rowType?.slice(1) + "Kind";
      return G.getEnumLabel(a, e.data?.kind) ?? "";
    }
  }
  /** Generates tableData for ExcelHelpers.export (ng1) */
  static getTableData(e, t) {
    const s = [], n = (() => {
      const r = [];
      return e.map((i) => i.rows && i.rows.map((c) => c.accounting && c.accounting.dimensions).flat()).flat().forEach((i) => {
        i && !r.includes(i.id) && r.push(i.id);
      }), r;
    })(), o = [
      d.get("SALAXY.REPORTS.rowsReport.worker"),
      d.get("SALAXY.REPORTS.rowsReport.socsec", null, t),
      d.get("SALAXY.REPORTS.rowsReport.message", null, t),
      d.get("SALAXY.REPORTS.rowsReport.rowType", null, t),
      d.get("SALAXY.REPORTS.rowsReport.rowTypeKind", null, t),
      d.get("SALAXY.REPORTS.rowsReport.type", null, t),
      d.get("SALAXY.REPORTS.rowsReport.sourceId", null, t),
      d.get("SALAXY.REPORTS.rowsReport.count", null, t),
      d.get("SALAXY.REPORTS.rowsReport.price", null, t),
      d.get("SALAXY.REPORTS.rowsReport.total", null, t)
    ];
    return n.forEach((r) => {
      o.push(r);
    }), s.push(o), e.forEach((r) => {
      r.rows?.forEach((u) => {
        const i = [];
        i.push(r.worker?.avatar?.displayName), i.push(r.worker?.paymentData?.socialSecurityNumber), i.push(u.message), i.push(G.getEnumLabel("CalculationRowType", u.rowType ?? "", void 0, t)), i.push(this.getKind(u, t)), i.push(u.type), i.push(u.sourceId), i.push(u.count), i.push(u.price), i.push(y.formatPrice((u.count ?? 1) * (u.price ?? 0))), n.forEach((c) => {
          const f = u.accounting?.dimensions?.filter((m) => m.id === c).map((m) => m.value).join(", ");
          i.push(f);
        }), s.push(i);
      });
    }), s;
  }
}
class Mf {
  /**
   * Generates config for SxyTable component
   * @param calcs Calculations for report
   * @param lang Language for report
   * @returns Configuration for SxyTable component
   */
  static getConfig(e, t) {
    const s = () => {
      const n = [];
      return e.forEach((o) => {
        (o.result?.irRows ?? []).forEach((u) => {
          n.push({
            calc: o,
            irCode: u.irData?.code,
            irCodeName: this.getIncomeType(u, t)?.label,
            worker: o.worker?.avatar?.displayName,
            message: u.message,
            rowType: this.translateRowType(u, t),
            kind: this.getKind(u, t),
            type: this.getType(u),
            count: u.count,
            price: u.price,
            unit: u?.unit === L.One ? "" : Ql.getUnitIndicator(u.unit ?? L.Undefined, t),
            total: u.total
          });
        });
      }), n;
    };
    return {
      include: [
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.worker", null, t), field: "worker", frozen: !0, minWidth: 100 },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.irCode", null, t), field: "irCode" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.incomeType", null, t), field: "irCodeName" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.rowType", null, t), field: "rowType" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.kind", null, t), field: "kind" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.type", null, t), field: "type" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.message", null, t), field: "message" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.count", null, t), field: "count" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.price", null, t), field: "price", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.unit", null, t), field: "unit" },
        { title: d.get("SALAXY.REPORTS.calcsIrRowsReport.total", null, t), field: "total", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } }
      ],
      options: {
        selectable: !1,
        layout: "fitColumns"
      },
      data: s()
    };
  }
  static getKind(e, t) {
    if (!e.data?.kind)
      return "";
    if ((e.data?.calculationRowType).charAt(0).toLowerCase() + e.data?.calculationRowType.slice(1) === v.IrIncomeType)
      return V.getAll(t).find((a) => e.data?.kind && a.transactionCode === e.data?.kind || e?.irData?.code && a.code === e?.irData?.code)?.label ?? "";
    {
      const a = e.data?.calculationRowType + "Kind";
      return G.getEnumLabel(a, e.data?.kind) ?? "";
    }
  }
  static getType(e) {
    let t = e?.calcData?.type ? e?.calcData?.type : `/builtIn/${e?.data?.calculationRowType.charAt(0).toLowerCase() + e?.data?.calculationRowType.slice(1)}`;
    return e.data?.kind && (t += `/${e.data?.kind}`), t;
  }
  /** Generates tableData for ExcelHelpers.export (ng1) */
  static getTableData(e, t) {
    const s = [], a = [
      d.get("SALAXY.REPORTS.calcsIrRowsReport.worker", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.irCode", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.incomeType", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.rowType", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.kind", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.type", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.message", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.count", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.price", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.unit", null, t),
      d.get("SALAXY.REPORTS.calcsIrRowsReport.total", null, t)
    ];
    return s.push(a), e.forEach((n) => {
      n?.result?.irRows?.forEach((o) => {
        const r = [];
        r.push(n.worker?.avatar?.displayName), r.push(o?.irData?.code), r.push(this.getIncomeType(o, t)?.label), r.push(o.message), r.push(this.translateRowType(o, t)), r.push(this.getKind(o, t)), r.push(this.getType(o)), r.push(o.count), r.push(o.price), r.push(o?.unit === L.One ? "" : Ql.getUnitIndicator(o.unit ?? L.Undefined, t)), r.push(o.total), s.push(r);
      });
    }), s;
  }
  static getIncomeType(e, t) {
    return V.getAll(t).find((s) => s.code === e.irData.code);
  }
  static translateRowType(e, t) {
    let s = e.data?.calculationRowType || v.Unknown;
    s = s.substr(0, 1).toLowerCase() + s.substr(1);
    const a = e.irData?.code, n = e.data?.kind;
    let o;
    return s === v.IrIncomeType ? o = V.getAll(t).find((r) => n && r.transactionCode === n || a > 0 && r.code === a)?.label : s === v.MealBenefit && a !== 334 ? o = V.getAll(t).find((r) => a > 0 && r.code === a)?.label : [
      v.Unknown,
      v.CarBenefit,
      v.BicycleBenefit,
      v.SubsidisedCommute,
      v.TaxAtSource,
      v.HourlySalaryWithWorkingTimeCompensation
    ].includes(s) ? o = V.getAll(t).find((r) => a > 0 && r.code === a)?.label : [
      v.DailyAllowance,
      v.EmploymentTermination,
      v.WorkingTimeCompensation,
      v.Remuneration,
      v.OtherCompensation,
      v.NonProfitOrg,
      v.MealBenefit,
      // main MealBenefit
      v.Training,
      v.PaidSickLeave
    ].includes(s) && n && (o = G.getEnumLabel(`${e.data?.calculationRowType}Kind`, n, void 0, t)), o || G.getEnumLabel("CalculationRowType", s, void 0, t);
  }
}
class Xf {
  /**
   * Generates config for SxyTable component
   * @param calcs Calculations for report
   * @param lang Language for report
   * @returns Configuration for SxyTable component
   */
  static getConfig(e, t) {
    const s = () => {
      const n = [], o = ["baseSalary", "benefits", "totalTaxable", "tax", "totalExpenses", "unionPayment", "foreclosure", "pension", "unemploymentInsurance", "otherDeductions", "salaryAdvance", "earnings", "deductions", "totalWorkerPayment"];
      if (e.forEach((r) => {
        n.push({
          worker: r.worker?.avatar?.sortableName,
          baseSalary: r.result?.totals?.totalGrossSalary,
          benefits: r.result?.workerCalc?.benefits,
          totalTaxable: r.result?.totals?.totalTaxable,
          tax: r.result?.workerCalc?.tax ?? 0 + (r.result?.workerCalc?.taxAtSource ?? 0),
          totalExpenses: r.result?.totals?.totalExpenses ?? 0 - (r.result?.workerCalc?.prepaidExpenses ?? 0),
          unionPayment: r.result?.workerCalc?.unionPayment,
          foreclosure: r.result?.workerCalc?.foreclosure,
          pension: r.result?.workerCalc?.pension,
          unemploymentInsurance: r.result?.workerCalc?.unemploymentInsurance,
          otherDeductions: r.result?.workerCalc?.otherDeductions,
          salaryAdvance: r.result?.workerCalc?.salaryAdvance,
          earnings: (r.result?.totals?.totalGrossSalary ?? 0) + (r.result?.totals?.totalExpenses ?? 0),
          deductions: r.result?.workerCalc?.deductions,
          totalWorkerPayment: r.result?.workerCalc?.totalWorkerPayment
        });
      }), e.length > 1) {
        const r = {};
        o.forEach((i) => {
          r[i] = 0;
        });
        const u = n.reduce(
          (i, c) => ({
            worker: "",
            baseSalary: i.baseSalary + c.baseSalary,
            benefits: i.benefits + c.benefits,
            totalTaxable: i.totalTaxable + c.totalTaxable,
            tax: i.tax + c.tax,
            totalExpenses: i.totalExpenses + c.totalExpenses,
            unionPayment: i.unionPayment + c.unionPayment,
            foreclosure: i.foreclosure + c.foreclosure,
            pension: i.pension + c.pension,
            unemploymentInsurance: i.unemploymentInsurance + c.unemploymentInsurance,
            otherDeductions: i.otherDeductions + c.otherDeductions,
            salaryAdvance: i.salaryAdvance + c.salaryAdvance,
            earnings: i.earnings + c.earnings,
            deductions: i.deductions + c.deductions,
            totalWorkerPayment: i.totalWorkerPayment + c.totalWorkerPayment
          }),
          r
        );
        n.push(u);
      }
      return n;
    };
    return {
      include: [
        { title: d.get("SALAXY.REPORTS.totals.table.worker", null, t), field: "worker", frozen: !0, minWidth: 100 },
        { title: d.get("SALAXY.REPORTS.totals.table.baseSalary", null, t), field: "baseSalary", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.benefits", null, t), field: "benefits", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.totalTaxable", null, t), field: "totalTaxable", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.tax", null, t), field: "tax", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.totalExpenses", null, t), field: "totalExpenses", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.unionPayment", null, t), field: "unionPayment", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.foreclosure", null, t), field: "foreclosure", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.pension", null, t), field: "pension", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.unemploymentInsurance", null, t), field: "unemploymentInsurance", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.otherDeductions", null, t), field: "otherDeductions", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.salaryAdvance", null, t), field: "salaryAdvance", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.earnings", null, t), field: "earnings", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.totalDeductions", null, t), field: "deductions", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } },
        { title: d.get("SALAXY.REPORTS.totals.table.totalWorkerPayment", null, t), field: "totalWorkerPayment", hozAlign: "right", formatter: "money", formatterParams: { symbol: "€", symbolAfter: !0, decimal: ",", thousand: " " } }
      ],
      options: {
        selectable: !1,
        layout: "fitData"
      },
      data: s()
    };
  }
  /** Generates tableData for ExcelHelpers.export (ng1) */
  static getTableData(e, t) {
    const s = [], a = [
      d.get("SALAXY.REPORTS.totals.table.company", null, t),
      d.get("SALAXY.REPORTS.totals.table.officialId", null, t),
      d.get("SALAXY.REPORTS.totals.table.worker", null, t),
      d.get("SALAXY.REPORTS.totals.table.salaryPeriod", null, t),
      d.get("SALAXY.REPORTS.totals.table.salaryDate", null, t),
      d.get("SALAXY.REPORTS.totals.table.baseSalary", null, t),
      d.get("SALAXY.REPORTS.totals.table.benefits", null, t),
      d.get("SALAXY.REPORTS.totals.table.totalTaxable", null, t),
      d.get("SALAXY.REPORTS.totals.table.tax", null, t),
      d.get("SALAXY.REPORTS.totals.table.totalExpenses", null, t),
      d.get("SALAXY.REPORTS.totals.table.unionPayment", null, t),
      d.get("SALAXY.REPORTS.totals.table.foreclosure", null, t),
      d.get("SALAXY.REPORTS.totals.table.pension", null, t),
      d.get("SALAXY.REPORTS.totals.table.unemploymentInsurance", null, t),
      d.get("SALAXY.REPORTS.totals.table.otherDeductions", null, t),
      d.get("SALAXY.REPORTS.totals.table.salaryAdvance", null, t),
      d.get("SALAXY.REPORTS.totals.table.earnings", null, t),
      d.get("SALAXY.REPORTS.totals.table.totalDeductions", null, t),
      d.get("SALAXY.REPORTS.totals.table.totalWorkerPayment", null, t)
    ];
    return s.push(a), e.forEach((n) => {
      const o = [];
      o.push(n.employer?.avatar?.displayName), o.push(n.employer?.officialId), o.push(n.worker?.avatar?.sortableName), o.push(g.getFormattedRange(n.info?.workStartDate ?? "", n.info?.workEndDate ?? "")), o.push(g.getFormattedDate(n.workflow?.salaryDate)), o.push(n.result?.totals?.totalGrossSalary), o.push(n.result?.workerCalc?.benefits), o.push(n.result?.totals?.totalTaxable), o.push((n.result?.workerCalc?.tax ?? 0) + (n.result?.workerCalc?.taxAtSource ?? 0)), o.push((n.result?.totals?.totalExpenses ?? 0) - (n.result?.workerCalc?.prepaidExpenses ?? 0)), o.push(n.result?.workerCalc?.unionPayment), o.push(n.result?.workerCalc?.foreclosure), o.push(n.result?.workerCalc?.pension), o.push(n.result?.workerCalc?.unemploymentInsurance), o.push(n.result?.workerCalc?.otherDeductions), o.push(n.result?.workerCalc?.salaryAdvance), o.push((n.result?.totals?.totalGrossSalary ?? 0) + (n.result?.totals?.totalExpenses ?? 0)), o.push(n.result?.workerCalc?.deductions), o.push(n.result?.workerCalc?.totalWorkerPayment), s.push(o);
    }), s;
  }
}
export {
  Ef as AccountingMapper,
  Of as AuthorizationMapper,
  $e as Barcodes,
  Qo as CalculationMapper,
  Jo as CalculationReportImpl,
  R as CalculationReportRow,
  K as CalculationReportRowGroup,
  x as CalculationTableRowData,
  _f as CalendarMapper,
  Tf as ESalaryMapper,
  Lf as InvoiceListMapper,
  Cf as InvoiceMapper,
  Mf as IrRowsReportConfigGenerator,
  _ as PaymentTableRowData,
  Kr as QrCodes,
  Df as RowsReportConfigGenerator,
  rt as SummaryMapper,
  bf as Templates,
  Xf as TotalsReportConfigGenerator,
  xf as WorkerSummaryMapper,
  tt as hbsTemplates
};
//# sourceMappingURL=salaxy-lib-reports.js.map
